import * as d from "react";
import D, { forwardRef as Je, createElement as Re, createContext as nn, useState as He, useContext as et, useLayoutEffect as gc, useEffect as Yr, Children as qf, isValidElement as Jf, useCallback as hn, useMemo as Bi } from "react";
import * as Xr from "react-dom";
import Qf from "react-dom";
var ii = { exports: {} }, ua = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var al;
function eh() {
  if (al) return ua;
  al = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(a, r, o) {
    var i = null;
    if (o !== void 0 && (i = "" + o), r.key !== void 0 && (i = "" + r.key), "key" in r) {
      o = {};
      for (var s in r)
        s !== "key" && (o[s] = r[s]);
    } else o = r;
    return r = o.ref, {
      $$typeof: e,
      type: a,
      key: i,
      ref: r !== void 0 ? r : null,
      props: o
    };
  }
  return ua.Fragment = t, ua.jsx = n, ua.jsxs = n, ua;
}
var pa = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rl;
function th() {
  return rl || (rl = 1, process.env.NODE_ENV !== "production" && function() {
    function e(N) {
      if (N == null) return null;
      if (typeof N == "function")
        return N.$$typeof === L ? null : N.displayName || N.name || null;
      if (typeof N == "string") return N;
      switch (N) {
        case g:
          return "Fragment";
        case b:
          return "Profiler";
        case y:
          return "StrictMode";
        case S:
          return "Suspense";
        case P:
          return "SuspenseList";
        case A:
          return "Activity";
      }
      if (typeof N == "object")
        switch (typeof N.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), N.$$typeof) {
          case v:
            return "Portal";
          case x:
            return (N.displayName || "Context") + ".Provider";
          case $:
            return (N._context.displayName || "Context") + ".Consumer";
          case w:
            var F = N.render;
            return N = N.displayName, N || (N = F.displayName || F.name || "", N = N !== "" ? "ForwardRef(" + N + ")" : "ForwardRef"), N;
          case C:
            return F = N.displayName || null, F !== null ? F : e(N.type) || "Memo";
          case T:
            F = N._payload, N = N._init;
            try {
              return e(N(F));
            } catch {
            }
        }
      return null;
    }
    function t(N) {
      return "" + N;
    }
    function n(N) {
      try {
        t(N);
        var F = !1;
      } catch {
        F = !0;
      }
      if (F) {
        F = console;
        var E = F.error, B = typeof Symbol == "function" && Symbol.toStringTag && N[Symbol.toStringTag] || N.constructor.name || "Object";
        return E.call(
          F,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          B
        ), t(N);
      }
    }
    function a(N) {
      if (N === g) return "<>";
      if (typeof N == "object" && N !== null && N.$$typeof === T)
        return "<...>";
      try {
        var F = e(N);
        return F ? "<" + F + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function r() {
      var N = V.A;
      return N === null ? null : N.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function i(N) {
      if (M.call(N, "key")) {
        var F = Object.getOwnPropertyDescriptor(N, "key").get;
        if (F && F.isReactWarning) return !1;
      }
      return N.key !== void 0;
    }
    function s(N, F) {
      function E() {
        Q || (Q = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          F
        ));
      }
      E.isReactWarning = !0, Object.defineProperty(N, "key", {
        get: E,
        configurable: !0
      });
    }
    function c() {
      var N = e(this.type);
      return W[N] || (W[N] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), N = this.props.ref, N !== void 0 ? N : null;
    }
    function u(N, F, E, B, X, U, ne, I) {
      return E = U.ref, N = {
        $$typeof: h,
        type: N,
        key: F,
        props: U,
        _owner: X
      }, (E !== void 0 ? E : null) !== null ? Object.defineProperty(N, "ref", {
        enumerable: !1,
        get: c
      }) : Object.defineProperty(N, "ref", { enumerable: !1, value: null }), N._store = {}, Object.defineProperty(N._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(N, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(N, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ne
      }), Object.defineProperty(N, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: I
      }), Object.freeze && (Object.freeze(N.props), Object.freeze(N)), N;
    }
    function p(N, F, E, B, X, U, ne, I) {
      var Y = F.children;
      if (Y !== void 0)
        if (B)
          if (_(Y)) {
            for (B = 0; B < Y.length; B++)
              m(Y[B]);
            Object.freeze && Object.freeze(Y);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else m(Y);
      if (M.call(F, "key")) {
        Y = e(N);
        var te = Object.keys(F).filter(function(me) {
          return me !== "key";
        });
        B = 0 < te.length ? "{key: someKey, " + te.join(": ..., ") + ": ...}" : "{key: someKey}", j[Y + B] || (te = 0 < te.length ? "{" + te.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          B,
          Y,
          te,
          Y
        ), j[Y + B] = !0);
      }
      if (Y = null, E !== void 0 && (n(E), Y = "" + E), i(F) && (n(F.key), Y = "" + F.key), "key" in F) {
        E = {};
        for (var le in F)
          le !== "key" && (E[le] = F[le]);
      } else E = F;
      return Y && s(
        E,
        typeof N == "function" ? N.displayName || N.name || "Unknown" : N
      ), u(
        N,
        Y,
        U,
        X,
        r(),
        E,
        ne,
        I
      );
    }
    function m(N) {
      typeof N == "object" && N !== null && N.$$typeof === h && N._store && (N._store.validated = 1);
    }
    var f = D, h = Symbol.for("react.transitional.element"), v = Symbol.for("react.portal"), g = Symbol.for("react.fragment"), y = Symbol.for("react.strict_mode"), b = Symbol.for("react.profiler"), $ = Symbol.for("react.consumer"), x = Symbol.for("react.context"), w = Symbol.for("react.forward_ref"), S = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), C = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), A = Symbol.for("react.activity"), L = Symbol.for("react.client.reference"), V = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, M = Object.prototype.hasOwnProperty, _ = Array.isArray, K = console.createTask ? console.createTask : function() {
      return null;
    };
    f = {
      "react-stack-bottom-frame": function(N) {
        return N();
      }
    };
    var Q, W = {}, q = f["react-stack-bottom-frame"].bind(
      f,
      o
    )(), z = K(a(o)), j = {};
    pa.Fragment = g, pa.jsx = function(N, F, E, B, X) {
      var U = 1e4 > V.recentlyCreatedOwnerStacks++;
      return p(
        N,
        F,
        E,
        !1,
        B,
        X,
        U ? Error("react-stack-top-frame") : q,
        U ? K(a(N)) : z
      );
    }, pa.jsxs = function(N, F, E, B, X) {
      var U = 1e4 > V.recentlyCreatedOwnerStacks++;
      return p(
        N,
        F,
        E,
        !0,
        B,
        X,
        U ? Error("react-stack-top-frame") : q,
        U ? K(a(N)) : z
      );
    };
  }()), pa;
}
process.env.NODE_ENV === "production" ? ii.exports = eh() : ii.exports = th();
var l = ii.exports;
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nh = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), bc = (...e) => e.filter((t, n, a) => !!t && t.trim() !== "" && a.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var ah = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rh = Je(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: a,
    className: r = "",
    children: o,
    iconNode: i,
    ...s
  }, c) => Re(
    "svg",
    {
      ref: c,
      ...ah,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: a ? Number(n) * 24 / Number(t) : n,
      className: bc("lucide", r),
      ...s
    },
    [
      ...i.map(([u, p]) => Re(u, p)),
      ...Array.isArray(o) ? o : [o]
    ]
  )
);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Et = (e, t) => {
  const n = Je(
    ({ className: a, ...r }, o) => Re(rh, {
      ref: o,
      iconNode: t,
      className: bc(`lucide-${nh(e)}`, a),
      ...r
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oh = Et("ArrowLeft", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ih = Et("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qr = Et("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sh = Et("CircleHelp", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vc = Et("Globe", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lh = Et("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ch = Et("Plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dh = Et("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uh = Et("Shield", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
/**
 * @license lucide-react v0.454.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ph = Et("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
function ol(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function jt(...e) {
  return (t) => {
    let n = !1;
    const a = e.map((r) => {
      const o = ol(r, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let r = 0; r < a.length; r++) {
          const o = a[r];
          typeof o == "function" ? o() : ol(e[r], null);
        }
      };
  };
}
function ue(...e) {
  return d.useCallback(jt(...e), e);
}
// @__NO_SIDE_EFFECTS__
function zt(e) {
  const t = /* @__PURE__ */ fh(e), n = d.forwardRef((a, r) => {
    const { children: o, ...i } = a, s = d.Children.toArray(o), c = s.find(gh);
    if (c) {
      const u = c.props.children, p = s.map((m) => m === c ? d.Children.count(u) > 1 ? d.Children.only(null) : d.isValidElement(u) ? u.props.children : null : m);
      return /* @__PURE__ */ l.jsx(t, { ...i, ref: r, children: d.isValidElement(u) ? d.cloneElement(u, void 0, p) : null });
    }
    return /* @__PURE__ */ l.jsx(t, { ...i, ref: r, children: o });
  });
  return n.displayName = `${e}.Slot`, n;
}
var mh = /* @__PURE__ */ zt("Slot");
// @__NO_SIDE_EFFECTS__
function fh(e) {
  const t = d.forwardRef((n, a) => {
    const { children: r, ...o } = n;
    if (d.isValidElement(r)) {
      const i = vh(r), s = bh(o, r.props);
      return r.type !== d.Fragment && (s.ref = a ? jt(a, i) : i), d.cloneElement(r, s);
    }
    return d.Children.count(r) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var yc = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function hh(e) {
  const t = ({ children: n }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = yc, t;
}
function gh(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === yc;
}
function bh(e, t) {
  const n = { ...t };
  for (const a in t) {
    const r = e[a], o = t[a];
    /^on[A-Z]/.test(a) ? r && o ? n[a] = (...s) => {
      o(...s), r(...s);
    } : r && (n[a] = r) : a === "style" ? n[a] = { ...r, ...o } : a === "className" && (n[a] = [r, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function vh(e) {
  var a, r;
  let t = (a = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function $c(e) {
  var t, n, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = $c(e[t])) && (a && (a += " "), a += n);
  } else for (n in e) e[n] && (a && (a += " "), a += n);
  return a;
}
function Ui() {
  for (var e, t, n = 0, a = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = $c(e)) && (a && (a += " "), a += t);
  return a;
}
const il = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, sl = Ui, Jr = (e, t) => (n) => {
  var a;
  if ((t == null ? void 0 : t.variants) == null) return sl(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: o } = t, i = Object.keys(r).map((u) => {
    const p = n == null ? void 0 : n[u], m = o == null ? void 0 : o[u];
    if (p === null) return null;
    const f = il(p) || il(m);
    return r[u][f];
  }), s = n && Object.entries(n).reduce((u, p) => {
    let [m, f] = p;
    return f === void 0 || (u[m] = f), u;
  }, {}), c = t == null || (a = t.compoundVariants) === null || a === void 0 ? void 0 : a.reduce((u, p) => {
    let { class: m, className: f, ...h } = p;
    return Object.entries(h).every((v) => {
      let [g, y] = v;
      return Array.isArray(y) ? y.includes({
        ...o,
        ...s
      }[g]) : {
        ...o,
        ...s
      }[g] === y;
    }) ? [
      ...u,
      m,
      f
    ] : u;
  }, []);
  return sl(e, i, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Gi = "-", yh = (e) => {
  const t = xh(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: a
  } = e;
  return {
    getClassGroupId: (i) => {
      const s = i.split(Gi);
      return s[0] === "" && s.length !== 1 && s.shift(), xc(s, t) || $h(i);
    },
    getConflictingClassGroupIds: (i, s) => {
      const c = n[i] || [];
      return s && a[i] ? [...c, ...a[i]] : c;
    }
  };
}, xc = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], a = t.nextPart.get(n), r = a ? xc(e.slice(1), a) : void 0;
  if (r)
    return r;
  if (t.validators.length === 0)
    return;
  const o = e.join(Gi);
  return (i = t.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : i.classGroupId;
}, ll = /^\[(.+)\]$/, $h = (e) => {
  if (ll.test(e)) {
    const t = ll.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, xh = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, a = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Ch(Object.entries(e.classGroups), n).forEach(([o, i]) => {
    si(i, a, o, t);
  }), a;
}, si = (e, t, n, a) => {
  e.forEach((r) => {
    if (typeof r == "string") {
      const o = r === "" ? t : cl(t, r);
      o.classGroupId = n;
      return;
    }
    if (typeof r == "function") {
      if (wh(r)) {
        si(r(a), t, n, a);
        return;
      }
      t.validators.push({
        validator: r,
        classGroupId: n
      });
      return;
    }
    Object.entries(r).forEach(([o, i]) => {
      si(i, cl(t, o), n, a);
    });
  });
}, cl = (e, t) => {
  let n = e;
  return t.split(Gi).forEach((a) => {
    n.nextPart.has(a) || n.nextPart.set(a, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(a);
  }), n;
}, wh = (e) => e.isThemeGetter, Ch = (e, t) => t ? e.map(([n, a]) => {
  const r = a.map((o) => typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(([i, s]) => [t + i, s])) : o);
  return [n, r];
}) : e, Sh = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  const r = (o, i) => {
    n.set(o, i), t++, t > e && (t = 0, a = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(o) {
      let i = n.get(o);
      if (i !== void 0)
        return i;
      if ((i = a.get(o)) !== void 0)
        return r(o, i), i;
    },
    set(o, i) {
      n.has(o) ? n.set(o, i) : r(o, i);
    }
  };
}, wc = "!", Eh = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, a = t.length === 1, r = t[0], o = t.length, i = (s) => {
    const c = [];
    let u = 0, p = 0, m;
    for (let y = 0; y < s.length; y++) {
      let b = s[y];
      if (u === 0) {
        if (b === r && (a || s.slice(y, y + o) === t)) {
          c.push(s.slice(p, y)), p = y + o;
          continue;
        }
        if (b === "/") {
          m = y;
          continue;
        }
      }
      b === "[" ? u++ : b === "]" && u--;
    }
    const f = c.length === 0 ? s : s.substring(p), h = f.startsWith(wc), v = h ? f.substring(1) : f, g = m && m > p ? m - p : void 0;
    return {
      modifiers: c,
      hasImportantModifier: h,
      baseClassName: v,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: i
  }) : i;
}, Rh = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((a) => {
    a[0] === "[" ? (t.push(...n.sort(), a), n = []) : n.push(a);
  }), t.push(...n.sort()), t;
}, Nh = (e) => ({
  cache: Sh(e.cacheSize),
  parseClassName: Eh(e),
  ...yh(e)
}), Ah = /\s+/, Ph = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: a,
    getConflictingClassGroupIds: r
  } = t, o = [], i = e.trim().split(Ah);
  let s = "";
  for (let c = i.length - 1; c >= 0; c -= 1) {
    const u = i[c], {
      modifiers: p,
      hasImportantModifier: m,
      baseClassName: f,
      maybePostfixModifierPosition: h
    } = n(u);
    let v = !!h, g = a(v ? f.substring(0, h) : f);
    if (!g) {
      if (!v) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (g = a(f), !g) {
        s = u + (s.length > 0 ? " " + s : s);
        continue;
      }
      v = !1;
    }
    const y = Rh(p).join(":"), b = m ? y + wc : y, $ = b + g;
    if (o.includes($))
      continue;
    o.push($);
    const x = r(g, v);
    for (let w = 0; w < x.length; ++w) {
      const S = x[w];
      o.push(b + S);
    }
    s = u + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function _h() {
  let e = 0, t, n, a = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Cc(t)) && (a && (a += " "), a += n);
  return a;
}
const Cc = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let a = 0; a < e.length; a++)
    e[a] && (t = Cc(e[a])) && (n && (n += " "), n += t);
  return n;
};
function Th(e, ...t) {
  let n, a, r, o = i;
  function i(c) {
    const u = t.reduce((p, m) => m(p), e());
    return n = Nh(u), a = n.cache.get, r = n.cache.set, o = s, s(c);
  }
  function s(c) {
    const u = a(c);
    if (u)
      return u;
    const p = Ph(c, n);
    return r(c, p), p;
  }
  return function() {
    return o(_h.apply(null, arguments));
  };
}
const $e = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Sc = /^\[(?:([a-z-]+):)?(.+)\]$/i, kh = /^\d+\/\d+$/, Oh = /* @__PURE__ */ new Set(["px", "full", "screen"]), jh = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Mh = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Ih = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Dh = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Lh = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Pt = (e) => Bn(e) || Oh.has(e) || kh.test(e), Gt = (e) => na(e, "length", zh), Bn = (e) => !!e && !Number.isNaN(Number(e)), Lo = (e) => na(e, "number", Bn), ma = (e) => !!e && Number.isInteger(Number(e)), Fh = (e) => e.endsWith("%") && Bn(e.slice(0, -1)), de = (e) => Sc.test(e), Ht = (e) => jh.test(e), Bh = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Uh = (e) => na(e, Bh, Ec), Gh = (e) => na(e, "position", Ec), Hh = /* @__PURE__ */ new Set(["image", "url"]), Wh = (e) => na(e, Hh, Zh), Vh = (e) => na(e, "", Kh), fa = () => !0, na = (e, t, n) => {
  const a = Sc.exec(e);
  return a ? a[1] ? typeof t == "string" ? a[1] === t : t.has(a[1]) : n(a[2]) : !1;
}, zh = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Mh.test(e) && !Ih.test(e)
), Ec = () => !1, Kh = (e) => Dh.test(e), Zh = (e) => Lh.test(e), Yh = () => {
  const e = $e("colors"), t = $e("spacing"), n = $e("blur"), a = $e("brightness"), r = $e("borderColor"), o = $e("borderRadius"), i = $e("borderSpacing"), s = $e("borderWidth"), c = $e("contrast"), u = $e("grayscale"), p = $e("hueRotate"), m = $e("invert"), f = $e("gap"), h = $e("gradientColorStops"), v = $e("gradientColorStopPositions"), g = $e("inset"), y = $e("margin"), b = $e("opacity"), $ = $e("padding"), x = $e("saturate"), w = $e("scale"), S = $e("sepia"), P = $e("skew"), C = $e("space"), T = $e("translate"), A = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], V = () => ["auto", de, t], M = () => [de, t], _ = () => ["", Pt, Gt], K = () => ["auto", Bn, de], Q = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], W = () => ["solid", "dashed", "dotted", "double", "none"], q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], z = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], j = () => ["", "0", de], N = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], F = () => [Bn, de];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [fa],
      spacing: [Pt, Gt],
      blur: ["none", "", Ht, de],
      brightness: F(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ht, de],
      borderSpacing: M(),
      borderWidth: _(),
      contrast: F(),
      grayscale: j(),
      hueRotate: F(),
      invert: j(),
      gap: M(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Fh, Gt],
      inset: V(),
      margin: V(),
      opacity: F(),
      padding: M(),
      saturate: F(),
      scale: F(),
      sepia: j(),
      skew: F(),
      space: M(),
      translate: M()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", de]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ht]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": N()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": N()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Q(), de]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: A()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": A()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": A()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ma, de]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: V()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", de]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: j()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: j()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ma, de]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [fa]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ma, de]
        }, de]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": K()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": K()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [fa]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ma, de]
        }, de]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": K()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": K()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", de]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", de]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...z()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...z(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...z(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [$]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [$]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [$]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [$]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [$]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [$]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [$]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [$]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [$]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [C]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [C]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", de, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [de, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [de, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ht]
        }, Ht]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [de, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [de, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [de, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [de, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ht, Gt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Lo]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [fa]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", de]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Bn, Lo]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Pt, de]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", de]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", de]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...W(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Pt, Gt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Pt, de]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: M()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", de]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", de]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Q(), Gh]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Uh]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Wh]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...W(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: W()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [r]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...W()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Pt, de]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Pt, Gt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: _()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Pt, Gt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ht, Vh]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [fa]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...q(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [a]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ht, de]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [p]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [m]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [a]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [p]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [m]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", de]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: F()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", de]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: F()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", de]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ma, de]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [T]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [T]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [P]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [P]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", de]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", de]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": M()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": M()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": M()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": M()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": M()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": M()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": M()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": M()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": M()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": M()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": M()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": M()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": M()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": M()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": M()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": M()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": M()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": M()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", de]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Pt, Gt, Lo]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Xh = /* @__PURE__ */ Th(Yh);
function R(...e) {
  return Xh(Ui(e));
}
const qh = Jr(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90 n3o-widget-primary-button",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Ne = d.forwardRef(
  ({ className: e, variant: t, size: n, asChild: a = !1, ...r }, o) => {
    const i = a ? mh : "button";
    return /* @__PURE__ */ l.jsx(
      i,
      {
        className: R(qh({ variant: t, size: n, className: e })),
        ref: o,
        ...r
      }
    );
  }
);
Ne.displayName = "Button";
const Rc = nn(null);
function Hi() {
  const e = et(Rc);
  if (!e)
    throw new Error("Counter components must be used within Counter");
  return e;
}
function Va({
  children: e,
  defaultValue: t = 0,
  min: n = 0,
  max: a = 1 / 0,
  onChange: r,
  value: o
}) {
  const [i, s] = He(t), c = o !== void 0, u = c ? o : i, p = (v) => {
    const g = Math.max(n, Math.min(a, v));
    c || s(g), r == null || r(g);
  }, h = {
    value: u,
    setValue: p,
    decrease: () => p(u - 1),
    increase: () => p(u + 1),
    min: n,
    max: a,
    canDecrease: u > n,
    canIncrease: u < a
  };
  return /* @__PURE__ */ l.jsx(Rc.Provider, { value: h, children: e });
}
Va.Label = function({ children: t, className: n }) {
  return /* @__PURE__ */ l.jsx("p", { className: R("text-base text-gray-700 mb-3", n), children: t });
};
Va.Controls = function({ children: t, className: n }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex items-center gap-2", n), children: t });
};
Va.DecreaseButton = function({
  children: t,
  className: n,
  ...a
}) {
  const { decrease: r, canDecrease: o } = Hi();
  return /* @__PURE__ */ l.jsx(
    Ne,
    {
      className: R("h-12 w-[110px] rounded-lg shadow-sm", n),
      variant: "outline",
      onClick: r,
      disabled: !o,
      ...a,
      children: t || /* @__PURE__ */ l.jsx(lh, { size: 18 })
    }
  );
};
Va.Display = function({
  children: t,
  className: n,
  onKeyDown: a,
  ...r
}) {
  const { value: o, increase: i, decrease: s, canIncrease: c, canDecrease: u, min: p, max: m } = Hi(), f = (v) => {
    v.key === "ArrowUp" && c ? (v.preventDefault(), i()) : v.key === "ArrowDown" && u && (v.preventDefault(), s()), a == null || a(v);
  }, h = () => t === void 0 ? o : typeof t == "function" ? t(o) : t;
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: R(
        "h-12 w-[110px] bg-white rounded-lg flex items-center justify-center text-lg font-medium border border-gray-100",
        "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500",
        "cursor-pointer select-none",
        n
      ),
      "aria-live": "polite",
      tabIndex: 0,
      onKeyDown: f,
      role: "spinbutton",
      "aria-valuenow": o,
      "aria-valuemin": p,
      "aria-valuemax": m === 1 / 0 ? void 0 : m,
      ...r,
      children: h()
    }
  );
};
Va.IncreaseButton = function({
  children: t,
  className: n,
  ...a
}) {
  const { increase: r, canIncrease: o } = Hi();
  return /* @__PURE__ */ l.jsx(
    Ne,
    {
      className: R("h-12 w-[110px] rounded-lg shadow-sm", n),
      variant: "outline",
      onClick: r,
      disabled: !o,
      ...a,
      children: t || /* @__PURE__ */ l.jsx(ch, { size: 18 })
    }
  );
};
function Jh(e, t) {
  const n = d.createContext(t), a = (o) => {
    const { children: i, ...s } = o, c = d.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ l.jsx(n.Provider, { value: c, children: i });
  };
  a.displayName = e + "Provider";
  function r(o) {
    const i = d.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${o}\` must be used within \`${e}\``);
  }
  return [a, r];
}
function Ve(e, t = []) {
  let n = [];
  function a(o, i) {
    const s = d.createContext(i), c = n.length;
    n = [...n, i];
    const u = (m) => {
      var b;
      const { scope: f, children: h, ...v } = m, g = ((b = f == null ? void 0 : f[e]) == null ? void 0 : b[c]) || s, y = d.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ l.jsx(g.Provider, { value: y, children: h });
    };
    u.displayName = o + "Provider";
    function p(m, f) {
      var g;
      const h = ((g = f == null ? void 0 : f[e]) == null ? void 0 : g[c]) || s, v = d.useContext(h);
      if (v) return v;
      if (i !== void 0) return i;
      throw new Error(`\`${m}\` must be used within \`${o}\``);
    }
    return [u, p];
  }
  const r = () => {
    const o = n.map((i) => d.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || o;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return r.scopeName = e, [a, Qh(r, ...t)];
}
function Qh(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const a = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(o) {
      const i = a.reduce((s, { useScope: c, scopeName: u }) => {
        const m = c(o)[`__scope${u}`];
        return { ...s, ...m };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function G(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function _e(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var a;
    return (a = t.current) == null ? void 0 : a.call(t, ...n);
  }, []);
}
function lt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [a, r] = eg({ defaultProp: t, onChange: n }), o = e !== void 0, i = o ? e : a, s = _e(n), c = d.useCallback(
    (u) => {
      if (o) {
        const m = typeof u == "function" ? u(e) : u;
        m !== e && s(m);
      } else
        r(u);
    },
    [o, e, r, s]
  );
  return [i, c];
}
function eg({
  defaultProp: e,
  onChange: t
}) {
  const n = d.useState(e), [a] = n, r = d.useRef(a), o = _e(t);
  return d.useEffect(() => {
    r.current !== a && (o(a), r.current = a);
  }, [a, r, o]), n;
}
function Qr(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var Me = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
};
function eo(e) {
  const [t, n] = d.useState(void 0);
  return Me(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const a = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const o = r[0];
        let i, s;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          i = u.inlineSize, s = u.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return a.observe(e, { box: "border-box" }), () => a.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function tg(e, t) {
  return d.useReducer((n, a) => t[n][a] ?? n, e);
}
var De = (e) => {
  const { present: t, children: n } = e, a = ng(t), r = typeof n == "function" ? n({ present: a.isPresent }) : d.Children.only(n), o = ue(a.ref, ag(r));
  return typeof n == "function" || a.isPresent ? d.cloneElement(r, { ref: o }) : null;
};
De.displayName = "Presence";
function ng(e) {
  const [t, n] = d.useState(), a = d.useRef({}), r = d.useRef(e), o = d.useRef("none"), i = e ? "mounted" : "unmounted", [s, c] = tg(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const u = mr(a.current);
    o.current = s === "mounted" ? u : "none";
  }, [s]), Me(() => {
    const u = a.current, p = r.current;
    if (p !== e) {
      const f = o.current, h = mr(u);
      e ? c("MOUNT") : h === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(p && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, c]), Me(() => {
    if (t) {
      let u;
      const p = t.ownerDocument.defaultView ?? window, m = (h) => {
        const g = mr(a.current).includes(h.animationName);
        if (h.target === t && g && (c("ANIMATION_END"), !r.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = p.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, f = (h) => {
        h.target === t && (o.current = mr(a.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        p.clearTimeout(u), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: d.useCallback((u) => {
      u && (a.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function mr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function ag(e) {
  var a, r;
  let t = (a = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : a.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var rg = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ee = rg.reduce((e, t) => {
  const n = /* @__PURE__ */ zt(`Primitive.${t}`), a = d.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, c = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l.jsx(c, { ...s, ref: o });
  });
  return a.displayName = `Primitive.${t}`, { ...e, [t]: a };
}, {});
function Nc(e, t) {
  e && Xr.flushSync(() => e.dispatchEvent(t));
}
var Wi = "Checkbox", [og, bC] = Ve(Wi), [ig, sg] = og(Wi), Ac = d.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: a,
      checked: r,
      defaultChecked: o,
      required: i,
      disabled: s,
      value: c = "on",
      onCheckedChange: u,
      form: p,
      ...m
    } = e, [f, h] = d.useState(null), v = ue(t, (w) => h(w)), g = d.useRef(!1), y = f ? p || !!f.closest("form") : !0, [b = !1, $] = lt({
      prop: r,
      defaultProp: o,
      onChange: u
    }), x = d.useRef(b);
    return d.useEffect(() => {
      const w = f == null ? void 0 : f.form;
      if (w) {
        const S = () => $(x.current);
        return w.addEventListener("reset", S), () => w.removeEventListener("reset", S);
      }
    }, [f, $]), /* @__PURE__ */ l.jsxs(ig, { scope: n, state: b, disabled: s, children: [
      /* @__PURE__ */ l.jsx(
        ee.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Vt(b) ? "mixed" : b,
          "aria-required": i,
          "data-state": Tc(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...m,
          ref: v,
          onKeyDown: G(e.onKeyDown, (w) => {
            w.key === "Enter" && w.preventDefault();
          }),
          onClick: G(e.onClick, (w) => {
            $((S) => Vt(S) ? !0 : !S), y && (g.current = w.isPropagationStopped(), g.current || w.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ l.jsx(
        lg,
        {
          control: f,
          bubbles: !g.current,
          name: a,
          value: c,
          checked: b,
          required: i,
          disabled: s,
          form: p,
          style: { transform: "translateX(-100%)" },
          defaultChecked: Vt(o) ? !1 : o
        }
      )
    ] });
  }
);
Ac.displayName = Wi;
var Pc = "CheckboxIndicator", _c = d.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: a, ...r } = e, o = sg(Pc, n);
    return /* @__PURE__ */ l.jsx(De, { present: a || Vt(o.state) || o.state === !0, children: /* @__PURE__ */ l.jsx(
      ee.span,
      {
        "data-state": Tc(o.state),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
_c.displayName = Pc;
var lg = (e) => {
  const { control: t, checked: n, bubbles: a = !0, defaultChecked: r, ...o } = e, i = d.useRef(null), s = Qr(n), c = eo(t);
  d.useEffect(() => {
    const p = i.current, m = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(m, "checked").set;
    if (s !== n && h) {
      const v = new Event("click", { bubbles: a });
      p.indeterminate = Vt(n), h.call(p, Vt(n) ? !1 : n), p.dispatchEvent(v);
    }
  }, [s, n, a]);
  const u = d.useRef(Vt(n) ? !1 : n);
  return /* @__PURE__ */ l.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: r ?? u.current,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...c,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Vt(e) {
  return e === "indeterminate";
}
function Tc(e) {
  return Vt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var kc = Ac, cg = _c;
function Ft(e, t) {
  if (e == null) return {};
  var n = {}, a = Object.keys(e), r, o;
  for (o = 0; o < a.length; o++)
    r = a[o], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
var dg = ["color"], ug = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, dg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), pg = ["color"], to = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, pg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), mg = ["color"], fg = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, mg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), hg = ["color"], gg = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, hg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), bg = ["color"], vg = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, bg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), yg = ["color"], $g = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, yg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), xg = ["color"], wg = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, xg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M5 7.5C5 7.22386 5.22386 7 5.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Cg = ["color"], Sg = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, Cg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
    fill: a
  }));
}), Eg = ["color"], Rg = /* @__PURE__ */ Je(function(e, t) {
  var n = e.color, a = n === void 0 ? "currentColor" : n, r = Ft(e, Eg);
  return Re("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), Re("path", {
    d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
const Rn = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  kc,
  {
    ref: n,
    className: R(
      "peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l.jsx(
      cg,
      {
        className: R("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ l.jsx(to, { className: "h-4 w-4" })
      }
    )
  }
));
Rn.displayName = kc.displayName;
function Ng(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = _e(e);
  d.useEffect(() => {
    const a = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", a, { capture: !0 }), () => t.removeEventListener("keydown", a, { capture: !0 });
  }, [n, t]);
}
var Ag = "DismissableLayer", li = "dismissableLayer.update", Pg = "dismissableLayer.pointerDownOutside", _g = "dismissableLayer.focusOutside", dl, Oc = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), aa = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: a,
      onPointerDownOutside: r,
      onFocusOutside: o,
      onInteractOutside: i,
      onDismiss: s,
      ...c
    } = e, u = d.useContext(Oc), [p, m] = d.useState(null), f = (p == null ? void 0 : p.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = d.useState({}), v = ue(t, (C) => m(C)), g = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(y), $ = p ? g.indexOf(p) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, w = $ >= b, S = Og((C) => {
      const T = C.target, A = [...u.branches].some((L) => L.contains(T));
      !w || A || (r == null || r(C), i == null || i(C), C.defaultPrevented || s == null || s());
    }, f), P = jg((C) => {
      const T = C.target;
      [...u.branches].some((L) => L.contains(T)) || (o == null || o(C), i == null || i(C), C.defaultPrevented || s == null || s());
    }, f);
    return Ng((C) => {
      $ === u.layers.size - 1 && (a == null || a(C), !C.defaultPrevented && s && (C.preventDefault(), s()));
    }, f), d.useEffect(() => {
      if (p)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (dl = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(p)), u.layers.add(p), ul(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = dl);
        };
    }, [p, f, n, u]), d.useEffect(() => () => {
      p && (u.layers.delete(p), u.layersWithOutsidePointerEventsDisabled.delete(p), ul());
    }, [p, u]), d.useEffect(() => {
      const C = () => h({});
      return document.addEventListener(li, C), () => document.removeEventListener(li, C);
    }, []), /* @__PURE__ */ l.jsx(
      ee.div,
      {
        ...c,
        ref: v,
        style: {
          pointerEvents: x ? w ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: G(e.onFocusCapture, P.onFocusCapture),
        onBlurCapture: G(e.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: G(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
aa.displayName = Ag;
var Tg = "DismissableLayerBranch", kg = d.forwardRef((e, t) => {
  const n = d.useContext(Oc), a = d.useRef(null), r = ue(t, a);
  return d.useEffect(() => {
    const o = a.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ l.jsx(ee.div, { ...e, ref: r });
});
kg.displayName = Tg;
function Og(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = _e(e), a = d.useRef(!1), r = d.useRef(() => {
  });
  return d.useEffect(() => {
    const o = (s) => {
      if (s.target && !a.current) {
        let c = function() {
          jc(
            Pg,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = c, t.addEventListener("click", r.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", r.current);
      a.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", o), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => a.current = !0
  };
}
function jg(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = _e(e), a = d.useRef(!1);
  return d.useEffect(() => {
    const r = (o) => {
      o.target && !a.current && jc(_g, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => a.current = !0,
    onBlurCapture: () => a.current = !1
  };
}
function ul() {
  const e = new CustomEvent(li);
  document.dispatchEvent(e);
}
function jc(e, t, n, { discrete: a }) {
  const r = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), a ? Nc(r, o) : r.dispatchEvent(o);
}
var Mg = d[" useId ".trim().toString()] || (() => {
}), Ig = 0;
function ke(e) {
  const [t, n] = d.useState(Mg());
  return Me(() => {
    n((a) => a ?? String(Ig++));
  }, [e]), t ? `radix-${t}` : "";
}
const Dg = ["top", "right", "bottom", "left"], Kt = Math.min, Ye = Math.max, Er = Math.round, fr = Math.floor, $t = (e) => ({
  x: e,
  y: e
}), Lg = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Fg = {
  start: "end",
  end: "start"
};
function ci(e, t, n) {
  return Ye(e, Kt(t, n));
}
function Mt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function It(e) {
  return e.split("-")[0];
}
function ra(e) {
  return e.split("-")[1];
}
function Vi(e) {
  return e === "x" ? "y" : "x";
}
function zi(e) {
  return e === "y" ? "height" : "width";
}
function Zt(e) {
  return ["top", "bottom"].includes(It(e)) ? "y" : "x";
}
function Ki(e) {
  return Vi(Zt(e));
}
function Bg(e, t, n) {
  n === void 0 && (n = !1);
  const a = ra(e), r = Ki(e), o = zi(r);
  let i = r === "x" ? a === (n ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (i = Rr(i)), [i, Rr(i)];
}
function Ug(e) {
  const t = Rr(e);
  return [di(e), t, di(t)];
}
function di(e) {
  return e.replace(/start|end/g, (t) => Fg[t]);
}
function Gg(e, t, n) {
  const a = ["left", "right"], r = ["right", "left"], o = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? r : a : t ? a : r;
    case "left":
    case "right":
      return t ? o : i;
    default:
      return [];
  }
}
function Hg(e, t, n, a) {
  const r = ra(e);
  let o = Gg(It(e), n === "start", a);
  return r && (o = o.map((i) => i + "-" + r), t && (o = o.concat(o.map(di)))), o;
}
function Rr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Lg[t]);
}
function Wg(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Mc(e) {
  return typeof e != "number" ? Wg(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Nr(e) {
  const {
    x: t,
    y: n,
    width: a,
    height: r
  } = e;
  return {
    width: a,
    height: r,
    top: n,
    left: t,
    right: t + a,
    bottom: n + r,
    x: t,
    y: n
  };
}
function pl(e, t, n) {
  let {
    reference: a,
    floating: r
  } = e;
  const o = Zt(t), i = Ki(t), s = zi(i), c = It(t), u = o === "y", p = a.x + a.width / 2 - r.width / 2, m = a.y + a.height / 2 - r.height / 2, f = a[s] / 2 - r[s] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: p,
        y: a.y - r.height
      };
      break;
    case "bottom":
      h = {
        x: p,
        y: a.y + a.height
      };
      break;
    case "right":
      h = {
        x: a.x + a.width,
        y: m
      };
      break;
    case "left":
      h = {
        x: a.x - r.width,
        y: m
      };
      break;
    default:
      h = {
        x: a.x,
        y: a.y
      };
  }
  switch (ra(t)) {
    case "start":
      h[i] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      h[i] += f * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const Vg = async (e, t, n) => {
  const {
    placement: a = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: i
  } = n, s = o.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: p,
    y: m
  } = pl(u, a, c), f = a, h = {}, v = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: y,
      fn: b
    } = s[g], {
      x: $,
      y: x,
      data: w,
      reset: S
    } = await b({
      x: p,
      y: m,
      initialPlacement: a,
      placement: f,
      strategy: r,
      middlewareData: h,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = $ ?? p, m = x ?? m, h = {
      ...h,
      [y]: {
        ...h[y],
        ...w
      }
    }, S && v <= 50 && (v++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (u = S.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : S.rects), {
      x: p,
      y: m
    } = pl(u, f, c)), g = -1);
  }
  return {
    x: p,
    y: m,
    placement: f,
    strategy: r,
    middlewareData: h
  };
};
async function Sa(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: a,
    y: r,
    platform: o,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: m = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Mt(t, e), v = Mc(h), y = s[f ? m === "floating" ? "reference" : "floating" : m], b = Nr(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(y))) == null || n ? y : y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: p,
    strategy: c
  })), $ = m === "floating" ? {
    x: a,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), w = await (o.isElement == null ? void 0 : o.isElement(x)) ? await (o.getScale == null ? void 0 : o.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Nr(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: $,
    offsetParent: x,
    strategy: c
  }) : $);
  return {
    top: (b.top - S.top + v.top) / w.y,
    bottom: (S.bottom - b.bottom + v.bottom) / w.y,
    left: (b.left - S.left + v.left) / w.x,
    right: (S.right - b.right + v.right) / w.x
  };
}
const zg = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: a,
      placement: r,
      rects: o,
      platform: i,
      elements: s,
      middlewareData: c
    } = t, {
      element: u,
      padding: p = 0
    } = Mt(e, t) || {};
    if (u == null)
      return {};
    const m = Mc(p), f = {
      x: n,
      y: a
    }, h = Ki(r), v = zi(h), g = await i.getDimensions(u), y = h === "y", b = y ? "top" : "left", $ = y ? "bottom" : "right", x = y ? "clientHeight" : "clientWidth", w = o.reference[v] + o.reference[h] - f[h] - o.floating[v], S = f[h] - o.reference[h], P = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let C = P ? P[x] : 0;
    (!C || !await (i.isElement == null ? void 0 : i.isElement(P))) && (C = s.floating[x] || o.floating[v]);
    const T = w / 2 - S / 2, A = C / 2 - g[v] / 2 - 1, L = Kt(m[b], A), V = Kt(m[$], A), M = L, _ = C - g[v] - V, K = C / 2 - g[v] / 2 + T, Q = ci(M, K, _), W = !c.arrow && ra(r) != null && K !== Q && o.reference[v] / 2 - (K < M ? L : V) - g[v] / 2 < 0, q = W ? K < M ? K - M : K - _ : 0;
    return {
      [h]: f[h] + q,
      data: {
        [h]: Q,
        centerOffset: K - Q - q,
        ...W && {
          alignmentOffset: q
        }
      },
      reset: W
    };
  }
}), Kg = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, a;
      const {
        placement: r,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: u
      } = t, {
        mainAxis: p = !0,
        crossAxis: m = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: g = !0,
        ...y
      } = Mt(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const b = It(r), $ = Zt(s), x = It(s) === s, w = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), S = f || (x || !g ? [Rr(s)] : Ug(s)), P = v !== "none";
      !f && P && S.push(...Hg(s, g, v, w));
      const C = [s, ...S], T = await Sa(t, y), A = [];
      let L = ((a = o.flip) == null ? void 0 : a.overflows) || [];
      if (p && A.push(T[b]), m) {
        const K = Bg(r, i, w);
        A.push(T[K[0]], T[K[1]]);
      }
      if (L = [...L, {
        placement: r,
        overflows: A
      }], !A.every((K) => K <= 0)) {
        var V, M;
        const K = (((V = o.flip) == null ? void 0 : V.index) || 0) + 1, Q = C[K];
        if (Q)
          return {
            data: {
              index: K,
              overflows: L
            },
            reset: {
              placement: Q
            }
          };
        let W = (M = L.filter((q) => q.overflows[0] <= 0).sort((q, z) => q.overflows[1] - z.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!W)
          switch (h) {
            case "bestFit": {
              var _;
              const q = (_ = L.filter((z) => {
                if (P) {
                  const j = Zt(z.placement);
                  return j === $ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  j === "y";
                }
                return !0;
              }).map((z) => [z.placement, z.overflows.filter((j) => j > 0).reduce((j, N) => j + N, 0)]).sort((z, j) => z[1] - j[1])[0]) == null ? void 0 : _[0];
              q && (W = q);
              break;
            }
            case "initialPlacement":
              W = s;
              break;
          }
        if (r !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
};
function ml(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function fl(e) {
  return Dg.some((t) => e[t] >= 0);
}
const Zg = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: a = "referenceHidden",
        ...r
      } = Mt(e, t);
      switch (a) {
        case "referenceHidden": {
          const o = await Sa(t, {
            ...r,
            elementContext: "reference"
          }), i = ml(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: fl(i)
            }
          };
        }
        case "escaped": {
          const o = await Sa(t, {
            ...r,
            altBoundary: !0
          }), i = ml(o, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: fl(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Yg(e, t) {
  const {
    placement: n,
    platform: a,
    elements: r
  } = e, o = await (a.isRTL == null ? void 0 : a.isRTL(r.floating)), i = It(n), s = ra(n), c = Zt(n) === "y", u = ["left", "top"].includes(i) ? -1 : 1, p = o && c ? -1 : 1, m = Mt(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: v
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return s && typeof v == "number" && (h = s === "end" ? v * -1 : v), c ? {
    x: h * p,
    y: f * u
  } : {
    x: f * u,
    y: h * p
  };
}
const Xg = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, a;
      const {
        x: r,
        y: o,
        placement: i,
        middlewareData: s
      } = t, c = await Yg(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (a = s.arrow) != null && a.alignmentOffset ? {} : {
        x: r + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, qg = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: a,
        placement: r
      } = t, {
        mainAxis: o = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: b,
              y: $
            } = y;
            return {
              x: b,
              y: $
            };
          }
        },
        ...c
      } = Mt(e, t), u = {
        x: n,
        y: a
      }, p = await Sa(t, c), m = Zt(It(r)), f = Vi(m);
      let h = u[f], v = u[m];
      if (o) {
        const y = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", $ = h + p[y], x = h - p[b];
        h = ci($, h, x);
      }
      if (i) {
        const y = m === "y" ? "top" : "left", b = m === "y" ? "bottom" : "right", $ = v + p[y], x = v - p[b];
        v = ci($, v, x);
      }
      const g = s.fn({
        ...t,
        [f]: h,
        [m]: v
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - a,
          enabled: {
            [f]: o,
            [m]: i
          }
        }
      };
    }
  };
}, Jg = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: a,
        placement: r,
        rects: o,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = Mt(e, t), p = {
        x: n,
        y: a
      }, m = Zt(r), f = Vi(m);
      let h = p[f], v = p[m];
      const g = Mt(s, t), y = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (c) {
        const x = f === "y" ? "height" : "width", w = o.reference[f] - o.floating[x] + y.mainAxis, S = o.reference[f] + o.reference[x] - y.mainAxis;
        h < w ? h = w : h > S && (h = S);
      }
      if (u) {
        var b, $;
        const x = f === "y" ? "width" : "height", w = ["top", "left"].includes(It(r)), S = o.reference[m] - o.floating[x] + (w && ((b = i.offset) == null ? void 0 : b[m]) || 0) + (w ? 0 : y.crossAxis), P = o.reference[m] + o.reference[x] + (w ? 0 : (($ = i.offset) == null ? void 0 : $[m]) || 0) - (w ? y.crossAxis : 0);
        v < S ? v = S : v > P && (v = P);
      }
      return {
        [f]: h,
        [m]: v
      };
    }
  };
}, Qg = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, a;
      const {
        placement: r,
        rects: o,
        platform: i,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...u
      } = Mt(e, t), p = await Sa(t, u), m = It(r), f = ra(r), h = Zt(r) === "y", {
        width: v,
        height: g
      } = o.floating;
      let y, b;
      m === "top" || m === "bottom" ? (y = m, b = f === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = m, y = f === "end" ? "top" : "bottom");
      const $ = g - p.top - p.bottom, x = v - p.left - p.right, w = Kt(g - p[y], $), S = Kt(v - p[b], x), P = !t.middlewareData.shift;
      let C = w, T = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (T = x), (a = t.middlewareData.shift) != null && a.enabled.y && (C = $), P && !f) {
        const L = Ye(p.left, 0), V = Ye(p.right, 0), M = Ye(p.top, 0), _ = Ye(p.bottom, 0);
        h ? T = v - 2 * (L !== 0 || V !== 0 ? L + V : Ye(p.left, p.right)) : C = g - 2 * (M !== 0 || _ !== 0 ? M + _ : Ye(p.top, p.bottom));
      }
      await c({
        ...t,
        availableWidth: T,
        availableHeight: C
      });
      const A = await i.getDimensions(s.floating);
      return v !== A.width || g !== A.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function no() {
  return typeof window < "u";
}
function oa(e) {
  return Ic(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Xe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Rt(e) {
  var t;
  return (t = (Ic(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ic(e) {
  return no() ? e instanceof Node || e instanceof Xe(e).Node : !1;
}
function ct(e) {
  return no() ? e instanceof Element || e instanceof Xe(e).Element : !1;
}
function wt(e) {
  return no() ? e instanceof HTMLElement || e instanceof Xe(e).HTMLElement : !1;
}
function hl(e) {
  return !no() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Xe(e).ShadowRoot;
}
function za(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: a,
    display: r
  } = dt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + a + n) && !["inline", "contents"].includes(r);
}
function e0(e) {
  return ["table", "td", "th"].includes(oa(e));
}
function ao(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Zi(e) {
  const t = Yi(), n = ct(e) ? dt(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((a) => (n.willChange || "").includes(a)) || ["paint", "layout", "strict", "content"].some((a) => (n.contain || "").includes(a));
}
function t0(e) {
  let t = Yt(e);
  for (; wt(t) && !Vn(t); ) {
    if (Zi(t))
      return t;
    if (ao(t))
      return null;
    t = Yt(t);
  }
  return null;
}
function Yi() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Vn(e) {
  return ["html", "body", "#document"].includes(oa(e));
}
function dt(e) {
  return Xe(e).getComputedStyle(e);
}
function ro(e) {
  return ct(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Yt(e) {
  if (oa(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    hl(e) && e.host || // Fallback.
    Rt(e)
  );
  return hl(t) ? t.host : t;
}
function Dc(e) {
  const t = Yt(e);
  return Vn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : wt(t) && za(t) ? t : Dc(t);
}
function Ea(e, t, n) {
  var a;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Dc(e), o = r === ((a = e.ownerDocument) == null ? void 0 : a.body), i = Xe(r);
  if (o) {
    const s = ui(i);
    return t.concat(i, i.visualViewport || [], za(r) ? r : [], s && n ? Ea(s) : []);
  }
  return t.concat(r, Ea(r, [], n));
}
function ui(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Lc(e) {
  const t = dt(e);
  let n = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const r = wt(e), o = r ? e.offsetWidth : n, i = r ? e.offsetHeight : a, s = Er(n) !== o || Er(a) !== i;
  return s && (n = o, a = i), {
    width: n,
    height: a,
    $: s
  };
}
function Xi(e) {
  return ct(e) ? e : e.contextElement;
}
function Un(e) {
  const t = Xi(e);
  if (!wt(t))
    return $t(1);
  const n = t.getBoundingClientRect(), {
    width: a,
    height: r,
    $: o
  } = Lc(t);
  let i = (o ? Er(n.width) : n.width) / a, s = (o ? Er(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const n0 = /* @__PURE__ */ $t(0);
function Fc(e) {
  const t = Xe(e);
  return !Yi() || !t.visualViewport ? n0 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function a0(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Xe(e) ? !1 : t;
}
function bn(e, t, n, a) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = Xi(e);
  let i = $t(1);
  t && (a ? ct(a) && (i = Un(a)) : i = Un(e));
  const s = a0(o, n, a) ? Fc(o) : $t(0);
  let c = (r.left + s.x) / i.x, u = (r.top + s.y) / i.y, p = r.width / i.x, m = r.height / i.y;
  if (o) {
    const f = Xe(o), h = a && ct(a) ? Xe(a) : a;
    let v = f, g = ui(v);
    for (; g && a && h !== v; ) {
      const y = Un(g), b = g.getBoundingClientRect(), $ = dt(g), x = b.left + (g.clientLeft + parseFloat($.paddingLeft)) * y.x, w = b.top + (g.clientTop + parseFloat($.paddingTop)) * y.y;
      c *= y.x, u *= y.y, p *= y.x, m *= y.y, c += x, u += w, v = Xe(g), g = ui(v);
    }
  }
  return Nr({
    width: p,
    height: m,
    x: c,
    y: u
  });
}
function qi(e, t) {
  const n = ro(e).scrollLeft;
  return t ? t.left + n : bn(Rt(e)).left + n;
}
function Bc(e, t, n) {
  n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), r = a.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    qi(e, a)
  )), o = a.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function r0(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: a,
    strategy: r
  } = e;
  const o = r === "fixed", i = Rt(a), s = t ? ao(t.floating) : !1;
  if (a === i || s && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = $t(1);
  const p = $t(0), m = wt(a);
  if ((m || !m && !o) && ((oa(a) !== "body" || za(i)) && (c = ro(a)), wt(a))) {
    const h = bn(a);
    u = Un(a), p.x = h.x + a.clientLeft, p.y = h.y + a.clientTop;
  }
  const f = i && !m && !o ? Bc(i, c, !0) : $t(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + p.x + f.x,
    y: n.y * u.y - c.scrollTop * u.y + p.y + f.y
  };
}
function o0(e) {
  return Array.from(e.getClientRects());
}
function i0(e) {
  const t = Rt(e), n = ro(e), a = e.ownerDocument.body, r = Ye(t.scrollWidth, t.clientWidth, a.scrollWidth, a.clientWidth), o = Ye(t.scrollHeight, t.clientHeight, a.scrollHeight, a.clientHeight);
  let i = -n.scrollLeft + qi(e);
  const s = -n.scrollTop;
  return dt(a).direction === "rtl" && (i += Ye(t.clientWidth, a.clientWidth) - r), {
    width: r,
    height: o,
    x: i,
    y: s
  };
}
function s0(e, t) {
  const n = Xe(e), a = Rt(e), r = n.visualViewport;
  let o = a.clientWidth, i = a.clientHeight, s = 0, c = 0;
  if (r) {
    o = r.width, i = r.height;
    const u = Yi();
    (!u || u && t === "fixed") && (s = r.offsetLeft, c = r.offsetTop);
  }
  return {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
function l0(e, t) {
  const n = bn(e, !0, t === "fixed"), a = n.top + e.clientTop, r = n.left + e.clientLeft, o = wt(e) ? Un(e) : $t(1), i = e.clientWidth * o.x, s = e.clientHeight * o.y, c = r * o.x, u = a * o.y;
  return {
    width: i,
    height: s,
    x: c,
    y: u
  };
}
function gl(e, t, n) {
  let a;
  if (t === "viewport")
    a = s0(e, n);
  else if (t === "document")
    a = i0(Rt(e));
  else if (ct(t))
    a = l0(t, n);
  else {
    const r = Fc(e);
    a = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return Nr(a);
}
function Uc(e, t) {
  const n = Yt(e);
  return n === t || !ct(n) || Vn(n) ? !1 : dt(n).position === "fixed" || Uc(n, t);
}
function c0(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let a = Ea(e, [], !1).filter((s) => ct(s) && oa(s) !== "body"), r = null;
  const o = dt(e).position === "fixed";
  let i = o ? Yt(e) : e;
  for (; ct(i) && !Vn(i); ) {
    const s = dt(i), c = Zi(i);
    !c && s.position === "fixed" && (r = null), (o ? !c && !r : !c && s.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || za(i) && !c && Uc(e, i)) ? a = a.filter((p) => p !== i) : r = s, i = Yt(i);
  }
  return t.set(e, a), a;
}
function d0(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: a,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? ao(t) ? [] : c0(t, this._c) : [].concat(n), a], s = i[0], c = i.reduce((u, p) => {
    const m = gl(t, p, r);
    return u.top = Ye(m.top, u.top), u.right = Kt(m.right, u.right), u.bottom = Kt(m.bottom, u.bottom), u.left = Ye(m.left, u.left), u;
  }, gl(t, s, r));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function u0(e) {
  const {
    width: t,
    height: n
  } = Lc(e);
  return {
    width: t,
    height: n
  };
}
function p0(e, t, n) {
  const a = wt(t), r = Rt(t), o = n === "fixed", i = bn(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = $t(0);
  if (a || !a && !o)
    if ((oa(t) !== "body" || za(r)) && (s = ro(t)), a) {
      const f = bn(t, !0, o, t);
      c.x = f.x + t.clientLeft, c.y = f.y + t.clientTop;
    } else r && (c.x = qi(r));
  const u = r && !a && !o ? Bc(r, s) : $t(0), p = i.left + s.scrollLeft - c.x - u.x, m = i.top + s.scrollTop - c.y - u.y;
  return {
    x: p,
    y: m,
    width: i.width,
    height: i.height
  };
}
function Fo(e) {
  return dt(e).position === "static";
}
function bl(e, t) {
  if (!wt(e) || dt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Rt(e) === n && (n = n.ownerDocument.body), n;
}
function Gc(e, t) {
  const n = Xe(e);
  if (ao(e))
    return n;
  if (!wt(e)) {
    let r = Yt(e);
    for (; r && !Vn(r); ) {
      if (ct(r) && !Fo(r))
        return r;
      r = Yt(r);
    }
    return n;
  }
  let a = bl(e, t);
  for (; a && e0(a) && Fo(a); )
    a = bl(a, t);
  return a && Vn(a) && Fo(a) && !Zi(a) ? n : a || t0(e) || n;
}
const m0 = async function(e) {
  const t = this.getOffsetParent || Gc, n = this.getDimensions, a = await n(e.floating);
  return {
    reference: p0(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function f0(e) {
  return dt(e).direction === "rtl";
}
const h0 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: r0,
  getDocumentElement: Rt,
  getClippingRect: d0,
  getOffsetParent: Gc,
  getElementRects: m0,
  getClientRects: o0,
  getDimensions: u0,
  getScale: Un,
  isElement: ct,
  isRTL: f0
};
function g0(e, t) {
  let n = null, a;
  const r = Rt(e);
  function o() {
    var s;
    clearTimeout(a), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), o();
    const {
      left: u,
      top: p,
      width: m,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !m || !f)
      return;
    const h = fr(p), v = fr(r.clientWidth - (u + m)), g = fr(r.clientHeight - (p + f)), y = fr(u), $ = {
      rootMargin: -h + "px " + -v + "px " + -g + "px " + -y + "px",
      threshold: Ye(0, Kt(1, c)) || 1
    };
    let x = !0;
    function w(S) {
      const P = S[0].intersectionRatio;
      if (P !== c) {
        if (!x)
          return i();
        P ? i(!1, P) : a = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...$,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, $);
    }
    n.observe(e);
  }
  return i(!0), o;
}
function b0(e, t, n, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = a, u = Xi(e), p = r || o ? [...u ? Ea(u) : [], ...Ea(t)] : [];
  p.forEach((b) => {
    r && b.addEventListener("scroll", n, {
      passive: !0
    }), o && b.addEventListener("resize", n);
  });
  const m = u && s ? g0(u, n) : null;
  let f = -1, h = null;
  i && (h = new ResizeObserver((b) => {
    let [$] = b;
    $ && $.target === u && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), u && !c && h.observe(u), h.observe(t));
  let v, g = c ? bn(e) : null;
  c && y();
  function y() {
    const b = bn(e);
    g && (b.x !== g.x || b.y !== g.y || b.width !== g.width || b.height !== g.height) && n(), g = b, v = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    p.forEach(($) => {
      r && $.removeEventListener("scroll", n), o && $.removeEventListener("resize", n);
    }), m == null || m(), (b = h) == null || b.disconnect(), h = null, c && cancelAnimationFrame(v);
  };
}
const v0 = Xg, y0 = qg, $0 = Kg, x0 = Qg, w0 = Zg, vl = zg, C0 = Jg, S0 = (e, t, n) => {
  const a = /* @__PURE__ */ new Map(), r = {
    platform: h0,
    ...n
  }, o = {
    ...r.platform,
    _c: a
  };
  return Vg(e, t, {
    ...r,
    platform: o
  });
};
var xr = typeof document < "u" ? gc : Yr;
function Ar(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, a, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (a = n; a-- !== 0; )
        if (!Ar(e[a], t[a]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (a = n; a-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[a]))
        return !1;
    for (a = n; a-- !== 0; ) {
      const o = r[a];
      if (!(o === "_owner" && e.$$typeof) && !Ar(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Hc(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function yl(e, t) {
  const n = Hc(e);
  return Math.round(t * n) / n;
}
function Bo(e) {
  const t = d.useRef(e);
  return xr(() => {
    t.current = e;
  }), t;
}
function E0(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: a = [],
    platform: r,
    elements: {
      reference: o,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: u
  } = e, [p, m] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = d.useState(a);
  Ar(f, a) || h(a);
  const [v, g] = d.useState(null), [y, b] = d.useState(null), $ = d.useCallback((z) => {
    z !== P.current && (P.current = z, g(z));
  }, []), x = d.useCallback((z) => {
    z !== C.current && (C.current = z, b(z));
  }, []), w = o || v, S = i || y, P = d.useRef(null), C = d.useRef(null), T = d.useRef(p), A = c != null, L = Bo(c), V = Bo(r), M = Bo(u), _ = d.useCallback(() => {
    if (!P.current || !C.current)
      return;
    const z = {
      placement: t,
      strategy: n,
      middleware: f
    };
    V.current && (z.platform = V.current), S0(P.current, C.current, z).then((j) => {
      const N = {
        ...j,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: M.current !== !1
      };
      K.current && !Ar(T.current, N) && (T.current = N, Xr.flushSync(() => {
        m(N);
      }));
    });
  }, [f, t, n, V, M]);
  xr(() => {
    u === !1 && T.current.isPositioned && (T.current.isPositioned = !1, m((z) => ({
      ...z,
      isPositioned: !1
    })));
  }, [u]);
  const K = d.useRef(!1);
  xr(() => (K.current = !0, () => {
    K.current = !1;
  }), []), xr(() => {
    if (w && (P.current = w), S && (C.current = S), w && S) {
      if (L.current)
        return L.current(w, S, _);
      _();
    }
  }, [w, S, _, L, A]);
  const Q = d.useMemo(() => ({
    reference: P,
    floating: C,
    setReference: $,
    setFloating: x
  }), [$, x]), W = d.useMemo(() => ({
    reference: w,
    floating: S
  }), [w, S]), q = d.useMemo(() => {
    const z = {
      position: n,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return z;
    const j = yl(W.floating, p.x), N = yl(W.floating, p.y);
    return s ? {
      ...z,
      transform: "translate(" + j + "px, " + N + "px)",
      ...Hc(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: j,
      top: N
    };
  }, [n, s, W.floating, p.x, p.y]);
  return d.useMemo(() => ({
    ...p,
    update: _,
    refs: Q,
    elements: W,
    floatingStyles: q
  }), [p, _, Q, W, q]);
}
const R0 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: a,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return a && t(a) ? a.current != null ? vl({
        element: a.current,
        padding: r
      }).fn(n) : {} : a ? vl({
        element: a,
        padding: r
      }).fn(n) : {};
    }
  };
}, N0 = (e, t) => ({
  ...v0(e),
  options: [e, t]
}), A0 = (e, t) => ({
  ...y0(e),
  options: [e, t]
}), P0 = (e, t) => ({
  ...C0(e),
  options: [e, t]
}), _0 = (e, t) => ({
  ...$0(e),
  options: [e, t]
}), T0 = (e, t) => ({
  ...x0(e),
  options: [e, t]
}), k0 = (e, t) => ({
  ...w0(e),
  options: [e, t]
}), O0 = (e, t) => ({
  ...R0(e),
  options: [e, t]
});
var j0 = "Arrow", Wc = d.forwardRef((e, t) => {
  const { children: n, width: a = 10, height: r = 5, ...o } = e;
  return /* @__PURE__ */ l.jsx(
    ee.svg,
    {
      ...o,
      ref: t,
      width: a,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ l.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Wc.displayName = j0;
var M0 = Wc, Ji = "Popper", [Vc, an] = Ve(Ji), [I0, zc] = Vc(Ji), Kc = (e) => {
  const { __scopePopper: t, children: n } = e, [a, r] = d.useState(null);
  return /* @__PURE__ */ l.jsx(I0, { scope: t, anchor: a, onAnchorChange: r, children: n });
};
Kc.displayName = Ji;
var Zc = "PopperAnchor", Yc = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: a, ...r } = e, o = zc(Zc, n), i = d.useRef(null), s = ue(t, i);
    return d.useEffect(() => {
      o.onAnchorChange((a == null ? void 0 : a.current) || i.current);
    }), a ? null : /* @__PURE__ */ l.jsx(ee.div, { ...r, ref: s });
  }
);
Yc.displayName = Zc;
var Qi = "PopperContent", [D0, L0] = Vc(Qi), Xc = d.forwardRef(
  (e, t) => {
    var I, Y, te, le, me, fe;
    const {
      __scopePopper: n,
      side: a = "bottom",
      sideOffset: r = 0,
      align: o = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: u = [],
      collisionPadding: p = 0,
      sticky: m = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: v,
      ...g
    } = e, y = zc(Qi, n), [b, $] = d.useState(null), x = ue(t, (Oe) => $(Oe)), [w, S] = d.useState(null), P = eo(w), C = (P == null ? void 0 : P.width) ?? 0, T = (P == null ? void 0 : P.height) ?? 0, A = a + (o !== "center" ? "-" + o : ""), L = typeof p == "number" ? p : { top: 0, right: 0, bottom: 0, left: 0, ...p }, V = Array.isArray(u) ? u : [u], M = V.length > 0, _ = {
      padding: L,
      boundary: V.filter(B0),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: M
    }, { refs: K, floatingStyles: Q, placement: W, isPositioned: q, middlewareData: z } = E0({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: A,
      whileElementsMounted: (...Oe) => b0(...Oe, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        N0({ mainAxis: r + T, alignmentAxis: i }),
        c && A0({
          mainAxis: !0,
          crossAxis: !1,
          limiter: m === "partial" ? P0() : void 0,
          ..._
        }),
        c && _0({ ..._ }),
        T0({
          ..._,
          apply: ({ elements: Oe, rects: k, availableWidth: oe, availableHeight: xe }) => {
            const { width: Se, height: je } = k.reference, be = Oe.floating.style;
            be.setProperty("--radix-popper-available-width", `${oe}px`), be.setProperty("--radix-popper-available-height", `${xe}px`), be.setProperty("--radix-popper-anchor-width", `${Se}px`), be.setProperty("--radix-popper-anchor-height", `${je}px`);
          }
        }),
        w && O0({ element: w, padding: s }),
        U0({ arrowWidth: C, arrowHeight: T }),
        f && k0({ strategy: "referenceHidden", ..._ })
      ]
    }), [j, N] = Qc(W), F = _e(v);
    Me(() => {
      q && (F == null || F());
    }, [q, F]);
    const E = (I = z.arrow) == null ? void 0 : I.x, B = (Y = z.arrow) == null ? void 0 : Y.y, X = ((te = z.arrow) == null ? void 0 : te.centerOffset) !== 0, [U, ne] = d.useState();
    return Me(() => {
      b && ne(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ l.jsx(
      "div",
      {
        ref: K.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Q,
          transform: q ? Q.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: U,
          "--radix-popper-transform-origin": [
            (le = z.transformOrigin) == null ? void 0 : le.x,
            (me = z.transformOrigin) == null ? void 0 : me.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((fe = z.hide) == null ? void 0 : fe.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l.jsx(
          D0,
          {
            scope: n,
            placedSide: j,
            onArrowChange: S,
            arrowX: E,
            arrowY: B,
            shouldHideArrow: X,
            children: /* @__PURE__ */ l.jsx(
              ee.div,
              {
                "data-side": j,
                "data-align": N,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: q ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Xc.displayName = Qi;
var qc = "PopperArrow", F0 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Jc = d.forwardRef(function(t, n) {
  const { __scopePopper: a, ...r } = t, o = L0(qc, a), i = F0[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l.jsx(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l.jsx(
          M0,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Jc.displayName = qc;
function B0(e) {
  return e !== null;
}
var U0 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, b, $;
    const { placement: n, rects: a, middlewareData: r } = t, i = ((y = r.arrow) == null ? void 0 : y.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [u, p] = Qc(n), m = { start: "0%", center: "50%", end: "100%" }[p], f = (((b = r.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, h = ((($ = r.arrow) == null ? void 0 : $.y) ?? 0) + c / 2;
    let v = "", g = "";
    return u === "bottom" ? (v = i ? m : `${f}px`, g = `${-c}px`) : u === "top" ? (v = i ? m : `${f}px`, g = `${a.floating.height + c}px`) : u === "right" ? (v = `${-c}px`, g = i ? m : `${h}px`) : u === "left" && (v = `${a.floating.width + c}px`, g = i ? m : `${h}px`), { data: { x: v, y: g } };
  }
});
function Qc(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Ka = Kc, Za = Yc, oo = Xc, io = Jc, G0 = "Portal", es = d.forwardRef((e, t) => {
  var s;
  const { container: n, ...a } = e, [r, o] = d.useState(!1);
  Me(() => o(!0), []);
  const i = n || r && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? Qf.createPortal(/* @__PURE__ */ l.jsx(ee.div, { ...a, ref: t }), i) : null;
});
es.displayName = G0;
var H0 = "VisuallyHidden", ts = d.forwardRef(
  (e, t) => /* @__PURE__ */ l.jsx(
    ee.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
ts.displayName = H0;
var W0 = ts, [so, vC] = Ve("Tooltip", [
  an
]), lo = an(), ed = "TooltipProvider", V0 = 700, pi = "tooltip.open", [z0, ns] = so(ed), td = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = V0,
    skipDelayDuration: a = 300,
    disableHoverableContent: r = !1,
    children: o
  } = e, i = d.useRef(!0), s = d.useRef(!1), c = d.useRef(0);
  return d.useEffect(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ l.jsx(
    z0,
    {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(c.current), i.current = !1;
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(c.current), c.current = window.setTimeout(
          () => i.current = !0,
          a
        );
      }, [a]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: d.useCallback((u) => {
        s.current = u;
      }, []),
      disableHoverableContent: r,
      children: o
    }
  );
};
td.displayName = ed;
var co = "Tooltip", [K0, uo] = so(co), nd = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: a,
    defaultOpen: r = !1,
    onOpenChange: o,
    disableHoverableContent: i,
    delayDuration: s
  } = e, c = ns(co, e.__scopeTooltip), u = lo(t), [p, m] = d.useState(null), f = ke(), h = d.useRef(0), v = i ?? c.disableHoverableContent, g = s ?? c.delayDuration, y = d.useRef(!1), [b = !1, $] = lt({
    prop: a,
    defaultProp: r,
    onChange: (C) => {
      C ? (c.onOpen(), document.dispatchEvent(new CustomEvent(pi))) : c.onClose(), o == null || o(C);
    }
  }), x = d.useMemo(() => b ? y.current ? "delayed-open" : "instant-open" : "closed", [b]), w = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, y.current = !1, $(!0);
  }, [$]), S = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, $(!1);
  }, [$]), P = d.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      y.current = !0, $(!0), h.current = 0;
    }, g);
  }, [g, $]);
  return d.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ l.jsx(Ka, { ...u, children: /* @__PURE__ */ l.jsx(
    K0,
    {
      scope: t,
      contentId: f,
      open: b,
      stateAttribute: x,
      trigger: p,
      onTriggerChange: m,
      onTriggerEnter: d.useCallback(() => {
        c.isOpenDelayedRef.current ? P() : w();
      }, [c.isOpenDelayedRef, P, w]),
      onTriggerLeave: d.useCallback(() => {
        v ? S() : (window.clearTimeout(h.current), h.current = 0);
      }, [S, v]),
      onOpen: w,
      onClose: S,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
nd.displayName = co;
var mi = "TooltipTrigger", ad = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...a } = e, r = uo(mi, n), o = ns(mi, n), i = lo(n), s = d.useRef(null), c = ue(t, s, r.onTriggerChange), u = d.useRef(!1), p = d.useRef(!1), m = d.useCallback(() => u.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", m), [m]), /* @__PURE__ */ l.jsx(Za, { asChild: !0, ...i, children: /* @__PURE__ */ l.jsx(
      ee.button,
      {
        "aria-describedby": r.open ? r.contentId : void 0,
        "data-state": r.stateAttribute,
        ...a,
        ref: c,
        onPointerMove: G(e.onPointerMove, (f) => {
          f.pointerType !== "touch" && !p.current && !o.isPointerInTransitRef.current && (r.onTriggerEnter(), p.current = !0);
        }),
        onPointerLeave: G(e.onPointerLeave, () => {
          r.onTriggerLeave(), p.current = !1;
        }),
        onPointerDown: G(e.onPointerDown, () => {
          r.open && r.onClose(), u.current = !0, document.addEventListener("pointerup", m, { once: !0 });
        }),
        onFocus: G(e.onFocus, () => {
          u.current || r.onOpen();
        }),
        onBlur: G(e.onBlur, r.onClose),
        onClick: G(e.onClick, r.onClose)
      }
    ) });
  }
);
ad.displayName = mi;
var Z0 = "TooltipPortal", [yC, Y0] = so(Z0, {
  forceMount: void 0
}), zn = "TooltipContent", rd = d.forwardRef(
  (e, t) => {
    const n = Y0(zn, e.__scopeTooltip), { forceMount: a = n.forceMount, side: r = "top", ...o } = e, i = uo(zn, e.__scopeTooltip);
    return /* @__PURE__ */ l.jsx(De, { present: a || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ l.jsx(od, { side: r, ...o, ref: t }) : /* @__PURE__ */ l.jsx(X0, { side: r, ...o, ref: t }) });
  }
), X0 = d.forwardRef((e, t) => {
  const n = uo(zn, e.__scopeTooltip), a = ns(zn, e.__scopeTooltip), r = d.useRef(null), o = ue(t, r), [i, s] = d.useState(null), { trigger: c, onClose: u } = n, p = r.current, { onPointerInTransitChange: m } = a, f = d.useCallback(() => {
    s(null), m(!1);
  }, [m]), h = d.useCallback(
    (v, g) => {
      const y = v.currentTarget, b = { x: v.clientX, y: v.clientY }, $ = t2(b, y.getBoundingClientRect()), x = n2(b, $), w = a2(g.getBoundingClientRect()), S = o2([...x, ...w]);
      s(S), m(!0);
    },
    [m]
  );
  return d.useEffect(() => () => f(), [f]), d.useEffect(() => {
    if (c && p) {
      const v = (y) => h(y, p), g = (y) => h(y, c);
      return c.addEventListener("pointerleave", v), p.addEventListener("pointerleave", g), () => {
        c.removeEventListener("pointerleave", v), p.removeEventListener("pointerleave", g);
      };
    }
  }, [c, p, h, f]), d.useEffect(() => {
    if (i) {
      const v = (g) => {
        const y = g.target, b = { x: g.clientX, y: g.clientY }, $ = (c == null ? void 0 : c.contains(y)) || (p == null ? void 0 : p.contains(y)), x = !r2(b, i);
        $ ? f() : x && (f(), u());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [c, p, i, u, f]), /* @__PURE__ */ l.jsx(od, { ...e, ref: o });
}), [q0, J0] = so(co, { isInside: !1 }), Q0 = /* @__PURE__ */ hh("TooltipContent"), od = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: a,
      "aria-label": r,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      ...s
    } = e, c = uo(zn, n), u = lo(n), { onClose: p } = c;
    return d.useEffect(() => (document.addEventListener(pi, p), () => document.removeEventListener(pi, p)), [p]), d.useEffect(() => {
      if (c.trigger) {
        const m = (f) => {
          const h = f.target;
          h != null && h.contains(c.trigger) && p();
        };
        return window.addEventListener("scroll", m, { capture: !0 }), () => window.removeEventListener("scroll", m, { capture: !0 });
      }
    }, [c.trigger, p]), /* @__PURE__ */ l.jsx(
      aa,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: o,
        onPointerDownOutside: i,
        onFocusOutside: (m) => m.preventDefault(),
        onDismiss: p,
        children: /* @__PURE__ */ l.jsxs(
          oo,
          {
            "data-state": c.stateAttribute,
            ...u,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ l.jsx(Q0, { children: a }),
              /* @__PURE__ */ l.jsx(q0, { scope: n, isInside: !0, children: /* @__PURE__ */ l.jsx(W0, { id: c.contentId, role: "tooltip", children: r || a }) })
            ]
          }
        )
      }
    );
  }
);
rd.displayName = zn;
var id = "TooltipArrow", e2 = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...a } = e, r = lo(n);
    return J0(
      id,
      n
    ).isInside ? null : /* @__PURE__ */ l.jsx(io, { ...r, ...a, ref: t });
  }
);
e2.displayName = id;
function t2(e, t) {
  const n = Math.abs(t.top - e.y), a = Math.abs(t.bottom - e.y), r = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(n, a, r, o)) {
    case o:
      return "left";
    case r:
      return "right";
    case n:
      return "top";
    case a:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function n2(e, t, n = 5) {
  const a = [];
  switch (t) {
    case "top":
      a.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      a.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      a.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      a.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return a;
}
function a2(e) {
  const { top: t, right: n, bottom: a, left: r } = e;
  return [
    { x: r, y: t },
    { x: n, y: t },
    { x: n, y: a },
    { x: r, y: a }
  ];
}
function r2(e, t) {
  const { x: n, y: a } = e;
  let r = !1;
  for (let o = 0, i = t.length - 1; o < t.length; i = o++) {
    const s = t[o].x, c = t[o].y, u = t[i].x, p = t[i].y;
    c > a != p > a && n < (u - s) * (a - c) / (p - c) + s && (r = !r);
  }
  return r;
}
function o2(e) {
  const t = e.slice();
  return t.sort((n, a) => n.x < a.x ? -1 : n.x > a.x ? 1 : n.y < a.y ? -1 : n.y > a.y ? 1 : 0), i2(t);
}
function i2(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let a = 0; a < e.length; a++) {
    const r = e[a];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], i = t[t.length - 2];
      if ((o.x - i.x) * (r.y - i.y) >= (o.y - i.y) * (r.x - i.x)) t.pop();
      else break;
    }
    t.push(r);
  }
  t.pop();
  const n = [];
  for (let a = e.length - 1; a >= 0; a--) {
    const r = e[a];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], i = n[n.length - 2];
      if ((o.x - i.x) * (r.y - i.y) >= (o.y - i.y) * (r.x - i.x)) n.pop();
      else break;
    }
    n.push(r);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var s2 = td, l2 = nd, c2 = ad, sd = rd;
const ld = s2, cd = l2, dd = c2, as = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, a) => /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
  sd,
  {
    ref: a,
    sideOffset: t,
    className: R(
      "z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
as.displayName = sd.displayName;
function rs(e) {
  const t = e + "CollectionProvider", [n, a] = Ve(t), [r, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (g) => {
    const { scope: y, children: b } = g, $ = D.useRef(null), x = D.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l.jsx(r, { scope: y, itemMap: x, collectionRef: $, children: b });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", c = /* @__PURE__ */ zt(s), u = D.forwardRef(
    (g, y) => {
      const { scope: b, children: $ } = g, x = o(s, b), w = ue(y, x.collectionRef);
      return /* @__PURE__ */ l.jsx(c, { ref: w, children: $ });
    }
  );
  u.displayName = s;
  const p = e + "CollectionItemSlot", m = "data-radix-collection-item", f = /* @__PURE__ */ zt(p), h = D.forwardRef(
    (g, y) => {
      const { scope: b, children: $, ...x } = g, w = D.useRef(null), S = ue(y, w), P = o(p, b);
      return D.useEffect(() => (P.itemMap.set(w, { ref: w, ...x }), () => void P.itemMap.delete(w))), /* @__PURE__ */ l.jsx(f, { [m]: "", ref: S, children: $ });
    }
  );
  h.displayName = p;
  function v(g) {
    const y = o(e + "CollectionConsumer", g);
    return D.useCallback(() => {
      const $ = y.collectionRef.current;
      if (!$) return [];
      const x = Array.from($.querySelectorAll(`[${m}]`));
      return Array.from(y.itemMap.values()).sort(
        (P, C) => x.indexOf(P.ref.current) - x.indexOf(C.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: i, Slot: u, ItemSlot: h },
    v,
    a
  ];
}
var d2 = d.createContext(void 0);
function Ya(e) {
  const t = d.useContext(d2);
  return e || t || "ltr";
}
var Uo = 0;
function po() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? $l()), document.body.insertAdjacentElement("beforeend", e[1] ?? $l()), Uo++, () => {
      Uo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Uo--;
    };
  }, []);
}
function $l() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Go = "focusScope.autoFocusOnMount", Ho = "focusScope.autoFocusOnUnmount", xl = { bubbles: !1, cancelable: !0 }, u2 = "FocusScope", Xa = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: a = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: o,
    ...i
  } = e, [s, c] = d.useState(null), u = _e(r), p = _e(o), m = d.useRef(null), f = ue(t, (g) => c(g)), h = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (a) {
      let g = function(x) {
        if (h.paused || !s) return;
        const w = x.target;
        s.contains(w) ? m.current = w : Wt(m.current, { select: !0 });
      }, y = function(x) {
        if (h.paused || !s) return;
        const w = x.relatedTarget;
        w !== null && (s.contains(w) || Wt(m.current, { select: !0 }));
      }, b = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && Wt(s);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", y);
      const $ = new MutationObserver(b);
      return s && $.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", y), $.disconnect();
      };
    }
  }, [a, s, h.paused]), d.useEffect(() => {
    if (s) {
      Cl.add(h);
      const g = document.activeElement;
      if (!s.contains(g)) {
        const b = new CustomEvent(Go, xl);
        s.addEventListener(Go, u), s.dispatchEvent(b), b.defaultPrevented || (p2(b2(ud(s)), { select: !0 }), document.activeElement === g && Wt(s));
      }
      return () => {
        s.removeEventListener(Go, u), setTimeout(() => {
          const b = new CustomEvent(Ho, xl);
          s.addEventListener(Ho, p), s.dispatchEvent(b), b.defaultPrevented || Wt(g ?? document.body, { select: !0 }), s.removeEventListener(Ho, p), Cl.remove(h);
        }, 0);
      };
    }
  }, [s, u, p, h]);
  const v = d.useCallback(
    (g) => {
      if (!n && !a || h.paused) return;
      const y = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
      if (y && b) {
        const $ = g.currentTarget, [x, w] = m2($);
        x && w ? !g.shiftKey && b === w ? (g.preventDefault(), n && Wt(x, { select: !0 })) : g.shiftKey && b === x && (g.preventDefault(), n && Wt(w, { select: !0 })) : b === $ && g.preventDefault();
      }
    },
    [n, a, h.paused]
  );
  return /* @__PURE__ */ l.jsx(ee.div, { tabIndex: -1, ...i, ref: f, onKeyDown: v });
});
Xa.displayName = u2;
function p2(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const a of e)
    if (Wt(a, { select: t }), document.activeElement !== n) return;
}
function m2(e) {
  const t = ud(e), n = wl(t, e), a = wl(t.reverse(), e);
  return [n, a];
}
function ud(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (a) => {
      const r = a.tagName === "INPUT" && a.type === "hidden";
      return a.disabled || a.hidden || r ? NodeFilter.FILTER_SKIP : a.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function wl(e, t) {
  for (const n of e)
    if (!f2(n, { upTo: t })) return n;
}
function f2(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function h2(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Wt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && h2(e) && t && e.select();
  }
}
var Cl = g2();
function g2() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Sl(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Sl(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Sl(e, t) {
  const n = [...e], a = n.indexOf(t);
  return a !== -1 && n.splice(a, 1), n;
}
function b2(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Wo = "rovingFocusGroup.onEntryFocus", v2 = { bubbles: !1, cancelable: !0 }, mo = "RovingFocusGroup", [fi, pd, y2] = rs(mo), [$2, fo] = Ve(
  mo,
  [y2]
), [x2, w2] = $2(mo), md = d.forwardRef(
  (e, t) => /* @__PURE__ */ l.jsx(fi.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(fi.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l.jsx(C2, { ...e, ref: t }) }) })
);
md.displayName = mo;
var C2 = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: a,
    loop: r = !1,
    dir: o,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: u,
    preventScrollOnEntryFocus: p = !1,
    ...m
  } = e, f = d.useRef(null), h = ue(t, f), v = Ya(o), [g = null, y] = lt({
    prop: i,
    defaultProp: s,
    onChange: c
  }), [b, $] = d.useState(!1), x = _e(u), w = pd(n), S = d.useRef(!1), [P, C] = d.useState(0);
  return d.useEffect(() => {
    const T = f.current;
    if (T)
      return T.addEventListener(Wo, x), () => T.removeEventListener(Wo, x);
  }, [x]), /* @__PURE__ */ l.jsx(
    x2,
    {
      scope: n,
      orientation: a,
      dir: v,
      loop: r,
      currentTabStopId: g,
      onItemFocus: d.useCallback(
        (T) => y(T),
        [y]
      ),
      onItemShiftTab: d.useCallback(() => $(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => C((T) => T + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => C((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ l.jsx(
        ee.div,
        {
          tabIndex: b || P === 0 ? -1 : 0,
          "data-orientation": a,
          ...m,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: G(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: G(e.onFocus, (T) => {
            const A = !S.current;
            if (T.target === T.currentTarget && A && !b) {
              const L = new CustomEvent(Wo, v2);
              if (T.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const V = w().filter((W) => W.focusable), M = V.find((W) => W.active), _ = V.find((W) => W.id === g), Q = [M, _, ...V].filter(
                  Boolean
                ).map((W) => W.ref.current);
                gd(Q, p);
              }
            }
            S.current = !1;
          }),
          onBlur: G(e.onBlur, () => $(!1))
        }
      )
    }
  );
}), fd = "RovingFocusGroupItem", hd = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: a = !0,
      active: r = !1,
      tabStopId: o,
      ...i
    } = e, s = ke(), c = o || s, u = w2(fd, n), p = u.currentTabStopId === c, m = pd(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = u;
    return d.useEffect(() => {
      if (a)
        return f(), () => h();
    }, [a, f, h]), /* @__PURE__ */ l.jsx(
      fi.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: a,
        active: r,
        children: /* @__PURE__ */ l.jsx(
          ee.span,
          {
            tabIndex: p ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: t,
            onMouseDown: G(e.onMouseDown, (v) => {
              a ? u.onItemFocus(c) : v.preventDefault();
            }),
            onFocus: G(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: G(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const g = R2(v, u.orientation, u.dir);
              if (g !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let b = m().filter(($) => $.focusable).map(($) => $.ref.current);
                if (g === "last") b.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && b.reverse();
                  const $ = b.indexOf(v.currentTarget);
                  b = u.loop ? N2(b, $ + 1) : b.slice($ + 1);
                }
                setTimeout(() => gd(b));
              }
            })
          }
        )
      }
    );
  }
);
hd.displayName = fd;
var S2 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function E2(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function R2(e, t, n) {
  const a = E2(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(a)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(a)))
    return S2[a];
}
function gd(e, t = !1) {
  const n = document.activeElement;
  for (const a of e)
    if (a === n || (a.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function N2(e, t) {
  return e.map((n, a) => e[(t + a) % e.length]);
}
var bd = md, vd = hd, A2 = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Tn = /* @__PURE__ */ new WeakMap(), hr = /* @__PURE__ */ new WeakMap(), gr = {}, Vo = 0, yd = function(e) {
  return e && (e.host || yd(e.parentNode));
}, P2 = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var a = yd(n);
    return a && e.contains(a) ? a : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, _2 = function(e, t, n, a) {
  var r = P2(t, Array.isArray(e) ? e : [e]);
  gr[n] || (gr[n] = /* @__PURE__ */ new WeakMap());
  var o = gr[n], i = [], s = /* @__PURE__ */ new Set(), c = new Set(r), u = function(m) {
    !m || s.has(m) || (s.add(m), u(m.parentNode));
  };
  r.forEach(u);
  var p = function(m) {
    !m || c.has(m) || Array.prototype.forEach.call(m.children, function(f) {
      if (s.has(f))
        p(f);
      else
        try {
          var h = f.getAttribute(a), v = h !== null && h !== "false", g = (Tn.get(f) || 0) + 1, y = (o.get(f) || 0) + 1;
          Tn.set(f, g), o.set(f, y), i.push(f), g === 1 && v && hr.set(f, !0), y === 1 && f.setAttribute(n, "true"), v || f.setAttribute(a, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return p(t), s.clear(), Vo++, function() {
    i.forEach(function(m) {
      var f = Tn.get(m) - 1, h = o.get(m) - 1;
      Tn.set(m, f), o.set(m, h), f || (hr.has(m) || m.removeAttribute(a), hr.delete(m)), h || m.removeAttribute(n);
    }), Vo--, Vo || (Tn = /* @__PURE__ */ new WeakMap(), Tn = /* @__PURE__ */ new WeakMap(), hr = /* @__PURE__ */ new WeakMap(), gr = {});
  };
}, ho = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var a = Array.from(Array.isArray(e) ? e : [e]), r = A2(e);
  return r ? (a.push.apply(a, Array.from(r.querySelectorAll("[aria-live]"))), _2(a, r, n, "aria-hidden")) : function() {
    return null;
  };
}, yt = function() {
  return yt = Object.assign || function(t) {
    for (var n, a = 1, r = arguments.length; a < r; a++) {
      n = arguments[a];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, yt.apply(this, arguments);
};
function $d(e, t) {
  var n = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)
      t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
  return n;
}
function T2(e, t, n) {
  if (n || arguments.length === 2) for (var a = 0, r = t.length, o; a < r; a++)
    (o || !(a in t)) && (o || (o = Array.prototype.slice.call(t, 0, a)), o[a] = t[a]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var wr = "right-scroll-bar-position", Cr = "width-before-scroll-bar", k2 = "with-scroll-bars-hidden", O2 = "--removed-body-scroll-bar-size";
function zo(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function j2(e, t) {
  var n = He(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(a) {
          var r = n.value;
          r !== a && (n.value = a, n.callback(a, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var M2 = typeof window < "u" ? d.useLayoutEffect : d.useEffect, El = /* @__PURE__ */ new WeakMap();
function I2(e, t) {
  var n = j2(null, function(a) {
    return e.forEach(function(r) {
      return zo(r, a);
    });
  });
  return M2(function() {
    var a = El.get(n);
    if (a) {
      var r = new Set(a), o = new Set(e), i = n.current;
      r.forEach(function(s) {
        o.has(s) || zo(s, null);
      }), o.forEach(function(s) {
        r.has(s) || zo(s, i);
      });
    }
    El.set(n, e);
  }, [e]), n;
}
function D2(e) {
  return e;
}
function L2(e, t) {
  t === void 0 && (t = D2);
  var n = [], a = !1, r = {
    read: function() {
      if (a)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var i = t(o, a);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (a = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      a = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), i = n;
      }
      var c = function() {
        var p = i;
        i = [], p.forEach(o);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), n = {
        push: function(p) {
          i.push(p), u();
        },
        filter: function(p) {
          return i = i.filter(p), n;
        }
      };
    }
  };
  return r;
}
function F2(e) {
  e === void 0 && (e = {});
  var t = L2(null);
  return t.options = yt({ async: !0, ssr: !1 }, e), t;
}
var xd = function(e) {
  var t = e.sideCar, n = $d(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var a = t.read();
  if (!a)
    throw new Error("Sidecar medium not found");
  return d.createElement(a, yt({}, n));
};
xd.isSideCarExport = !0;
function B2(e, t) {
  return e.useMedium(t), xd;
}
var wd = F2(), Ko = function() {
}, go = d.forwardRef(function(e, t) {
  var n = d.useRef(null), a = d.useState({
    onScrollCapture: Ko,
    onWheelCapture: Ko,
    onTouchMoveCapture: Ko
  }), r = a[0], o = a[1], i = e.forwardProps, s = e.children, c = e.className, u = e.removeScrollBar, p = e.enabled, m = e.shards, f = e.sideCar, h = e.noIsolation, v = e.inert, g = e.allowPinchZoom, y = e.as, b = y === void 0 ? "div" : y, $ = e.gapMode, x = $d(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = f, S = I2([n, t]), P = yt(yt({}, x), r);
  return d.createElement(
    d.Fragment,
    null,
    p && d.createElement(w, { sideCar: wd, removeScrollBar: u, shards: m, noIsolation: h, inert: v, setCallbacks: o, allowPinchZoom: !!g, lockRef: n, gapMode: $ }),
    i ? d.cloneElement(d.Children.only(s), yt(yt({}, P), { ref: S })) : d.createElement(b, yt({}, P, { className: c, ref: S }), s)
  );
});
go.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
go.classNames = {
  fullWidth: Cr,
  zeroRight: wr
};
var U2 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function G2() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = U2();
  return t && e.setAttribute("nonce", t), e;
}
function H2(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function W2(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var V2 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = G2()) && (H2(t, n), W2(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, z2 = function() {
  var e = V2();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Cd = function() {
  var e = z2(), t = function(n) {
    var a = n.styles, r = n.dynamic;
    return e(a, r), null;
  };
  return t;
}, K2 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Zo = function(e) {
  return parseInt(e || "", 10) || 0;
}, Z2 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], a = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Zo(n), Zo(a), Zo(r)];
}, Y2 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return K2;
  var t = Z2(e), n = document.documentElement.clientWidth, a = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, a - n + t[2] - t[0])
  };
}, X2 = Cd(), Gn = "data-scroll-locked", q2 = function(e, t, n, a) {
  var r = e.left, o = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(k2, ` {
   overflow: hidden `).concat(a, `;
   padding-right: `).concat(s, "px ").concat(a, `;
  }
  body[`).concat(Gn, `] {
    overflow: hidden `).concat(a, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(a, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(a, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(a, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(wr, ` {
    right: `).concat(s, "px ").concat(a, `;
  }
  
  .`).concat(Cr, ` {
    margin-right: `).concat(s, "px ").concat(a, `;
  }
  
  .`).concat(wr, " .").concat(wr, ` {
    right: 0 `).concat(a, `;
  }
  
  .`).concat(Cr, " .").concat(Cr, ` {
    margin-right: 0 `).concat(a, `;
  }
  
  body[`).concat(Gn, `] {
    `).concat(O2, ": ").concat(s, `px;
  }
`);
}, Rl = function() {
  var e = parseInt(document.body.getAttribute(Gn) || "0", 10);
  return isFinite(e) ? e : 0;
}, J2 = function() {
  d.useEffect(function() {
    return document.body.setAttribute(Gn, (Rl() + 1).toString()), function() {
      var e = Rl() - 1;
      e <= 0 ? document.body.removeAttribute(Gn) : document.body.setAttribute(Gn, e.toString());
    };
  }, []);
}, Q2 = function(e) {
  var t = e.noRelative, n = e.noImportant, a = e.gapMode, r = a === void 0 ? "margin" : a;
  J2();
  var o = d.useMemo(function() {
    return Y2(r);
  }, [r]);
  return d.createElement(X2, { styles: q2(o, !t, r, n ? "" : "!important") });
}, hi = !1;
if (typeof window < "u")
  try {
    var br = Object.defineProperty({}, "passive", {
      get: function() {
        return hi = !0, !0;
      }
    });
    window.addEventListener("test", br, br), window.removeEventListener("test", br, br);
  } catch {
    hi = !1;
  }
var kn = hi ? { passive: !1 } : !1, e1 = function(e) {
  return e.tagName === "TEXTAREA";
}, Sd = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !e1(e) && n[t] === "visible")
  );
}, t1 = function(e) {
  return Sd(e, "overflowY");
}, n1 = function(e) {
  return Sd(e, "overflowX");
}, Nl = function(e, t) {
  var n = t.ownerDocument, a = t;
  do {
    typeof ShadowRoot < "u" && a instanceof ShadowRoot && (a = a.host);
    var r = Ed(e, a);
    if (r) {
      var o = Rd(e, a), i = o[1], s = o[2];
      if (i > s)
        return !0;
    }
    a = a.parentNode;
  } while (a && a !== n.body);
  return !1;
}, a1 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, a = e.clientHeight;
  return [
    t,
    n,
    a
  ];
}, r1 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, a = e.clientWidth;
  return [
    t,
    n,
    a
  ];
}, Ed = function(e, t) {
  return e === "v" ? t1(t) : n1(t);
}, Rd = function(e, t) {
  return e === "v" ? a1(t) : r1(t);
}, o1 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, i1 = function(e, t, n, a, r) {
  var o = o1(e, window.getComputedStyle(t).direction), i = o * a, s = n.target, c = t.contains(s), u = !1, p = i > 0, m = 0, f = 0;
  do {
    var h = Rd(e, s), v = h[0], g = h[1], y = h[2], b = g - y - o * v;
    (v || b) && Ed(e, s) && (m += b, f += v), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (p && (Math.abs(m) < 1 || !r) || !p && (Math.abs(f) < 1 || !r)) && (u = !0), u;
}, vr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Al = function(e) {
  return [e.deltaX, e.deltaY];
}, Pl = function(e) {
  return e && "current" in e ? e.current : e;
}, s1 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, l1 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, c1 = 0, On = [];
function d1(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), a = d.useRef(), r = d.useState(c1++)[0], o = d.useState(Cd)[0], i = d.useRef(e);
  d.useEffect(function() {
    i.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var g = T2([e.lockRef.current], (e.shards || []).map(Pl), !0).filter(Boolean);
      return g.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), g.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = d.useCallback(function(g, y) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = vr(g), $ = n.current, x = "deltaX" in g ? g.deltaX : $[0] - b[0], w = "deltaY" in g ? g.deltaY : $[1] - b[1], S, P = g.target, C = Math.abs(x) > Math.abs(w) ? "h" : "v";
    if ("touches" in g && C === "h" && P.type === "range")
      return !1;
    var T = Nl(C, P);
    if (!T)
      return !0;
    if (T ? S = C : (S = C === "v" ? "h" : "v", T = Nl(C, P)), !T)
      return !1;
    if (!a.current && "changedTouches" in g && (x || w) && (a.current = S), !S)
      return !0;
    var A = a.current || S;
    return i1(A, y, g, A === "h" ? x : w, !0);
  }, []), c = d.useCallback(function(g) {
    var y = g;
    if (!(!On.length || On[On.length - 1] !== o)) {
      var b = "deltaY" in y ? Al(y) : vr(y), $ = t.current.filter(function(S) {
        return S.name === y.type && (S.target === y.target || y.target === S.shadowParent) && s1(S.delta, b);
      })[0];
      if ($ && $.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!$) {
        var x = (i.current.shards || []).map(Pl).filter(Boolean).filter(function(S) {
          return S.contains(y.target);
        }), w = x.length > 0 ? s(y, x[0]) : !i.current.noIsolation;
        w && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = d.useCallback(function(g, y, b, $) {
    var x = { name: g, delta: y, target: b, should: $, shadowParent: u1(b) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== x;
      });
    }, 1);
  }, []), p = d.useCallback(function(g) {
    n.current = vr(g), a.current = void 0;
  }, []), m = d.useCallback(function(g) {
    u(g.type, Al(g), g.target, s(g, e.lockRef.current));
  }, []), f = d.useCallback(function(g) {
    u(g.type, vr(g), g.target, s(g, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return On.push(o), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, kn), document.addEventListener("touchmove", c, kn), document.addEventListener("touchstart", p, kn), function() {
      On = On.filter(function(g) {
        return g !== o;
      }), document.removeEventListener("wheel", c, kn), document.removeEventListener("touchmove", c, kn), document.removeEventListener("touchstart", p, kn);
    };
  }, []);
  var h = e.removeScrollBar, v = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    v ? d.createElement(o, { styles: l1(r) }) : null,
    h ? d.createElement(Q2, { gapMode: e.gapMode }) : null
  );
}
function u1(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const p1 = B2(wd, d1);
var qa = d.forwardRef(function(e, t) {
  return d.createElement(go, yt({}, e, { ref: t, sideCar: p1 }));
});
qa.classNames = go.classNames;
var gi = ["Enter", " "], m1 = ["ArrowDown", "PageUp", "Home"], Nd = ["ArrowUp", "PageDown", "End"], f1 = [...m1, ...Nd], h1 = {
  ltr: [...gi, "ArrowRight"],
  rtl: [...gi, "ArrowLeft"]
}, g1 = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Ja = "Menu", [Ra, b1, v1] = rs(Ja), [Nn, Ad] = Ve(Ja, [
  v1,
  an,
  fo
]), Qa = an(), Pd = fo(), [_d, rn] = Nn(Ja), [y1, er] = Nn(Ja), Td = (e) => {
  const { __scopeMenu: t, open: n = !1, children: a, dir: r, onOpenChange: o, modal: i = !0 } = e, s = Qa(t), [c, u] = d.useState(null), p = d.useRef(!1), m = _e(o), f = Ya(r);
  return d.useEffect(() => {
    const h = () => {
      p.current = !0, document.addEventListener("pointerdown", v, { capture: !0, once: !0 }), document.addEventListener("pointermove", v, { capture: !0, once: !0 });
    }, v = () => p.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", v, { capture: !0 }), document.removeEventListener("pointermove", v, { capture: !0 });
    };
  }, []), /* @__PURE__ */ l.jsx(Ka, { ...s, children: /* @__PURE__ */ l.jsx(
    _d,
    {
      scope: t,
      open: n,
      onOpenChange: m,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ l.jsx(
        y1,
        {
          scope: t,
          onClose: d.useCallback(() => m(!1), [m]),
          isUsingKeyboardRef: p,
          dir: f,
          modal: i,
          children: a
        }
      )
    }
  ) });
};
Td.displayName = Ja;
var $1 = "MenuAnchor", os = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...a } = e, r = Qa(n);
    return /* @__PURE__ */ l.jsx(Za, { ...r, ...a, ref: t });
  }
);
os.displayName = $1;
var is = "MenuPortal", [x1, kd] = Nn(is, {
  forceMount: void 0
}), Od = (e) => {
  const { __scopeMenu: t, forceMount: n, children: a, container: r } = e, o = rn(is, t);
  return /* @__PURE__ */ l.jsx(x1, { scope: t, forceMount: n, children: /* @__PURE__ */ l.jsx(De, { present: n || o.open, children: /* @__PURE__ */ l.jsx(es, { asChild: !0, container: r, children: a }) }) });
};
Od.displayName = is;
var Qe = "MenuContent", [w1, ss] = Nn(Qe), jd = d.forwardRef(
  (e, t) => {
    const n = kd(Qe, e.__scopeMenu), { forceMount: a = n.forceMount, ...r } = e, o = rn(Qe, e.__scopeMenu), i = er(Qe, e.__scopeMenu);
    return /* @__PURE__ */ l.jsx(Ra.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ l.jsx(De, { present: a || o.open, children: /* @__PURE__ */ l.jsx(Ra.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ l.jsx(C1, { ...r, ref: t }) : /* @__PURE__ */ l.jsx(S1, { ...r, ref: t }) }) }) });
  }
), C1 = d.forwardRef(
  (e, t) => {
    const n = rn(Qe, e.__scopeMenu), a = d.useRef(null), r = ue(t, a);
    return d.useEffect(() => {
      const o = a.current;
      if (o) return ho(o);
    }, []), /* @__PURE__ */ l.jsx(
      ls,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: G(
          e.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), S1 = d.forwardRef((e, t) => {
  const n = rn(Qe, e.__scopeMenu);
  return /* @__PURE__ */ l.jsx(
    ls,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), E1 = /* @__PURE__ */ zt("MenuContent.ScrollLock"), ls = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: a = !1,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: c,
      onEscapeKeyDown: u,
      onPointerDownOutside: p,
      onFocusOutside: m,
      onInteractOutside: f,
      onDismiss: h,
      disableOutsideScroll: v,
      ...g
    } = e, y = rn(Qe, n), b = er(Qe, n), $ = Qa(n), x = Pd(n), w = b1(n), [S, P] = d.useState(null), C = d.useRef(null), T = ue(t, C, y.onContentChange), A = d.useRef(0), L = d.useRef(""), V = d.useRef(0), M = d.useRef(null), _ = d.useRef("right"), K = d.useRef(0), Q = v ? qa : d.Fragment, W = v ? { as: E1, allowPinchZoom: !0 } : void 0, q = (j) => {
      var I, Y;
      const N = L.current + j, F = w().filter((te) => !te.disabled), E = document.activeElement, B = (I = F.find((te) => te.ref.current === E)) == null ? void 0 : I.textValue, X = F.map((te) => te.textValue), U = D1(X, N, B), ne = (Y = F.find((te) => te.textValue === U)) == null ? void 0 : Y.ref.current;
      (function te(le) {
        L.current = le, window.clearTimeout(A.current), le !== "" && (A.current = window.setTimeout(() => te(""), 1e3));
      })(N), ne && setTimeout(() => ne.focus());
    };
    d.useEffect(() => () => window.clearTimeout(A.current), []), po();
    const z = d.useCallback((j) => {
      var F, E;
      return _.current === ((F = M.current) == null ? void 0 : F.side) && F1(j, (E = M.current) == null ? void 0 : E.area);
    }, []);
    return /* @__PURE__ */ l.jsx(
      w1,
      {
        scope: n,
        searchRef: L,
        onItemEnter: d.useCallback(
          (j) => {
            z(j) && j.preventDefault();
          },
          [z]
        ),
        onItemLeave: d.useCallback(
          (j) => {
            var N;
            z(j) || ((N = C.current) == null || N.focus(), P(null));
          },
          [z]
        ),
        onTriggerLeave: d.useCallback(
          (j) => {
            z(j) && j.preventDefault();
          },
          [z]
        ),
        pointerGraceTimerRef: V,
        onPointerGraceIntentChange: d.useCallback((j) => {
          M.current = j;
        }, []),
        children: /* @__PURE__ */ l.jsx(Q, { ...W, children: /* @__PURE__ */ l.jsx(
          Xa,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: G(o, (j) => {
              var N;
              j.preventDefault(), (N = C.current) == null || N.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ l.jsx(
              aa,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: u,
                onPointerDownOutside: p,
                onFocusOutside: m,
                onInteractOutside: f,
                onDismiss: h,
                children: /* @__PURE__ */ l.jsx(
                  bd,
                  {
                    asChild: !0,
                    ...x,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: a,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: P,
                    onEntryFocus: G(c, (j) => {
                      b.isUsingKeyboardRef.current || j.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ l.jsx(
                      oo,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": qd(y.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...$,
                        ...g,
                        ref: T,
                        style: { outline: "none", ...g.style },
                        onKeyDown: G(g.onKeyDown, (j) => {
                          const F = j.target.closest("[data-radix-menu-content]") === j.currentTarget, E = j.ctrlKey || j.altKey || j.metaKey, B = j.key.length === 1;
                          F && (j.key === "Tab" && j.preventDefault(), !E && B && q(j.key));
                          const X = C.current;
                          if (j.target !== X || !f1.includes(j.key)) return;
                          j.preventDefault();
                          const ne = w().filter((I) => !I.disabled).map((I) => I.ref.current);
                          Nd.includes(j.key) && ne.reverse(), M1(ne);
                        }),
                        onBlur: G(e.onBlur, (j) => {
                          j.currentTarget.contains(j.target) || (window.clearTimeout(A.current), L.current = "");
                        }),
                        onPointerMove: G(
                          e.onPointerMove,
                          Na((j) => {
                            const N = j.target, F = K.current !== j.clientX;
                            if (j.currentTarget.contains(N) && F) {
                              const E = j.clientX > K.current ? "right" : "left";
                              _.current = E, K.current = j.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
jd.displayName = Qe;
var R1 = "MenuGroup", cs = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...a } = e;
    return /* @__PURE__ */ l.jsx(ee.div, { role: "group", ...a, ref: t });
  }
);
cs.displayName = R1;
var N1 = "MenuLabel", Md = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...a } = e;
    return /* @__PURE__ */ l.jsx(ee.div, { ...a, ref: t });
  }
);
Md.displayName = N1;
var Pr = "MenuItem", _l = "menu.itemSelect", bo = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: a, ...r } = e, o = d.useRef(null), i = er(Pr, e.__scopeMenu), s = ss(Pr, e.__scopeMenu), c = ue(t, o), u = d.useRef(!1), p = () => {
      const m = o.current;
      if (!n && m) {
        const f = new CustomEvent(_l, { bubbles: !0, cancelable: !0 });
        m.addEventListener(_l, (h) => a == null ? void 0 : a(h), { once: !0 }), Nc(m, f), f.defaultPrevented ? u.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ l.jsx(
      Id,
      {
        ...r,
        ref: c,
        disabled: n,
        onClick: G(e.onClick, p),
        onPointerDown: (m) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, m), u.current = !0;
        },
        onPointerUp: G(e.onPointerUp, (m) => {
          var f;
          u.current || (f = m.currentTarget) == null || f.click();
        }),
        onKeyDown: G(e.onKeyDown, (m) => {
          const f = s.searchRef.current !== "";
          n || f && m.key === " " || gi.includes(m.key) && (m.currentTarget.click(), m.preventDefault());
        })
      }
    );
  }
);
bo.displayName = Pr;
var Id = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: a = !1, textValue: r, ...o } = e, i = ss(Pr, n), s = Pd(n), c = d.useRef(null), u = ue(t, c), [p, m] = d.useState(!1), [f, h] = d.useState("");
    return d.useEffect(() => {
      const v = c.current;
      v && h((v.textContent ?? "").trim());
    }, [o.children]), /* @__PURE__ */ l.jsx(
      Ra.ItemSlot,
      {
        scope: n,
        disabled: a,
        textValue: r ?? f,
        children: /* @__PURE__ */ l.jsx(vd, { asChild: !0, ...s, focusable: !a, children: /* @__PURE__ */ l.jsx(
          ee.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": a || void 0,
            "data-disabled": a ? "" : void 0,
            ...o,
            ref: u,
            onPointerMove: G(
              e.onPointerMove,
              Na((v) => {
                a ? i.onItemLeave(v) : (i.onItemEnter(v), v.defaultPrevented || v.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: G(
              e.onPointerLeave,
              Na((v) => i.onItemLeave(v))
            ),
            onFocus: G(e.onFocus, () => m(!0)),
            onBlur: G(e.onBlur, () => m(!1))
          }
        ) })
      }
    );
  }
), A1 = "MenuCheckboxItem", Dd = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: a, ...r } = e;
    return /* @__PURE__ */ l.jsx(Gd, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ l.jsx(
      bo,
      {
        role: "menuitemcheckbox",
        "aria-checked": _r(n) ? "mixed" : n,
        ...r,
        ref: t,
        "data-state": ps(n),
        onSelect: G(
          r.onSelect,
          () => a == null ? void 0 : a(_r(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Dd.displayName = A1;
var Ld = "MenuRadioGroup", [P1, _1] = Nn(
  Ld,
  { value: void 0, onValueChange: () => {
  } }
), Fd = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: a, ...r } = e, o = _e(a);
    return /* @__PURE__ */ l.jsx(P1, { scope: e.__scopeMenu, value: n, onValueChange: o, children: /* @__PURE__ */ l.jsx(cs, { ...r, ref: t }) });
  }
);
Fd.displayName = Ld;
var Bd = "MenuRadioItem", Ud = d.forwardRef(
  (e, t) => {
    const { value: n, ...a } = e, r = _1(Bd, e.__scopeMenu), o = n === r.value;
    return /* @__PURE__ */ l.jsx(Gd, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ l.jsx(
      bo,
      {
        role: "menuitemradio",
        "aria-checked": o,
        ...a,
        ref: t,
        "data-state": ps(o),
        onSelect: G(
          a.onSelect,
          () => {
            var i;
            return (i = r.onValueChange) == null ? void 0 : i.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ud.displayName = Bd;
var ds = "MenuItemIndicator", [Gd, T1] = Nn(
  ds,
  { checked: !1 }
), Hd = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: a, ...r } = e, o = T1(ds, n);
    return /* @__PURE__ */ l.jsx(
      De,
      {
        present: a || _r(o.checked) || o.checked === !0,
        children: /* @__PURE__ */ l.jsx(
          ee.span,
          {
            ...r,
            ref: t,
            "data-state": ps(o.checked)
          }
        )
      }
    );
  }
);
Hd.displayName = ds;
var k1 = "MenuSeparator", Wd = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...a } = e;
    return /* @__PURE__ */ l.jsx(
      ee.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...a,
        ref: t
      }
    );
  }
);
Wd.displayName = k1;
var O1 = "MenuArrow", Vd = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...a } = e, r = Qa(n);
    return /* @__PURE__ */ l.jsx(io, { ...r, ...a, ref: t });
  }
);
Vd.displayName = O1;
var us = "MenuSub", [j1, zd] = Nn(us), Kd = (e) => {
  const { __scopeMenu: t, children: n, open: a = !1, onOpenChange: r } = e, o = rn(us, t), i = Qa(t), [s, c] = d.useState(null), [u, p] = d.useState(null), m = _e(r);
  return d.useEffect(() => (o.open === !1 && m(!1), () => m(!1)), [o.open, m]), /* @__PURE__ */ l.jsx(Ka, { ...i, children: /* @__PURE__ */ l.jsx(
    _d,
    {
      scope: t,
      open: a,
      onOpenChange: m,
      content: u,
      onContentChange: p,
      children: /* @__PURE__ */ l.jsx(
        j1,
        {
          scope: t,
          contentId: ke(),
          triggerId: ke(),
          trigger: s,
          onTriggerChange: c,
          children: n
        }
      )
    }
  ) });
};
Kd.displayName = us;
var ya = "MenuSubTrigger", Zd = d.forwardRef(
  (e, t) => {
    const n = rn(ya, e.__scopeMenu), a = er(ya, e.__scopeMenu), r = zd(ya, e.__scopeMenu), o = ss(ya, e.__scopeMenu), i = d.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = o, u = { __scopeMenu: e.__scopeMenu }, p = d.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return d.useEffect(() => p, [p]), d.useEffect(() => {
      const m = s.current;
      return () => {
        window.clearTimeout(m), c(null);
      };
    }, [s, c]), /* @__PURE__ */ l.jsx(os, { asChild: !0, ...u, children: /* @__PURE__ */ l.jsx(
      Id,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": qd(n.open),
        ...e,
        ref: jt(t, r.onTriggerChange),
        onClick: (m) => {
          var f;
          (f = e.onClick) == null || f.call(e, m), !(e.disabled || m.defaultPrevented) && (m.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: G(
          e.onPointerMove,
          Na((m) => {
            o.onItemEnter(m), !m.defaultPrevented && !e.disabled && !n.open && !i.current && (o.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: G(
          e.onPointerLeave,
          Na((m) => {
            var h, v;
            p();
            const f = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (f) {
              const g = (v = n.content) == null ? void 0 : v.dataset.side, y = g === "right", b = y ? -5 : 5, $ = f[y ? "left" : "right"], x = f[y ? "right" : "left"];
              o.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: m.clientX + b, y: m.clientY },
                  { x: $, y: f.top },
                  { x, y: f.top },
                  { x, y: f.bottom },
                  { x: $, y: f.bottom }
                ],
                side: g
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => o.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (o.onTriggerLeave(m), m.defaultPrevented) return;
              o.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: G(e.onKeyDown, (m) => {
          var h;
          const f = o.searchRef.current !== "";
          e.disabled || f && m.key === " " || h1[a.dir].includes(m.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), m.preventDefault());
        })
      }
    ) });
  }
);
Zd.displayName = ya;
var Yd = "MenuSubContent", Xd = d.forwardRef(
  (e, t) => {
    const n = kd(Qe, e.__scopeMenu), { forceMount: a = n.forceMount, ...r } = e, o = rn(Qe, e.__scopeMenu), i = er(Qe, e.__scopeMenu), s = zd(Yd, e.__scopeMenu), c = d.useRef(null), u = ue(t, c);
    return /* @__PURE__ */ l.jsx(Ra.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ l.jsx(De, { present: a || o.open, children: /* @__PURE__ */ l.jsx(Ra.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ l.jsx(
      ls,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...r,
        ref: u,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (p) => {
          var m;
          i.isUsingKeyboardRef.current && ((m = c.current) == null || m.focus()), p.preventDefault();
        },
        onCloseAutoFocus: (p) => p.preventDefault(),
        onFocusOutside: G(e.onFocusOutside, (p) => {
          p.target !== s.trigger && o.onOpenChange(!1);
        }),
        onEscapeKeyDown: G(e.onEscapeKeyDown, (p) => {
          i.onClose(), p.preventDefault();
        }),
        onKeyDown: G(e.onKeyDown, (p) => {
          var h;
          const m = p.currentTarget.contains(p.target), f = g1[i.dir].includes(p.key);
          m && f && (o.onOpenChange(!1), (h = s.trigger) == null || h.focus(), p.preventDefault());
        })
      }
    ) }) }) });
  }
);
Xd.displayName = Yd;
function qd(e) {
  return e ? "open" : "closed";
}
function _r(e) {
  return e === "indeterminate";
}
function ps(e) {
  return _r(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function M1(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function I1(e, t) {
  return e.map((n, a) => e[(t + a) % e.length]);
}
function D1(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let i = I1(e, Math.max(o, 0));
  r.length === 1 && (i = i.filter((u) => u !== n));
  const c = i.find(
    (u) => u.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function L1(e, t) {
  const { x: n, y: a } = e;
  let r = !1;
  for (let o = 0, i = t.length - 1; o < t.length; i = o++) {
    const s = t[o].x, c = t[o].y, u = t[i].x, p = t[i].y;
    c > a != p > a && n < (u - s) * (a - c) / (p - c) + s && (r = !r);
  }
  return r;
}
function F1(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return L1(n, t);
}
function Na(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var B1 = Td, U1 = os, G1 = Od, H1 = jd, W1 = cs, V1 = Md, z1 = bo, K1 = Dd, Z1 = Fd, Y1 = Ud, X1 = Hd, q1 = Wd, J1 = Vd, Q1 = Kd, eb = Zd, tb = Xd, ms = "DropdownMenu", [nb, $C] = Ve(
  ms,
  [Ad]
), Le = Ad(), [ab, Jd] = nb(ms), Qd = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: a,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, c = Le(t), u = d.useRef(null), [p = !1, m] = lt({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ l.jsx(
    ab,
    {
      scope: t,
      triggerId: ke(),
      triggerRef: u,
      contentId: ke(),
      open: p,
      onOpenChange: m,
      onOpenToggle: d.useCallback(() => m((f) => !f), [m]),
      modal: s,
      children: /* @__PURE__ */ l.jsx(B1, { ...c, open: p, onOpenChange: m, dir: a, modal: s, children: n })
    }
  );
};
Qd.displayName = ms;
var eu = "DropdownMenuTrigger", tu = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: a = !1, ...r } = e, o = Jd(eu, n), i = Le(n);
    return /* @__PURE__ */ l.jsx(U1, { asChild: !0, ...i, children: /* @__PURE__ */ l.jsx(
      ee.button,
      {
        type: "button",
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": o.open ? "open" : "closed",
        "data-disabled": a ? "" : void 0,
        disabled: a,
        ...r,
        ref: jt(t, o.triggerRef),
        onPointerDown: G(e.onPointerDown, (s) => {
          !a && s.button === 0 && s.ctrlKey === !1 && (o.onOpenToggle(), o.open || s.preventDefault());
        }),
        onKeyDown: G(e.onKeyDown, (s) => {
          a || (["Enter", " "].includes(s.key) && o.onOpenToggle(), s.key === "ArrowDown" && o.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
tu.displayName = eu;
var rb = "DropdownMenuPortal", nu = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, a = Le(t);
  return /* @__PURE__ */ l.jsx(G1, { ...a, ...n });
};
nu.displayName = rb;
var au = "DropdownMenuContent", ru = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...a } = e, r = Jd(au, n), o = Le(n), i = d.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      H1,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...o,
        ...a,
        ref: t,
        onCloseAutoFocus: G(e.onCloseAutoFocus, (s) => {
          var c;
          i.current || (c = r.triggerRef.current) == null || c.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: G(e.onInteractOutside, (s) => {
          const c = s.detail.originalEvent, u = c.button === 0 && c.ctrlKey === !0, p = c.button === 2 || u;
          (!r.modal || p) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
ru.displayName = au;
var ob = "DropdownMenuGroup", ou = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
    return /* @__PURE__ */ l.jsx(W1, { ...r, ...a, ref: t });
  }
);
ou.displayName = ob;
var ib = "DropdownMenuLabel", iu = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
    return /* @__PURE__ */ l.jsx(V1, { ...r, ...a, ref: t });
  }
);
iu.displayName = ib;
var sb = "DropdownMenuItem", su = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
    return /* @__PURE__ */ l.jsx(z1, { ...r, ...a, ref: t });
  }
);
su.displayName = sb;
var lb = "DropdownMenuCheckboxItem", lu = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
  return /* @__PURE__ */ l.jsx(K1, { ...r, ...a, ref: t });
});
lu.displayName = lb;
var cb = "DropdownMenuRadioGroup", db = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
  return /* @__PURE__ */ l.jsx(Z1, { ...r, ...a, ref: t });
});
db.displayName = cb;
var ub = "DropdownMenuRadioItem", cu = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
  return /* @__PURE__ */ l.jsx(Y1, { ...r, ...a, ref: t });
});
cu.displayName = ub;
var pb = "DropdownMenuItemIndicator", du = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
  return /* @__PURE__ */ l.jsx(X1, { ...r, ...a, ref: t });
});
du.displayName = pb;
var mb = "DropdownMenuSeparator", uu = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
  return /* @__PURE__ */ l.jsx(q1, { ...r, ...a, ref: t });
});
uu.displayName = mb;
var fb = "DropdownMenuArrow", hb = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
    return /* @__PURE__ */ l.jsx(J1, { ...r, ...a, ref: t });
  }
);
hb.displayName = fb;
var gb = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: a, onOpenChange: r, defaultOpen: o } = e, i = Le(t), [s = !1, c] = lt({
    prop: a,
    defaultProp: o,
    onChange: r
  });
  return /* @__PURE__ */ l.jsx(Q1, { ...i, open: s, onOpenChange: c, children: n });
}, bb = "DropdownMenuSubTrigger", pu = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
  return /* @__PURE__ */ l.jsx(eb, { ...r, ...a, ref: t });
});
pu.displayName = bb;
var vb = "DropdownMenuSubContent", mu = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...a } = e, r = Le(n);
  return /* @__PURE__ */ l.jsx(
    tb,
    {
      ...r,
      ...a,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
mu.displayName = vb;
var yb = Qd, $b = tu, xb = nu, fu = ru, wb = ou, hu = iu, gu = su, bu = lu, vu = cu, yu = du, $u = uu, Cb = gb, xu = pu, wu = mu;
const fs = yb, hs = $b, xC = wb, wC = xb, CC = Cb, Sb = d.forwardRef(({ className: e, inset: t, children: n, ...a }, r) => /* @__PURE__ */ l.jsxs(
  xu,
  {
    ref: r,
    className: R(
      "flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...a,
    children: [
      n,
      /* @__PURE__ */ l.jsx(gg, { className: "ml-auto" })
    ]
  }
));
Sb.displayName = xu.displayName;
const Eb = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  wu,
  {
    ref: n,
    className: R(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
Eb.displayName = wu.displayName;
const vo = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, a) => /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
  fu,
  {
    ref: a,
    sideOffset: t,
    className: R(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
vo.displayName = fu.displayName;
const yo = d.forwardRef(({ className: e, inset: t, ...n }, a) => /* @__PURE__ */ l.jsx(
  gu,
  {
    ref: a,
    className: R(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...n
  }
));
yo.displayName = gu.displayName;
const Rb = d.forwardRef(({ className: e, children: t, checked: n, ...a }, r) => /* @__PURE__ */ l.jsxs(
  bu,
  {
    ref: r,
    className: R(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...a,
    children: [
      /* @__PURE__ */ l.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ l.jsx(yu, { children: /* @__PURE__ */ l.jsx(to, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
Rb.displayName = bu.displayName;
const Nb = d.forwardRef(({ className: e, children: t, ...n }, a) => /* @__PURE__ */ l.jsxs(
  vu,
  {
    ref: a,
    className: R(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ l.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ l.jsx(yu, { children: /* @__PURE__ */ l.jsx(Sg, { className: "h-4 w-4 fill-current" }) }) }),
      t
    ]
  }
));
Nb.displayName = vu.displayName;
const Ab = d.forwardRef(({ className: e, inset: t, ...n }, a) => /* @__PURE__ */ l.jsx(
  hu,
  {
    ref: a,
    className: R(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
Ab.displayName = hu.displayName;
const Pb = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  $u,
  {
    ref: n,
    className: R("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Pb.displayName = $u.displayName;
var _b = "Label", Cu = d.forwardRef((e, t) => /* @__PURE__ */ l.jsx(
  ee.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var r;
      n.target.closest("button, input, select, textarea") || ((r = e.onMouseDown) == null || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Cu.displayName = _b;
var Su = Cu;
const Tb = Jr(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), $o = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  Su,
  {
    ref: n,
    className: R(Tb(), e),
    ...t
  }
));
$o.displayName = Su.displayName;
const Eu = nn(null), gs = () => {
  const e = et(Eu);
  if (!e) throw new Error("Must be used within <CheckboxDropdown>");
  return e;
};
function kb({
  selectedOption: e,
  setSelectedOption: t,
  isSelected: n,
  onToggle: a,
  onChange: r,
  options: o,
  children: i,
  className: s
}) {
  const c = (u) => {
    var p;
    return ((p = o.find((m) => m.id === u)) == null ? void 0 : p.name) || "";
  };
  return /* @__PURE__ */ l.jsx(
    Eu.Provider,
    {
      value: { selectedOption: e, setSelectedOption: t, isSelected: n, onToggle: a, onChange: r, options: o, getOptionName: c },
      children: /* @__PURE__ */ l.jsx("div", { className: R("flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-lg", s), children: i })
    }
  );
}
function Ob({ label: e, className: t }) {
  const { isSelected: n, onToggle: a } = gs();
  return /* @__PURE__ */ l.jsxs("div", { className: R("flex items-center gap-2", t), children: [
    /* @__PURE__ */ l.jsx(Rn, { id: "donationType", checked: n, onCheckedChange: a }),
    /* @__PURE__ */ l.jsx($o, { htmlFor: "donationType", children: e })
  ] });
}
function jb({ className: e }) {
  const { selectedOption: t, setSelectedOption: n, onChange: a, options: r, getOptionName: o } = gs();
  return /* @__PURE__ */ l.jsxs(fs, { children: [
    /* @__PURE__ */ l.jsx(hs, { asChild: !0, children: /* @__PURE__ */ l.jsxs(Ne, { variant: "link", className: R("p-0 underline flex items-center", e), children: [
      o(t),
      " ",
      /* @__PURE__ */ l.jsx(qr, { className: "ml-1 h-4 w-4" })
    ] }) }),
    /* @__PURE__ */ l.jsx(vo, { children: r.map((i) => /* @__PURE__ */ l.jsx(
      yo,
      {
        onSelect: () => {
          n(i.id), a(i.id);
        },
        children: i.name
      },
      i.id
    )) })
  ] });
}
function Mb({ content: e, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("ml-auto", t), children: /* @__PURE__ */ l.jsx(ld, { children: /* @__PURE__ */ l.jsxs(cd, { children: [
    /* @__PURE__ */ l.jsx(dd, { asChild: !0, children: /* @__PURE__ */ l.jsx(Ne, { variant: "ghost", size: "icon", className: "h-6 w-6 rounded-full border", children: /* @__PURE__ */ l.jsx(sh, { className: "h-4 w-4" }) }) }),
    /* @__PURE__ */ l.jsx(as, { children: /* @__PURE__ */ l.jsx("p", { children: e }) })
  ] }) }) });
}
const SC = {
  Root: kb,
  Dropdown: jb,
  Checkbox: Ob,
  Tooltip: Mb,
  useCheckboxDropdown: gs
}, Ru = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("div", { className: R("flex gap-3 pt-4", t), children: e }), Ib = ({ children: e, className: t, onClick: n }) => /* @__PURE__ */ l.jsx(Ne, { className: t, variant: "outline", onClick: n, children: e }), Db = ({ children: e, className: t, onClick: n }) => /* @__PURE__ */ l.jsx(Ne, { className: R("flex-1", t), onClick: n, children: e });
Ru.Back = Ib;
Ru.Next = Db;
const EC = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: `bg-destructive/15 text-destructive text-sm p-3 rounded-md ${t || ""}`,
    children: e
  }
), Lb = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: `border-t border-orange-100 bg-orange-50 p-4 ${t || ""}`,
    children: e
  }
), Fb = ({ className: e, children: t }) => /* @__PURE__ */ l.jsx("p", { className: `text-sm text-orange-800 ${e || ""}`, children: t });
Lb.Line = Fb;
const Bb = ({
  selected: e,
  onSelect: t,
  children: n,
  className: a,
  ...r
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R(
      "p-4 cursor-pointer",
      e && "bg-gray-100",
      a
    ),
    onClick: t,
    ...r,
    children: /* @__PURE__ */ l.jsx("div", { className: "group flex items-center justify-between gap-3", children: n })
  }
), Ub = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("div", { className: R("flex gap-2", t), children: e }), Gb = ({ children: e }) => /* @__PURE__ */ l.jsx("div", { className: "rounded-lg bg-gray-200 p-0", children: e }), Hb = ({ src: e, alt: t, className: n }) => /* @__PURE__ */ l.jsx(
  "img",
  {
    src: e,
    alt: t,
    className: R("size-10 object-cover rounded opacity-50 group-hover:opacity-100 transition-opacity duration-200", n)
  }
), Wb = ({ children: e }) => /* @__PURE__ */ l.jsx("div", { className: "block sm:hidden", children: e }), RC = Object.assign(Bb, {
  Action: Wb,
  Content: Ub,
  Icon: Gb,
  Image: Hb
});
function NC({ className: e, children: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex flex-1 min-h-svh sm:min-h-0 flex-col bg-background sm:rounded-xl min-w-[360px] overflow-y-auto", e), children: /* @__PURE__ */ l.jsx("div", { className: "flex-1", children: /* @__PURE__ */ l.jsx("div", { className: "flex flex-col h-full", children: t }) }) });
}
const bs = d.forwardRef(
  ({ className: e, type: t, ...n }, a) => /* @__PURE__ */ l.jsx(
    "input",
    {
      type: t,
      className: R(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: a,
      ...n
    }
  )
);
bs.displayName = "Input";
var vs = "Switch", [Vb, AC] = Ve(vs), [zb, Kb] = Vb(vs), Nu = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: a,
      checked: r,
      defaultChecked: o,
      required: i,
      disabled: s,
      value: c = "on",
      onCheckedChange: u,
      form: p,
      ...m
    } = e, [f, h] = d.useState(null), v = ue(t, (x) => h(x)), g = d.useRef(!1), y = f ? p || !!f.closest("form") : !0, [b = !1, $] = lt({
      prop: r,
      defaultProp: o,
      onChange: u
    });
    return /* @__PURE__ */ l.jsxs(zb, { scope: n, checked: b, disabled: s, children: [
      /* @__PURE__ */ l.jsx(
        ee.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": i,
          "data-state": _u(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...m,
          ref: v,
          onClick: G(e.onClick, (x) => {
            $((w) => !w), y && (g.current = x.isPropagationStopped(), g.current || x.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ l.jsx(
        Zb,
        {
          control: f,
          bubbles: !g.current,
          name: a,
          value: c,
          checked: b,
          required: i,
          disabled: s,
          form: p,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Nu.displayName = vs;
var Au = "SwitchThumb", Pu = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...a } = e, r = Kb(Au, n);
    return /* @__PURE__ */ l.jsx(
      ee.span,
      {
        "data-state": _u(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...a,
        ref: t
      }
    );
  }
);
Pu.displayName = Au;
var Zb = (e) => {
  const { control: t, checked: n, bubbles: a = !0, ...r } = e, o = d.useRef(null), i = Qr(n), s = eo(t);
  return d.useEffect(() => {
    const c = o.current, u = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (i !== n && m) {
      const f = new Event("click", { bubbles: a });
      m.call(c, n), c.dispatchEvent(f);
    }
  }, [i, n, a]), /* @__PURE__ */ l.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...r,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function _u(e) {
  return e ? "checked" : "unchecked";
}
var Tu = Nu, Yb = Pu;
const ku = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  Tu,
  {
    className: R(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      e
    ),
    ...t,
    ref: n,
    children: /* @__PURE__ */ l.jsx(
      Yb,
      {
        className: R(
          "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
ku.displayName = Tu.displayName;
const ys = d.createContext({}), on = ({
  children: e,
  className: t,
  searchValue: n,
  onSearchChange: a,
  switchChecked: r,
  onSwitchChange: o
}) => {
  const [i, s] = d.useState(""), [c, u] = d.useState(!1), p = d.useMemo(
    () => ({
      searchValue: n !== void 0 ? n : i,
      setSearchValue: a || s,
      switchChecked: r !== void 0 ? r : c,
      setSwitchChecked: o || u
    }),
    [n, a, i, r, o, c]
  );
  return /* @__PURE__ */ l.jsx(ys.Provider, { value: p, children: /* @__PURE__ */ l.jsx("div", { className: R("sticky top-0 bg-background z-10", t), children: e }) });
};
on.Row = function({ children: t, className: n }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("p-4 border-b flex items-center", n), children: t });
};
on.BackButton = function({ onClick: t, className: n }) {
  return /* @__PURE__ */ l.jsx(Ne, { variant: "ghost", size: "icon", onClick: t, className: n, children: /* @__PURE__ */ l.jsx(oh, { className: "h-4 w-4" }) });
};
on.Title = function({ children: t, className: n }) {
  return /* @__PURE__ */ l.jsx("h2", { className: R("font-medium text-lg ml-2", n), children: t });
};
on.Section = function({ children: t, className: n }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("p-4 border-b", n), children: t });
};
on.SearchContainer = function({ children: t, className: n }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex items-center gap-3 mb-4", n), children: t });
};
on.SearchInput = function({
  placeholder: t,
  value: n,
  onChange: a,
  className: r
}) {
  const o = d.useContext(ys), i = n !== void 0 ? n : o.searchValue || "", s = a || (o.setSearchValue ? (c) => o.setSearchValue(c.target.value) : void 0);
  return /* @__PURE__ */ l.jsxs("div", { className: R("relative flex-1", r), children: [
    /* @__PURE__ */ l.jsx(dh, { className: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" }),
    /* @__PURE__ */ l.jsx(
      bs,
      {
        placeholder: t,
        className: "pl-9",
        value: i,
        onChange: s
      }
    )
  ] });
};
on.ResetButton = function({ onClick: t, className: n }) {
  return /* @__PURE__ */ l.jsx(
    Ne,
    {
      variant: "outline",
      size: "sm",
      className: R("text-xs", n),
      onClick: t,
      children: "Reset"
    }
  );
};
on.Switch = function({
  id: t,
  label: n,
  checked: a,
  onCheckedChange: r,
  className: o
}) {
  const i = d.useContext(ys), s = a !== void 0 ? a : i.switchChecked || !1, c = r || i.setSwitchChecked;
  return /* @__PURE__ */ l.jsxs("div", { className: R("flex items-center space-x-2", o), children: [
    /* @__PURE__ */ l.jsx(ku, { id: t, checked: s, onCheckedChange: c }),
    /* @__PURE__ */ l.jsx($o, { htmlFor: t, className: "text-sm", children: n })
  ] });
};
const Xb = ({ className: e, children: t }) => /* @__PURE__ */ l.jsx("div", { className: R("flex-1 overflow-y-auto h-full", e), children: t }), qb = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("div", { className: R("p-8 text-center text-gray-500", t), children: /* @__PURE__ */ l.jsx("p", { children: e }) }), $s = ({ className: e, children: t }) => /* @__PURE__ */ l.jsx("div", { className: R("divide-y", e), children: t }), Jb = ({ categories: e, renderCategory: t, className: n }) => /* @__PURE__ */ l.jsx($s, { className: n, children: e.map((a) => /* @__PURE__ */ l.jsx(D.Fragment, { children: t(a) }, a.id)) }), Qb = ({ items: e, renderItem: t, className: n }) => /* @__PURE__ */ l.jsx($s, { className: n, children: e.map((a) => /* @__PURE__ */ l.jsx(D.Fragment, { children: t(a) }, a.id)) }), PC = Object.assign({}, {
  Container: Xb,
  EmptyMessage: qb,
  Content: $s,
  CategoryList: Jb,
  ItemList: Qb
});
function e3({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("absolute inset-0 z-50 flex flex-col bg-black/70", t), children: e });
}
const t3 = function({ children: t, className: n }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("sm:mt-48 flex max-w-[920px] min-h-[600px] sm:max-h-[600px] w-full mx-auto", n), children: t });
}, n3 = function({ children: t, className: n }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex h-auto flex-col justify-end sm:flex-row lg:gap-4 w-full", n), children: t });
}, _C = Object.assign(e3, {
  Container: t3,
  Content: n3
}), tr = ({ isVisible: e, children: t, className: n }) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R(
      "hidden sm:flex relative h-full min-w-[360px] min-h-[280px] sm:min-h-[600px] w-full sm:rounded-xl overflow-hidden transition-all ease-in-out duration-500 bg-cover",
      n,
      {
        "hidden opacity-0": !e,
        "bg-background": e
      }
    ),
    children: t
  }
), a3 = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("div", { className: R("p-4 overflow-y-auto text-sm", t), children: e }), r3 = ({ src: e, alt: t, className: n }) => /* @__PURE__ */ l.jsx("img", { src: e, alt: t, className: R("h-auto w-full object-cover rounded", n) }), o3 = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("h3", { className: R("mb-2 font-bold text-lg sm:text-xl mt-2", t), children: e }), i3 = ({ children: e }) => /* @__PURE__ */ l.jsx("p", { className: "text-gray-700 text-xs sm:text-base pb-2", children: e }), s3 = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
tr.Image = r3;
tr.Title = o3;
tr.Description = i3;
tr.Content = a3;
tr.ContentHTML = s3;
const l3 = {
  manrope: "font-[Manrope]",
  signika: "font-[Signika]",
  lato: "font-[Lato]",
  inter: "font-[Inter]",
  epilogue: "font-[Epilogue]",
  bitter: "font-[Bitter]",
  system: "font-sans"
};
function c3({
  variant: e = "p",
  as: t,
  className: n,
  children: a,
  font: r = "system",
  ...o
}) {
  const s = t || ((u) => {
    switch (u) {
      case "h1":
      case "h2":
      case "h3":
      case "h4":
      case "h5":
      case "h6":
        return u;
      case "list":
        return "ul";
      case "inline-code":
        return "code";
      case "lead":
      case "large":
      case "small":
      case "muted":
        return "p";
      case "blockquote":
        return "blockquote";
      case "span":
        return u;
      default:
        return "p";
    }
  })(e), c = {
    h1: "scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl",
    h2: "scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight first:mt-0",
    h3: "scroll-m-20 text-2xl font-semibold tracking-tight",
    h4: "scroll-m-20 text-xl font-semibold tracking-tight",
    h5: "scroll-m-20 text-base font-semibold tracking-tight",
    h6: "scroll-m-20 text-base font-semibold tracking-tight",
    p: "leading-7 [&:not(:first-child)]:mt-1.5",
    blockquote: "mt-6 border-l-2 pl-6 italic",
    list: "my-6 ml-6 list-disc [&>li]:mt-2",
    "inline-code": "relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold",
    lead: "text-xl text-muted-foreground",
    large: "text-lg font-semibold",
    small: "text-sm font-medium leading-none",
    muted: "text-sm text-muted-foreground",
    span: "text-sm"
  };
  return D.createElement(
    s,
    {
      className: R(c[e], l3[r], n),
      ...o
    },
    a
  );
}
const xs = ({ children: e, className: t, key: n, onItemSelected: a }) => /* @__PURE__ */ l.jsx(
  Ne,
  {
    variant: "secondary",
    onClick: () => a(),
    className: R(
      "gap-2 whitespace-normal flex-1 w-full text-sm",
      "font-medium  flex items-center justify-between",
      "p-4 rounded-lg bg-gray-50 hover:bg-accent/50 ",
      "transition-colors h-auto hover:border border-black",
      t
    ),
    children: e
  },
  n
), d3 = ({ src: e, alt: t, className: n, parentClassName: a }) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R(
      "h-12 w-12 overflow-hidden rounded-md bg-gray-200",
      a
    ),
    children: /* @__PURE__ */ l.jsx(
      "img",
      {
        src: e,
        alt: t,
        className: R("h-full w-full object-cover", n)
      }
    )
  }
), u3 = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx(
  c3,
  {
    variant: "span",
    className: R("flex items-center gap-2", t),
    children: e
  }
), p3 = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("div", { className: R("flex items-center gap-3", t), children: e });
xs.Image = d3;
xs.Title = u3;
xs.Container = p3;
const m3 = {
  none: "",
  all: "rounded-2xl",
  top: "rounded-t-2xl",
  bottom: "rounded-b-2xl"
};
function ws({ children: e, className: t, rounded: n = "none" }) {
  return /* @__PURE__ */ l.jsx("div", { className: R(
    "flex items-center gap-3 p-4 bg-gray-100 rounded-xl",
    m3[n],
    t
  ), children: e });
}
function f3({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "rounded-lg bg-gray-200", children: e });
}
function h3({
  title: e = "Allocate to",
  description: t = "General Fund"
}) {
  return /* @__PURE__ */ l.jsxs("div", { children: [
    /* @__PURE__ */ l.jsx("h2", { className: "font-semibold text-xs tracking-wider uppercase opacity-60", children: e }),
    /* @__PURE__ */ l.jsx("p", { children: t })
  ] });
}
function g3({
  children: e,
  label: t = "Change",
  onClick: n
}) {
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: e ?? /* @__PURE__ */ l.jsx(
    Ne,
    {
      variant: "ghost",
      className: "ml-auto hover:bg-gray-200 text-xs",
      onClick: n,
      children: t
    }
  ) });
}
ws.TitleIcon = f3;
ws.Title = h3;
ws.Action = g3;
const nr = ({
  value: e = 0,
  onSelect: t,
  isSelected: n,
  className: a,
  selectedClassName: r,
  children: o
}) => /* @__PURE__ */ l.jsx(
  Ne,
  {
    onClick: () => t == null ? void 0 : t(e),
    variant: "outline",
    className: R(
      "w-full text-left h-auto p-4 rounded-lg",
      "transition-colors duration-200",
      "border-2",
      "block",
      "hover:bg-gray-50",
      n && ["border-primary", "bg-gray-50", r],
      !n && "border-input",
      a
    ),
    children: /* @__PURE__ */ l.jsx("div", { className: "flex justify-between items-start", children: o })
  }
);
nr.Content = ({
  children: e,
  className: t
}) => /* @__PURE__ */ l.jsx("div", { className: R("space-y-1", t), children: e });
nr.Title = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("h3", { className: R("font-semibold text-foreground", t), children: e });
nr.Description = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("p", { className: R("text-sm text-muted-foreground", t), children: e });
nr.Amount = ({ children: e, className: t }) => /* @__PURE__ */ l.jsx("span", { className: R("text-2xl font-bold", t), children: e });
nr.Badge = ({ children: e }) => /* @__PURE__ */ l.jsx(l.Fragment, { children: e });
var Cs = "Dialog", [Ou, TC] = Ve(Cs), [b3, mt] = Ou(Cs), ju = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: a,
    defaultOpen: r,
    onOpenChange: o,
    modal: i = !0
  } = e, s = d.useRef(null), c = d.useRef(null), [u = !1, p] = lt({
    prop: a,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ l.jsx(
    b3,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: ke(),
      titleId: ke(),
      descriptionId: ke(),
      open: u,
      onOpenChange: p,
      onOpenToggle: d.useCallback(() => p((m) => !m), [p]),
      modal: i,
      children: n
    }
  );
};
ju.displayName = Cs;
var Mu = "DialogTrigger", Iu = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = mt(Mu, n), o = ue(t, r.triggerRef);
    return /* @__PURE__ */ l.jsx(
      ee.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Rs(r.open),
        ...a,
        ref: o,
        onClick: G(e.onClick, r.onOpenToggle)
      }
    );
  }
);
Iu.displayName = Mu;
var Ss = "DialogPortal", [v3, Du] = Ou(Ss, {
  forceMount: void 0
}), Lu = (e) => {
  const { __scopeDialog: t, forceMount: n, children: a, container: r } = e, o = mt(Ss, t);
  return /* @__PURE__ */ l.jsx(v3, { scope: t, forceMount: n, children: d.Children.map(a, (i) => /* @__PURE__ */ l.jsx(De, { present: n || o.open, children: /* @__PURE__ */ l.jsx(es, { asChild: !0, container: r, children: i }) })) });
};
Lu.displayName = Ss;
var Tr = "DialogOverlay", Fu = d.forwardRef(
  (e, t) => {
    const n = Du(Tr, e.__scopeDialog), { forceMount: a = n.forceMount, ...r } = e, o = mt(Tr, e.__scopeDialog);
    return o.modal ? /* @__PURE__ */ l.jsx(De, { present: a || o.open, children: /* @__PURE__ */ l.jsx($3, { ...r, ref: t }) }) : null;
  }
);
Fu.displayName = Tr;
var y3 = /* @__PURE__ */ zt("DialogOverlay.RemoveScroll"), $3 = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = mt(Tr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ l.jsx(qa, { as: y3, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ l.jsx(
        ee.div,
        {
          "data-state": Rs(r.open),
          ...a,
          ref: t,
          style: { pointerEvents: "auto", ...a.style }
        }
      ) })
    );
  }
), vn = "DialogContent", Bu = d.forwardRef(
  (e, t) => {
    const n = Du(vn, e.__scopeDialog), { forceMount: a = n.forceMount, ...r } = e, o = mt(vn, e.__scopeDialog);
    return /* @__PURE__ */ l.jsx(De, { present: a || o.open, children: o.modal ? /* @__PURE__ */ l.jsx(x3, { ...r, ref: t }) : /* @__PURE__ */ l.jsx(w3, { ...r, ref: t }) });
  }
);
Bu.displayName = vn;
var x3 = d.forwardRef(
  (e, t) => {
    const n = mt(vn, e.__scopeDialog), a = d.useRef(null), r = ue(t, n.contentRef, a);
    return d.useEffect(() => {
      const o = a.current;
      if (o) return ho(o);
    }, []), /* @__PURE__ */ l.jsx(
      Uu,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: G(e.onCloseAutoFocus, (o) => {
          var i;
          o.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: G(e.onPointerDownOutside, (o) => {
          const i = o.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && o.preventDefault();
        }),
        onFocusOutside: G(
          e.onFocusOutside,
          (o) => o.preventDefault()
        )
      }
    );
  }
), w3 = d.forwardRef(
  (e, t) => {
    const n = mt(vn, e.__scopeDialog), a = d.useRef(!1), r = d.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      Uu,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, o), o.defaultPrevented || (a.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), a.current = !1, r.current = !1;
        },
        onInteractOutside: (o) => {
          var c, u;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (a.current = !0, o.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = o.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(i)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && r.current && o.preventDefault();
        }
      }
    );
  }
), Uu = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: a, onOpenAutoFocus: r, onCloseAutoFocus: o, ...i } = e, s = mt(vn, n), c = d.useRef(null), u = ue(t, c);
    return po(), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        Xa,
        {
          asChild: !0,
          loop: !0,
          trapped: a,
          onMountAutoFocus: r,
          onUnmountAutoFocus: o,
          children: /* @__PURE__ */ l.jsx(
            aa,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Rs(s.open),
              ...i,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx(C3, { titleId: s.titleId }),
        /* @__PURE__ */ l.jsx(E3, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Es = "DialogTitle", Gu = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = mt(Es, n);
    return /* @__PURE__ */ l.jsx(ee.h2, { id: r.titleId, ...a, ref: t });
  }
);
Gu.displayName = Es;
var Hu = "DialogDescription", Wu = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = mt(Hu, n);
    return /* @__PURE__ */ l.jsx(ee.p, { id: r.descriptionId, ...a, ref: t });
  }
);
Wu.displayName = Hu;
var Vu = "DialogClose", zu = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...a } = e, r = mt(Vu, n);
    return /* @__PURE__ */ l.jsx(
      ee.button,
      {
        type: "button",
        ...a,
        ref: t,
        onClick: G(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
zu.displayName = Vu;
function Rs(e) {
  return e ? "open" : "closed";
}
var Ku = "DialogTitleWarning", [kC, Zu] = Jh(Ku, {
  contentName: vn,
  titleName: Es,
  docsSlug: "dialog"
}), C3 = ({ titleId: e }) => {
  const t = Zu(Ku), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, S3 = "DialogDescriptionWarning", E3 = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Zu(S3).contentName}}.`;
  return d.useEffect(() => {
    var o;
    const r = (o = e.current) == null ? void 0 : o.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
}, xo = ju, Ns = Iu, wo = Lu, ia = Fu, sa = Bu, ar = Gu, rr = Wu, Co = zu;
const Yu = xo, OC = Ns, R3 = wo, jC = Co, As = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ia,
  {
    ref: n,
    className: R(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
As.displayName = ia.displayName;
const Ps = d.forwardRef(({ className: e, children: t, hideClose: n, ...a }, r) => /* @__PURE__ */ l.jsxs(R3, { children: [
  /* @__PURE__ */ l.jsx(As, {}),
  /* @__PURE__ */ l.jsxs(
    sa,
    {
      ref: r,
      className: R(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...a,
      children: [
        t,
        !n && /* @__PURE__ */ l.jsxs(Co, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ l.jsx($g, { className: "h-4 w-4" }),
          /* @__PURE__ */ l.jsx("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Ps.displayName = sa.displayName;
const N3 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
N3.displayName = "DialogHeader";
const A3 = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
A3.displayName = "DialogFooter";
const P3 = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ar,
  {
    ref: n,
    className: R(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
P3.displayName = ar.displayName;
const _3 = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  rr,
  {
    ref: n,
    className: R("text-sm text-muted-foreground", e),
    ...t
  }
));
_3.displayName = rr.displayName;
const Xu = nn(null), T3 = () => {
  const e = et(Xu);
  if (!e) throw new Error("Must be used inside <DonationDialog>");
  return e;
};
function So({
  open: e,
  onOpenChange: t,
  onClose: n,
  children: a,
  className: r
}) {
  return /* @__PURE__ */ l.jsx(Xu.Provider, { value: { onClose: n }, children: /* @__PURE__ */ l.jsxs(Yu, { open: e, onOpenChange: t, children: [
    /* @__PURE__ */ l.jsx(As, { className: "fixed inset-0 z-40 bg-black/50" }),
    /* @__PURE__ */ l.jsx(
      Ps,
      {
        className: R(
          "overflow-y-auto !fixed !top-0 translate-y-0 !p-0 !bg-black/20 border-none !w-full !max-w-[6000px] data-[state=closed]:slide-out-to-top-[0%] data-[state=open]:slide-in-from-bottom-[50%]",
          r
        ),
        children: a
      }
    )
  ] }) });
}
function k3({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex justify-between items-center w-full h-24 p-6 flex-shrink-0", t), children: e });
}
function O3({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "w-[40px] flex items-start", children: /* @__PURE__ */ l.jsx("div", { className: "transform scale-50 sm:scale-100 origin-left", children: e }) });
}
function j3({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "flex gap-2", children: e });
}
function M3({ onClick: e, children: t }) {
  return /* @__PURE__ */ l.jsx(
    Ne,
    {
      onClick: e,
      variant: "default",
      className: "flex text-white py-1.5 px-2.5 gap-2 items-center border rounded-full bg-transparent",
      children: t
    }
  );
}
function I3({ count: e, className: t }) {
  return e === 0 ? null : /* @__PURE__ */ l.jsx("span", { className: `px-2 rounded-full bg-red-600 text-white ${t}`, children: e });
}
function D3({ children: e, className: t }) {
  const { onClose: n } = T3();
  return /* @__PURE__ */ l.jsx(
    Ne,
    {
      onClick: n,
      className: R("flex gap-4 text-white items-center rounded-full bg-transparent hover:bg-accent/10", t),
      children: e || /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        /* @__PURE__ */ l.jsx("span", { className: "hidden sm:block opacity-50 text-xs", children: "Close" }),
        /* @__PURE__ */ l.jsx(ph, { className: "h-6 w-6" })
      ] })
    }
  );
}
So.Header = Object.assign(k3, {
  Logo: O3,
  Basket: M3,
  BasketCounter: I3,
  HeaderContent: j3,
  Close: D3
});
function L3({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex-1 flex-col items-center min-h-screen justify-between max-h-screen", t), children: e });
}
function F3({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex max-w-[920px] min-h-[600px] w-full mx-auto sm:pt-24", t), children: /* @__PURE__ */ l.jsx("div", { className: "flex h-auto flex-col sm:flex-row lg:gap-4 w-full", children: e }) });
}
function B3({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: R(
        "flex relative h-full min-w-[360px] min-h-[280px] sm:min-h-[600px] w-full sm:rounded-xl overflow-hidden md:brightness-75 hover:brightness-100 transition-all ease-in-out duration-500 bg-cover",
        t
      ),
      "data-slot": "dialog-panel",
      children: e
    }
  );
}
function U3({ src: e, alt: t }) {
  return /* @__PURE__ */ l.jsx("img", { src: e, alt: t, className: "h-full w-full object-cover", loading: "lazy" });
}
function G3({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "absolute bottom-0 left-0 right-0 sm:rounded sm:bottom-4 sm:left-4 sm:right-4 border-b-4 border-primary bg-white/90 p-6 backdrop-blur-sm", children: e });
}
function H3({ children: e }) {
  return /* @__PURE__ */ l.jsx("h3", { className: "hidden sm:block mb-2 text-sm font-medium uppercase text-gray-500", children: e });
}
function W3({ children: e }) {
  return /* @__PURE__ */ l.jsx("p", { className: "text-gray-700 text-xs sm:text-base", children: e });
}
function V3({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex flex-col bg-background sm:rounded-xl min-w-[360px] min-h-fit", t), "data-slot": "dialog-body", children: e });
}
So.Content = Object.assign(F3, {
  Panel: B3,
  Body: V3,
  Image: U3,
  PanelContent: G3,
  Title: H3,
  Description: W3,
  Container: L3
});
function z3({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsxs("div", { className: R("flex flex-col items-center justify-center gap-4", t), "data-slot": "dialog-footer", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "flex items-center justify-center w-full p-4 pt-8 gap-2 text-xs text-white text-center opacity-60", children: [
      /* @__PURE__ */ l.jsx(uh, { className: "h-4 w-4" }),
      e
    ] }),
    /* @__PURE__ */ l.jsx("div", { className: "h-24 flex-shrink-0" })
  ] });
}
So.Footer = z3;
const MC = So, qu = nn(null);
function K3() {
  const e = et(qu);
  if (!e)
    throw new Error("DonationAmountOptions components must be used within DonationAmountOptions.Root");
  return e;
}
function Z3({ children: e, selected: t, onChange: n, className: a }) {
  const r = (o) => {
    n == null || n(o);
  };
  return /* @__PURE__ */ l.jsx(
    qu.Provider,
    {
      value: {
        selected: t,
        onSelect: r,
        hasDescriptions: !1
      },
      children: /* @__PURE__ */ l.jsx("div", { className: R("grid auto-cols-fr gap-2", a), children: e })
    }
  );
}
function Y3({ value: e, label: t, description: n, className: a, selectedClassName: r = "n3o-custom-selected-amount" }) {
  const { selected: o, onSelect: i, hasDescriptions: s } = K3();
  return /* @__PURE__ */ l.jsxs(
    Ne,
    {
      variant: o === e ? "default" : "outline",
      className: R(
        "flex gap-1 h-fit items-center",
        s ? "flex-row justify-start" : "flex-col",
        o === e ? "" : "border-none outline outline-border -outline-offset-2",
        a,
        r
      ),
      onClick: () => i(e),
      children: [
        /* @__PURE__ */ l.jsx("div", { className: R(
          "font-semibold",
          s ? "text-base min-w-12 !text-start" : "text-lg"
        ), children: t }),
        n && /* @__PURE__ */ l.jsx("div", { className: R(
          "text-pretty font-normal text-start text-xs opacity-80",
          s ? "line-clamp-[2] text-[11px] !max-w-[225px]" : ""
        ), children: n })
      ]
    }
  );
}
function X3({ children: e, className: t, hasDescriptions: n = !1 }) {
  const a = qf.toArray(e).filter(Jf), r = a.length;
  if (n)
    return /* @__PURE__ */ l.jsx("div", { className: R("flex flex-col gap-2", t), children: a });
  if (r === 5)
    return /* @__PURE__ */ l.jsxs("div", { className: R("flex flex-col gap-4", t), children: [
      /* @__PURE__ */ l.jsx("div", { className: "grid grid-cols-3 gap-2", children: a.slice(0, 3) }),
      /* @__PURE__ */ l.jsx("div", { className: "grid grid-cols-2 gap-2", children: a.slice(3) })
    ] });
  const o = r === 2 || r === 4 ? "grid-cols-2" : "grid-cols-3";
  let i = (s) => s;
  return r === 1 && (i = (s) => /* @__PURE__ */ l.jsx("div", { className: "col-span-1", style: { gridColumn: "2 / span 1" }, children: s })), /* @__PURE__ */ l.jsx("div", { className: R(
    "grid gap-2",
    o,
    t
  ), children: a.map((s) => i(s)) });
}
function q3({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex gap-2", t), children: e });
}
const IC = {
  Container: Z3,
  Option: Y3,
  Grid: X3,
  Row: q3
}, DC = ({
  value: e,
  options: t,
  containterClassName: n,
  selectedClassName: a = "n3o-donation-frequency-selected",
  onChange: r
}) => /* @__PURE__ */ l.jsx("div", { className: R("flex gap-1 bg-gray-600/10 p-1 rounded-md", n), children: t.map((o) => /* @__PURE__ */ l.jsx(
  Ne,
  {
    className: R("flex-1 shadow-md", e === o.value ? a : ""),
    variant: e === o.value ? "default" : "outline",
    onClick: () => r(o.value),
    children: o.label
  },
  o.value
)) }), Ju = nn(
  void 0
);
function J3({ value: e, onChange: t, children: n, className: a }) {
  return /* @__PURE__ */ l.jsx(Ju.Provider, { value: { value: e, onChange: t }, children: /* @__PURE__ */ l.jsx("div", { className: `flex items-center gap-2 ${a || ""}`, children: n }) });
}
function Tl({ children: e, position: t = "left", className: n }) {
  const a = t === "left" ? "left-3" : "right-3";
  return /* @__PURE__ */ l.jsx(
    "span",
    {
      className: `absolute ${a} top-1/2 -translate-y-1/2 ${n || ""}`,
      children: e
    }
  );
}
function Q3({ className: e, ...t }) {
  const n = et(Ju);
  if (!n) throw new Error("CurrencyInput.Input must be used within CurrencyInput.Root");
  return /* @__PURE__ */ l.jsx(
    "input",
    {
      type: "number",
      value: n.value,
      onChange: (a) => n.onChange(parseInt(a.target.value)),
      className: `w-full rounded-md border px-8 py-2 text-xl font-bold ${e || ""}`,
      ...t
    }
  );
}
function ev({ children: e, className: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: `relative flex-1 ${t || ""}`, children: e });
}
const LC = {
  Root: J3,
  Container: ev,
  Input: Q3,
  LeftAddon: (e) => /* @__PURE__ */ l.jsx(Tl, { ...e, position: "left" }),
  RightAddon: (e) => /* @__PURE__ */ l.jsx(Tl, { ...e, position: "right" })
};
function Qu({ className: e, children: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex h-full flex-col overflow-y-auto", e), children: t });
}
function tv({ className: e, children: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("flex flex-col gap-4 p-4", e), children: t });
}
function nv({ className: e, children: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: R("pt-6 p-5", e), children: t });
}
Qu.Body = tv;
Qu.Footer = nv;
const ep = nn(null);
function _s() {
  const e = et(ep);
  if (!e) throw new Error("CurrencySelector components must be used within <CurrencySelector.Root>");
  return e;
}
function av({
  children: e,
  currentCurrency: t,
  currencyOptions: n,
  onCurrencyChange: a,
  showConfirmation: r,
  onShowConfirmationChange: o,
  requireConfirmation: i = !0
}) {
  const [s, c] = He(!1), [u, p] = He(null), m = r ?? s, f = o ?? c, h = hn((y) => {
    y !== t.code && (i ? (p(y), f(!0)) : a(y));
  }, [t.code, f, a, i]), v = hn(() => {
    u && (a(u), p(null), f(!1));
  }, [u, a, f]), g = hn(() => {
    p(null), f(!1);
  }, [f]);
  return /* @__PURE__ */ l.jsx(
    ep.Provider,
    {
      value: {
        currentCurrency: t,
        currencyOptions: n,
        showConfirmation: m,
        setShowConfirmation: f,
        handleCurrencyChange: h,
        handleConfirmCurrencyChange: v,
        handleCancelCurrencyChange: g
      },
      children: e
    }
  );
}
function rv({ className: e }) {
  const { currentCurrency: t } = _s(), [n, a] = He(!1);
  return /* @__PURE__ */ l.jsxs(fs, { open: n, onOpenChange: a, children: [
    /* @__PURE__ */ l.jsx(hs, { asChild: !0, children: /* @__PURE__ */ l.jsxs(
      Ne,
      {
        className: Ui(
          "flex text-white py-1.5 px-2.5 gap-0 items-center border rounded-full bg-transparent",
          e
        ),
        children: [
          t.symbol,
          " ",
          t.code,
          /* @__PURE__ */ l.jsx(qr, { className: "ml-1 h-4 w-4" })
        ]
      }
    ) }),
    /* @__PURE__ */ l.jsx(tp, { onClose: () => a(!1) })
  ] });
}
function tp({ onClose: e }) {
  const { currencyOptions: t, handleCurrencyChange: n } = _s();
  return /* @__PURE__ */ l.jsx(vo, { sideOffset: 4, children: Object.entries(t).map(([a, { symbol: r, code: o }]) => /* @__PURE__ */ l.jsxs(
    yo,
    {
      onClick: () => {
        n(a), e();
      },
      children: [
        r,
        " ",
        o
      ]
    },
    a
  )) });
}
function ov({
  children: e,
  open: t,
  onOpenChange: n
}) {
  const {
    showConfirmation: a,
    setShowConfirmation: r
  } = _s(), o = t !== void 0 ? t : a, i = n !== void 0 ? n : r;
  return /* @__PURE__ */ l.jsx(
    Yu,
    {
      open: o,
      onOpenChange: i,
      children: /* @__PURE__ */ l.jsx(Ps, { children: e })
    }
  );
}
const FC = Object.assign(av, {
  Trigger: rv,
  List: tp,
  ConfirmDialog: ov
}), np = D.createContext(void 0);
function kr({
  adminFee: e,
  onAdminFeeChange: t,
  checkboxLabel: n = "Contribute towards admin fee",
  amounts: a,
  selectedAmount: r,
  onAmountChange: o,
  tooltipText: i = "Contributing towards our admin costs can help us to continue providing a high level of service."
}) {
  const [s, c] = He(r || a[0]), u = (p) => {
    c(p), o == null || o(p);
  };
  return /* @__PURE__ */ l.jsx(np.Provider, { value: { adminFee: e, onAdminFeeChange: t }, children: /* @__PURE__ */ l.jsxs("div", { className: "flex items-center justify-between py-3 px-4 border-b border-slate-200 bg-slate-50 rounded-tl-lg rounded-tr-lg", children: [
    /* @__PURE__ */ l.jsx(kr.CheckboxLabel, { checkboxLabel: n }),
    /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ l.jsxs(fs, { children: [
        /* @__PURE__ */ l.jsx(hs, { asChild: !0, children: /* @__PURE__ */ l.jsxs(
          Ne,
          {
            variant: "link",
            className: "gap-1 px-2 underline flex items-center text-sm font-medium",
            onClick: (p) => p.stopPropagation(),
            children: [
              s,
              /* @__PURE__ */ l.jsx(qr, { className: " h-4 w-4" })
            ]
          }
        ) }),
        /* @__PURE__ */ l.jsx(vo, { onClick: (p) => p.stopPropagation(), children: a.map((p) => /* @__PURE__ */ l.jsx(
          yo,
          {
            onSelect: () => u(p),
            children: p
          },
          p
        )) })
      ] }),
      /* @__PURE__ */ l.jsx(kr.InfoButton, { tooltipText: i })
    ] })
  ] }) });
}
function iv({ checkboxLabel: e }) {
  const t = et(np);
  if (!t)
    throw new Error("AdminFeeOption.CheckboxLabel must be used within AdminFeeOption");
  const { adminFee: n, onAdminFeeChange: a } = t;
  return /* @__PURE__ */ l.jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ l.jsx(
      Rn,
      {
        id: "admin-fee",
        checked: n,
        onCheckedChange: (r) => a(r),
        className: "rounded-sm data-[state=checked]:bg-black data-[state=checked]:border-black"
      }
    ),
    /* @__PURE__ */ l.jsx(
      "label",
      {
        htmlFor: "admin-fee",
        className: "text-sm font-medium cursor-pointer flex items-center gap-1",
        children: e
      }
    )
  ] });
}
function sv({ tooltipText: e }) {
  const [t, n] = D.useState(!1);
  return /* @__PURE__ */ l.jsx(ld, { children: /* @__PURE__ */ l.jsxs(cd, { open: t, onOpenChange: n, children: [
    /* @__PURE__ */ l.jsx(dd, { asChild: !0, children: /* @__PURE__ */ l.jsx(
      Ne,
      {
        variant: "ghost",
        size: "icon",
        className: "h-6 w-6 rounded-full border",
        onClick: (a) => {
          a.stopPropagation(), n(!t);
        },
        children: "?"
      }
    ) }),
    /* @__PURE__ */ l.jsx(
      as,
      {
        className: "max-w-[240px] text-wrap",
        sideOffset: 5,
        children: /* @__PURE__ */ l.jsx("p", { className: "text-sm", children: e })
      }
    )
  ] }) });
}
kr.CheckboxLabel = iv;
kr.InfoButton = sv;
var Ts = "Radio", [lv, ap] = Ve(Ts), [cv, dv] = lv(Ts), rp = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: a,
      checked: r = !1,
      required: o,
      disabled: i,
      value: s = "on",
      onCheck: c,
      form: u,
      ...p
    } = e, [m, f] = d.useState(null), h = ue(t, (y) => f(y)), v = d.useRef(!1), g = m ? u || !!m.closest("form") : !0;
    return /* @__PURE__ */ l.jsxs(cv, { scope: n, checked: r, disabled: i, children: [
      /* @__PURE__ */ l.jsx(
        ee.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": r,
          "data-state": sp(r),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...p,
          ref: h,
          onClick: G(e.onClick, (y) => {
            r || c == null || c(), g && (v.current = y.isPropagationStopped(), v.current || y.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ l.jsx(
        uv,
        {
          control: m,
          bubbles: !v.current,
          name: a,
          value: s,
          checked: r,
          required: o,
          disabled: i,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
rp.displayName = Ts;
var op = "RadioIndicator", ip = d.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: a, ...r } = e, o = dv(op, n);
    return /* @__PURE__ */ l.jsx(De, { present: a || o.checked, children: /* @__PURE__ */ l.jsx(
      ee.span,
      {
        "data-state": sp(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    ) });
  }
);
ip.displayName = op;
var uv = (e) => {
  const { control: t, checked: n, bubbles: a = !0, ...r } = e, o = d.useRef(null), i = Qr(n), s = eo(t);
  return d.useEffect(() => {
    const c = o.current, u = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (i !== n && m) {
      const f = new Event("click", { bubbles: a });
      m.call(c, n), c.dispatchEvent(f);
    }
  }, [i, n, a]), /* @__PURE__ */ l.jsx(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: n,
      ...r,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function sp(e) {
  return e ? "checked" : "unchecked";
}
var pv = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], ks = "RadioGroup", [mv, BC] = Ve(ks, [
  fo,
  ap
]), lp = fo(), cp = ap(), [fv, hv] = mv(ks), dp = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: a,
      defaultValue: r,
      value: o,
      required: i = !1,
      disabled: s = !1,
      orientation: c,
      dir: u,
      loop: p = !0,
      onValueChange: m,
      ...f
    } = e, h = lp(n), v = Ya(u), [g, y] = lt({
      prop: o,
      defaultProp: r,
      onChange: m
    });
    return /* @__PURE__ */ l.jsx(
      fv,
      {
        scope: n,
        name: a,
        required: i,
        disabled: s,
        value: g,
        onValueChange: y,
        children: /* @__PURE__ */ l.jsx(
          bd,
          {
            asChild: !0,
            ...h,
            orientation: c,
            dir: v,
            loop: p,
            children: /* @__PURE__ */ l.jsx(
              ee.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": c,
                "data-disabled": s ? "" : void 0,
                dir: v,
                ...f,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
dp.displayName = ks;
var up = "RadioGroupItem", pp = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: a, ...r } = e, o = hv(up, n), i = o.disabled || a, s = lp(n), c = cp(n), u = d.useRef(null), p = ue(t, u), m = o.value === r.value, f = d.useRef(!1);
    return d.useEffect(() => {
      const h = (g) => {
        pv.includes(g.key) && (f.current = !0);
      }, v = () => f.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", v), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", v);
      };
    }, []), /* @__PURE__ */ l.jsx(
      vd,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: m,
        children: /* @__PURE__ */ l.jsx(
          rp,
          {
            disabled: i,
            required: o.required,
            checked: m,
            ...c,
            ...r,
            name: o.name,
            ref: p,
            onCheck: () => o.onValueChange(r.value),
            onKeyDown: G((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: G(r.onFocus, () => {
              var h;
              f.current && ((h = u.current) == null || h.click());
            })
          }
        )
      }
    );
  }
);
pp.displayName = up;
var gv = "RadioGroupIndicator", mp = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...a } = e, r = cp(n);
    return /* @__PURE__ */ l.jsx(ip, { ...r, ...a, ref: t });
  }
);
mp.displayName = gv;
var fp = dp, hp = pp, bv = mp;
const gp = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  fp,
  {
    className: R("grid gap-2", e),
    ...t,
    ref: n
  }
));
gp.displayName = fp.displayName;
const bp = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  hp,
  {
    ref: n,
    className: R(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l.jsx(bv, { className: "flex items-center justify-center", children: /* @__PURE__ */ l.jsx(to, { className: "h-3.5 w-3.5 fill-primary" }) })
  }
));
bp.displayName = hp.displayName;
const vp = /* @__PURE__ */ new Set(), We = /* @__PURE__ */ new WeakMap(), Kn = /* @__PURE__ */ new WeakMap(), yn = /* @__PURE__ */ new WeakMap(), bi = /* @__PURE__ */ new WeakMap(), vv = /* @__PURE__ */ new WeakMap(), Zn = /* @__PURE__ */ new WeakMap(), Or = /* @__PURE__ */ new WeakMap(), $a = /* @__PURE__ */ new WeakSet();
let Xt, Os = 0, js = 0;
const Ot = "__aa_tgt", Aa = "__aa_del", jr = "__aa_new", yv = (e) => {
  const t = Ev(e);
  t && t.forEach((n) => Rv(n));
}, $v = (e) => {
  e.forEach((t) => {
    t.target === Xt && wv(), We.has(t.target) && An(t.target);
  });
};
function xv(e) {
  const t = bi.get(e);
  t == null || t.disconnect();
  let n = We.get(e), a = 0;
  const r = 5;
  n || (n = Yn(e), We.set(e, n));
  const { offsetWidth: o, offsetHeight: i } = Xt, c = [
    n.top - r,
    o - (n.left + r + n.width),
    i - (n.top + r + n.height),
    n.left - r
  ].map((p) => `${-1 * Math.floor(p)}px`).join(" "), u = new IntersectionObserver(() => {
    ++a > 1 && An(e);
  }, {
    root: Xt,
    threshold: 1,
    rootMargin: c
  });
  u.observe(e), bi.set(e, u);
}
function An(e) {
  clearTimeout(Or.get(e));
  const t = Eo(e), n = Pa(t) ? 500 : t.duration;
  Or.set(e, setTimeout(async () => {
    const a = yn.get(e);
    try {
      await (a == null ? void 0 : a.finished), We.set(e, Yn(e)), xv(e);
    } catch {
    }
  }, n));
}
function wv() {
  clearTimeout(Or.get(Xt)), Or.set(Xt, setTimeout(() => {
    vp.forEach((e) => wp(e, (t) => yp(() => An(t))));
  }, 100));
}
function Cv(e) {
  setTimeout(() => {
    vv.set(e, setInterval(() => yp(An.bind(null, e)), 2e3));
  }, Math.round(2e3 * Math.random()));
}
function yp(e) {
  typeof requestIdleCallback == "function" ? requestIdleCallback(() => e()) : requestAnimationFrame(() => e());
}
let vi, Ln;
const Sv = typeof window < "u" && "ResizeObserver" in window;
Sv && (Xt = document.documentElement, vi = new MutationObserver(yv), Ln = new ResizeObserver($v), window.addEventListener("scroll", () => {
  js = window.scrollY, Os = window.scrollX;
}), Ln.observe(Xt));
function Ev(e) {
  return e.reduce((a, r) => [
    ...a,
    ...Array.from(r.addedNodes),
    ...Array.from(r.removedNodes)
  ], []).every((a) => a.nodeName === "#comment") ? !1 : e.reduce((a, r) => {
    if (a === !1)
      return !1;
    if (r.target instanceof Element) {
      if (Yo(r.target), !a.has(r.target)) {
        a.add(r.target);
        for (let o = 0; o < r.target.children.length; o++) {
          const i = r.target.children.item(o);
          if (i) {
            if (Aa in i)
              return !1;
            Yo(r.target, i), a.add(i);
          }
        }
      }
      if (r.removedNodes.length)
        for (let o = 0; o < r.removedNodes.length; o++) {
          const i = r.removedNodes[o];
          if (Aa in i)
            return !1;
          i instanceof Element && (a.add(i), Yo(r.target, i), Kn.set(i, [
            r.previousSibling,
            r.nextSibling
          ]));
        }
    }
    return a;
  }, /* @__PURE__ */ new Set());
}
function Yo(e, t) {
  !t && !(Ot in e) ? Object.defineProperty(e, Ot, { value: e }) : t && !(Ot in t) && Object.defineProperty(t, Ot, { value: e });
}
function Rv(e) {
  var t;
  const n = e.isConnected, a = We.has(e);
  n && Kn.has(e) && Kn.delete(e), yn.has(e) && ((t = yn.get(e)) === null || t === void 0 || t.cancel()), jr in e ? kl(e) : a && n ? Av(e) : a && !n ? Pv(e) : kl(e);
}
function vt(e) {
  return Number(e.replace(/[^0-9.\-]/g, ""));
}
function Nv(e) {
  let t = e.parentElement;
  for (; t; ) {
    if (t.scrollLeft || t.scrollTop)
      return { x: t.scrollLeft, y: t.scrollTop };
    t = t.parentElement;
  }
  return { x: 0, y: 0 };
}
function Yn(e) {
  const t = e.getBoundingClientRect(), { x: n, y: a } = Nv(e);
  return {
    top: t.top + a,
    left: t.left + n,
    width: t.width,
    height: t.height
  };
}
function $p(e, t, n) {
  let a = t.width, r = t.height, o = n.width, i = n.height;
  const s = getComputedStyle(e);
  if (s.getPropertyValue("box-sizing") === "content-box") {
    const u = vt(s.paddingTop) + vt(s.paddingBottom) + vt(s.borderTopWidth) + vt(s.borderBottomWidth), p = vt(s.paddingLeft) + vt(s.paddingRight) + vt(s.borderRightWidth) + vt(s.borderLeftWidth);
    a -= p, o -= p, r -= u, i -= u;
  }
  return [a, o, r, i].map(Math.round);
}
function Eo(e) {
  return Ot in e && Zn.has(e[Ot]) ? Zn.get(e[Ot]) : { duration: 250, easing: "ease-in-out" };
}
function xp(e) {
  if (Ot in e)
    return e[Ot];
}
function Ms(e) {
  const t = xp(e);
  return t ? $a.has(t) : !1;
}
function wp(e, ...t) {
  t.forEach((n) => n(e, Zn.has(e)));
  for (let n = 0; n < e.children.length; n++) {
    const a = e.children.item(n);
    a && t.forEach((r) => r(a, Zn.has(a)));
  }
}
function Is(e) {
  return Array.isArray(e) ? e : [e];
}
function Pa(e) {
  return typeof e == "function";
}
function Av(e) {
  const t = We.get(e), n = Yn(e);
  if (!Ms(e))
    return We.set(e, n);
  let a;
  if (!t)
    return;
  const r = Eo(e);
  if (typeof r != "function") {
    const o = t.left - n.left, i = t.top - n.top, [s, c, u, p] = $p(e, t, n), m = {
      transform: `translate(${o}px, ${i}px)`
    }, f = {
      transform: "translate(0, 0)"
    };
    s !== c && (m.width = `${s}px`, f.width = `${c}px`), u !== p && (m.height = `${u}px`, f.height = `${p}px`), a = e.animate([m, f], {
      duration: r.duration,
      easing: r.easing
    });
  } else {
    const [o] = Is(r(e, "remain", t, n));
    a = new Animation(o), a.play();
  }
  yn.set(e, a), We.set(e, n), a.addEventListener("finish", An.bind(null, e));
}
function kl(e) {
  jr in e && delete e[jr];
  const t = Yn(e);
  We.set(e, t);
  const n = Eo(e);
  if (!Ms(e))
    return;
  let a;
  if (typeof n != "function")
    a = e.animate([
      { transform: "scale(.98)", opacity: 0 },
      { transform: "scale(0.98)", opacity: 0, offset: 0.5 },
      { transform: "scale(1)", opacity: 1 }
    ], {
      duration: n.duration * 1.5,
      easing: "ease-in"
    });
  else {
    const [r] = Is(n(e, "add", t));
    a = new Animation(r), a.play();
  }
  yn.set(e, a), a.addEventListener("finish", An.bind(null, e));
}
function Ol(e, t) {
  var n;
  e.remove(), We.delete(e), Kn.delete(e), yn.delete(e), (n = bi.get(e)) === null || n === void 0 || n.disconnect(), setTimeout(() => {
    if (Aa in e && delete e[Aa], Object.defineProperty(e, jr, { value: !0, configurable: !0 }), t && e instanceof HTMLElement)
      for (const a in t)
        e.style[a] = "";
  }, 0);
}
function Pv(e) {
  var t;
  if (!Kn.has(e) || !We.has(e))
    return;
  const [n, a] = Kn.get(e);
  Object.defineProperty(e, Aa, { value: !0, configurable: !0 });
  const r = window.scrollX, o = window.scrollY;
  if (a && a.parentNode && a.parentNode instanceof Element ? a.parentNode.insertBefore(e, a) : n && n.parentNode ? n.parentNode.appendChild(e) : (t = xp(e)) === null || t === void 0 || t.appendChild(e), !Ms(e))
    return Ol(e);
  const [i, s, c, u] = Tv(e), p = Eo(e), m = We.get(e);
  (r !== Os || o !== js) && _v(e, r, o, p);
  let f, h = {
    position: "absolute",
    top: `${i}px`,
    left: `${s}px`,
    width: `${c}px`,
    height: `${u}px`,
    margin: "0",
    pointerEvents: "none",
    transformOrigin: "center",
    zIndex: "100"
  };
  if (!Pa(p))
    Object.assign(e.style, h), f = e.animate([
      {
        transform: "scale(1)",
        opacity: 1
      },
      {
        transform: "scale(.98)",
        opacity: 0
      }
    ], { duration: p.duration, easing: "ease-out" });
  else {
    const [v, g] = Is(p(e, "remove", m));
    (g == null ? void 0 : g.styleReset) !== !1 && (h = (g == null ? void 0 : g.styleReset) || h, Object.assign(e.style, h)), f = new Animation(v), f.play();
  }
  yn.set(e, f), f.addEventListener("finish", Ol.bind(null, e, h));
}
function _v(e, t, n, a) {
  const r = Os - t, o = js - n, i = document.documentElement.style.scrollBehavior;
  if (getComputedStyle(Xt).scrollBehavior === "smooth" && (document.documentElement.style.scrollBehavior = "auto"), window.scrollTo(window.scrollX + r, window.scrollY + o), !e.parentElement)
    return;
  const c = e.parentElement;
  let u = c.clientHeight, p = c.clientWidth;
  const m = performance.now();
  function f() {
    requestAnimationFrame(() => {
      if (!Pa(a)) {
        const h = u - c.clientHeight, v = p - c.clientWidth;
        m + a.duration > performance.now() ? (window.scrollTo({
          left: window.scrollX - v,
          top: window.scrollY - h
        }), u = c.clientHeight, p = c.clientWidth, f()) : document.documentElement.style.scrollBehavior = i;
      }
    });
  }
  f();
}
function Tv(e) {
  const t = We.get(e), [n, , a] = $p(e, t, Yn(e));
  let r = e.parentElement;
  for (; r && (getComputedStyle(r).position === "static" || r instanceof HTMLBodyElement); )
    r = r.parentElement;
  r || (r = document.body);
  const o = getComputedStyle(r), i = We.get(r) || Yn(r), s = Math.round(t.top - i.top) - vt(o.borderTopWidth), c = Math.round(t.left - i.left) - vt(o.borderLeftWidth);
  return [s, c, n, a];
}
function kv(e, t = {}) {
  return vi && Ln && (window.matchMedia("(prefers-reduced-motion: reduce)").matches && !Pa(t) && !t.disrespectUserMotionPreference || ($a.add(e), getComputedStyle(e).position === "static" && Object.assign(e.style, { position: "relative" }), wp(e, An, Cv, (r) => Ln == null ? void 0 : Ln.observe(r)), Pa(t) ? Zn.set(e, t) : Zn.set(e, { duration: 250, easing: "ease-in-out", ...t }), vi.observe(e, { childList: !0 }), vp.add(e))), Object.freeze({
    parent: e,
    enable: () => {
      $a.add(e);
    },
    disable: () => {
      $a.delete(e);
    },
    isEnabled: () => $a.has(e)
  });
}
function Cp(e) {
  const [t, n] = He(), a = Bi(() => e, []), r = hn((i) => {
    i instanceof HTMLElement ? n(kv(i, a)) : n(void 0);
  }, [a]), o = hn((i) => {
    t && (i ? t.enable() : t.disable());
  }, [t]);
  return [r, o];
}
const Ds = nn(void 0);
function Xn({ children: e, className: t = "", ...n }) {
  const [a] = Cp();
  return /* @__PURE__ */ l.jsx(Ds.Provider, { value: n, children: /* @__PURE__ */ l.jsx(
    "div",
    {
      className: `flex flex-col gap-3 rounded-lg bg-accent/50 p-4 ${n.isOrganization ? "opacity-75" : ""} ${t}`,
      ref: a,
      children: e
    }
  ) });
}
function Ov({ children: e }) {
  return /* @__PURE__ */ l.jsx("p", { className: "text-sm text-gray-600", children: e });
}
function jv({ children: e }) {
  const t = et(Ds);
  if (!t) throw new Error("GiftAid.Options must be used within GiftAidRoot");
  return /* @__PURE__ */ l.jsx(
    gp,
    {
      value: t.giftAidOption,
      onValueChange: t.onGiftAidOptionChange,
      className: "space-y-2",
      children: e
    }
  );
}
function Mv({ value: e, children: t, icon: n }) {
  return /* @__PURE__ */ l.jsxs("div", { className: "flex items-start gap-3", children: [
    /* @__PURE__ */ l.jsx(bp, { value: e, id: e, className: "mt-1" }),
    /* @__PURE__ */ l.jsxs("div", { className: "flex flex-1 items-center justify-between relative pr-24", children: [
      /* @__PURE__ */ l.jsx($o, { htmlFor: e, className: "text-sm", children: t }),
      n
    ] })
  ] });
}
function Iv({ children: e }) {
  const t = et(Ds);
  if (!t) throw new Error("BoostMessage must be used within GiftAidRoot");
  return t.giftAidOption === "boost" ? /* @__PURE__ */ l.jsx("div", { className: "mt-3 text-sm text-gray-700", children: e }) : null;
}
Xn.Root = Xn;
Xn.OrganizationMessage = Ov;
Xn.Options = jv;
Xn.Option = Mv;
Xn.BoostMessage = Iv;
function Ls({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "space-y-4 rounded-lg bg-accent/50 p-4", children: e });
}
function Dv({ children: e }) {
  return /* @__PURE__ */ l.jsx("p", { className: "text-sm font-medium text-gray-600 mb-4", children: e });
}
function Lv({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "flex items-center space-x-6", children: e });
}
function Fv({ id: e, label: t, checked: n, onChange: a }) {
  return /* @__PURE__ */ l.jsxs("div", { className: "flex items-center space-x-2", children: [
    /* @__PURE__ */ l.jsx(Rn, { id: e, checked: n, onCheckedChange: (r) => a == null ? void 0 : a(e, r) }),
    /* @__PURE__ */ l.jsx(
      "label",
      {
        htmlFor: e,
        className: "text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        children: t
      }
    )
  ] });
}
Ls.Message = Dv;
Ls.OptionsGroup = Lv;
Ls.Option = Fv;
function Sp({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "space-y-4 bg-slate-100 p-4 rounded-bl-lg rounded-br-lg", children: /* @__PURE__ */ l.jsx("div", { className: "flex justify-between items-center", children: e }) });
}
function Bv({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "text-sm text-slate-400", children: e });
}
function Uv({ value: e, additional: t = "", frequency: n = "/month" }) {
  const a = t !== "" ? `${e} + ${t}` : e;
  return /* @__PURE__ */ l.jsxs("div", { className: "text-base", children: [
    /* @__PURE__ */ l.jsx("span", { className: "font-semibold text-xl", children: a }),
    /* @__PURE__ */ l.jsx("span", { className: "text-xs", children: n })
  ] });
}
Sp.Title = Bv;
Sp.Amount = Uv;
function Fs({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "space-y-4 border rounded-lg p-4", children: e });
}
function Gv({ title: e }) {
  return /* @__PURE__ */ l.jsx("h3", { className: "text-xs font-semibold text-muted-foreground", children: e });
}
function Hv({ name: e, description: t, amount: n, children: a }) {
  return /* @__PURE__ */ l.jsxs("div", { className: "rounded-lg bg-slate-50 p-3", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "flex justify-between items-start", children: [
      /* @__PURE__ */ l.jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ l.jsx("h4", { className: "text-base font-semibold", children: e }),
        /* @__PURE__ */ l.jsx("p", { className: "text-xs text-muted-foreground", children: t })
      ] }),
      /* @__PURE__ */ l.jsx("div", { className: "font-semibold", children: n })
    ] }),
    a || null
  ] });
}
function Wv({ onRemove: e }) {
  return /* @__PURE__ */ l.jsx(
    Ne,
    {
      variant: "link",
      className: "mt-2 h-auto p-0 text-xs text-muted-foreground hover:underline",
      onClick: e,
      children: "REMOVE"
    }
  );
}
Fs.Header = Gv;
Fs.Content = Hv;
Fs.Footer = Wv;
function Pn({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "border rounded-lg p-4", children: e });
}
function Vv({ children: e }) {
  return /* @__PURE__ */ l.jsx("h3", { className: "text-sm font-semibold uppercase tracking-wide mb-2", children: e });
}
function zv({ children: e }) {
  return /* @__PURE__ */ l.jsx("p", { className: "text-sm text-muted-foreground", children: e });
}
function Kv({ value: e, frequency: t }) {
  return /* @__PURE__ */ l.jsxs("span", { className: "text-xl font-semibold", children: [
    e,
    t
  ] });
}
function Zv({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "flex items-center justify-between bg-accent/50 p-4 rounded-md", children: e });
}
function Yv({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "flex items-center justify-between bg-accent/50 p-4 rounded-md", children: e });
}
function Xv({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "border-t border-orange-100 bg-orange-50 p-4", children: e });
}
function qv({ children: e }) {
  return /* @__PURE__ */ l.jsx("p", { className: "text-sm text-orange-800", children: e });
}
Pn.Title = Vv;
Pn.Description = zv;
Pn.Amount = Kv;
Pn.Content = Zv;
Pn.ContentContainer = Yv;
Pn.ContentWarning = Xv;
Pn.WarningLine = qv;
function yi(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var Jv = [" ", "Enter", "ArrowUp", "ArrowDown"], Qv = [" ", "Enter"], or = "Select", [Ro, No, ey] = rs(or), [la, UC] = Ve(or, [
  ey,
  an
]), Ao = an(), [ty, sn] = la(or), [ny, ay] = la(or), Ep = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: a,
    defaultOpen: r,
    onOpenChange: o,
    value: i,
    defaultValue: s,
    onValueChange: c,
    dir: u,
    name: p,
    autoComplete: m,
    disabled: f,
    required: h,
    form: v
  } = e, g = Ao(t), [y, b] = d.useState(null), [$, x] = d.useState(null), [w, S] = d.useState(!1), P = Ya(u), [C = !1, T] = lt({
    prop: a,
    defaultProp: r,
    onChange: o
  }), [A, L] = lt({
    prop: i,
    defaultProp: s,
    onChange: c
  }), V = d.useRef(null), M = y ? v || !!y.closest("form") : !0, [_, K] = d.useState(/* @__PURE__ */ new Set()), Q = Array.from(_).map((W) => W.props.value).join(";");
  return /* @__PURE__ */ l.jsx(Ka, { ...g, children: /* @__PURE__ */ l.jsxs(
    ty,
    {
      required: h,
      scope: t,
      trigger: y,
      onTriggerChange: b,
      valueNode: $,
      onValueNodeChange: x,
      valueNodeHasChildren: w,
      onValueNodeHasChildrenChange: S,
      contentId: ke(),
      value: A,
      onValueChange: L,
      open: C,
      onOpenChange: T,
      dir: P,
      triggerPointerDownPosRef: V,
      disabled: f,
      children: [
        /* @__PURE__ */ l.jsx(Ro.Provider, { scope: t, children: /* @__PURE__ */ l.jsx(
          ny,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: d.useCallback((W) => {
              K((q) => new Set(q).add(W));
            }, []),
            onNativeOptionRemove: d.useCallback((W) => {
              K((q) => {
                const z = new Set(q);
                return z.delete(W), z;
              });
            }, []),
            children: n
          }
        ) }),
        M ? /* @__PURE__ */ l.jsxs(
          Yp,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: p,
            autoComplete: m,
            value: A,
            onChange: (W) => L(W.target.value),
            disabled: f,
            form: v,
            children: [
              A === void 0 ? /* @__PURE__ */ l.jsx("option", { value: "" }) : null,
              Array.from(_)
            ]
          },
          Q
        ) : null
      ]
    }
  ) });
};
Ep.displayName = or;
var Rp = "SelectTrigger", Np = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: a = !1, ...r } = e, o = Ao(n), i = sn(Rp, n), s = i.disabled || a, c = ue(t, i.onTriggerChange), u = No(n), p = d.useRef("touch"), [m, f, h] = Xp((g) => {
      const y = u().filter((x) => !x.disabled), b = y.find((x) => x.value === i.value), $ = qp(y, g, b);
      $ !== void 0 && i.onValueChange($.value);
    }), v = (g) => {
      s || (i.onOpenChange(!0), h()), g && (i.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ l.jsx(Za, { asChild: !0, ...o, children: /* @__PURE__ */ l.jsx(
      ee.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": Zp(i.value) ? "" : void 0,
        ...r,
        ref: c,
        onClick: G(r.onClick, (g) => {
          g.currentTarget.focus(), p.current !== "mouse" && v(g);
        }),
        onPointerDown: G(r.onPointerDown, (g) => {
          p.current = g.pointerType;
          const y = g.target;
          y.hasPointerCapture(g.pointerId) && y.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (v(g), g.preventDefault());
        }),
        onKeyDown: G(r.onKeyDown, (g) => {
          const y = m.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && f(g.key), !(y && g.key === " ") && Jv.includes(g.key) && (v(), g.preventDefault());
        })
      }
    ) });
  }
);
Np.displayName = Rp;
var Ap = "SelectValue", Pp = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: a, style: r, children: o, placeholder: i = "", ...s } = e, c = sn(Ap, n), { onValueNodeHasChildrenChange: u } = c, p = o !== void 0, m = ue(t, c.onValueNodeChange);
    return Me(() => {
      u(p);
    }, [u, p]), /* @__PURE__ */ l.jsx(
      ee.span,
      {
        ...s,
        ref: m,
        style: { pointerEvents: "none" },
        children: Zp(c.value) ? /* @__PURE__ */ l.jsx(l.Fragment, { children: i }) : o
      }
    );
  }
);
Pp.displayName = Ap;
var ry = "SelectIcon", _p = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: a, ...r } = e;
    return /* @__PURE__ */ l.jsx(ee.span, { "aria-hidden": !0, ...r, ref: t, children: a || "▼" });
  }
);
_p.displayName = ry;
var $n = "SelectContent", Tp = d.forwardRef(
  (e, t) => {
    const n = sn($n, e.__scopeSelect), [a, r] = d.useState();
    if (Me(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const o = a;
      return o ? Xr.createPortal(
        /* @__PURE__ */ l.jsx(kp, { scope: e.__scopeSelect, children: /* @__PURE__ */ l.jsx(Ro.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ l.jsx("div", { children: e.children }) }) }),
        o
      ) : null;
    }
    return /* @__PURE__ */ l.jsx(Op, { ...e, ref: t });
  }
);
Tp.displayName = $n;
var ot = 10, [kp, ln] = la($n), oy = "SelectContentImpl", iy = /* @__PURE__ */ zt("SelectContent.RemoveScroll"), Op = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: a = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: c,
      align: u,
      alignOffset: p,
      arrowPadding: m,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: g,
      avoidCollisions: y,
      //
      ...b
    } = e, $ = sn($n, n), [x, w] = d.useState(null), [S, P] = d.useState(null), C = ue(t, (I) => w(I)), [T, A] = d.useState(null), [L, V] = d.useState(
      null
    ), M = No(n), [_, K] = d.useState(!1), Q = d.useRef(!1);
    d.useEffect(() => {
      if (x) return ho(x);
    }, [x]), po();
    const W = d.useCallback(
      (I) => {
        const [Y, ...te] = M().map((fe) => fe.ref.current), [le] = te.slice(-1), me = document.activeElement;
        for (const fe of I)
          if (fe === me || (fe == null || fe.scrollIntoView({ block: "nearest" }), fe === Y && S && (S.scrollTop = 0), fe === le && S && (S.scrollTop = S.scrollHeight), fe == null || fe.focus(), document.activeElement !== me)) return;
      },
      [M, S]
    ), q = d.useCallback(
      () => W([T, x]),
      [W, T, x]
    );
    d.useEffect(() => {
      _ && q();
    }, [_, q]);
    const { onOpenChange: z, triggerPointerDownPosRef: j } = $;
    d.useEffect(() => {
      if (x) {
        let I = { x: 0, y: 0 };
        const Y = (le) => {
          var me, fe;
          I = {
            x: Math.abs(Math.round(le.pageX) - (((me = j.current) == null ? void 0 : me.x) ?? 0)),
            y: Math.abs(Math.round(le.pageY) - (((fe = j.current) == null ? void 0 : fe.y) ?? 0))
          };
        }, te = (le) => {
          I.x <= 10 && I.y <= 10 ? le.preventDefault() : x.contains(le.target) || z(!1), document.removeEventListener("pointermove", Y), j.current = null;
        };
        return j.current !== null && (document.addEventListener("pointermove", Y), document.addEventListener("pointerup", te, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Y), document.removeEventListener("pointerup", te, { capture: !0 });
        };
      }
    }, [x, z, j]), d.useEffect(() => {
      const I = () => z(!1);
      return window.addEventListener("blur", I), window.addEventListener("resize", I), () => {
        window.removeEventListener("blur", I), window.removeEventListener("resize", I);
      };
    }, [z]);
    const [N, F] = Xp((I) => {
      const Y = M().filter((me) => !me.disabled), te = Y.find((me) => me.ref.current === document.activeElement), le = qp(Y, I, te);
      le && setTimeout(() => le.ref.current.focus());
    }), E = d.useCallback(
      (I, Y, te) => {
        const le = !Q.current && !te;
        ($.value !== void 0 && $.value === Y || le) && (A(I), le && (Q.current = !0));
      },
      [$.value]
    ), B = d.useCallback(() => x == null ? void 0 : x.focus(), [x]), X = d.useCallback(
      (I, Y, te) => {
        const le = !Q.current && !te;
        ($.value !== void 0 && $.value === Y || le) && V(I);
      },
      [$.value]
    ), U = a === "popper" ? $i : jp, ne = U === $i ? {
      side: s,
      sideOffset: c,
      align: u,
      alignOffset: p,
      arrowPadding: m,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: g,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ l.jsx(
      kp,
      {
        scope: n,
        content: x,
        viewport: S,
        onViewportChange: P,
        itemRefCallback: E,
        selectedItem: T,
        onItemLeave: B,
        itemTextRefCallback: X,
        focusSelectedItem: q,
        selectedItemText: L,
        position: a,
        isPositioned: _,
        searchRef: N,
        children: /* @__PURE__ */ l.jsx(qa, { as: iy, allowPinchZoom: !0, children: /* @__PURE__ */ l.jsx(
          Xa,
          {
            asChild: !0,
            trapped: $.open,
            onMountAutoFocus: (I) => {
              I.preventDefault();
            },
            onUnmountAutoFocus: G(r, (I) => {
              var Y;
              (Y = $.trigger) == null || Y.focus({ preventScroll: !0 }), I.preventDefault();
            }),
            children: /* @__PURE__ */ l.jsx(
              aa,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: o,
                onPointerDownOutside: i,
                onFocusOutside: (I) => I.preventDefault(),
                onDismiss: () => $.onOpenChange(!1),
                children: /* @__PURE__ */ l.jsx(
                  U,
                  {
                    role: "listbox",
                    id: $.contentId,
                    "data-state": $.open ? "open" : "closed",
                    dir: $.dir,
                    onContextMenu: (I) => I.preventDefault(),
                    ...b,
                    ...ne,
                    onPlaced: () => K(!0),
                    ref: C,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: G(b.onKeyDown, (I) => {
                      const Y = I.ctrlKey || I.altKey || I.metaKey;
                      if (I.key === "Tab" && I.preventDefault(), !Y && I.key.length === 1 && F(I.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(I.key)) {
                        let le = M().filter((me) => !me.disabled).map((me) => me.ref.current);
                        if (["ArrowUp", "End"].includes(I.key) && (le = le.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(I.key)) {
                          const me = I.target, fe = le.indexOf(me);
                          le = le.slice(fe + 1);
                        }
                        setTimeout(() => W(le)), I.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Op.displayName = oy;
var sy = "SelectItemAlignedPosition", jp = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: a, ...r } = e, o = sn($n, n), i = ln($n, n), [s, c] = d.useState(null), [u, p] = d.useState(null), m = ue(t, (C) => p(C)), f = No(n), h = d.useRef(!1), v = d.useRef(!0), { viewport: g, selectedItem: y, selectedItemText: b, focusSelectedItem: $ } = i, x = d.useCallback(() => {
    if (o.trigger && o.valueNode && s && u && g && y && b) {
      const C = o.trigger.getBoundingClientRect(), T = u.getBoundingClientRect(), A = o.valueNode.getBoundingClientRect(), L = b.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const me = L.left - T.left, fe = A.left - me, Oe = C.left - fe, k = C.width + Oe, oe = Math.max(k, T.width), xe = window.innerWidth - ot, Se = yi(fe, [
          ot,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(ot, xe - oe)
        ]);
        s.style.minWidth = k + "px", s.style.left = Se + "px";
      } else {
        const me = T.right - L.right, fe = window.innerWidth - A.right - me, Oe = window.innerWidth - C.right - fe, k = C.width + Oe, oe = Math.max(k, T.width), xe = window.innerWidth - ot, Se = yi(fe, [
          ot,
          Math.max(ot, xe - oe)
        ]);
        s.style.minWidth = k + "px", s.style.right = Se + "px";
      }
      const V = f(), M = window.innerHeight - ot * 2, _ = g.scrollHeight, K = window.getComputedStyle(u), Q = parseInt(K.borderTopWidth, 10), W = parseInt(K.paddingTop, 10), q = parseInt(K.borderBottomWidth, 10), z = parseInt(K.paddingBottom, 10), j = Q + W + _ + z + q, N = Math.min(y.offsetHeight * 5, j), F = window.getComputedStyle(g), E = parseInt(F.paddingTop, 10), B = parseInt(F.paddingBottom, 10), X = C.top + C.height / 2 - ot, U = M - X, ne = y.offsetHeight / 2, I = y.offsetTop + ne, Y = Q + W + I, te = j - Y;
      if (Y <= X) {
        const me = V.length > 0 && y === V[V.length - 1].ref.current;
        s.style.bottom = "0px";
        const fe = u.clientHeight - g.offsetTop - g.offsetHeight, Oe = Math.max(
          U,
          ne + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (me ? B : 0) + fe + q
        ), k = Y + Oe;
        s.style.height = k + "px";
      } else {
        const me = V.length > 0 && y === V[0].ref.current;
        s.style.top = "0px";
        const Oe = Math.max(
          X,
          Q + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (me ? E : 0) + ne
        ) + te;
        s.style.height = Oe + "px", g.scrollTop = Y - X + g.offsetTop;
      }
      s.style.margin = `${ot}px 0`, s.style.minHeight = N + "px", s.style.maxHeight = M + "px", a == null || a(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    f,
    o.trigger,
    o.valueNode,
    s,
    u,
    g,
    y,
    b,
    o.dir,
    a
  ]);
  Me(() => x(), [x]);
  const [w, S] = d.useState();
  Me(() => {
    u && S(window.getComputedStyle(u).zIndex);
  }, [u]);
  const P = d.useCallback(
    (C) => {
      C && v.current === !0 && (x(), $ == null || $(), v.current = !1);
    },
    [x, $]
  );
  return /* @__PURE__ */ l.jsx(
    cy,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: P,
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: w
          },
          children: /* @__PURE__ */ l.jsx(
            ee.div,
            {
              ...r,
              ref: m,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
jp.displayName = sy;
var ly = "SelectPopperPosition", $i = d.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: a = "start",
    collisionPadding: r = ot,
    ...o
  } = e, i = Ao(n);
  return /* @__PURE__ */ l.jsx(
    oo,
    {
      ...i,
      ...o,
      ref: t,
      align: a,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...o.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
$i.displayName = ly;
var [cy, Bs] = la($n, {}), xi = "SelectViewport", Mp = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: a, ...r } = e, o = ln(xi, n), i = Bs(xi, n), s = ue(t, o.onViewportChange), c = d.useRef(0);
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: a
        }
      ),
      /* @__PURE__ */ l.jsx(Ro.Slot, { scope: n, children: /* @__PURE__ */ l.jsx(
        ee.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: G(r.onScroll, (u) => {
            const p = u.currentTarget, { contentWrapper: m, shouldExpandOnScrollRef: f } = i;
            if (f != null && f.current && m) {
              const h = Math.abs(c.current - p.scrollTop);
              if (h > 0) {
                const v = window.innerHeight - ot * 2, g = parseFloat(m.style.minHeight), y = parseFloat(m.style.height), b = Math.max(g, y);
                if (b < v) {
                  const $ = b + h, x = Math.min(v, $), w = $ - x;
                  m.style.height = x + "px", m.style.bottom === "0px" && (p.scrollTop = w > 0 ? w : 0, m.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = p.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Mp.displayName = xi;
var Ip = "SelectGroup", [dy, uy] = la(Ip), py = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...a } = e, r = ke();
    return /* @__PURE__ */ l.jsx(dy, { scope: n, id: r, children: /* @__PURE__ */ l.jsx(ee.div, { role: "group", "aria-labelledby": r, ...a, ref: t }) });
  }
);
py.displayName = Ip;
var Dp = "SelectLabel", Lp = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...a } = e, r = uy(Dp, n);
    return /* @__PURE__ */ l.jsx(ee.div, { id: r.id, ...a, ref: t });
  }
);
Lp.displayName = Dp;
var Mr = "SelectItem", [my, Fp] = la(Mr), Bp = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: a,
      disabled: r = !1,
      textValue: o,
      ...i
    } = e, s = sn(Mr, n), c = ln(Mr, n), u = s.value === a, [p, m] = d.useState(o ?? ""), [f, h] = d.useState(!1), v = ue(
      t,
      ($) => {
        var x;
        return (x = c.itemRefCallback) == null ? void 0 : x.call(c, $, a, r);
      }
    ), g = ke(), y = d.useRef("touch"), b = () => {
      r || (s.onValueChange(a), s.onOpenChange(!1));
    };
    if (a === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ l.jsx(
      my,
      {
        scope: n,
        value: a,
        disabled: r,
        textId: g,
        isSelected: u,
        onItemTextChange: d.useCallback(($) => {
          m((x) => x || (($ == null ? void 0 : $.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ l.jsx(
          Ro.ItemSlot,
          {
            scope: n,
            value: a,
            disabled: r,
            textValue: p,
            children: /* @__PURE__ */ l.jsx(
              ee.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": u && f,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...i,
                ref: v,
                onFocus: G(i.onFocus, () => h(!0)),
                onBlur: G(i.onBlur, () => h(!1)),
                onClick: G(i.onClick, () => {
                  y.current !== "mouse" && b();
                }),
                onPointerUp: G(i.onPointerUp, () => {
                  y.current === "mouse" && b();
                }),
                onPointerDown: G(i.onPointerDown, ($) => {
                  y.current = $.pointerType;
                }),
                onPointerMove: G(i.onPointerMove, ($) => {
                  var x;
                  y.current = $.pointerType, r ? (x = c.onItemLeave) == null || x.call(c) : y.current === "mouse" && $.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: G(i.onPointerLeave, ($) => {
                  var x;
                  $.currentTarget === document.activeElement && ((x = c.onItemLeave) == null || x.call(c));
                }),
                onKeyDown: G(i.onKeyDown, ($) => {
                  var w;
                  ((w = c.searchRef) == null ? void 0 : w.current) !== "" && $.key === " " || (Qv.includes($.key) && b(), $.key === " " && $.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Bp.displayName = Mr;
var xa = "SelectItemText", Up = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: a, style: r, ...o } = e, i = sn(xa, n), s = ln(xa, n), c = Fp(xa, n), u = ay(xa, n), [p, m] = d.useState(null), f = ue(
      t,
      (b) => m(b),
      c.onItemTextChange,
      (b) => {
        var $;
        return ($ = s.itemTextRefCallback) == null ? void 0 : $.call(s, b, c.value, c.disabled);
      }
    ), h = p == null ? void 0 : p.textContent, v = d.useMemo(
      () => /* @__PURE__ */ l.jsx("option", { value: c.value, disabled: c.disabled, children: h }, c.value),
      [c.disabled, c.value, h]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: y } = u;
    return Me(() => (g(v), () => y(v)), [g, y, v]), /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(ee.span, { id: c.textId, ...o, ref: f }),
      c.isSelected && i.valueNode && !i.valueNodeHasChildren ? Xr.createPortal(o.children, i.valueNode) : null
    ] });
  }
);
Up.displayName = xa;
var Gp = "SelectItemIndicator", Hp = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...a } = e;
    return Fp(Gp, n).isSelected ? /* @__PURE__ */ l.jsx(ee.span, { "aria-hidden": !0, ...a, ref: t }) : null;
  }
);
Hp.displayName = Gp;
var wi = "SelectScrollUpButton", Wp = d.forwardRef((e, t) => {
  const n = ln(wi, e.__scopeSelect), a = Bs(wi, e.__scopeSelect), [r, o] = d.useState(!1), i = ue(t, a.onScrollButtonChange);
  return Me(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = c.scrollTop > 0;
        o(u);
      };
      const c = n.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ l.jsx(
    zp,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = n;
        s && c && (s.scrollTop = s.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
Wp.displayName = wi;
var Ci = "SelectScrollDownButton", Vp = d.forwardRef((e, t) => {
  const n = ln(Ci, e.__scopeSelect), a = Bs(Ci, e.__scopeSelect), [r, o] = d.useState(!1), i = ue(t, a.onScrollButtonChange);
  return Me(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = c.scrollHeight - c.clientHeight, p = Math.ceil(c.scrollTop) < u;
        o(p);
      };
      const c = n.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ l.jsx(
    zp,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = n;
        s && c && (s.scrollTop = s.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
Vp.displayName = Ci;
var zp = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: a, ...r } = e, o = ln("SelectScrollButton", n), i = d.useRef(null), s = No(n), c = d.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return d.useEffect(() => () => c(), [c]), Me(() => {
    var p;
    const u = s().find((m) => m.ref.current === document.activeElement);
    (p = u == null ? void 0 : u.ref.current) == null || p.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ l.jsx(
    ee.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: G(r.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(a, 50));
      }),
      onPointerMove: G(r.onPointerMove, () => {
        var u;
        (u = o.onItemLeave) == null || u.call(o), i.current === null && (i.current = window.setInterval(a, 50));
      }),
      onPointerLeave: G(r.onPointerLeave, () => {
        c();
      })
    }
  );
}), fy = "SelectSeparator", Kp = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...a } = e;
    return /* @__PURE__ */ l.jsx(ee.div, { "aria-hidden": !0, ...a, ref: t });
  }
);
Kp.displayName = fy;
var Si = "SelectArrow", hy = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...a } = e, r = Ao(n), o = sn(Si, n), i = ln(Si, n);
    return o.open && i.position === "popper" ? /* @__PURE__ */ l.jsx(io, { ...r, ...a, ref: t }) : null;
  }
);
hy.displayName = Si;
function Zp(e) {
  return e === "" || e === void 0;
}
var Yp = d.forwardRef(
  (e, t) => {
    const { value: n, ...a } = e, r = d.useRef(null), o = ue(t, r), i = Qr(n);
    return d.useEffect(() => {
      const s = r.current, c = window.HTMLSelectElement.prototype, p = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (i !== n && p) {
        const m = new Event("change", { bubbles: !0 });
        p.call(s, n), s.dispatchEvent(m);
      }
    }, [i, n]), /* @__PURE__ */ l.jsx(ts, { asChild: !0, children: /* @__PURE__ */ l.jsx("select", { ...a, ref: o, defaultValue: n }) });
  }
);
Yp.displayName = "BubbleSelect";
function Xp(e) {
  const t = _e(e), n = d.useRef(""), a = d.useRef(0), r = d.useCallback(
    (i) => {
      const s = n.current + i;
      t(s), function c(u) {
        n.current = u, window.clearTimeout(a.current), u !== "" && (a.current = window.setTimeout(() => c(""), 1e3));
      }(s);
    },
    [t]
  ), o = d.useCallback(() => {
    n.current = "", window.clearTimeout(a.current);
  }, []);
  return d.useEffect(() => () => window.clearTimeout(a.current), []), [n, r, o];
}
function qp(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let i = gy(e, Math.max(o, 0));
  r.length === 1 && (i = i.filter((u) => u !== n));
  const c = i.find(
    (u) => u.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function gy(e, t) {
  return e.map((n, a) => e[(t + a) % e.length]);
}
var by = Ep, Jp = Np, vy = Pp, yy = _p, Qp = Tp, $y = Mp, em = Lp, tm = Bp, xy = Up, wy = Hp, nm = Wp, am = Vp, rm = Kp;
const Cy = by, Sy = vy, om = d.forwardRef(({ className: e, children: t, ...n }, a) => /* @__PURE__ */ l.jsxs(
  Jp,
  {
    ref: a,
    className: R(
      "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ l.jsx(yy, { asChild: !0, children: /* @__PURE__ */ l.jsx(ug, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
om.displayName = Jp.displayName;
const im = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  nm,
  {
    ref: n,
    className: R(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l.jsx(vg, {})
  }
));
im.displayName = nm.displayName;
const sm = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  am,
  {
    ref: n,
    className: R(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l.jsx(fg, {})
  }
));
sm.displayName = am.displayName;
const lm = d.forwardRef(({ className: e, children: t, position: n = "popper", ...a }, r) => /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsxs(
  Qp,
  {
    ref: r,
    className: R(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...a,
    children: [
      /* @__PURE__ */ l.jsx(im, {}),
      /* @__PURE__ */ l.jsx(
        $y,
        {
          className: R(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ l.jsx(sm, {})
    ]
  }
) }));
lm.displayName = Qp.displayName;
const Ey = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  em,
  {
    ref: n,
    className: R("px-2 py-1.5 text-sm font-semibold", e),
    ...t
  }
));
Ey.displayName = em.displayName;
const cm = d.forwardRef(({ className: e, children: t, ...n }, a) => /* @__PURE__ */ l.jsxs(
  tm,
  {
    ref: a,
    className: R(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-2 pr-8 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ l.jsx("span", { className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ l.jsx(wy, { children: /* @__PURE__ */ l.jsx(to, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ l.jsx(xy, { children: t })
    ]
  }
));
cm.displayName = tm.displayName;
const Ry = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  rm,
  {
    ref: n,
    className: R("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Ry.displayName = rm.displayName;
const Po = nn(
  void 0
);
function ir({ children: e, initialState: t, onChange: n }) {
  const [a, r] = He(t || { isChecked: !1 }), [o] = Cp(), i = hn((c, u) => {
    const p = { ...a, [c]: u };
    r(p), n == null || n(p);
  }, [n, a]), s = Bi(
    () => ({
      isChecked: a.isChecked,
      setValue: i
    }),
    [a.isChecked, i]
  );
  return /* @__PURE__ */ l.jsx(Po.Provider, { value: s, children: /* @__PURE__ */ l.jsx("div", { className: "bg-accent/50 rounded-lg p-4 space-y-4 overflow-hidden", ref: o, children: e }) });
}
function Ny() {
  const e = et(Po);
  if (!e)
    throw new Error("OrganizationDonationOption.Checkbox must be used within OrganizationDonationOption");
  const { isChecked: t, setValue: n } = e;
  return /* @__PURE__ */ l.jsx(
    Rn,
    {
      id: "organization",
      checked: t,
      onCheckedChange: () => n("isChecked", !t)
    }
  );
}
function Ay({ children: e }) {
  return /* @__PURE__ */ l.jsx(
    "label",
    {
      htmlFor: "organization",
      className: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      children: e
    }
  );
}
function Py({ children: e }) {
  const { isChecked: t } = et(Po) || {};
  return t ? /* @__PURE__ */ l.jsx("div", { className: "space-y-4", children: e }) : null;
}
function _y({ id: e, label: t, placeholder: n, value: a, ...r }) {
  const { setValue: o } = dm(), i = (s) => {
    o(e, s.target.value);
  };
  return /* @__PURE__ */ l.jsxs("div", { className: "space-y-1.5 mx-6", children: [
    /* @__PURE__ */ l.jsx("label", { htmlFor: e, className: "text-sm text-gray-600", children: t }),
    /* @__PURE__ */ l.jsx(bs, { id: e, placeholder: n, defaultValue: a, onChange: i, ...r, className: "bg-white" })
  ] });
}
function Ty({ id: e, label: t, options: n, placeholder: a, value: r, onChange: o }) {
  const { setValue: i } = dm(), s = (c) => {
    i(e, c), o == null || o(c);
  };
  return /* @__PURE__ */ l.jsxs("div", { className: "space-y-1.5 mx-6", children: [
    /* @__PURE__ */ l.jsx("label", { htmlFor: e, className: "text-sm text-gray-600", children: t }),
    /* @__PURE__ */ l.jsxs(Cy, { defaultValue: r, onValueChange: s, children: [
      /* @__PURE__ */ l.jsx(om, { id: e, className: "bg-white", children: /* @__PURE__ */ l.jsx(Sy, { placeholder: a }) }),
      /* @__PURE__ */ l.jsx(lm, { children: n.map((c) => /* @__PURE__ */ l.jsx(cm, { value: c.value, children: c.label }, c.value)) })
    ] })
  ] });
}
function dm() {
  const e = et(Po);
  if (!e)
    throw new Error("useOrganizationDonationOption must be used within OrganizationDonationOption");
  return e;
}
ir.Checkbox = Ny;
ir.Label = Ay;
ir.Details = Py;
ir.Input = _y;
ir.Select = Ty;
function um({ children: e }) {
  return /* @__PURE__ */ l.jsx("div", { className: "pt-6 space-y-3", children: e });
}
function ky({
  children: e,
  icon: t,
  bgColor: n = "bg-white",
  textColor: a = "text-black",
  hoverColor: r = "hover:bg-gray-50",
  onClick: o
}) {
  return /* @__PURE__ */ l.jsxs(
    Ne,
    {
      className: `w-full ${n} ${a} border ${r} h-12 flex items-center justify-center`,
      onClick: o,
      children: [
        t && /* @__PURE__ */ l.jsx("span", { className: "mr-2", children: t }),
        e
      ]
    }
  );
}
function Oy() {
  return /* @__PURE__ */ l.jsx("div", { className: "my-2 border-t border-gray-200" });
}
um.Button = ky;
um.Divider = Oy;
const Us = D.createContext(void 0);
function xn({
  items: e,
  initialSelectedIds: t = [],
  onSelectionChange: n
}) {
  const [a, r] = He(t), o = (i, s) => {
    const c = s ? [...a, i] : a.filter((u) => u !== i);
    r(c), n == null || n(c);
  };
  return /* @__PURE__ */ l.jsx(Us.Provider, { value: { selectedIds: a, handleSelect: o }, children: /* @__PURE__ */ l.jsx("div", { className: "space-y-4", children: e.map((i) => /* @__PURE__ */ l.jsx(xn.Item, { item: i }, i.id)) }) });
}
function jy({ item: e }) {
  const t = D.useContext(Us);
  if (!t)
    throw new Error("UpsellDonationList.Item must be used within UpsellDonationList");
  const { selectedIds: n, handleSelect: a } = t, r = n.includes(e.id);
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      onClick: () => a(e.id, !r),
      className: `flex items-center gap-3 rounded-lg bg-gray-50 p-4 cursor-pointer select-none ${r ? "border border-primary" : "border border-transparent"}`,
      children: [
        /* @__PURE__ */ l.jsx(
          Rn,
          {
            checked: r,
            onCheckedChange: (o) => a(e.id, o),
            onClick: (o) => o.stopPropagation(),
            className: "self-center"
          }
        ),
        e.imageSrc && /* @__PURE__ */ l.jsx(xn.Image, { src: e.imageSrc, alt: e.name }),
        /* @__PURE__ */ l.jsx(
          xn.Content,
          {
            name: e.name,
            amount: e.amount,
            description: e.description,
            isSelected: r
          }
        )
      ]
    }
  );
}
function My({ itemId: e }) {
  const t = D.useContext(Us);
  if (!t)
    throw new Error("UpsellDonationList.Checkbox must be used within UpsellDonationList");
  const { selectedIds: n, handleSelect: a } = t;
  return /* @__PURE__ */ l.jsx(
    Rn,
    {
      checked: n.includes(e),
      onCheckedChange: (r) => a(e, r),
      className: "self-center"
    }
  );
}
function Iy({ src: e, alt: t }) {
  return /* @__PURE__ */ l.jsx("div", { className: "h-12 w-12 overflow-hidden rounded-md bg-gray-200", children: /* @__PURE__ */ l.jsx("img", { src: e, alt: t, className: "h-full w-full object-cover" }) });
}
function Dy({ name: e, amount: t, description: n, isSelected: a }) {
  return /* @__PURE__ */ l.jsxs("div", { className: "flex flex-1 items-center justify-between", children: [
    /* @__PURE__ */ l.jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ l.jsx("h4", { className: "font-medium", children: e }),
      /* @__PURE__ */ l.jsx("p", { className: "text-sm text-gray-600", children: n })
    ] }),
    /* @__PURE__ */ l.jsx("p", { className: `font-semibold ${a ? "" : "opacity-40"}`, children: t })
  ] });
}
xn.Item = jy;
xn.Checkbox = My;
xn.Image = Iy;
xn.Content = Dy;
const GC = xo, HC = Ns, WC = Co, Ly = wo, pm = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ia,
  {
    className: R(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
pm.displayName = ia.displayName;
const Fy = Jr(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), By = d.forwardRef(({ side: e = "right", className: t, children: n, ...a }, r) => /* @__PURE__ */ l.jsxs(Ly, { children: [
  /* @__PURE__ */ l.jsx(pm, {}),
  /* @__PURE__ */ l.jsx(
    sa,
    {
      ref: r,
      className: R(Fy({ side: e }), t),
      ...a,
      children: n
    }
  )
] }));
By.displayName = sa.displayName;
const Uy = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
Uy.displayName = "SheetHeader";
const Gy = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
Gy.displayName = "SheetFooter";
const Hy = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ar,
  {
    ref: n,
    className: R("text-lg font-semibold text-foreground", e),
    ...t
  }
));
Hy.displayName = ar.displayName;
const Wy = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  rr,
  {
    ref: n,
    className: R("text-sm text-muted-foreground", e),
    ...t
  }
));
Wy.displayName = rr.displayName;
var Vy = Object.defineProperty, zy = Object.defineProperties, Ky = Object.getOwnPropertyDescriptors, Ir = Object.getOwnPropertySymbols, mm = Object.prototype.hasOwnProperty, fm = Object.prototype.propertyIsEnumerable, jl = (e, t, n) => t in e ? Vy(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Zy = (e, t) => {
  for (var n in t || (t = {})) mm.call(t, n) && jl(e, n, t[n]);
  if (Ir) for (var n of Ir(t)) fm.call(t, n) && jl(e, n, t[n]);
  return e;
}, Yy = (e, t) => zy(e, Ky(t)), Xy = (e, t) => {
  var n = {};
  for (var a in e) mm.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
  if (e != null && Ir) for (var a of Ir(e)) t.indexOf(a) < 0 && fm.call(e, a) && (n[a] = e[a]);
  return n;
};
function qy(e) {
  let t = setTimeout(e, 0), n = setTimeout(e, 10), a = setTimeout(e, 50);
  return [t, n, a];
}
function Jy(e) {
  let t = d.useRef();
  return d.useEffect(() => {
    t.current = e;
  }), t.current;
}
var Qy = 18, hm = 40, e$ = `${hm}px`, t$ = ["[data-lastpass-icon-root]", "com-1password-button", "[data-dashlanecreated]", '[style$="2147483647 !important;"]'].join(",");
function n$({ containerRef: e, inputRef: t, pushPasswordManagerStrategy: n, isFocused: a }) {
  let [r, o] = d.useState(!1), [i, s] = d.useState(!1), [c, u] = d.useState(!1), p = d.useMemo(() => n === "none" ? !1 : (n === "increase-width" || n === "experimental-no-flickering") && r && i, [r, i, n]), m = d.useCallback(() => {
    let f = e.current, h = t.current;
    if (!f || !h || c || n === "none") return;
    let v = f, g = v.getBoundingClientRect().left + v.offsetWidth, y = v.getBoundingClientRect().top + v.offsetHeight / 2, b = g - Qy, $ = y;
    document.querySelectorAll(t$).length === 0 && document.elementFromPoint(b, $) === f || (o(!0), u(!0));
  }, [e, t, c, n]);
  return d.useEffect(() => {
    let f = e.current;
    if (!f || n === "none") return;
    function h() {
      let g = window.innerWidth - f.getBoundingClientRect().right;
      s(g >= hm);
    }
    h();
    let v = setInterval(h, 1e3);
    return () => {
      clearInterval(v);
    };
  }, [e, n]), d.useEffect(() => {
    let f = a || document.activeElement === t.current;
    if (n === "none" || !f) return;
    let h = setTimeout(m, 0), v = setTimeout(m, 2e3), g = setTimeout(m, 5e3), y = setTimeout(() => {
      u(!0);
    }, 6e3);
    return () => {
      clearTimeout(h), clearTimeout(v), clearTimeout(g), clearTimeout(y);
    };
  }, [t, a, n, m]), { hasPWMBadge: r, willPushPWMBadge: p, PWM_BADGE_SPACE_WIDTH: e$ };
}
var gm = d.createContext({}), bm = d.forwardRef((e, t) => {
  var n = e, { value: a, onChange: r, maxLength: o, textAlign: i = "left", pattern: s, placeholder: c, inputMode: u = "numeric", onComplete: p, pushPasswordManagerStrategy: m = "increase-width", pasteTransformer: f, containerClassName: h, noScriptCSSFallback: v = a$, render: g, children: y } = n, b = Xy(n, ["value", "onChange", "maxLength", "textAlign", "pattern", "placeholder", "inputMode", "onComplete", "pushPasswordManagerStrategy", "pasteTransformer", "containerClassName", "noScriptCSSFallback", "render", "children"]), $, x, w, S, P;
  let [C, T] = d.useState(typeof b.defaultValue == "string" ? b.defaultValue : ""), A = a ?? C, L = Jy(A), V = d.useCallback((k) => {
    r == null || r(k), T(k);
  }, [r]), M = d.useMemo(() => s ? typeof s == "string" ? new RegExp(s) : s : null, [s]), _ = d.useRef(null), K = d.useRef(null), Q = d.useRef({ value: A, onChange: V, isIOS: typeof window < "u" && ((x = ($ = window == null ? void 0 : window.CSS) == null ? void 0 : $.supports) == null ? void 0 : x.call($, "-webkit-touch-callout", "none")) }), W = d.useRef({ prev: [(w = _.current) == null ? void 0 : w.selectionStart, (S = _.current) == null ? void 0 : S.selectionEnd, (P = _.current) == null ? void 0 : P.selectionDirection] });
  d.useImperativeHandle(t, () => _.current, []), d.useEffect(() => {
    let k = _.current, oe = K.current;
    if (!k || !oe) return;
    Q.current.value !== k.value && Q.current.onChange(k.value), W.current.prev = [k.selectionStart, k.selectionEnd, k.selectionDirection];
    function xe() {
      if (document.activeElement !== k) {
        E(null), X(null);
        return;
      }
      let be = k.selectionStart, Ae = k.selectionEnd, dn = k.selectionDirection, Ke = k.maxLength, Ze = k.value, nt = W.current.prev, at = -1, ht = -1, At;
      if (Ze.length !== 0 && be !== null && Ae !== null) {
        let Io = be === Ae, pn = be === Ze.length && Ze.length < Ke;
        if (Io && !pn) {
          let gt = be;
          if (gt === 0) at = 0, ht = 1, At = "forward";
          else if (gt === Ke) at = gt - 1, ht = gt, At = "backward";
          else if (Ke > 1 && Ze.length > 1) {
            let da = 0;
            if (nt[0] !== null && nt[1] !== null) {
              At = gt < nt[1] ? "backward" : "forward";
              let Do = nt[0] === nt[1] && nt[0] < Ke;
              At === "backward" && !Do && (da = -1);
            }
            at = da + gt, ht = da + gt + 1;
          }
        }
        at !== -1 && ht !== -1 && at !== ht && _.current.setSelectionRange(at, ht, At);
      }
      let un = at !== -1 ? at : be, dr = ht !== -1 ? ht : Ae, ur = At ?? dn;
      E(un), X(dr), W.current.prev = [un, dr, ur];
    }
    if (document.addEventListener("selectionchange", xe, { capture: !0 }), xe(), document.activeElement === k && N(!0), !document.getElementById("input-otp-style")) {
      let be = document.createElement("style");
      if (be.id = "input-otp-style", document.head.appendChild(be), be.sheet) {
        let Ae = "background: transparent !important; color: transparent !important; border-color: transparent !important; opacity: 0 !important; box-shadow: none !important; -webkit-box-shadow: none !important; -webkit-text-fill-color: transparent !important;";
        ha(be.sheet, "[data-input-otp]::selection { background: transparent !important; color: transparent !important; }"), ha(be.sheet, `[data-input-otp]:autofill { ${Ae} }`), ha(be.sheet, `[data-input-otp]:-webkit-autofill { ${Ae} }`), ha(be.sheet, "@supports (-webkit-touch-callout: none) { [data-input-otp] { letter-spacing: -.6em !important; font-weight: 100 !important; font-stretch: ultra-condensed; font-optical-sizing: none !important; left: -1px !important; right: 1px !important; } }"), ha(be.sheet, "[data-input-otp] + * { pointer-events: all !important; }");
      }
    }
    let Se = () => {
      oe && oe.style.setProperty("--root-height", `${k.clientHeight}px`);
    };
    Se();
    let je = new ResizeObserver(Se);
    return je.observe(k), () => {
      document.removeEventListener("selectionchange", xe, { capture: !0 }), je.disconnect();
    };
  }, []);
  let [q, z] = d.useState(!1), [j, N] = d.useState(!1), [F, E] = d.useState(null), [B, X] = d.useState(null);
  d.useEffect(() => {
    qy(() => {
      var k, oe, xe, Se;
      (k = _.current) == null || k.dispatchEvent(new Event("input"));
      let je = (oe = _.current) == null ? void 0 : oe.selectionStart, be = (xe = _.current) == null ? void 0 : xe.selectionEnd, Ae = (Se = _.current) == null ? void 0 : Se.selectionDirection;
      je !== null && be !== null && (E(je), X(be), W.current.prev = [je, be, Ae]);
    });
  }, [A, j]), d.useEffect(() => {
    L !== void 0 && A !== L && L.length < o && A.length === o && (p == null || p(A));
  }, [o, p, L, A]);
  let U = n$({ containerRef: K, inputRef: _, pushPasswordManagerStrategy: m, isFocused: j }), ne = d.useCallback((k) => {
    let oe = k.currentTarget.value.slice(0, o);
    if (oe.length > 0 && M && !M.test(oe)) {
      k.preventDefault();
      return;
    }
    typeof L == "string" && oe.length < L.length && document.dispatchEvent(new Event("selectionchange")), V(oe);
  }, [o, V, L, M]), I = d.useCallback(() => {
    var k;
    if (_.current) {
      let oe = Math.min(_.current.value.length, o - 1), xe = _.current.value.length;
      (k = _.current) == null || k.setSelectionRange(oe, xe), E(oe), X(xe);
    }
    N(!0);
  }, [o]), Y = d.useCallback((k) => {
    var oe, xe;
    let Se = _.current;
    if (!f && (!Q.current.isIOS || !k.clipboardData || !Se)) return;
    let je = k.clipboardData.getData("text/plain"), be = f ? f(je) : je;
    k.preventDefault();
    let Ae = (oe = _.current) == null ? void 0 : oe.selectionStart, dn = (xe = _.current) == null ? void 0 : xe.selectionEnd, Ke = (Ae !== dn ? A.slice(0, Ae) + be + A.slice(dn) : A.slice(0, Ae) + be + A.slice(Ae)).slice(0, o);
    if (Ke.length > 0 && M && !M.test(Ke)) return;
    Se.value = Ke, V(Ke);
    let Ze = Math.min(Ke.length, o - 1), nt = Ke.length;
    Se.setSelectionRange(Ze, nt), E(Ze), X(nt);
  }, [o, V, M, A]), te = d.useMemo(() => ({ position: "relative", cursor: b.disabled ? "default" : "text", userSelect: "none", WebkitUserSelect: "none", pointerEvents: "none" }), [b.disabled]), le = d.useMemo(() => ({ position: "absolute", inset: 0, width: U.willPushPWMBadge ? `calc(100% + ${U.PWM_BADGE_SPACE_WIDTH})` : "100%", clipPath: U.willPushPWMBadge ? `inset(0 ${U.PWM_BADGE_SPACE_WIDTH} 0 0)` : void 0, height: "100%", display: "flex", textAlign: i, opacity: "1", color: "transparent", pointerEvents: "all", background: "transparent", caretColor: "transparent", border: "0 solid transparent", outline: "0 solid transparent", boxShadow: "none", lineHeight: "1", letterSpacing: "-.5em", fontSize: "var(--root-height)", fontFamily: "monospace", fontVariantNumeric: "tabular-nums" }), [U.PWM_BADGE_SPACE_WIDTH, U.willPushPWMBadge, i]), me = d.useMemo(() => d.createElement("input", Yy(Zy({ autoComplete: b.autoComplete || "one-time-code" }, b), { "data-input-otp": !0, "data-input-otp-placeholder-shown": A.length === 0 || void 0, "data-input-otp-mss": F, "data-input-otp-mse": B, inputMode: u, pattern: M == null ? void 0 : M.source, "aria-placeholder": c, style: le, maxLength: o, value: A, ref: _, onPaste: (k) => {
    var oe;
    Y(k), (oe = b.onPaste) == null || oe.call(b, k);
  }, onChange: ne, onMouseOver: (k) => {
    var oe;
    z(!0), (oe = b.onMouseOver) == null || oe.call(b, k);
  }, onMouseLeave: (k) => {
    var oe;
    z(!1), (oe = b.onMouseLeave) == null || oe.call(b, k);
  }, onFocus: (k) => {
    var oe;
    I(), (oe = b.onFocus) == null || oe.call(b, k);
  }, onBlur: (k) => {
    var oe;
    N(!1), (oe = b.onBlur) == null || oe.call(b, k);
  } })), [ne, I, Y, u, le, o, B, F, b, M == null ? void 0 : M.source, A]), fe = d.useMemo(() => ({ slots: Array.from({ length: o }).map((k, oe) => {
    var xe;
    let Se = j && F !== null && B !== null && (F === B && oe === F || oe >= F && oe < B), je = A[oe] !== void 0 ? A[oe] : null, be = A[0] !== void 0 ? null : (xe = c == null ? void 0 : c[oe]) != null ? xe : null;
    return { char: je, placeholderChar: be, isActive: Se, hasFakeCaret: Se && je === null };
  }), isFocused: j, isHovering: !b.disabled && q }), [j, q, o, B, F, b.disabled, A]), Oe = d.useMemo(() => g ? g(fe) : d.createElement(gm.Provider, { value: fe }, y), [y, fe, g]);
  return d.createElement(d.Fragment, null, v !== null && d.createElement("noscript", null, d.createElement("style", null, v)), d.createElement("div", { ref: K, "data-input-otp-container": !0, style: te, className: h }, Oe, d.createElement("div", { style: { position: "absolute", inset: 0, pointerEvents: "none" } }, me)));
});
bm.displayName = "Input";
function ha(e, t) {
  try {
    e.insertRule(t);
  } catch {
    console.error("input-otp could not insert CSS rule:", t);
  }
}
var a$ = `
[data-input-otp] {
  --nojs-bg: white !important;
  --nojs-fg: black !important;

  background-color: var(--nojs-bg) !important;
  color: var(--nojs-fg) !important;
  caret-color: var(--nojs-fg) !important;
  letter-spacing: .25em !important;
  text-align: center !important;
  border: 1px solid var(--nojs-fg) !important;
  border-radius: 4px !important;
  width: 100% !important;
}
@media (prefers-color-scheme: dark) {
  [data-input-otp] {
    --nojs-bg: black !important;
    --nojs-fg: white !important;
  }
}`;
const r$ = d.forwardRef(({ className: e, containerClassName: t, ...n }, a) => /* @__PURE__ */ l.jsx(
  bm,
  {
    ref: a,
    containerClassName: R(
      "flex items-center gap-2 has-[:disabled]:opacity-50",
      t
    ),
    className: R("disabled:cursor-not-allowed", e),
    ...n
  }
));
r$.displayName = "InputOTP";
const o$ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx("div", { ref: n, className: R("flex items-center", e), ...t }));
o$.displayName = "InputOTPGroup";
const i$ = d.forwardRef(({ index: e, className: t, ...n }, a) => {
  const r = d.useContext(gm), { char: o, hasFakeCaret: i, isActive: s } = r.slots[e];
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      ref: a,
      className: R(
        "relative flex h-9 w-9 items-center justify-center border-y border-r border-input text-sm shadow-sm transition-all first:rounded-l-md first:border-l last:rounded-r-md",
        s && "z-10 ring-1 ring-ring",
        t
      ),
      ...n,
      children: [
        o,
        i && /* @__PURE__ */ l.jsx("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ l.jsx("div", { className: "h-4 w-px animate-caret-blink bg-foreground duration-1000" }) })
      ]
    }
  );
});
i$.displayName = "InputOTPSlot";
const s$ = d.forwardRef(({ ...e }, t) => /* @__PURE__ */ l.jsx("div", { ref: t, role: "separator", ...e, children: /* @__PURE__ */ l.jsx(wg, {}) }));
s$.displayName = "InputOTPSeparator";
const l$ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: n,
    className: R(
      "rounded-xl border bg-card text-card-foreground shadow",
      e
    ),
    ...t
  }
));
l$.displayName = "Card";
const c$ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: n,
    className: R("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
c$.displayName = "CardHeader";
const d$ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: n,
    className: R("font-semibold leading-none tracking-tight", e),
    ...t
  }
));
d$.displayName = "CardTitle";
const u$ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: n,
    className: R("text-sm text-muted-foreground", e),
    ...t
  }
));
u$.displayName = "CardDescription";
const p$ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx("div", { ref: n, className: R("p-6 pt-0", e), ...t }));
p$.displayName = "CardContent";
const m$ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  "div",
  {
    ref: n,
    className: R("flex items-center p-6 pt-0", e),
    ...t
  }
));
m$.displayName = "CardFooter";
const f$ = Jr(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function VC({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ l.jsx("div", { className: R(f$({ variant: t }), e), ...n });
}
const h$ = d.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
    "textarea",
    {
      className: R(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: n,
      ...t
    }
  )
);
h$.displayName = "Textarea";
function zC({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: R("animate-pulse rounded-md bg-primary/10", e),
      ...t
    }
  );
}
function g$(e, t) {
  return d.useReducer((n, a) => t[n][a] ?? n, e);
}
var Gs = "ScrollArea", [vm, KC] = Ve(Gs), [b$, tt] = vm(Gs), ym = d.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: a = "hover",
      dir: r,
      scrollHideDelay: o = 600,
      ...i
    } = e, [s, c] = d.useState(null), [u, p] = d.useState(null), [m, f] = d.useState(null), [h, v] = d.useState(null), [g, y] = d.useState(null), [b, $] = d.useState(0), [x, w] = d.useState(0), [S, P] = d.useState(!1), [C, T] = d.useState(!1), A = ue(t, (V) => c(V)), L = Ya(r);
    return /* @__PURE__ */ l.jsx(
      b$,
      {
        scope: n,
        type: a,
        dir: L,
        scrollHideDelay: o,
        scrollArea: s,
        viewport: u,
        onViewportChange: p,
        content: m,
        onContentChange: f,
        scrollbarX: h,
        onScrollbarXChange: v,
        scrollbarXEnabled: S,
        onScrollbarXEnabledChange: P,
        scrollbarY: g,
        onScrollbarYChange: y,
        scrollbarYEnabled: C,
        onScrollbarYEnabledChange: T,
        onCornerWidthChange: $,
        onCornerHeightChange: w,
        children: /* @__PURE__ */ l.jsx(
          ee.div,
          {
            dir: L,
            ...i,
            ref: A,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
ym.displayName = Gs;
var $m = "ScrollAreaViewport", xm = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: a, nonce: r, ...o } = e, i = tt($m, n), s = d.useRef(null), c = ue(t, s, i.onViewportChange);
    return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      /* @__PURE__ */ l.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ l.jsx(
        ee.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...o,
          ref: c,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ l.jsx("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: a })
        }
      )
    ] });
  }
);
xm.displayName = $m;
var Nt = "ScrollAreaScrollbar", Hs = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...a } = e, r = tt(Nt, e.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: i } = r, s = e.orientation === "horizontal";
    return d.useEffect(() => (s ? o(!0) : i(!0), () => {
      s ? o(!1) : i(!1);
    }), [s, o, i]), r.type === "hover" ? /* @__PURE__ */ l.jsx(v$, { ...a, ref: t, forceMount: n }) : r.type === "scroll" ? /* @__PURE__ */ l.jsx(y$, { ...a, ref: t, forceMount: n }) : r.type === "auto" ? /* @__PURE__ */ l.jsx(wm, { ...a, ref: t, forceMount: n }) : r.type === "always" ? /* @__PURE__ */ l.jsx(Ws, { ...a, ref: t }) : null;
  }
);
Hs.displayName = Nt;
var v$ = d.forwardRef((e, t) => {
  const { forceMount: n, ...a } = e, r = tt(Nt, e.__scopeScrollArea), [o, i] = d.useState(!1);
  return d.useEffect(() => {
    const s = r.scrollArea;
    let c = 0;
    if (s) {
      const u = () => {
        window.clearTimeout(c), i(!0);
      }, p = () => {
        c = window.setTimeout(() => i(!1), r.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", u), s.addEventListener("pointerleave", p), () => {
        window.clearTimeout(c), s.removeEventListener("pointerenter", u), s.removeEventListener("pointerleave", p);
      };
    }
  }, [r.scrollArea, r.scrollHideDelay]), /* @__PURE__ */ l.jsx(De, { present: n || o, children: /* @__PURE__ */ l.jsx(
    wm,
    {
      "data-state": o ? "visible" : "hidden",
      ...a,
      ref: t
    }
  ) });
}), y$ = d.forwardRef((e, t) => {
  const { forceMount: n, ...a } = e, r = tt(Nt, e.__scopeScrollArea), o = e.orientation === "horizontal", i = To(() => c("SCROLL_END"), 100), [s, c] = g$("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return d.useEffect(() => {
    if (s === "idle") {
      const u = window.setTimeout(() => c("HIDE"), r.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [s, r.scrollHideDelay, c]), d.useEffect(() => {
    const u = r.viewport, p = o ? "scrollLeft" : "scrollTop";
    if (u) {
      let m = u[p];
      const f = () => {
        const h = u[p];
        m !== h && (c("SCROLL"), i()), m = h;
      };
      return u.addEventListener("scroll", f), () => u.removeEventListener("scroll", f);
    }
  }, [r.viewport, o, c, i]), /* @__PURE__ */ l.jsx(De, { present: n || s !== "hidden", children: /* @__PURE__ */ l.jsx(
    Ws,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...a,
      ref: t,
      onPointerEnter: G(e.onPointerEnter, () => c("POINTER_ENTER")),
      onPointerLeave: G(e.onPointerLeave, () => c("POINTER_LEAVE"))
    }
  ) });
}), wm = d.forwardRef((e, t) => {
  const n = tt(Nt, e.__scopeScrollArea), { forceMount: a, ...r } = e, [o, i] = d.useState(!1), s = e.orientation === "horizontal", c = To(() => {
    if (n.viewport) {
      const u = n.viewport.offsetWidth < n.viewport.scrollWidth, p = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(s ? u : p);
    }
  }, 10);
  return qn(n.viewport, c), qn(n.content, c), /* @__PURE__ */ l.jsx(De, { present: a || o, children: /* @__PURE__ */ l.jsx(
    Ws,
    {
      "data-state": o ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), Ws = d.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...a } = e, r = tt(Nt, e.__scopeScrollArea), o = d.useRef(null), i = d.useRef(0), [s, c] = d.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = Nm(s.viewport, s.content), p = {
    ...a,
    sizes: s,
    onSizesChange: c,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (f) => o.current = f,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (f) => i.current = f
  };
  function m(f, h) {
    return E$(f, i.current, s, h);
  }
  return n === "horizontal" ? /* @__PURE__ */ l.jsx(
    $$,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && o.current) {
          const f = r.viewport.scrollLeft, h = Ml(f, s, r.dir);
          o.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (f) => {
        r.viewport && (r.viewport.scrollLeft = f);
      },
      onDragScroll: (f) => {
        r.viewport && (r.viewport.scrollLeft = m(f, r.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ l.jsx(
    x$,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && o.current) {
          const f = r.viewport.scrollTop, h = Ml(f, s);
          o.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (f) => {
        r.viewport && (r.viewport.scrollTop = f);
      },
      onDragScroll: (f) => {
        r.viewport && (r.viewport.scrollTop = m(f));
      }
    }
  ) : null;
}), $$ = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: a, ...r } = e, o = tt(Nt, e.__scopeScrollArea), [i, s] = d.useState(), c = d.useRef(null), u = ue(t, c, o.onScrollbarXChange);
  return d.useEffect(() => {
    c.current && s(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ l.jsx(
    Sm,
    {
      "data-orientation": "horizontal",
      ...r,
      ref: u,
      sizes: n,
      style: {
        bottom: 0,
        left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": _o(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.x),
      onDragScroll: (p) => e.onDragScroll(p.x),
      onWheelScroll: (p, m) => {
        if (o.viewport) {
          const f = o.viewport.scrollLeft + p.deltaX;
          e.onWheelScroll(f), Pm(f, m) && p.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && i && a({
          content: o.viewport.scrollWidth,
          viewport: o.viewport.offsetWidth,
          scrollbar: {
            size: c.current.clientWidth,
            paddingStart: Lr(i.paddingLeft),
            paddingEnd: Lr(i.paddingRight)
          }
        });
      }
    }
  );
}), x$ = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: a, ...r } = e, o = tt(Nt, e.__scopeScrollArea), [i, s] = d.useState(), c = d.useRef(null), u = ue(t, c, o.onScrollbarYChange);
  return d.useEffect(() => {
    c.current && s(getComputedStyle(c.current));
  }, [c]), /* @__PURE__ */ l.jsx(
    Sm,
    {
      "data-orientation": "vertical",
      ...r,
      ref: u,
      sizes: n,
      style: {
        top: 0,
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": _o(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.y),
      onDragScroll: (p) => e.onDragScroll(p.y),
      onWheelScroll: (p, m) => {
        if (o.viewport) {
          const f = o.viewport.scrollTop + p.deltaY;
          e.onWheelScroll(f), Pm(f, m) && p.preventDefault();
        }
      },
      onResize: () => {
        c.current && o.viewport && i && a({
          content: o.viewport.scrollHeight,
          viewport: o.viewport.offsetHeight,
          scrollbar: {
            size: c.current.clientHeight,
            paddingStart: Lr(i.paddingTop),
            paddingEnd: Lr(i.paddingBottom)
          }
        });
      }
    }
  );
}), [w$, Cm] = vm(Nt), Sm = d.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: a,
    hasThumb: r,
    onThumbChange: o,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: c,
    onDragScroll: u,
    onWheelScroll: p,
    onResize: m,
    ...f
  } = e, h = tt(Nt, n), [v, g] = d.useState(null), y = ue(t, (A) => g(A)), b = d.useRef(null), $ = d.useRef(""), x = h.viewport, w = a.content - a.viewport, S = _e(p), P = _e(c), C = To(m, 10);
  function T(A) {
    if (b.current) {
      const L = A.clientX - b.current.left, V = A.clientY - b.current.top;
      u({ x: L, y: V });
    }
  }
  return d.useEffect(() => {
    const A = (L) => {
      const V = L.target;
      (v == null ? void 0 : v.contains(V)) && S(L, w);
    };
    return document.addEventListener("wheel", A, { passive: !1 }), () => document.removeEventListener("wheel", A, { passive: !1 });
  }, [x, v, w, S]), d.useEffect(P, [a, P]), qn(v, C), qn(h.content, C), /* @__PURE__ */ l.jsx(
    w$,
    {
      scope: n,
      scrollbar: v,
      hasThumb: r,
      onThumbChange: _e(o),
      onThumbPointerUp: _e(i),
      onThumbPositionChange: P,
      onThumbPointerDown: _e(s),
      children: /* @__PURE__ */ l.jsx(
        ee.div,
        {
          ...f,
          ref: y,
          style: { position: "absolute", ...f.style },
          onPointerDown: G(e.onPointerDown, (A) => {
            A.button === 0 && (A.target.setPointerCapture(A.pointerId), b.current = v.getBoundingClientRect(), $.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), T(A));
          }),
          onPointerMove: G(e.onPointerMove, T),
          onPointerUp: G(e.onPointerUp, (A) => {
            const L = A.target;
            L.hasPointerCapture(A.pointerId) && L.releasePointerCapture(A.pointerId), document.body.style.webkitUserSelect = $.current, h.viewport && (h.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), Dr = "ScrollAreaThumb", Em = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...a } = e, r = Cm(Dr, e.__scopeScrollArea);
    return /* @__PURE__ */ l.jsx(De, { present: n || r.hasThumb, children: /* @__PURE__ */ l.jsx(C$, { ref: t, ...a }) });
  }
), C$ = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: a, ...r } = e, o = tt(Dr, n), i = Cm(Dr, n), { onThumbPositionChange: s } = i, c = ue(
      t,
      (m) => i.onThumbChange(m)
    ), u = d.useRef(void 0), p = To(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return d.useEffect(() => {
      const m = o.viewport;
      if (m) {
        const f = () => {
          if (p(), !u.current) {
            const h = R$(m, s);
            u.current = h, s();
          }
        };
        return s(), m.addEventListener("scroll", f), () => m.removeEventListener("scroll", f);
      }
    }, [o.viewport, p, s]), /* @__PURE__ */ l.jsx(
      ee.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...r,
        ref: c,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...a
        },
        onPointerDownCapture: G(e.onPointerDownCapture, (m) => {
          const h = m.target.getBoundingClientRect(), v = m.clientX - h.left, g = m.clientY - h.top;
          i.onThumbPointerDown({ x: v, y: g });
        }),
        onPointerUp: G(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
Em.displayName = Dr;
var Vs = "ScrollAreaCorner", Rm = d.forwardRef(
  (e, t) => {
    const n = tt(Vs, e.__scopeScrollArea), a = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && a ? /* @__PURE__ */ l.jsx(S$, { ...e, ref: t }) : null;
  }
);
Rm.displayName = Vs;
var S$ = d.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...a } = e, r = tt(Vs, n), [o, i] = d.useState(0), [s, c] = d.useState(0), u = !!(o && s);
  return qn(r.scrollbarX, () => {
    var m;
    const p = ((m = r.scrollbarX) == null ? void 0 : m.offsetHeight) || 0;
    r.onCornerHeightChange(p), c(p);
  }), qn(r.scrollbarY, () => {
    var m;
    const p = ((m = r.scrollbarY) == null ? void 0 : m.offsetWidth) || 0;
    r.onCornerWidthChange(p), i(p);
  }), u ? /* @__PURE__ */ l.jsx(
    ee.div,
    {
      ...a,
      ref: t,
      style: {
        width: o,
        height: s,
        position: "absolute",
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Lr(e) {
  return e ? parseInt(e, 10) : 0;
}
function Nm(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function _o(e) {
  const t = Nm(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, a = (e.scrollbar.size - n) * t;
  return Math.max(a, 18);
}
function E$(e, t, n, a = "ltr") {
  const r = _o(n), o = r / 2, i = t || o, s = r - i, c = n.scrollbar.paddingStart + i, u = n.scrollbar.size - n.scrollbar.paddingEnd - s, p = n.content - n.viewport, m = a === "ltr" ? [0, p] : [p * -1, 0];
  return Am([c, u], m)(e);
}
function Ml(e, t, n = "ltr") {
  const a = _o(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, o = t.scrollbar.size - r, i = t.content - t.viewport, s = o - a, c = n === "ltr" ? [0, i] : [i * -1, 0], u = yi(e, c);
  return Am([0, i], [0, s])(u);
}
function Am(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const a = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + a * (n - e[0]);
  };
}
function Pm(e, t) {
  return e > 0 && e < t;
}
var R$ = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, a = 0;
  return function r() {
    const o = { left: e.scrollLeft, top: e.scrollTop }, i = n.left !== o.left, s = n.top !== o.top;
    (i || s) && t(), n = o, a = window.requestAnimationFrame(r);
  }(), () => window.cancelAnimationFrame(a);
};
function To(e, t) {
  const n = _e(e), a = d.useRef(0);
  return d.useEffect(() => () => window.clearTimeout(a.current), []), d.useCallback(() => {
    window.clearTimeout(a.current), a.current = window.setTimeout(n, t);
  }, [n, t]);
}
function qn(e, t) {
  const n = _e(t);
  Me(() => {
    let a = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(a), a = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(a), r.unobserve(e);
      };
    }
  }, [e, n]);
}
var _m = ym, N$ = xm, A$ = Rm;
const P$ = d.forwardRef(({ className: e, children: t, ...n }, a) => /* @__PURE__ */ l.jsxs(
  _m,
  {
    ref: a,
    className: R("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ l.jsx(N$, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ l.jsx(Tm, {}),
      /* @__PURE__ */ l.jsx(A$, {})
    ]
  }
));
P$.displayName = _m.displayName;
const Tm = d.forwardRef(({ className: e, orientation: t = "vertical", ...n }, a) => /* @__PURE__ */ l.jsx(
  Hs,
  {
    ref: a,
    orientation: t,
    className: R(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ l.jsx(Em, { className: "relative flex-1 rounded-full bg-border" })
  }
));
Tm.displayName = Hs.displayName;
var Il = 1, _$ = 0.9, T$ = 0.8, k$ = 0.17, Xo = 0.1, qo = 0.999, O$ = 0.9999, j$ = 0.99, M$ = /[\\\/_+.#"@\[\(\{&]/, I$ = /[\\\/_+.#"@\[\(\{&]/g, D$ = /[\s-]/, km = /[\s-]/g;
function Ei(e, t, n, a, r, o, i) {
  if (o === t.length) return r === e.length ? Il : j$;
  var s = `${r},${o}`;
  if (i[s] !== void 0) return i[s];
  for (var c = a.charAt(o), u = n.indexOf(c, r), p = 0, m, f, h, v; u >= 0; ) m = Ei(e, t, n, a, u + 1, o + 1, i), m > p && (u === r ? m *= Il : M$.test(e.charAt(u - 1)) ? (m *= T$, h = e.slice(r, u - 1).match(I$), h && r > 0 && (m *= Math.pow(qo, h.length))) : D$.test(e.charAt(u - 1)) ? (m *= _$, v = e.slice(r, u - 1).match(km), v && r > 0 && (m *= Math.pow(qo, v.length))) : (m *= k$, r > 0 && (m *= Math.pow(qo, u - r))), e.charAt(u) !== t.charAt(o) && (m *= O$)), (m < Xo && n.charAt(u - 1) === a.charAt(o + 1) || a.charAt(o + 1) === a.charAt(o) && n.charAt(u - 1) !== a.charAt(o)) && (f = Ei(e, t, n, a, u + 1, o + 2, i), f * Xo > m && (m = f * Xo)), m > p && (p = m), u = n.indexOf(c, u + 1);
  return i[s] = p, p;
}
function Dl(e) {
  return e.toLowerCase().replace(km, " ");
}
function L$(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, Ei(e, t, Dl(e), Dl(t), 0, 0, {});
}
var ga = '[cmdk-group=""]', Jo = '[cmdk-group-items=""]', F$ = '[cmdk-group-heading=""]', Om = '[cmdk-item=""]', Ll = `${Om}:not([aria-disabled="true"])`, Ri = "cmdk-item-select", Mn = "data-value", B$ = (e, t, n) => L$(e, t, n), jm = d.createContext(void 0), sr = () => d.useContext(jm), Mm = d.createContext(void 0), zs = () => d.useContext(Mm), Im = d.createContext(void 0), Dm = d.forwardRef((e, t) => {
  let n = In(() => {
    var E, B;
    return { search: "", value: (B = (E = e.value) != null ? E : e.defaultValue) != null ? B : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), a = In(() => /* @__PURE__ */ new Set()), r = In(() => /* @__PURE__ */ new Map()), o = In(() => /* @__PURE__ */ new Map()), i = In(() => /* @__PURE__ */ new Set()), s = Lm(e), { label: c, children: u, value: p, onValueChange: m, filter: f, shouldFilter: h, loop: v, disablePointerSelection: g = !1, vimBindings: y = !0, ...b } = e, $ = ke(), x = ke(), w = ke(), S = d.useRef(null), P = q$();
  wn(() => {
    if (p !== void 0) {
      let E = p.trim();
      n.current.value = E, C.emit();
    }
  }, [p]), wn(() => {
    P(6, _);
  }, []);
  let C = d.useMemo(() => ({ subscribe: (E) => (i.current.add(E), () => i.current.delete(E)), snapshot: () => n.current, setState: (E, B, X) => {
    var U, ne, I, Y;
    if (!Object.is(n.current[E], B)) {
      if (n.current[E] = B, E === "search") M(), L(), P(1, V);
      else if (E === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let te = document.getElementById(w);
          te ? te.focus() : (U = document.getElementById($)) == null || U.focus();
        }
        if (P(7, () => {
          var te;
          n.current.selectedItemId = (te = K()) == null ? void 0 : te.id, C.emit();
        }), X || P(5, _), ((ne = s.current) == null ? void 0 : ne.value) !== void 0) {
          let te = B ?? "";
          (Y = (I = s.current).onValueChange) == null || Y.call(I, te);
          return;
        }
      }
      C.emit();
    }
  }, emit: () => {
    i.current.forEach((E) => E());
  } }), []), T = d.useMemo(() => ({ value: (E, B, X) => {
    var U;
    B !== ((U = o.current.get(E)) == null ? void 0 : U.value) && (o.current.set(E, { value: B, keywords: X }), n.current.filtered.items.set(E, A(B, X)), P(2, () => {
      L(), C.emit();
    }));
  }, item: (E, B) => (a.current.add(E), B && (r.current.has(B) ? r.current.get(B).add(E) : r.current.set(B, /* @__PURE__ */ new Set([E]))), P(3, () => {
    M(), L(), n.current.value || V(), C.emit();
  }), () => {
    o.current.delete(E), a.current.delete(E), n.current.filtered.items.delete(E);
    let X = K();
    P(4, () => {
      M(), (X == null ? void 0 : X.getAttribute("id")) === E && V(), C.emit();
    });
  }), group: (E) => (r.current.has(E) || r.current.set(E, /* @__PURE__ */ new Set()), () => {
    o.current.delete(E), r.current.delete(E);
  }), filter: () => s.current.shouldFilter, label: c || e["aria-label"], getDisablePointerSelection: () => s.current.disablePointerSelection, listId: $, inputId: w, labelId: x, listInnerRef: S }), []);
  function A(E, B) {
    var X, U;
    let ne = (U = (X = s.current) == null ? void 0 : X.filter) != null ? U : B$;
    return E ? ne(E, n.current.search, B) : 0;
  }
  function L() {
    if (!n.current.search || s.current.shouldFilter === !1) return;
    let E = n.current.filtered.items, B = [];
    n.current.filtered.groups.forEach((U) => {
      let ne = r.current.get(U), I = 0;
      ne.forEach((Y) => {
        let te = E.get(Y);
        I = Math.max(te, I);
      }), B.push([U, I]);
    });
    let X = S.current;
    Q().sort((U, ne) => {
      var I, Y;
      let te = U.getAttribute("id"), le = ne.getAttribute("id");
      return ((I = E.get(le)) != null ? I : 0) - ((Y = E.get(te)) != null ? Y : 0);
    }).forEach((U) => {
      let ne = U.closest(Jo);
      ne ? ne.appendChild(U.parentElement === ne ? U : U.closest(`${Jo} > *`)) : X.appendChild(U.parentElement === X ? U : U.closest(`${Jo} > *`));
    }), B.sort((U, ne) => ne[1] - U[1]).forEach((U) => {
      var ne;
      let I = (ne = S.current) == null ? void 0 : ne.querySelector(`${ga}[${Mn}="${encodeURIComponent(U[0])}"]`);
      I == null || I.parentElement.appendChild(I);
    });
  }
  function V() {
    let E = Q().find((X) => X.getAttribute("aria-disabled") !== "true"), B = E == null ? void 0 : E.getAttribute(Mn);
    C.setState("value", B || void 0);
  }
  function M() {
    var E, B, X, U;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = a.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let ne = 0;
    for (let I of a.current) {
      let Y = (B = (E = o.current.get(I)) == null ? void 0 : E.value) != null ? B : "", te = (U = (X = o.current.get(I)) == null ? void 0 : X.keywords) != null ? U : [], le = A(Y, te);
      n.current.filtered.items.set(I, le), le > 0 && ne++;
    }
    for (let [I, Y] of r.current) for (let te of Y) if (n.current.filtered.items.get(te) > 0) {
      n.current.filtered.groups.add(I);
      break;
    }
    n.current.filtered.count = ne;
  }
  function _() {
    var E, B, X;
    let U = K();
    U && (((E = U.parentElement) == null ? void 0 : E.firstChild) === U && ((X = (B = U.closest(ga)) == null ? void 0 : B.querySelector(F$)) == null || X.scrollIntoView({ block: "nearest" })), U.scrollIntoView({ block: "nearest" }));
  }
  function K() {
    var E;
    return (E = S.current) == null ? void 0 : E.querySelector(`${Om}[aria-selected="true"]`);
  }
  function Q() {
    var E;
    return Array.from(((E = S.current) == null ? void 0 : E.querySelectorAll(Ll)) || []);
  }
  function W(E) {
    let B = Q()[E];
    B && C.setState("value", B.getAttribute(Mn));
  }
  function q(E) {
    var B;
    let X = K(), U = Q(), ne = U.findIndex((Y) => Y === X), I = U[ne + E];
    (B = s.current) != null && B.loop && (I = ne + E < 0 ? U[U.length - 1] : ne + E === U.length ? U[0] : U[ne + E]), I && C.setState("value", I.getAttribute(Mn));
  }
  function z(E) {
    let B = K(), X = B == null ? void 0 : B.closest(ga), U;
    for (; X && !U; ) X = E > 0 ? Y$(X, ga) : X$(X, ga), U = X == null ? void 0 : X.querySelector(Ll);
    U ? C.setState("value", U.getAttribute(Mn)) : q(E);
  }
  let j = () => W(Q().length - 1), N = (E) => {
    E.preventDefault(), E.metaKey ? j() : E.altKey ? z(1) : q(1);
  }, F = (E) => {
    E.preventDefault(), E.metaKey ? W(0) : E.altKey ? z(-1) : q(-1);
  };
  return d.createElement(ee.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (E) => {
    var B;
    (B = b.onKeyDown) == null || B.call(b, E);
    let X = E.nativeEvent.isComposing || E.keyCode === 229;
    if (!(E.defaultPrevented || X)) switch (E.key) {
      case "n":
      case "j": {
        y && E.ctrlKey && N(E);
        break;
      }
      case "ArrowDown": {
        N(E);
        break;
      }
      case "p":
      case "k": {
        y && E.ctrlKey && F(E);
        break;
      }
      case "ArrowUp": {
        F(E);
        break;
      }
      case "Home": {
        E.preventDefault(), W(0);
        break;
      }
      case "End": {
        E.preventDefault(), j();
        break;
      }
      case "Enter": {
        E.preventDefault();
        let U = K();
        if (U) {
          let ne = new Event(Ri);
          U.dispatchEvent(ne);
        }
      }
    }
  } }, d.createElement("label", { "cmdk-label": "", htmlFor: T.inputId, id: T.labelId, style: Q$ }, c), ko(e, (E) => d.createElement(Mm.Provider, { value: C }, d.createElement(jm.Provider, { value: T }, E))));
}), U$ = d.forwardRef((e, t) => {
  var n, a;
  let r = ke(), o = d.useRef(null), i = d.useContext(Im), s = sr(), c = Lm(e), u = (a = (n = c.current) == null ? void 0 : n.forceMount) != null ? a : i == null ? void 0 : i.forceMount;
  wn(() => {
    if (!u) return s.item(r, i == null ? void 0 : i.id);
  }, [u]);
  let p = Fm(r, o, [e.value, e.children, o], e.keywords), m = zs(), f = qt((P) => P.value && P.value === p.current), h = qt((P) => u || s.filter() === !1 ? !0 : P.search ? P.filtered.items.get(r) > 0 : !0);
  d.useEffect(() => {
    let P = o.current;
    if (!(!P || e.disabled)) return P.addEventListener(Ri, v), () => P.removeEventListener(Ri, v);
  }, [h, e.onSelect, e.disabled]);
  function v() {
    var P, C;
    g(), (C = (P = c.current).onSelect) == null || C.call(P, p.current);
  }
  function g() {
    m.setState("value", p.current, !0);
  }
  if (!h) return null;
  let { disabled: y, value: b, onSelect: $, forceMount: x, keywords: w, ...S } = e;
  return d.createElement(ee.div, { ref: jt(o, t), ...S, id: r, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!f, "data-disabled": !!y, "data-selected": !!f, onPointerMove: y || s.getDisablePointerSelection() ? void 0 : g, onClick: y ? void 0 : v }, e.children);
}), G$ = d.forwardRef((e, t) => {
  let { heading: n, children: a, forceMount: r, ...o } = e, i = ke(), s = d.useRef(null), c = d.useRef(null), u = ke(), p = sr(), m = qt((h) => r || p.filter() === !1 ? !0 : h.search ? h.filtered.groups.has(i) : !0);
  wn(() => p.group(i), []), Fm(i, s, [e.value, e.heading, c]);
  let f = d.useMemo(() => ({ id: i, forceMount: r }), [r]);
  return d.createElement(ee.div, { ref: jt(s, t), ...o, "cmdk-group": "", role: "presentation", hidden: m ? void 0 : !0 }, n && d.createElement("div", { ref: c, "cmdk-group-heading": "", "aria-hidden": !0, id: u }, n), ko(e, (h) => d.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? u : void 0 }, d.createElement(Im.Provider, { value: f }, h))));
}), H$ = d.forwardRef((e, t) => {
  let { alwaysRender: n, ...a } = e, r = d.useRef(null), o = qt((i) => !i.search);
  return !n && !o ? null : d.createElement(ee.div, { ref: jt(r, t), ...a, "cmdk-separator": "", role: "separator" });
}), W$ = d.forwardRef((e, t) => {
  let { onValueChange: n, ...a } = e, r = e.value != null, o = zs(), i = qt((u) => u.search), s = qt((u) => u.selectedItemId), c = sr();
  return d.useEffect(() => {
    e.value != null && o.setState("search", e.value);
  }, [e.value]), d.createElement(ee.input, { ref: t, ...a, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": c.listId, "aria-labelledby": c.labelId, "aria-activedescendant": s, id: c.inputId, type: "text", value: r ? e.value : i, onChange: (u) => {
    r || o.setState("search", u.target.value), n == null || n(u.target.value);
  } });
}), V$ = d.forwardRef((e, t) => {
  let { children: n, label: a = "Suggestions", ...r } = e, o = d.useRef(null), i = d.useRef(null), s = qt((u) => u.selectedItemId), c = sr();
  return d.useEffect(() => {
    if (i.current && o.current) {
      let u = i.current, p = o.current, m, f = new ResizeObserver(() => {
        m = requestAnimationFrame(() => {
          let h = u.offsetHeight;
          p.style.setProperty("--cmdk-list-height", h.toFixed(1) + "px");
        });
      });
      return f.observe(u), () => {
        cancelAnimationFrame(m), f.unobserve(u);
      };
    }
  }, []), d.createElement(ee.div, { ref: jt(o, t), ...r, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": s, "aria-label": a, id: c.listId }, ko(e, (u) => d.createElement("div", { ref: jt(i, c.listInnerRef), "cmdk-list-sizer": "" }, u)));
}), z$ = d.forwardRef((e, t) => {
  let { open: n, onOpenChange: a, overlayClassName: r, contentClassName: o, container: i, ...s } = e;
  return d.createElement(xo, { open: n, onOpenChange: a }, d.createElement(wo, { container: i }, d.createElement(ia, { "cmdk-overlay": "", className: r }), d.createElement(sa, { "aria-label": e.label, "cmdk-dialog": "", className: o }, d.createElement(Dm, { ref: t, ...s }))));
}), K$ = d.forwardRef((e, t) => qt((n) => n.filtered.count === 0) ? d.createElement(ee.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), Z$ = d.forwardRef((e, t) => {
  let { progress: n, children: a, label: r = "Loading...", ...o } = e;
  return d.createElement(ee.div, { ref: t, ...o, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": r }, ko(e, (i) => d.createElement("div", { "aria-hidden": !0 }, i)));
}), ze = Object.assign(Dm, { List: V$, Item: U$, Input: W$, Group: G$, Separator: H$, Dialog: z$, Empty: K$, Loading: Z$ });
function Y$(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function X$(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function Lm(e) {
  let t = d.useRef(e);
  return wn(() => {
    t.current = e;
  }), t;
}
var wn = typeof window > "u" ? d.useEffect : d.useLayoutEffect;
function In(e) {
  let t = d.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function qt(e) {
  let t = zs(), n = () => e(t.snapshot());
  return d.useSyncExternalStore(t.subscribe, n, n);
}
function Fm(e, t, n, a = []) {
  let r = d.useRef(), o = sr();
  return wn(() => {
    var i;
    let s = (() => {
      var u;
      for (let p of n) {
        if (typeof p == "string") return p.trim();
        if (typeof p == "object" && "current" in p) return p.current ? (u = p.current.textContent) == null ? void 0 : u.trim() : r.current;
      }
    })(), c = a.map((u) => u.trim());
    o.value(e, s, c), (i = t.current) == null || i.setAttribute(Mn, s), r.current = s;
  }), r;
}
var q$ = () => {
  let [e, t] = d.useState(), n = In(() => /* @__PURE__ */ new Map());
  return wn(() => {
    n.current.forEach((a) => a()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (a, r) => {
    n.current.set(a, r), t({});
  };
};
function J$(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function ko({ asChild: e, children: t }, n) {
  return e && d.isValidElement(t) ? d.cloneElement(J$(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var Q$ = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const Bm = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ze,
  {
    ref: n,
    className: R(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
      e
    ),
    ...t
  }
));
Bm.displayName = ze.displayName;
const Um = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsxs("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ l.jsx(Rg, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ l.jsx(
    ze.Input,
    {
      ref: n,
      className: R(
        "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ...t
    }
  )
] }));
Um.displayName = ze.Input.displayName;
const Gm = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ze.List,
  {
    ref: n,
    className: R("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
Gm.displayName = ze.List.displayName;
const Hm = d.forwardRef((e, t) => /* @__PURE__ */ l.jsx(
  ze.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
Hm.displayName = ze.Empty.displayName;
const Wm = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ze.Group,
  {
    ref: n,
    className: R(
      "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
      e
    ),
    ...t
  }
));
Wm.displayName = ze.Group.displayName;
const e4 = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ze.Separator,
  {
    ref: n,
    className: R("-mx-1 h-px bg-border", e),
    ...t
  }
));
e4.displayName = ze.Separator.displayName;
const Vm = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ze.Item,
  {
    ref: n,
    className: R(
      "relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      e
    ),
    ...t
  }
));
Vm.displayName = ze.Item.displayName;
var Ks = "Popover", [zm, ZC] = Ve(Ks, [
  an
]), lr = an(), [t4, _n] = zm(Ks), Km = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: a,
    defaultOpen: r,
    onOpenChange: o,
    modal: i = !1
  } = e, s = lr(t), c = d.useRef(null), [u, p] = d.useState(!1), [m = !1, f] = lt({
    prop: a,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ l.jsx(Ka, { ...s, children: /* @__PURE__ */ l.jsx(
    t4,
    {
      scope: t,
      contentId: ke(),
      triggerRef: c,
      open: m,
      onOpenChange: f,
      onOpenToggle: d.useCallback(() => f((h) => !h), [f]),
      hasCustomAnchor: u,
      onCustomAnchorAdd: d.useCallback(() => p(!0), []),
      onCustomAnchorRemove: d.useCallback(() => p(!1), []),
      modal: i,
      children: n
    }
  ) });
};
Km.displayName = Ks;
var Zm = "PopoverAnchor", n4 = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...a } = e, r = _n(Zm, n), o = lr(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = r;
    return d.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ l.jsx(Za, { ...o, ...a, ref: t });
  }
);
n4.displayName = Zm;
var Ym = "PopoverTrigger", Xm = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...a } = e, r = _n(Ym, n), o = lr(n), i = ue(t, r.triggerRef), s = /* @__PURE__ */ l.jsx(
      ee.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": ef(r.open),
        ...a,
        ref: i,
        onClick: G(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? s : /* @__PURE__ */ l.jsx(Za, { asChild: !0, ...o, children: s });
  }
);
Xm.displayName = Ym;
var a4 = "PopoverPortal", [YC, r4] = zm(a4, {
  forceMount: void 0
}), Jn = "PopoverContent", qm = d.forwardRef(
  (e, t) => {
    const n = r4(Jn, e.__scopePopover), { forceMount: a = n.forceMount, ...r } = e, o = _n(Jn, e.__scopePopover);
    return /* @__PURE__ */ l.jsx(De, { present: a || o.open, children: o.modal ? /* @__PURE__ */ l.jsx(i4, { ...r, ref: t }) : /* @__PURE__ */ l.jsx(s4, { ...r, ref: t }) });
  }
);
qm.displayName = Jn;
var o4 = /* @__PURE__ */ zt("PopoverContent.RemoveScroll"), i4 = d.forwardRef(
  (e, t) => {
    const n = _n(Jn, e.__scopePopover), a = d.useRef(null), r = ue(t, a), o = d.useRef(!1);
    return d.useEffect(() => {
      const i = a.current;
      if (i) return ho(i);
    }, []), /* @__PURE__ */ l.jsx(qa, { as: o4, allowPinchZoom: !0, children: /* @__PURE__ */ l.jsx(
      Jm,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: G(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), o.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: G(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || c;
            o.current = u;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: G(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), s4 = d.forwardRef(
  (e, t) => {
    const n = _n(Jn, e.__scopePopover), a = d.useRef(!1), r = d.useRef(!1);
    return /* @__PURE__ */ l.jsx(
      Jm,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (o) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, o), o.defaultPrevented || (a.current || (s = n.triggerRef.current) == null || s.focus(), o.preventDefault()), a.current = !1, r.current = !1;
        },
        onInteractOutside: (o) => {
          var c, u;
          (c = e.onInteractOutside) == null || c.call(e, o), o.defaultPrevented || (a.current = !0, o.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = o.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(i)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && r.current && o.preventDefault();
        }
      }
    );
  }
), Jm = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: a,
      onOpenAutoFocus: r,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: u,
      onInteractOutside: p,
      ...m
    } = e, f = _n(Jn, n), h = lr(n);
    return po(), /* @__PURE__ */ l.jsx(
      Xa,
      {
        asChild: !0,
        loop: !0,
        trapped: a,
        onMountAutoFocus: r,
        onUnmountAutoFocus: o,
        children: /* @__PURE__ */ l.jsx(
          aa,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: p,
            onEscapeKeyDown: s,
            onPointerDownOutside: c,
            onFocusOutside: u,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ l.jsx(
              oo,
              {
                "data-state": ef(f.open),
                role: "dialog",
                id: f.contentId,
                ...h,
                ...m,
                ref: t,
                style: {
                  ...m.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Qm = "PopoverClose", l4 = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...a } = e, r = _n(Qm, n);
    return /* @__PURE__ */ l.jsx(
      ee.button,
      {
        type: "button",
        ...a,
        ref: t,
        onClick: G(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
l4.displayName = Qm;
var c4 = "PopoverArrow", d4 = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...a } = e, r = lr(n);
    return /* @__PURE__ */ l.jsx(io, { ...r, ...a, ref: t });
  }
);
d4.displayName = c4;
function ef(e) {
  return e ? "open" : "closed";
}
var u4 = Km, p4 = Xm, tf = qm;
const m4 = u4, f4 = p4, nf = d.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...a }, r) => /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(
  tf,
  {
    ref: r,
    align: t,
    sideOffset: n,
    className: R(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...a
  }
) }));
nf.displayName = tf.displayName;
function Zs() {
  return (Zs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }).apply(this, arguments);
}
function h4(e, t) {
  if (e == null) return {};
  var n, a, r = {}, o = Object.keys(e);
  for (a = 0; a < o.length; a++) t.indexOf(n = o[a]) >= 0 || (r[n] = e[n]);
  return r;
}
var g4 = { ac: !0, ad: !0, ae: !0, af: !0, afar: !0, ag: !0, ai: !0, al: !0, am: !0, ao: !0, aq: !0, ar: !0, as: !0, at: !0, au: !0, "au-aboriginal": !0, "au-act": !0, "au-nsw": !0, "au-nt": !0, "au-qld": !0, "au-tas": !0, "au-vic": !0, "au-wa": !0, aw: !0, ax: !0, az: !0, ba: !0, bb: !0, bd: !0, be: !0, bf: !0, bg: !0, bh: !0, bi: !0, bj: !0, bl: !0, bm: !0, bn: !0, bo: !0, "bq-bo": !0, "bq-sa": !0, "bq-se": !0, bq: !0, br: !0, bs: !0, bt: !0, bv: !0, bw: !0, by: !0, bz: !0, "ca-bc": !0, ca: !0, cc: !0, cd: !0, cf: !0, cg: !0, "ch-gr": !0, ch: !0, ci: !0, ck: !0, cl: !0, cm: !0, "cn-xj": !0, cn: !0, co: !0, cp: !0, cq: !0, cr: !0, cu: !0, cv: !0, cw: !0, cx: !0, cy: !0, cz: !0, de: !0, dg: !0, dj: !0, dk: !0, dm: !0, do: !0, dz: !0, ea: !0, earth: !0, east_african_federation: !0, easter_island: !0, "ec-w": !0, ec: !0, ee: !0, eg: !0, eh: !0, er: !0, "es-ar": !0, "es-ce": !0, "es-cn": !0, "es-ct": !0, "es-ga": !0, "es-ib": !0, "es-ml": !0, "es-pv": !0, "es-variant": !0, es: !0, "et-or": !0, "et-ti": !0, et: !0, eu: !0, european_union: !0, ewe: !0, fi: !0, fj: !0, fk: !0, fm: !0, fo: !0, "fr-20r": !0, "fr-bre": !0, "fr-cp": !0, fr: !0, fx: !0, ga: !0, "gb-con": !0, "gb-eng": !0, "gb-nir": !0, "gb-ork": !0, "gb-sct": !0, "gb-wls": !0, gb: !0, gd: !0, "ge-ab": !0, ge: !0, gf: !0, gg: !0, gh: !0, gi: !0, gl: !0, gm: !0, gn: !0, gp: !0, gq: !0, gr: !0, gs: !0, gt: !0, gu: !0, guarani: !0, gw: !0, gy: !0, hausa: !0, hk: !0, hm: !0, hmong: !0, hn: !0, hr: !0, ht: !0, hu: !0, ic: !0, id: !0, "id-jb": !0, "id-jt": !0, ie: !0, il: !0, im: !0, "in-as": !0, "in-gj": !0, "in-ka": !0, "in-or": !0, "in-tn": !0, in: !0, io: !0, iq: !0, ir: !0, is: !0, "it-23": !0, "it-82": !0, "it-88": !0, it: !0, je: !0, jm: !0, jo: !0, jp: !0, kanuri: !0, ke: !0, kg: !0, kh: !0, ki: !0, kikuyu: !0, km: !0, kn: !0, kongo: !0, kp: !0, kr: !0, kurdistan: !0, kw: !0, ky: !0, kz: !0, la: !0, lb: !0, lc: !0, li: !0, lk: !0, lr: !0, ls: !0, lt: !0, lu: !0, lv: !0, ly: !0, ma: !0, malayali: !0, manipur: !0, maori: !0, mc: !0, md: !0, me: !0, mf: !0, mg: !0, mh: !0, mizoram: !0, mk: !0, ml: !0, mm: !0, mn: !0, mo: !0, mp: !0, mq: !0, mr: !0, ms: !0, mt: !0, mu: !0, mv: !0, mw: !0, mx: !0, my: !0, mz: !0, na: !0, nato: !0, nc: !0, ne: !0, nf: !0, ng: !0, ni: !0, "nl-fr": !0, nl: !0, no: !0, northern_cyprus: !0, np: !0, nr: !0, nu: !0, nz: !0, occitania: !0, olympics: !0, om: !0, otomi: !0, pa: !0, pe: !0, pf: !0, pg: !0, ph: !0, "pk-jk": !0, "pk-sd": !0, pk: !0, pl: !0, pm: !0, pn: !0, pr: !0, ps: !0, "pt-20": !0, "pt-30": !0, pt: !0, pw: !0, py: !0, qa: !0, quechua: !0, re: !0, ro: !0, rs: !0, ru: !0, "ru-ba": !0, "ru-ce": !0, "ru-cu": !0, "ru-da": !0, "ru-ko": !0, "ru-ta": !0, "ru-ud": !0, rw: !0, sa: !0, sami: !0, sb: !0, sc: !0, sd: !0, se: !0, sg: !0, "sh-ac": !0, "sh-hl": !0, "sh-ta": !0, sh: !0, si: !0, sj: !0, sk: !0, sl: !0, sm: !0, sn: !0, so: !0, somaliland: !0, south_ossetia: !0, soviet_union: !0, sr: !0, ss: !0, st: !0, su: !0, sv: !0, sx: !0, sy: !0, sz: !0, ta: !0, tc: !0, td: !0, tf: !0, tg: !0, th: !0, tibet: !0, tj: !0, tk: !0, tl: !0, tm: !0, tn: !0, to: !0, torres_strait_islands: !0, tr: !0, transnistria: !0, tt: !0, tv: !0, tw: !0, tz: !0, ua: !0, ug: !0, uk: !0, um: !0, un: !0, united_nations: !0, "us-hi": !0, us: !0, uy: !0, uz: !0, va: !0, vc: !0, ve: !0, vg: !0, vi: !0, vn: !0, vu: !0, wf: !0, wiphala: !0, ws: !0, xk: !0, xx: !0, ye: !0, yorubaland: !0, yt: !0, za: !0, zm: !0, zw: !0 }, b4 = ["countryCode", "cdnUrl"], v4 = function(e, t, n, a) {
  return a === void 0 && (a = ""), Zs({}, n, { title: n.title || e, height: n.height || 100, src: "" + (t || "https://react-circle-flags.pages.dev/") + a + e + ".svg" });
}, Ni = function(e) {
  var t = e.countryCode, n = e.cdnUrl, a = h4(e, b4);
  return D.createElement("img", Zs({ "data-testid": "circle-country-flag" }, v4(function(r) {
    return g4[r] ? r : "xx";
  }(t).toLowerCase(), n, a)));
}, Fr = {}, cn = {};
Object.defineProperty(cn, "__esModule", {
  value: !0
});
cn.currencySymbolMap = void 0;
cn.getNameFromCurrency = of;
cn.getSafeNameFromCurrency = $4;
cn.getSafeSymbolFromCurrency = y4;
cn.getSymbolFromCurrency = rf;
var af = cn.currencySymbolMap = [{
  symbol: "د.إ",
  name: "UAE Dirham",
  code: "AED",
  number: "784"
}, {
  symbol: "؋",
  name: "Afghani",
  code: "AFN",
  number: "971"
}, {
  symbol: "L",
  name: "Lek",
  code: "ALL",
  number: "008"
}, {
  symbol: "֏",
  name: "Armenian Dram",
  code: "AMD",
  number: "051"
}, {
  symbol: "ƒ",
  name: "Netherlands Antillean Guilder",
  code: "ANG",
  number: "532"
}, {
  symbol: "Kz",
  name: "Kwanza",
  code: "AOA",
  number: "973"
}, {
  symbol: "$",
  name: "Argentine Peso",
  code: "ARS",
  number: "032"
}, {
  symbol: "$",
  name: "Australian Dollar",
  code: "AUD",
  number: "036"
}, {
  symbol: "ƒ",
  name: "Aruban Florin",
  code: "AWG",
  number: "533"
}, {
  symbol: "₼",
  name: "Azerbaijan Manat",
  code: "AZN",
  number: "944"
}, {
  symbol: "KM",
  name: "Convertible Mark",
  code: "BAM",
  number: "977"
}, {
  symbol: "$",
  name: "Barbados Dollar",
  code: "BBD",
  number: "052"
}, {
  symbol: "৳",
  name: "Taka",
  code: "BDT",
  number: "050"
}, {
  symbol: "лв",
  name: "Bulgarian Lev",
  code: "BGN",
  number: "975"
}, {
  symbol: ".د.ب",
  name: "Bahraini Dinar",
  code: "BHD",
  number: "048"
}, {
  symbol: "FBu",
  name: "Burundi Franc",
  code: "BIF",
  number: "108"
}, {
  symbol: "$",
  name: "Bermudian Dollar",
  code: "BMD",
  number: "060"
}, {
  symbol: "$",
  name: "Brunei Dollar",
  code: "BND",
  number: "096"
}, {
  symbol: "$b",
  name: "Boliviano",
  code: "BOB",
  number: "068"
}, {
  symbol: "BOV",
  name: "Mvdol",
  code: "BOV",
  number: "984"
}, {
  symbol: "R$",
  name: "Brazilian Real",
  code: "BRL",
  number: "986"
}, {
  symbol: "$",
  name: "Bahamian Dollar",
  code: "BSD",
  number: "044"
}, {
  symbol: "₿",
  name: "",
  code: "BTC",
  number: ""
}, {
  symbol: "Nu.",
  name: "Ngultrum",
  code: "BTN",
  number: "064"
}, {
  symbol: "P",
  name: "Pula",
  code: "BWP",
  number: "072"
}, {
  symbol: "Br",
  name: "Belarusian Ruble",
  code: "BYN",
  number: "933"
}, {
  symbol: "Br",
  name: "",
  code: "BYR",
  number: ""
}, {
  symbol: "BZ$",
  name: "Belize Dollar",
  code: "BZD",
  number: "084"
}, {
  symbol: "$",
  name: "Canadian Dollar",
  code: "CAD",
  number: "124"
}, {
  symbol: "FC",
  name: "Congolese Franc",
  code: "CDF",
  number: "976"
}, {
  symbol: "CHE",
  name: "WIR Euro",
  code: "CHE",
  number: "947"
}, {
  symbol: "₣",
  name: "Swiss Franc",
  code: "CHF",
  number: "756"
}, {
  symbol: "CHW",
  name: "WIR Franc",
  code: "CHW",
  number: "948"
}, {
  symbol: "CLF",
  name: "Unidad de Fomento",
  code: "CLF",
  number: "990"
}, {
  symbol: "$",
  name: "Chilean Peso",
  code: "CLP",
  number: "152"
}, {
  symbol: "¥",
  name: "",
  code: "CNH",
  number: ""
}, {
  symbol: "¥",
  name: "Yuan Renminbi",
  code: "CNY",
  number: "156"
}, {
  symbol: "$",
  name: "Colombian Peso",
  code: "COP",
  number: "170"
}, {
  symbol: "COU",
  name: "Unidad de Valor Real",
  code: "COU",
  number: "970"
}, {
  symbol: "₡",
  name: "Costa Rican Colon",
  code: "CRC",
  number: "188"
}, {
  symbol: "$",
  name: "Peso Convertible",
  code: "CUC",
  number: "931"
}, {
  symbol: "₱",
  name: "Cuban Peso",
  code: "CUP",
  number: "192"
}, {
  symbol: "$",
  name: "Cabo Verde Escudo",
  code: "CVE",
  number: "132"
}, {
  symbol: "Kč",
  name: "Czech Koruna",
  code: "CZK",
  number: "203"
}, {
  symbol: "Fdj",
  name: "Djibouti Franc",
  code: "DJF",
  number: "262"
}, {
  symbol: "kr",
  name: "Danish Krone",
  code: "DKK",
  number: "208"
}, {
  symbol: "RD$",
  name: "Dominican Peso",
  code: "DOP",
  number: "214"
}, {
  symbol: "دج",
  name: "Algerian Dinar",
  code: "DZD",
  number: "012"
}, {
  symbol: "kr",
  name: "",
  code: "EEK",
  number: ""
}, {
  symbol: "E£",
  name: "Egyptian Pound",
  code: "EGP",
  number: "818"
}, {
  symbol: "Nfk",
  name: "Nakfa",
  code: "ERN",
  number: "232"
}, {
  symbol: "Br",
  name: "Ethiopian Birr",
  code: "ETB",
  number: "230"
}, {
  symbol: "Ξ",
  name: "",
  code: "ETH",
  number: ""
}, {
  symbol: "€",
  name: "Euro",
  code: "EUR",
  number: "978"
}, {
  symbol: "$",
  name: "Fiji Dollar",
  code: "FJD",
  number: "242"
}, {
  symbol: "£",
  name: "Falkland Islands Pound",
  code: "FKP",
  number: "238"
}, {
  symbol: "E£",
  name: "Pound Sterling",
  code: "GBP",
  number: "826"
}, {
  symbol: "₾",
  name: "Lari",
  code: "GEL",
  number: "981"
}, {
  symbol: "£",
  name: "",
  code: "GGP",
  number: ""
}, {
  symbol: "₵",
  name: "",
  code: "GHC",
  number: ""
}, {
  symbol: "GH₵",
  name: "Ghana Cedi",
  code: "GHS",
  number: "936"
}, {
  symbol: "£",
  name: "Gibraltar Pound",
  code: "GIP",
  number: "292"
}, {
  symbol: "D",
  name: "Dalasi",
  code: "GMD",
  number: "270"
}, {
  symbol: "FG",
  name: "Guinean Franc",
  code: "GNF",
  number: "324"
}, {
  symbol: "Q",
  name: "Quetzal",
  code: "GTQ",
  number: "320"
}, {
  symbol: "$",
  name: "Guyana Dollar",
  code: "GYD",
  number: "328"
}, {
  symbol: "$",
  name: "Hong Kong Dollar",
  code: "HKD",
  number: "344"
}, {
  symbol: "L",
  name: "Lempira",
  code: "HNL",
  number: "340"
}, {
  symbol: "kn",
  name: "",
  code: "HRK",
  number: ""
}, {
  symbol: "G",
  name: "Gourde",
  code: "HTG",
  number: "332"
}, {
  symbol: "Ft",
  name: "Forint",
  code: "HUF",
  number: "348"
}, {
  symbol: "Rp",
  name: "Rupiah",
  code: "IDR",
  number: "360"
}, {
  symbol: "₪",
  name: "New Israeli Sheqel",
  code: "ILS",
  number: "376"
}, {
  symbol: "£",
  name: "",
  code: "IMP",
  number: ""
}, {
  symbol: "₹",
  name: "Indian Rupee",
  code: "INR",
  number: "356"
}, {
  symbol: "د.ع",
  name: "Iraqi Dinar",
  code: "IQD",
  number: "368"
}, {
  symbol: "﷼",
  name: "Iranian Rial",
  code: "IRR",
  number: "364"
}, {
  symbol: "kr",
  name: "Iceland Krona",
  code: "ISK",
  number: "352"
}, {
  symbol: "£",
  name: "",
  code: "JEP",
  number: ""
}, {
  symbol: "J$",
  name: "Jamaican Dollar",
  code: "JMD",
  number: "388"
}, {
  symbol: "JD",
  name: "Jordanian Dinar",
  code: "JOD",
  number: "400"
}, {
  symbol: "¥",
  name: "Yen",
  code: "JPY",
  number: "392"
}, {
  symbol: "KSh",
  name: "Kenyan Shilling",
  code: "KES",
  number: "404"
}, {
  symbol: "лв",
  name: "Som",
  code: "KGS",
  number: "417"
}, {
  symbol: "៛",
  name: "Riel",
  code: "KHR",
  number: "116"
}, {
  symbol: "CF",
  name: "Comorian Franc",
  code: "KMF",
  number: "174"
}, {
  symbol: "₩",
  name: "North Korean Won",
  code: "KPW",
  number: "408"
}, {
  symbol: "₩",
  name: "Won",
  code: "KRW",
  number: "410"
}, {
  symbol: "KD",
  name: "Kuwaiti Dinar",
  code: "KWD",
  number: "414"
}, {
  symbol: "$",
  name: "Cayman Islands Dollar",
  code: "KYD",
  number: "136"
}, {
  symbol: "₸",
  name: "Tenge",
  code: "KZT",
  number: "398"
}, {
  symbol: "₭",
  name: "Lao Kip",
  code: "LAK",
  number: "418"
}, {
  symbol: "£",
  name: "Lebanese Pound",
  code: "LBP",
  number: "422"
}, {
  symbol: "₨",
  name: "Sri Lanka Rupee",
  code: "LKR",
  number: "144"
}, {
  symbol: "$",
  name: "Liberian Dollar",
  code: "LRD",
  number: "430"
}, {
  symbol: "M",
  name: "Loti",
  code: "LSL",
  number: "426"
}, {
  symbol: "Ł",
  name: "",
  code: "LTC",
  number: ""
}, {
  symbol: "Lt",
  name: "",
  code: "LTL",
  number: ""
}, {
  symbol: "Ls",
  name: "",
  code: "LVL",
  number: ""
}, {
  symbol: "LD",
  name: "Libyan Dinar",
  code: "LYD",
  number: "434"
}, {
  symbol: "MAD",
  name: "Moroccan Dirham",
  code: "MAD",
  number: "504"
}, {
  symbol: "lei",
  name: "Moldovan Leu",
  code: "MDL",
  number: "498"
}, {
  symbol: "Ar",
  name: "Malagasy Ariary",
  code: "MGA",
  number: "969"
}, {
  symbol: "ден",
  name: "Denar",
  code: "MKD",
  number: "807"
}, {
  symbol: "K",
  name: "Kyat",
  code: "MMK",
  number: "104"
}, {
  symbol: "₮",
  name: "Tugrik",
  code: "MNT",
  number: "496"
}, {
  symbol: "MOP$",
  name: "Pataca",
  code: "MOP",
  number: "446"
}, {
  symbol: "UM",
  name: "",
  code: "MRO",
  number: ""
}, {
  symbol: "UM",
  name: "Ouguiya",
  code: "MRU",
  number: "929"
}, {
  symbol: "₨",
  name: "Mauritius Rupee",
  code: "MUR",
  number: "480"
}, {
  symbol: "Rf",
  name: "Rufiyaa",
  code: "MVR",
  number: "462"
}, {
  symbol: "MK",
  name: "Malawi Kwacha",
  code: "MWK",
  number: "454"
}, {
  symbol: "$",
  name: "Mexican Peso",
  code: "MXN",
  number: "484"
}, {
  symbol: "MXV",
  name: "Mexican Unidad de Inversion (UDI)",
  code: "MXV",
  number: "979"
}, {
  symbol: "RM",
  name: "Malaysian Ringgit",
  code: "MYR",
  number: "458"
}, {
  symbol: "MT",
  name: "Mozambique Metical",
  code: "MZN",
  number: "943"
}, {
  symbol: "$",
  name: "Namibia Dollar",
  code: "NAD",
  number: "516"
}, {
  symbol: "₦",
  name: "Naira",
  code: "NGN",
  number: "566"
}, {
  symbol: "C$",
  name: "Cordoba Oro",
  code: "NIO",
  number: "558"
}, {
  symbol: "kr",
  name: "Norwegian Krone",
  code: "NOK",
  number: "578"
}, {
  symbol: "₨",
  name: "Nepalese Rupee",
  code: "NPR",
  number: "524"
}, {
  symbol: "$",
  name: "New Zealand Dollar",
  code: "NZD",
  number: "554"
}, {
  symbol: "﷼",
  name: "Rial Omani",
  code: "OMR",
  number: "512"
}, {
  symbol: "B/.",
  name: "Balboa",
  code: "PAB",
  number: "590"
}, {
  symbol: "S/.",
  name: "Sol",
  code: "PEN",
  number: "604"
}, {
  symbol: "K",
  name: "Kina",
  code: "PGK",
  number: "598"
}, {
  symbol: "₱",
  name: "Philippine Peso",
  code: "PHP",
  number: "608"
}, {
  symbol: "₨",
  name: "Pakistan Rupee",
  code: "PKR",
  number: "586"
}, {
  symbol: "zł",
  name: "Zloty",
  code: "PLN",
  number: "985"
}, {
  symbol: "Gs",
  name: "Guarani",
  code: "PYG",
  number: "600"
}, {
  symbol: "﷼",
  name: "Qatari Rial",
  code: "QAR",
  number: "634"
}, {
  symbol: "￥",
  name: "",
  code: "RMB",
  number: ""
}, {
  symbol: "lei",
  name: "Romanian Leu",
  code: "RON",
  number: "946"
}, {
  symbol: "Дин.",
  name: "Serbian Dinar",
  code: "RSD",
  number: "941"
}, {
  symbol: "₽",
  name: "Russian Ruble",
  code: "RUB",
  number: "643"
}, {
  symbol: "R₣",
  name: "Rwanda Franc",
  code: "RWF",
  number: "646"
}, {
  symbol: "﷼",
  name: "Saudi Riyal",
  code: "SAR",
  number: "682"
}, {
  symbol: "$",
  name: "Solomon Islands Dollar",
  code: "SBD",
  number: "090"
}, {
  symbol: "₨",
  name: "Seychelles Rupee",
  code: "SCR",
  number: "690"
}, {
  symbol: "ج.س.",
  name: "Sudanese Pound",
  code: "SDG",
  number: "938"
}, {
  symbol: "kr",
  name: "Swedish Krona",
  code: "SEK",
  number: "752"
}, {
  symbol: "S$",
  name: "Singapore Dollar",
  code: "SGD",
  number: "702"
}, {
  symbol: "£",
  name: "Saint Helena Pound",
  code: "SHP",
  number: "654"
}, {
  symbol: "Le",
  name: "",
  code: "SLL",
  number: ""
}, {
  symbol: "S",
  name: "Somali Shilling",
  code: "SOS",
  number: "706"
}, {
  symbol: "$",
  name: "Surinam Dollar",
  code: "SRD",
  number: "968"
}, {
  symbol: "£",
  name: "South Sudanese Pound",
  code: "SSP",
  number: "728"
}, {
  symbol: "Db",
  name: "",
  code: "STD",
  number: ""
}, {
  symbol: "Db",
  name: "Dobra",
  code: "STN",
  number: "930"
}, {
  symbol: "$",
  name: "El Salvador Colon",
  code: "SVC",
  number: "222"
}, {
  symbol: "£",
  name: "Syrian Pound",
  code: "SYP",
  number: "760"
}, {
  symbol: "E",
  name: "Lilangeni",
  code: "SZL",
  number: "748"
}, {
  symbol: "฿",
  name: "Baht",
  code: "THB",
  number: "764"
}, {
  symbol: "SM",
  name: "Somoni",
  code: "TJS",
  number: "972"
}, {
  symbol: "T",
  name: "Turkmenistan New Manat",
  code: "TMT",
  number: "934"
}, {
  symbol: "د.ت",
  name: "Tunisian Dinar",
  code: "TND",
  number: "788"
}, {
  symbol: "T$",
  name: "Pa’anga",
  code: "TOP",
  number: "776"
}, {
  symbol: "₤",
  name: "",
  code: "TRL",
  number: ""
}, {
  symbol: "₺",
  name: "Turkish Lira",
  code: "TRY",
  number: "949"
}, {
  symbol: "TT$",
  name: "Trinidad and Tobago Dollar",
  code: "TTD",
  number: "780"
}, {
  symbol: "$",
  name: "",
  code: "TVD",
  number: ""
}, {
  symbol: "NT$",
  name: "New Taiwan Dollar",
  code: "TWD",
  number: "901"
}, {
  symbol: "TSh",
  name: "Tanzanian Shilling",
  code: "TZS",
  number: "834"
}, {
  symbol: "₴",
  name: "Hryvnia",
  code: "UAH",
  number: "980"
}, {
  symbol: "USh",
  name: "Uganda Shilling",
  code: "UGX",
  number: "800"
}, {
  symbol: "$",
  name: "US Dollar",
  code: "USD",
  number: "840"
}, {
  symbol: "UYI",
  name: "Uruguay Peso en Unidades Indexadas (UI)",
  code: "UYI",
  number: "940"
}, {
  symbol: "$U",
  name: "Peso Uruguayo",
  code: "UYU",
  number: "858"
}, {
  symbol: "UYW",
  name: "Unidad Previsional",
  code: "UYW",
  number: "927"
}, {
  symbol: "лв",
  name: "Uzbekistan Sum",
  code: "UZS",
  number: "860"
}, {
  symbol: "Bs",
  name: "",
  code: "VEF",
  number: ""
}, {
  symbol: "Bs.S",
  name: "Bolívar Soberano",
  code: "VES",
  number: "928"
}, {
  symbol: "₫",
  name: "Dong",
  code: "VND",
  number: "704"
}, {
  symbol: "VT",
  name: "Vatu",
  code: "VUV",
  number: "548"
}, {
  symbol: "WS$",
  name: "Tala",
  code: "WST",
  number: "882"
}, {
  symbol: "FCFA",
  name: "CFA Franc BEAC",
  code: "XAF",
  number: "950"
}, {
  symbol: "Ƀ",
  name: "",
  code: "XBT",
  number: ""
}, {
  symbol: "$",
  name: "East Caribbean Dollar",
  code: "XCD",
  number: "951"
}, {
  symbol: "CFA",
  name: "CFA Franc BCEAO",
  code: "XOF",
  number: "952"
}, {
  symbol: "₣",
  name: "CFP Franc",
  code: "XPF",
  number: "953"
}, {
  symbol: "Sucre",
  name: "Sucre",
  code: "XSU",
  number: "994"
}, {
  symbol: "XUA",
  name: "ADB Unit of Account",
  code: "XUA",
  number: "965"
}, {
  symbol: "﷼",
  name: "Yemeni Rial",
  code: "YER",
  number: "886"
}, {
  symbol: "R",
  name: "Rand",
  code: "ZAR",
  number: "710"
}, {
  symbol: "ZK",
  name: "Zambian Kwacha",
  code: "ZMW",
  number: "967"
}, {
  symbol: "Z$",
  name: "Zimbabwean Dollar",
  code: "ZWD",
  number: ""
}, {
  symbol: "$",
  name: "Zimbabwean Dollar",
  code: "ZWL",
  number: ""
}];
function rf(e) {
  var t;
  if (typeof e == "string") {
    var n = (t = af.find(function(a) {
      return a.code === e.toUpperCase();
    })) === null || t === void 0 ? void 0 : t.symbol;
    return n ?? void 0;
  }
}
function y4(e) {
  var t;
  return (t = rf(e)) !== null && t !== void 0 ? t : e;
}
function of(e) {
  var t;
  if (typeof e != "string")
    return e;
  var n = (t = af.find(function(a) {
    return a.code === e.toUpperCase();
  })) === null || t === void 0 ? void 0 : t.name;
  return n ?? e;
}
function $4(e) {
  var t;
  return (t = of(e)) !== null && t !== void 0 ? t : e;
}
var sf = {}, ae = {};
Object.defineProperty(ae, "__esModule", {
  value: !0
});
ae.westernEurope = ae.westernAsia = ae.westAfrica = ae.southernEurope = ae.southernAsia = ae.southernAfrica = ae.southeastAsia = ae.southAmerica = ae.polynesia = ae.northernEurope = ae.northernAmerica = ae.northAfrica = ae.micronesia = ae.melanesia = ae.easternEurope = ae.eastAsia = ae.eastAfrica = ae.centralAsia = ae.centralAmerica = ae.centralAfrica = ae.caribbean = ae.australia = ae.antartica = void 0;
ae.centralAsia = {
  name: "Central Asia",
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_Asia
    "KZ",
    // Kazakhstan
    "KG",
    // Kyrgyzstan
    "TJ",
    // Tajikistan
    "TM",
    // Turkmenistan
    "UZ"
    // Uzbekistan
  ]
};
ae.southernAsia = {
  name: "Southern Asia",
  countries: [
    // source is http://en.wikipedia.org/wiki/South_Asia
    "AF",
    // Afghanistan
    "BD",
    // Bangladesh
    "BT",
    // Bhutan
    "IO",
    // British Indian Ocean Territory
    "IN",
    // India
    "IR",
    // Iran
    "MV",
    // Maldives
    "NP",
    // Nepal
    "PK",
    // Pakistan
    "LK"
    // Sri Lanka
  ]
};
ae.southeastAsia = {
  name: "Southeast Asia",
  countries: [
    // source is http://en.wikipedia.org/wiki/Southeast_Asia
    "BN",
    // Brunei
    "KH",
    // Cambodia
    "CX",
    // Christmas Island
    "CC",
    // Cocos (Keeling) Islands
    "TL",
    // East Timor
    "ID",
    // Indonesia
    "LA",
    // Laos
    "MY",
    // Malaysia
    "MM",
    // Myanmar (Burma)
    "PH",
    // Philippines
    "SG",
    // Singapore
    "TH",
    // Thailand
    "VN"
    // Vietnam
  ]
};
ae.eastAsia = {
  name: "East Asia",
  countries: [
    // source is http://en.wikipedia.org/wiki/East_Asia
    "CN",
    // China
    "HK",
    // Hong Kong
    "JP",
    // Japan
    "KP",
    // North Korea
    "KR",
    // South Korea
    "MO",
    // Macao
    "MN",
    // Mongolia
    "TW"
    // Taiwan
  ]
};
ae.westernAsia = {
  name: "Western Asia",
  countries: [
    // source is http://en.wikipedia.org/wiki/Western_Asia
    "AM",
    // Armenia
    "AZ",
    // Azerbaijan
    "BH",
    // Bahrain
    "IQ",
    // Iraq
    "IL",
    // Israel
    "JO",
    // Jordan
    "KW",
    // Kuwait
    "LB",
    // Lebanon
    "OM",
    // Oman
    "PS",
    // Palestinian territories
    "QA",
    // Qatar
    "SA",
    // Saudi Arabia
    "SY",
    // Syria
    "TR",
    // Turkey
    "AE",
    // United Arab Emirates
    "YE"
    // Yemen
  ]
};
ae.centralAfrica = {
  name: "Central Aftrica",
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_Africa
    "AO",
    // Angola
    "CM",
    // Cameroon
    "CF",
    // Central African Republic
    "TD",
    // Chad
    "CG",
    // Republic of the Congo
    "CD",
    // Democratic Republic of the Congo
    "GQ",
    // Equatorial Guinea
    "GA",
    // Gabon
    "ST"
    // São Tomé and Príncipe
  ]
};
ae.northAfrica = {
  name: "North Africa",
  countries: [
    // source is http://en.wikipedia.org/wiki/North_Africa
    "DZ",
    // Algeria
    "EG",
    // Egypt
    "LY",
    // Libya
    "MA",
    // Morocco
    "SD",
    // Sudan
    "TN",
    // Tunisia
    "EH"
    // Western Sahara
  ]
};
ae.southernAfrica = {
  name: "Southern Africa",
  countries: [
    // source is http://en.wikipedia.org/wiki/Southern_Africa
    "BW",
    // Botswana
    "LS",
    // Lesotho
    "NA",
    // Namibia
    "ZA",
    // South Africa
    "SZ"
    // Swaziland
  ]
};
ae.eastAfrica = {
  name: "East Africa",
  countries: [
    // source is http://en.wikipedia.org/wiki/East_Africa
    "BI",
    // Burundi
    "KM",
    // Comoros
    "DJ",
    // Djibouti
    "ER",
    // Eritrea
    "ET",
    // Ethiopia
    "KE",
    // Kenya
    "MG",
    // Madagascar
    "MW",
    // Malawi
    "MU",
    // Mauritius
    "YT",
    // Mayotte (France)
    "MZ",
    // Mozambique
    "RE",
    // Réunion (France)
    "RW",
    // Rwanda
    "SC",
    // Seychelles
    "SO",
    // Somalia
    "SS",
    // South Sudan
    "TZ",
    // Tanzania
    "UG",
    // Uganda
    "ZM",
    // Zambia
    "ZW"
    // Zimbabwe
  ]
};
ae.westAfrica = {
  name: "West Africa",
  countries: [
    // source is http://en.wikipedia.org/wiki/West_Africa
    "BJ",
    // Benin
    "BF",
    // Burkina Faso
    "CV",
    // Cabo Verde
    "CI",
    // Côte d'Ivoire
    "GM",
    // Gambia
    "GH",
    // Ghana
    "GN",
    // Guinea
    "GW",
    // Guinea-Bissau
    "LR",
    // Liberia
    "ML",
    // Mali
    "MR",
    // Mauritania
    "NE",
    // Niger
    "NG",
    // Nigeria
    "SH",
    // Saint Helena, Ascension and Tristan da Cunha (United Kingdom)
    "SN",
    // Senegal
    "SL",
    // Sierra Leone
    "TG"
    // Togo
  ]
};
ae.centralAmerica = {
  name: "Central America",
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_America
    "BZ",
    // Belize
    "CR",
    // Costa Rica
    "SV",
    // El Salvador
    "GT",
    // Guatemala
    "HN",
    // Honduras
    "NI",
    // Nicaragua
    "PA"
    // Panama
  ]
};
ae.northernAmerica = {
  name: "Northern America",
  countries: [
    // source is http://en.wikipedia.org/wiki/Northern_America
    "BM",
    // Bermuda
    "CA",
    // Canada
    "GL",
    // Greenland
    "MX",
    // Mexico
    "PM",
    // Saint Pierre and Miquelon
    "US"
    // United States
  ]
};
ae.caribbean = {
  name: "Caribbean",
  countries: [
    // source is http://en.wikipedia.org/wiki/Caribbean
    "AI",
    // Anguilla
    "AG",
    // Antigua and Barbuda
    "AW",
    // Aruba
    "BS",
    // Bahamas
    "BB",
    // Barbados
    "BQ",
    // Bonaire, Sint Eustatius & Saba
    "VG",
    // British Virgin Islands
    "KY",
    // Cayman Islands
    "CU",
    // Cuba
    "CW",
    // Curaçao
    "DM",
    // Dominica
    "DO",
    // Dominican Republic
    "GD",
    // Grenada
    "GP",
    // Guadeloupe
    "HT",
    // Haiti
    "JM",
    // Jamaica
    "MQ",
    // Martinique
    "MS",
    // Montserrat
    "PR",
    // Puerto Rico
    "BL",
    // Saint Barthélemy
    "KN",
    // St. Kitts & Nevis
    "LC",
    // Saint Lucia
    "MF",
    // Saint Martin
    "VC",
    // Saint Vincent and the Grenadines
    "SX",
    // Sint Maarten
    "TT",
    // Trinidad and Tobago
    "TC",
    // Turks & Caicos
    "VI"
    // United States Virgin Islands
  ]
};
ae.southAmerica = {
  name: "South America",
  countries: [
    // source is http://en.wikipedia.org/wiki/South_America
    "AR",
    // Argentina
    "BO",
    // Bolivia
    "BR",
    // Brazil
    "CL",
    // Chile
    "CO",
    // Colombia
    "EC",
    // Ecuador
    "FK",
    // Falkland Islands
    "GF",
    // French Guiana
    "GY",
    // Guyana
    "PY",
    // Paraguay
    "PE",
    // Peru
    "SR",
    // Suriname
    "UY",
    // Uruguay
    "VE"
    // Venezuela
  ]
};
ae.antartica = {
  name: "Antartica",
  countries: [
    // source is http://en.wikipedia.org/wiki/Antarctica
    "AQ",
    // Antarctica
    "BV",
    // Bouvet Island
    "TF",
    // French Southern Territories
    "HM",
    // Heard Island and McDonald Islands
    "GS"
    // South Georgia and the South Sandwich Islands
  ]
};
ae.northernEurope = {
  name: "Northern Europe",
  countries: [
    // source is http://en.wikipedia.org/wiki/Northern_Europe
    "AX",
    // Åland
    "DK",
    // Denmark
    "EE",
    // Estonia
    "FO",
    // Faroe Islands
    "FI",
    // Finland
    "GG",
    // Guernsey
    "IS",
    // Iceland
    "IE",
    // Republic of Ireland
    "JE",
    // Jersey (UK)
    "IM",
    // Isle of Man
    "LV",
    // Latvia
    "LT",
    // Lithuania
    "NO",
    // Norway
    "SJ",
    // Svalbard and Jan Mayen
    "SE",
    // Sweden
    "GB"
    // United Kingdom
  ]
};
ae.southernEurope = {
  name: "Southern Europe",
  countries: [
    // source is http://en.wikipedia.org/wiki/Southern_Europe
    "AL",
    // Albania
    "AD",
    // Andorra
    "BA",
    // Bosnia and Herzegovina
    "HR",
    // Croatia
    "CY",
    // Cyprus
    "GI",
    // Gibraltar
    "GR",
    // Greece
    "IT",
    // Italy
    "MK",
    // Republic of Macedonia
    "VA",
    // Vatican City
    "MT",
    // Malta
    "ME",
    // Montenegro
    "PT",
    // Portugal
    "SM",
    // San Marino
    "RS",
    // Serbia
    "SI",
    // Slovenia
    "ES"
    // Spain
  ]
};
ae.easternEurope = {
  name: "Eastern Europe",
  countries: [
    // source is http://en.wikipedia.org/wiki/Eastern_Europe
    "BY",
    // Belarus
    "BG",
    // Bulgaria
    "CZ",
    // Czech Republic
    "GE",
    // Georgia
    "HU",
    // Hungary
    "MD",
    // Moldova
    "PL",
    // Poland
    "RO",
    // Romania
    "RU",
    // Russia
    "SK",
    // Slovakia
    "UA"
    // Ukraine
  ]
};
ae.westernEurope = {
  name: "Western Europe",
  countries: [
    // source is http://en.wikipedia.org/wiki/Western_Europe
    "AT",
    // Austria
    "BE",
    // Belgium
    "FR",
    // France
    "DE",
    // Germany
    "LI",
    // Liechtenstein
    "LU",
    // Luxembourg
    "MC",
    // Monaco
    "NL",
    // Netherlands
    "CH"
    // Switzerland
  ]
};
ae.australia = {
  name: "Australia",
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    "AU",
    // Australia
    "NF"
    // Norfolk Island
  ]
};
ae.melanesia = {
  name: "Melanesia",
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    "FJ",
    // Fiji
    "NC",
    //  New Caledonia
    "PG",
    // Papua New Guinea
    "SB",
    // Solomon Islands
    "VU"
    // Vanuatu
  ]
};
ae.micronesia = {
  name: "Micronesia",
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    "GU",
    // Guam
    "KI",
    // Kiribati
    "MH",
    // Marshall Islands
    "FM",
    // Micronesia, Fed. Sts.
    "NR",
    // Nauru
    "MP",
    // Northern Mariana Islands
    "PW",
    // Palau
    "UM"
    // United States Minor Outlying Islands
  ]
};
ae.polynesia = {
  name: "Polynesia",
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    "AS",
    // American Samoa
    "CK",
    // Cook Islands
    "PF",
    // French Polynesia
    "NU",
    // Niue
    "PN",
    // Pitcairn Islands
    "WS",
    // Samoa
    "TK",
    // Tokelau
    "TO",
    // Tonga
    "TV",
    // Tuvalu
    "WF",
    // Wallis and Futuna
    "NZ"
    // New Zealand https://worldpopulationreview.com/country-rankings/polynesian-countries
  ]
};
(function(e) {
  function t(f) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
      return typeof h;
    } : function(h) {
      return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
    }, t(f);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(ae);
  function a(f) {
    if (typeof WeakMap != "function") return null;
    var h = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
    return (a = function(y) {
      return y ? v : h;
    })(f);
  }
  function r(f, h) {
    if (f && f.__esModule) return f;
    if (f === null || t(f) != "object" && typeof f != "function") return { default: f };
    var v = a(h);
    if (v && v.has(f)) return v.get(f);
    var g = { __proto__: null }, y = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var b in f) if (b !== "default" && {}.hasOwnProperty.call(f, b)) {
      var $ = y ? Object.getOwnPropertyDescriptor(f, b) : null;
      $ && ($.get || $.set) ? Object.defineProperty(g, b, $) : g[b] = f[b];
    }
    return g.default = f, v && v.set(f, g), g;
  }
  var o = {
    name: "Asia",
    regions: ["centralAsia", "southernAsia", "southeastAsia", "eastAsia", "westernAsia"],
    countries: [n.centralAsia.countries, n.southernAsia.countries, n.southeastAsia.countries, n.eastAsia.countries, n.westernAsia.countries].reduce(function(f, h) {
      return f.concat(h);
    }, []).sort()
  }, i = {
    name: "Africa",
    regions: ["centralAfrica", "northAfrica", "southernAfrica", "eastAfrica", "westAfrica"],
    countries: [n.centralAfrica.countries, n.northAfrica.countries, n.southernAfrica.countries, n.eastAfrica.countries, n.westAfrica.countries].reduce(function(f, h) {
      return f.concat(h);
    }, []).sort()
  }, s = {
    name: "North America",
    regions: ["centralAmerica", "northernAmerica", "caribbean"],
    countries: [n.centralAmerica.countries, n.northernAmerica.countries, n.caribbean.countries].reduce(function(f, h) {
      return f.concat(h);
    }, []).sort()
  }, c = {
    name: "South America",
    regions: ["southAmerica"],
    countries: [n.southAmerica.countries].reduce(function(f, h) {
      return f.concat(h);
    }, []).sort()
  }, u = {
    name: "Antartica",
    regions: ["antartica"],
    countries: [n.antartica.countries].reduce(function(f, h) {
      return f.concat(h);
    }, []).sort()
  }, p = {
    name: "Europe",
    regions: ["northernEurope", "southernEurope", "easternEurope", "westernEurope"],
    countries: [n.northernEurope.countries, n.southernEurope.countries, n.easternEurope.countries, n.westernEurope.countries].reduce(function(f, h) {
      return f.concat(h);
    }, []).sort()
  }, m = {
    name: "Oceania",
    regions: ["australia", "melanesia", "micronesia", "polynesia"],
    countries: [n.australia.countries, n.melanesia.countries, n.micronesia.countries, n.polynesia.countries].reduce(function(f, h) {
      return f.concat(h);
    }, []).sort()
  };
  e.default = {
    asia: o,
    africa: i,
    northAmerica: s,
    southAmerica: c,
    antartica: u,
    europe: p,
    oceania: m
  };
})(sf);
var lf = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, e.default = [{
    alpha2: "AC",
    alpha3: "ASC",
    countryCallingCodes: ["+247"],
    currencies: ["USD"],
    emoji: "🇦🇨",
    ioc: "SHP",
    languages: ["eng"],
    name: "Ascension Island",
    status: "reserved"
  }, {
    alpha2: "AD",
    alpha3: "AND",
    countryCallingCodes: ["+376"],
    currencies: ["EUR"],
    emoji: "🇦🇩",
    ioc: "AND",
    languages: ["cat"],
    name: "Andorra",
    status: "assigned"
  }, {
    alpha2: "AE",
    alpha3: "ARE",
    countryCallingCodes: ["+971"],
    currencies: ["AED"],
    emoji: "🇦🇪",
    ioc: "UAE",
    languages: ["ara"],
    name: "United Arab Emirates",
    status: "assigned"
  }, {
    alpha2: "AF",
    alpha3: "AFG",
    countryCallingCodes: ["+93"],
    currencies: ["AFN"],
    emoji: "🇦🇫",
    ioc: "AFG",
    languages: ["pus"],
    name: "Afghanistan",
    status: "assigned"
  }, {
    alpha2: "AG",
    alpha3: "ATG",
    countryCallingCodes: ["+1 268"],
    currencies: ["XCD"],
    emoji: "🇦🇬",
    ioc: "ANT",
    languages: ["eng"],
    name: "Antigua And Barbuda",
    status: "assigned"
  }, {
    alpha2: "AI",
    alpha3: "AIA",
    countryCallingCodes: ["+1 264"],
    currencies: ["XCD"],
    emoji: "🇦🇮",
    ioc: "",
    languages: ["eng"],
    name: "Anguilla",
    status: "assigned"
  }, {
    alpha2: "AI",
    alpha3: "AFI",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "French Afar and Issas",
    status: "deleted"
  }, {
    alpha2: "AL",
    alpha3: "ALB",
    countryCallingCodes: ["+355"],
    currencies: ["ALL"],
    emoji: "🇦🇱",
    ioc: "ALB",
    languages: ["sqi"],
    name: "Albania",
    status: "assigned"
  }, {
    alpha2: "AM",
    alpha3: "ARM",
    countryCallingCodes: ["+374"],
    currencies: ["AMD"],
    emoji: "🇦🇲",
    ioc: "ARM",
    languages: ["hye", "rus"],
    name: "Armenia",
    status: "assigned"
  }, {
    alpha2: "AN",
    alpha3: "ANT",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Netherlands Antilles",
    status: "deleted"
  }, {
    alpha2: "AO",
    alpha3: "AGO",
    countryCallingCodes: ["+244"],
    currencies: ["AOA"],
    emoji: "🇦🇴",
    ioc: "ANG",
    languages: ["por"],
    name: "Angola",
    status: "assigned"
  }, {
    alpha2: "AQ",
    alpha3: "ATA",
    countryCallingCodes: ["+672"],
    currencies: [],
    emoji: "🇦🇶",
    ioc: "",
    languages: [],
    name: "Antarctica",
    status: "assigned"
  }, {
    alpha2: "AR",
    alpha3: "ARG",
    countryCallingCodes: ["+54"],
    currencies: ["ARS"],
    emoji: "🇦🇷",
    ioc: "ARG",
    languages: ["spa"],
    name: "Argentina",
    status: "assigned"
  }, {
    alpha2: "AS",
    alpha3: "ASM",
    countryCallingCodes: ["+1 684"],
    currencies: ["USD"],
    emoji: "🇦🇸",
    ioc: "ASA",
    languages: ["eng", "smo"],
    name: "American Samoa",
    status: "assigned"
  }, {
    alpha2: "AT",
    alpha3: "AUT",
    countryCallingCodes: ["+43"],
    currencies: ["EUR"],
    emoji: "🇦🇹",
    ioc: "AUT",
    languages: ["deu"],
    name: "Austria",
    status: "assigned"
  }, {
    alpha2: "AU",
    alpha3: "AUS",
    countryCallingCodes: ["+61"],
    currencies: ["AUD"],
    emoji: "🇦🇺",
    ioc: "AUS",
    languages: ["eng"],
    name: "Australia",
    status: "assigned"
  }, {
    alpha2: "AW",
    alpha3: "ABW",
    countryCallingCodes: ["+297"],
    currencies: ["AWG"],
    emoji: "🇦🇼",
    ioc: "ARU",
    languages: ["nld"],
    name: "Aruba",
    status: "assigned"
  }, {
    alpha2: "AX",
    alpha3: "ALA",
    countryCallingCodes: ["+358"],
    currencies: ["EUR"],
    emoji: "🇦🇽",
    ioc: "",
    languages: ["swe"],
    name: "Åland Islands",
    status: "assigned"
  }, {
    alpha2: "AZ",
    alpha3: "AZE",
    countryCallingCodes: ["+994"],
    currencies: ["AZN"],
    emoji: "🇦🇿",
    ioc: "AZE",
    languages: ["aze"],
    name: "Azerbaijan",
    status: "assigned"
  }, {
    alpha2: "BA",
    alpha3: "BIH",
    countryCallingCodes: ["+387"],
    currencies: ["BAM"],
    emoji: "🇧🇦",
    ioc: "BIH",
    languages: ["bos", "cre", "srp"],
    name: "Bosnia & Herzegovina",
    status: "assigned"
  }, {
    alpha2: "BB",
    alpha3: "BRB",
    countryCallingCodes: ["+1 246"],
    currencies: ["BBD"],
    emoji: "🇧🇧",
    ioc: "BAR",
    languages: ["eng"],
    name: "Barbados",
    status: "assigned"
  }, {
    alpha2: "BD",
    alpha3: "BGD",
    countryCallingCodes: ["+880"],
    currencies: ["BDT"],
    emoji: "🇧🇩",
    ioc: "BAN",
    languages: ["ben"],
    name: "Bangladesh",
    status: "assigned"
  }, {
    alpha2: "BE",
    alpha3: "BEL",
    countryCallingCodes: ["+32"],
    currencies: ["EUR"],
    emoji: "🇧🇪",
    ioc: "BEL",
    languages: ["nld", "fra", "deu"],
    name: "Belgium",
    status: "assigned"
  }, {
    alpha2: "BF",
    alpha3: "BFA",
    countryCallingCodes: ["+226"],
    currencies: ["XOF"],
    emoji: "🇧🇫",
    ioc: "BUR",
    languages: ["fra"],
    name: "Burkina Faso",
    status: "assigned"
  }, {
    alpha2: "BG",
    alpha3: "BGR",
    countryCallingCodes: ["+359"],
    currencies: ["BGN"],
    emoji: "🇧🇬",
    ioc: "BUL",
    languages: ["bul"],
    name: "Bulgaria",
    status: "assigned"
  }, {
    alpha2: "BH",
    alpha3: "BHR",
    countryCallingCodes: ["+973"],
    currencies: ["BHD"],
    emoji: "🇧🇭",
    ioc: "BRN",
    languages: ["ara"],
    name: "Bahrain",
    status: "assigned"
  }, {
    alpha2: "BI",
    alpha3: "BDI",
    countryCallingCodes: ["+257"],
    currencies: ["BIF"],
    emoji: "🇧🇮",
    ioc: "BDI",
    languages: ["fra"],
    name: "Burundi",
    status: "assigned"
  }, {
    alpha2: "BJ",
    alpha3: "BEN",
    countryCallingCodes: ["+229"],
    currencies: ["XOF"],
    emoji: "🇧🇯",
    ioc: "BEN",
    languages: ["fra"],
    name: "Benin",
    status: "assigned"
  }, {
    alpha2: "BL",
    alpha3: "BLM",
    countryCallingCodes: ["+590"],
    currencies: ["EUR"],
    emoji: "🇧🇱",
    ioc: "",
    languages: ["fra"],
    name: "Saint Barthélemy",
    status: "assigned"
  }, {
    alpha2: "BM",
    alpha3: "BMU",
    countryCallingCodes: ["+1 441"],
    currencies: ["BMD"],
    emoji: "🇧🇲",
    ioc: "BER",
    languages: ["eng"],
    name: "Bermuda",
    status: "assigned"
  }, {
    alpha2: "BN",
    alpha3: "BRN",
    countryCallingCodes: ["+673"],
    currencies: ["BND"],
    emoji: "🇧🇳",
    ioc: "BRU",
    languages: ["msa", "eng"],
    name: "Brunei Darussalam",
    status: "assigned"
  }, {
    alpha2: "BO",
    alpha3: "BOL",
    countryCallingCodes: ["+591"],
    currencies: ["BOB", "BOV"],
    emoji: "🇧🇴",
    ioc: "BOL",
    languages: ["spa", "aym", "que"],
    name: "Bolivia, Plurinational State Of",
    status: "assigned"
  }, {
    alpha2: "BQ",
    alpha3: "BES",
    countryCallingCodes: ["+599"],
    currencies: ["USD"],
    emoji: "🇧🇶",
    ioc: "",
    languages: ["nld"],
    name: "Bonaire, Sint Eustatius And Saba",
    status: "assigned"
  }, {
    alpha2: "BQ",
    alpha3: "ATB",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "British Antarctic Territory",
    status: "deleted"
  }, {
    alpha2: "BR",
    alpha3: "BRA",
    countryCallingCodes: ["+55"],
    currencies: ["BRL"],
    emoji: "🇧🇷",
    ioc: "BRA",
    languages: ["por"],
    name: "Brazil",
    status: "assigned"
  }, {
    alpha2: "BS",
    alpha3: "BHS",
    countryCallingCodes: ["+1 242"],
    currencies: ["BSD"],
    emoji: "🇧🇸",
    ioc: "BAH",
    languages: ["eng"],
    name: "Bahamas",
    status: "assigned"
  }, {
    alpha2: "BT",
    alpha3: "BTN",
    countryCallingCodes: ["+975"],
    currencies: ["INR", "BTN"],
    emoji: "🇧🇹",
    ioc: "BHU",
    languages: ["dzo"],
    name: "Bhutan",
    status: "assigned"
  }, {
    alpha2: "BU",
    alpha3: "BUR",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Burma",
    status: "deleted"
  }, {
    alpha2: "BV",
    alpha3: "BVT",
    countryCallingCodes: [],
    currencies: ["NOK"],
    emoji: "🇧🇻",
    ioc: "",
    languages: [],
    name: "Bouvet Island",
    status: "assigned"
  }, {
    alpha2: "BW",
    alpha3: "BWA",
    countryCallingCodes: ["+267"],
    currencies: ["BWP"],
    emoji: "🇧🇼",
    ioc: "BOT",
    languages: ["eng", "tsn"],
    name: "Botswana",
    status: "assigned"
  }, {
    alpha2: "BY",
    alpha3: "BLR",
    countryCallingCodes: ["+375"],
    currencies: ["BYN"],
    emoji: "🇧🇾",
    ioc: "BLR",
    languages: ["bel", "rus"],
    name: "Belarus",
    status: "assigned"
  }, {
    alpha2: "BY",
    alpha3: "BYS",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Byelorussian SSR",
    status: "deleted"
  }, {
    alpha2: "BZ",
    alpha3: "BLZ",
    countryCallingCodes: ["+501"],
    currencies: ["BZD"],
    emoji: "🇧🇿",
    ioc: "BIZ",
    languages: ["eng"],
    name: "Belize",
    status: "assigned"
  }, {
    alpha2: "CA",
    alpha3: "CAN",
    countryCallingCodes: ["+1"],
    currencies: ["CAD"],
    emoji: "🇨🇦",
    ioc: "CAN",
    languages: ["eng", "fra"],
    name: "Canada",
    status: "assigned"
  }, {
    alpha2: "CC",
    alpha3: "CCK",
    countryCallingCodes: ["+61"],
    currencies: ["AUD"],
    emoji: "🇨🇨",
    ioc: "",
    languages: ["eng"],
    name: "Cocos (Keeling) Islands",
    status: "assigned"
  }, {
    alpha2: "CD",
    alpha3: "COD",
    countryCallingCodes: ["+243"],
    currencies: ["CDF"],
    emoji: "🇨🇩",
    ioc: "COD",
    languages: ["fra", "lin", "kon", "swa"],
    name: "Democratic Republic Of Congo",
    status: "assigned"
  }, {
    alpha2: "CF",
    alpha3: "CAF",
    countryCallingCodes: ["+236"],
    currencies: ["XAF"],
    emoji: "🇨🇫",
    ioc: "CAF",
    languages: ["fra", "sag"],
    name: "Central African Republic",
    status: "assigned"
  }, {
    alpha2: "CG",
    alpha3: "COG",
    countryCallingCodes: ["+242"],
    currencies: ["XAF"],
    emoji: "🇨🇬",
    ioc: "CGO",
    languages: ["fra", "lin"],
    name: "Republic Of Congo",
    status: "assigned"
  }, {
    alpha2: "CH",
    alpha3: "CHE",
    countryCallingCodes: ["+41"],
    currencies: ["CHF", "CHE", "CHW"],
    emoji: "🇨🇭",
    ioc: "SUI",
    languages: ["deu", "fra", "ita", "roh"],
    name: "Switzerland",
    status: "assigned"
  }, {
    alpha2: "CI",
    alpha3: "CIV",
    countryCallingCodes: ["+225"],
    currencies: ["XOF"],
    emoji: "🇨🇮",
    ioc: "CIV",
    languages: ["fra"],
    name: "Côte d'Ivoire",
    status: "assigned"
  }, {
    alpha2: "CK",
    alpha3: "COK",
    countryCallingCodes: ["+682"],
    currencies: ["NZD"],
    emoji: "🇨🇰",
    ioc: "COK",
    languages: ["eng", "mri"],
    name: "Cook Islands",
    status: "assigned"
  }, {
    alpha2: "CL",
    alpha3: "CHL",
    countryCallingCodes: ["+56"],
    currencies: ["CLP", "CLF"],
    emoji: "🇨🇱",
    ioc: "CHI",
    languages: ["spa"],
    name: "Chile",
    status: "assigned"
  }, {
    alpha2: "CM",
    alpha3: "CMR",
    countryCallingCodes: ["+237"],
    currencies: ["XAF"],
    emoji: "🇨🇲",
    ioc: "CMR",
    languages: ["eng", "fra"],
    name: "Cameroon",
    status: "assigned"
  }, {
    alpha2: "CN",
    alpha3: "CHN",
    countryCallingCodes: ["+86"],
    currencies: ["CNY"],
    emoji: "🇨🇳",
    ioc: "CHN",
    languages: ["zho"],
    name: "China",
    status: "assigned"
  }, {
    alpha2: "CO",
    alpha3: "COL",
    countryCallingCodes: ["+57"],
    currencies: ["COP", "COU"],
    emoji: "🇨🇴",
    ioc: "COL",
    languages: ["spa"],
    name: "Colombia",
    status: "assigned"
  }, {
    alpha2: "CP",
    alpha3: "CPT",
    countryCallingCodes: [],
    currencies: ["EUR"],
    emoji: "🇨🇵",
    ioc: "",
    languages: [],
    name: "Clipperton Island",
    status: "reserved"
  }, {
    alpha2: "CR",
    alpha3: "CRI",
    countryCallingCodes: ["+506"],
    currencies: ["CRC"],
    emoji: "🇨🇷",
    ioc: "CRC",
    languages: ["spa"],
    name: "Costa Rica",
    status: "assigned"
  }, {
    alpha2: "CS",
    alpha3: "CSK",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Czechoslovakia",
    status: "deleted"
  }, {
    alpha2: "CS",
    alpha3: "SCG",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Serbia and Montenegro",
    status: "deleted"
  }, {
    alpha2: "CT",
    alpha3: "CTE",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Canton and Enderbury Islands",
    status: "deleted"
  }, {
    alpha2: "CU",
    alpha3: "CUB",
    countryCallingCodes: ["+53"],
    currencies: ["CUP", "CUC"],
    emoji: "🇨🇺",
    ioc: "CUB",
    languages: ["spa"],
    name: "Cuba",
    status: "assigned"
  }, {
    alpha2: "CV",
    alpha3: "CPV",
    countryCallingCodes: ["+238"],
    currencies: ["CVE"],
    emoji: "🇨🇻",
    ioc: "CPV",
    languages: ["por"],
    name: "Cabo Verde",
    status: "assigned"
  }, {
    alpha2: "CW",
    alpha3: "CUW",
    countryCallingCodes: ["+599"],
    currencies: ["ANG"],
    emoji: "🇨🇼",
    ioc: "",
    languages: ["nld"],
    name: "Curacao",
    status: "assigned"
  }, {
    alpha2: "CX",
    alpha3: "CXR",
    countryCallingCodes: ["+61"],
    currencies: ["AUD"],
    emoji: "🇨🇽",
    ioc: "",
    languages: ["eng"],
    name: "Christmas Island",
    status: "assigned"
  }, {
    alpha2: "CY",
    alpha3: "CYP",
    countryCallingCodes: ["+357"],
    currencies: ["EUR"],
    emoji: "🇨🇾",
    ioc: "CYP",
    languages: ["ell", "tur"],
    name: "Cyprus",
    status: "assigned"
  }, {
    alpha2: "CZ",
    alpha3: "CZE",
    countryCallingCodes: ["+420"],
    currencies: ["CZK"],
    emoji: "🇨🇿",
    ioc: "CZE",
    languages: ["ces"],
    name: "Czech Republic",
    status: "assigned"
  }, {
    alpha2: "DD",
    alpha3: "DDR",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "German Democratic Republic",
    status: "deleted"
  }, {
    alpha2: "DE",
    alpha3: "DEU",
    countryCallingCodes: ["+49"],
    currencies: ["EUR"],
    emoji: "🇩🇪",
    ioc: "GER",
    languages: ["deu"],
    name: "Germany",
    status: "assigned"
  }, {
    alpha2: "DG",
    alpha3: "DGA",
    countryCallingCodes: [],
    currencies: ["USD"],
    emoji: "🇩🇬",
    ioc: "",
    languages: [],
    name: "Diego Garcia",
    status: "reserved"
  }, {
    alpha2: "DJ",
    alpha3: "DJI",
    countryCallingCodes: ["+253"],
    currencies: ["DJF"],
    emoji: "🇩🇯",
    ioc: "DJI",
    languages: ["ara", "fra"],
    name: "Djibouti",
    status: "assigned"
  }, {
    alpha2: "DK",
    alpha3: "DNK",
    countryCallingCodes: ["+45"],
    currencies: ["DKK"],
    emoji: "🇩🇰",
    ioc: "DEN",
    languages: ["dan"],
    name: "Denmark",
    status: "assigned"
  }, {
    alpha2: "DM",
    alpha3: "DMA",
    countryCallingCodes: ["+1 767"],
    currencies: ["XCD"],
    emoji: "🇩🇲",
    ioc: "DMA",
    languages: ["eng"],
    name: "Dominica",
    status: "assigned"
  }, {
    alpha2: "DO",
    alpha3: "DOM",
    countryCallingCodes: ["+1 809", "+1 829", "+1 849"],
    currencies: ["DOP"],
    emoji: "🇩🇴",
    ioc: "DOM",
    languages: ["spa"],
    name: "Dominican Republic",
    status: "assigned"
  }, {
    alpha2: "DY",
    alpha3: "DHY",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Dahomey",
    status: "deleted"
  }, {
    alpha2: "DZ",
    alpha3: "DZA",
    countryCallingCodes: ["+213"],
    currencies: ["DZD"],
    emoji: "🇩🇿",
    ioc: "ALG",
    languages: ["ara"],
    name: "Algeria",
    status: "assigned"
  }, {
    alpha2: "EA",
    alpha3: "",
    countryCallingCodes: [],
    currencies: ["EUR"],
    emoji: "🇪🇦",
    ioc: "",
    languages: [],
    name: "Ceuta, Mulilla",
    status: "reserved"
  }, {
    alpha2: "EC",
    alpha3: "ECU",
    countryCallingCodes: ["+593"],
    currencies: ["USD"],
    emoji: "🇪🇨",
    ioc: "ECU",
    languages: ["spa", "que"],
    name: "Ecuador",
    status: "assigned"
  }, {
    alpha2: "EE",
    alpha3: "EST",
    countryCallingCodes: ["+372"],
    currencies: ["EUR"],
    emoji: "🇪🇪",
    ioc: "EST",
    languages: ["est"],
    name: "Estonia",
    status: "assigned"
  }, {
    alpha2: "EG",
    alpha3: "EGY",
    countryCallingCodes: ["+20"],
    currencies: ["EGP"],
    emoji: "🇪🇬",
    ioc: "EGY",
    languages: ["ara"],
    name: "Egypt",
    status: "assigned"
  }, {
    alpha2: "EH",
    alpha3: "ESH",
    countryCallingCodes: ["+212"],
    currencies: ["MAD"],
    emoji: "🇪🇭",
    ioc: "",
    languages: [],
    name: "Western Sahara",
    status: "assigned"
  }, {
    alpha2: "ER",
    alpha3: "ERI",
    countryCallingCodes: ["+291"],
    currencies: ["ERN"],
    emoji: "🇪🇷",
    ioc: "ERI",
    languages: ["eng", "ara", "tir"],
    name: "Eritrea",
    status: "assigned"
  }, {
    alpha2: "ES",
    alpha3: "ESP",
    countryCallingCodes: ["+34"],
    currencies: ["EUR"],
    emoji: "🇪🇸",
    ioc: "ESP",
    languages: ["spa", "cat", "glg", "eus"],
    name: "Spain",
    status: "assigned"
  }, {
    alpha2: "ET",
    alpha3: "ETH",
    countryCallingCodes: ["+251"],
    currencies: ["ETB"],
    emoji: "🇪🇹",
    ioc: "ETH",
    languages: ["amh"],
    name: "Ethiopia",
    status: "assigned"
  }, {
    alpha2: "EU",
    alpha3: "EUE",
    countryCallingCodes: ["+388"],
    currencies: ["EUR"],
    emoji: "🇪🇺",
    ioc: "",
    languages: [],
    name: "European Union",
    status: "reserved"
  }, {
    alpha2: "FI",
    alpha3: "FIN",
    countryCallingCodes: ["+358"],
    currencies: ["EUR"],
    emoji: "🇫🇮",
    ioc: "FIN",
    languages: ["fin", "swe"],
    name: "Finland",
    status: "assigned"
  }, {
    alpha2: "FJ",
    alpha3: "FJI",
    countryCallingCodes: ["+679"],
    currencies: ["FJD"],
    emoji: "🇫🇯",
    ioc: "FIJ",
    languages: ["eng", "fij"],
    name: "Fiji",
    status: "assigned"
  }, {
    alpha2: "FK",
    alpha3: "FLK",
    countryCallingCodes: ["+500"],
    currencies: ["FKP"],
    emoji: "🇫🇰",
    ioc: "",
    languages: ["eng"],
    name: "Falkland Islands",
    status: "assigned"
  }, {
    alpha2: "FM",
    alpha3: "FSM",
    countryCallingCodes: ["+691"],
    currencies: ["USD"],
    emoji: "🇫🇲",
    ioc: "FSM",
    languages: ["eng"],
    name: "Micronesia, Federated States Of",
    status: "assigned"
  }, {
    alpha2: "FO",
    alpha3: "FRO",
    countryCallingCodes: ["+298"],
    currencies: ["DKK"],
    emoji: "🇫🇴",
    ioc: "FAI",
    languages: ["fao", "dan"],
    name: "Faroe Islands",
    status: "assigned"
  }, {
    alpha2: "FQ",
    alpha3: "ATF",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "French Southern and Antarctic Territories",
    status: "deleted"
  }, {
    alpha2: "FR",
    alpha3: "FRA",
    countryCallingCodes: ["+33"],
    currencies: ["EUR"],
    emoji: "🇫🇷",
    ioc: "FRA",
    languages: ["fra"],
    name: "France",
    status: "assigned"
  }, {
    alpha2: "FX",
    alpha3: "FXX",
    countryCallingCodes: ["+241"],
    currencies: ["EUR"],
    emoji: "",
    ioc: "",
    languages: ["fra"],
    name: "France, Metropolitan",
    status: "reserved"
  }, {
    alpha2: "GA",
    alpha3: "GAB",
    countryCallingCodes: ["+241"],
    currencies: ["XAF"],
    emoji: "🇬🇦",
    ioc: "GAB",
    languages: ["fra"],
    name: "Gabon",
    status: "assigned"
  }, {
    alpha2: "GB",
    alpha3: "GBR",
    countryCallingCodes: ["+44"],
    currencies: ["GBP"],
    emoji: "🇬🇧",
    ioc: "GBR",
    languages: ["eng", "cor", "gle", "gla", "cym"],
    name: "United Kingdom",
    status: "assigned"
  }, {
    alpha2: "GD",
    alpha3: "GRD",
    countryCallingCodes: ["+473"],
    currencies: ["XCD"],
    emoji: "🇬🇩",
    ioc: "GRN",
    languages: ["eng"],
    name: "Grenada",
    status: "assigned"
  }, {
    alpha2: "GE",
    alpha3: "GEO",
    countryCallingCodes: ["+995"],
    currencies: ["GEL"],
    emoji: "🇬🇪",
    ioc: "GEO",
    languages: ["kat"],
    name: "Georgia",
    status: "assigned"
  }, {
    alpha2: "GE",
    alpha3: "GEL",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Gilbert and Ellice Islands",
    status: "deleted"
  }, {
    alpha2: "GF",
    alpha3: "GUF",
    countryCallingCodes: ["+594"],
    currencies: ["EUR"],
    emoji: "🇬🇫",
    ioc: "",
    languages: ["fra"],
    name: "French Guiana",
    status: "assigned"
  }, {
    alpha2: "GG",
    alpha3: "GGY",
    countryCallingCodes: ["+44"],
    currencies: ["GBP"],
    emoji: "🇬🇬",
    ioc: "GCI",
    languages: ["fra"],
    name: "Guernsey",
    status: "assigned"
  }, {
    alpha2: "GH",
    alpha3: "GHA",
    countryCallingCodes: ["+233"],
    currencies: ["GHS"],
    emoji: "🇬🇭",
    ioc: "GHA",
    languages: ["eng"],
    name: "Ghana",
    status: "assigned"
  }, {
    alpha2: "GI",
    alpha3: "GIB",
    countryCallingCodes: ["+350"],
    currencies: ["GIP"],
    emoji: "🇬🇮",
    ioc: "",
    languages: ["eng"],
    name: "Gibraltar",
    status: "assigned"
  }, {
    alpha2: "GL",
    alpha3: "GRL",
    countryCallingCodes: ["+299"],
    currencies: ["DKK"],
    emoji: "🇬🇱",
    ioc: "",
    languages: ["kal"],
    name: "Greenland",
    status: "assigned"
  }, {
    alpha2: "GM",
    alpha3: "GMB",
    countryCallingCodes: ["+220"],
    currencies: ["GMD"],
    emoji: "🇬🇲",
    ioc: "GAM",
    languages: ["eng"],
    name: "Gambia",
    status: "assigned"
  }, {
    alpha2: "GN",
    alpha3: "GIN",
    countryCallingCodes: ["+224"],
    currencies: ["GNF"],
    emoji: "🇬🇳",
    ioc: "GUI",
    languages: ["fra"],
    name: "Guinea",
    status: "assigned"
  }, {
    alpha2: "GP",
    alpha3: "GLP",
    countryCallingCodes: ["+590"],
    currencies: ["EUR"],
    emoji: "🇬🇵",
    ioc: "",
    languages: ["fra"],
    name: "Guadeloupe",
    status: "assigned"
  }, {
    alpha2: "GQ",
    alpha3: "GNQ",
    countryCallingCodes: ["+240"],
    currencies: ["XAF"],
    emoji: "🇬🇶",
    ioc: "GEQ",
    languages: ["spa", "fra", "por"],
    name: "Equatorial Guinea",
    status: "assigned"
  }, {
    alpha2: "GR",
    alpha3: "GRC",
    countryCallingCodes: ["+30"],
    currencies: ["EUR"],
    emoji: "🇬🇷",
    ioc: "GRE",
    languages: ["ell"],
    name: "Greece",
    status: "assigned"
  }, {
    alpha2: "GS",
    alpha3: "SGS",
    countryCallingCodes: ["+500"],
    currencies: ["GBP"],
    emoji: "🇬🇸",
    ioc: "",
    languages: ["eng"],
    name: "South Georgia And The South Sandwich Islands",
    status: "assigned"
  }, {
    alpha2: "GT",
    alpha3: "GTM",
    countryCallingCodes: ["+502"],
    currencies: ["GTQ"],
    emoji: "🇬🇹",
    ioc: "GUA",
    languages: ["spa"],
    name: "Guatemala",
    status: "assigned"
  }, {
    alpha2: "GU",
    alpha3: "GUM",
    countryCallingCodes: ["+1 671"],
    currencies: ["USD"],
    emoji: "🇬🇺",
    ioc: "GUM",
    languages: ["eng"],
    name: "Guam",
    status: "assigned"
  }, {
    alpha2: "GW",
    alpha3: "GNB",
    countryCallingCodes: ["+245"],
    currencies: ["XOF"],
    emoji: "🇬🇼",
    ioc: "GBS",
    languages: ["por"],
    name: "Guinea-bissau",
    status: "assigned"
  }, {
    alpha2: "GY",
    alpha3: "GUY",
    countryCallingCodes: ["+592"],
    currencies: ["GYD"],
    emoji: "🇬🇾",
    ioc: "GUY",
    languages: ["eng"],
    name: "Guyana",
    status: "assigned"
  }, {
    alpha2: "HK",
    alpha3: "HKG",
    countryCallingCodes: ["+852"],
    currencies: ["HKD"],
    emoji: "🇭🇰",
    ioc: "HKG",
    languages: ["zho", "eng"],
    name: "Hong Kong",
    status: "assigned"
  }, {
    alpha2: "HM",
    alpha3: "HMD",
    countryCallingCodes: [],
    currencies: ["AUD"],
    emoji: "🇭🇲",
    ioc: "",
    languages: [],
    name: "Heard Island And McDonald Islands",
    status: "assigned"
  }, {
    alpha2: "HN",
    alpha3: "HND",
    countryCallingCodes: ["+504"],
    currencies: ["HNL"],
    emoji: "🇭🇳",
    ioc: "HON",
    languages: ["spa"],
    name: "Honduras",
    status: "assigned"
  }, {
    alpha2: "HR",
    alpha3: "HRV",
    countryCallingCodes: ["+385"],
    currencies: ["EUR"],
    emoji: "🇭🇷",
    ioc: "CRO",
    languages: ["hrv"],
    name: "Croatia",
    status: "assigned"
  }, {
    alpha2: "HT",
    alpha3: "HTI",
    countryCallingCodes: ["+509"],
    currencies: ["HTG", "USD"],
    emoji: "🇭🇹",
    ioc: "HAI",
    languages: ["fra", "hat"],
    name: "Haiti",
    status: "assigned"
  }, {
    alpha2: "HU",
    alpha3: "HUN",
    countryCallingCodes: ["+36"],
    currencies: ["HUF"],
    emoji: "🇭🇺",
    ioc: "HUN",
    languages: ["hun"],
    name: "Hungary",
    status: "assigned"
  }, {
    alpha2: "HV",
    alpha3: "HVO",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Upper Volta",
    status: "deleted"
  }, {
    alpha2: "IC",
    alpha3: "",
    countryCallingCodes: [],
    currencies: ["EUR"],
    emoji: "🇮🇨",
    ioc: "",
    languages: [],
    name: "Canary Islands",
    status: "reserved"
  }, {
    alpha2: "ID",
    alpha3: "IDN",
    countryCallingCodes: ["+62"],
    currencies: ["IDR"],
    emoji: "🇮🇩",
    ioc: "INA",
    languages: ["ind"],
    name: "Indonesia",
    status: "assigned"
  }, {
    alpha2: "IE",
    alpha3: "IRL",
    countryCallingCodes: ["+353"],
    currencies: ["EUR"],
    emoji: "🇮🇪",
    ioc: "IRL",
    languages: ["eng", "gle"],
    name: "Ireland",
    status: "assigned"
  }, {
    alpha2: "IL",
    alpha3: "ISR",
    countryCallingCodes: ["+972"],
    currencies: ["ILS"],
    emoji: "🇮🇱",
    ioc: "ISR",
    languages: ["heb", "ara", "eng"],
    name: "Israel",
    status: "assigned"
  }, {
    alpha2: "IM",
    alpha3: "IMN",
    countryCallingCodes: ["+44"],
    currencies: ["GBP"],
    emoji: "🇮🇲",
    ioc: "",
    languages: ["eng", "glv"],
    name: "Isle Of Man",
    status: "assigned"
  }, {
    alpha2: "IN",
    alpha3: "IND",
    countryCallingCodes: ["+91"],
    currencies: ["INR"],
    emoji: "🇮🇳",
    ioc: "IND",
    languages: ["eng", "hin"],
    name: "India",
    status: "assigned"
  }, {
    alpha2: "IO",
    alpha3: "IOT",
    countryCallingCodes: ["+246"],
    currencies: ["USD"],
    emoji: "🇮🇴",
    ioc: "",
    languages: ["eng"],
    name: "British Indian Ocean Territory",
    status: "assigned"
  }, {
    alpha2: "IQ",
    alpha3: "IRQ",
    countryCallingCodes: ["+964"],
    currencies: ["IQD"],
    emoji: "🇮🇶",
    ioc: "IRQ",
    languages: ["ara", "kur"],
    name: "Iraq",
    status: "assigned"
  }, {
    alpha2: "IR",
    alpha3: "IRN",
    countryCallingCodes: ["+98"],
    currencies: ["IRR"],
    emoji: "🇮🇷",
    ioc: "IRI",
    languages: ["fas"],
    name: "Iran, Islamic Republic Of",
    status: "assigned"
  }, {
    alpha2: "IS",
    alpha3: "ISL",
    countryCallingCodes: ["+354"],
    currencies: ["ISK"],
    emoji: "🇮🇸",
    ioc: "ISL",
    languages: ["isl"],
    name: "Iceland",
    status: "assigned"
  }, {
    alpha2: "IT",
    alpha3: "ITA",
    countryCallingCodes: ["+39"],
    currencies: ["EUR"],
    emoji: "🇮🇹",
    ioc: "ITA",
    languages: ["ita"],
    name: "Italy",
    status: "assigned"
  }, {
    alpha2: "JE",
    alpha3: "JEY",
    countryCallingCodes: ["+44"],
    currencies: ["GBP"],
    emoji: "🇯🇪",
    ioc: "JCI",
    languages: ["eng", "fra"],
    name: "Jersey",
    status: "assigned"
  }, {
    alpha2: "JM",
    alpha3: "JAM",
    countryCallingCodes: ["+1 876"],
    currencies: ["JMD"],
    emoji: "🇯🇲",
    ioc: "JAM",
    languages: ["eng"],
    name: "Jamaica",
    status: "assigned"
  }, {
    alpha2: "JO",
    alpha3: "JOR",
    countryCallingCodes: ["+962"],
    currencies: ["JOD"],
    emoji: "🇯🇴",
    ioc: "JOR",
    languages: ["ara"],
    name: "Jordan",
    status: "assigned"
  }, {
    alpha2: "JP",
    alpha3: "JPN",
    countryCallingCodes: ["+81"],
    currencies: ["JPY"],
    emoji: "🇯🇵",
    ioc: "JPN",
    languages: ["jpn"],
    name: "Japan",
    status: "assigned"
  }, {
    alpha2: "JT",
    alpha3: "JTN",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Johnston Island",
    status: "deleted"
  }, {
    alpha2: "KE",
    alpha3: "KEN",
    countryCallingCodes: ["+254"],
    currencies: ["KES"],
    emoji: "🇰🇪",
    ioc: "KEN",
    languages: ["eng", "swa"],
    name: "Kenya",
    status: "assigned"
  }, {
    alpha2: "KG",
    alpha3: "KGZ",
    countryCallingCodes: ["+996"],
    currencies: ["KGS"],
    emoji: "🇰🇬",
    ioc: "KGZ",
    languages: ["rus"],
    name: "Kyrgyzstan",
    status: "assigned"
  }, {
    alpha2: "KH",
    alpha3: "KHM",
    countryCallingCodes: ["+855"],
    currencies: ["KHR"],
    emoji: "🇰🇭",
    ioc: "CAM",
    languages: ["khm"],
    name: "Cambodia",
    status: "assigned"
  }, {
    alpha2: "KI",
    alpha3: "KIR",
    countryCallingCodes: ["+686"],
    currencies: ["AUD"],
    emoji: "🇰🇮",
    ioc: "KIR",
    languages: ["eng"],
    name: "Kiribati",
    status: "assigned"
  }, {
    alpha2: "KM",
    alpha3: "COM",
    countryCallingCodes: ["+269"],
    currencies: ["KMF"],
    emoji: "🇰🇲",
    ioc: "COM",
    languages: ["ara", "fra"],
    name: "Comoros",
    status: "assigned"
  }, {
    alpha2: "KN",
    alpha3: "KNA",
    countryCallingCodes: ["+1 869"],
    currencies: ["XCD"],
    emoji: "🇰🇳",
    ioc: "SKN",
    languages: ["eng"],
    name: "Saint Kitts And Nevis",
    status: "assigned"
  }, {
    alpha2: "KP",
    alpha3: "PRK",
    countryCallingCodes: ["+850"],
    currencies: ["KPW"],
    emoji: "🇰🇵",
    ioc: "PRK",
    languages: ["kor"],
    name: "Korea, Democratic People's Republic Of",
    status: "assigned"
  }, {
    alpha2: "KR",
    alpha3: "KOR",
    countryCallingCodes: ["+82"],
    currencies: ["KRW"],
    emoji: "🇰🇷",
    ioc: "KOR",
    languages: ["kor"],
    name: "Korea, Republic Of",
    status: "assigned"
  }, {
    alpha2: "KW",
    alpha3: "KWT",
    countryCallingCodes: ["+965"],
    currencies: ["KWD"],
    emoji: "🇰🇼",
    ioc: "KUW",
    languages: ["ara"],
    name: "Kuwait",
    status: "assigned"
  }, {
    alpha2: "KY",
    alpha3: "CYM",
    countryCallingCodes: ["+1 345"],
    currencies: ["KYD"],
    emoji: "🇰🇾",
    ioc: "CAY",
    languages: ["eng"],
    name: "Cayman Islands",
    status: "assigned"
  }, {
    alpha2: "KZ",
    alpha3: "KAZ",
    countryCallingCodes: ["+7", "+7 6", "+7 7"],
    currencies: ["KZT"],
    emoji: "🇰🇿",
    ioc: "KAZ",
    languages: ["kaz", "rus"],
    name: "Kazakhstan",
    status: "assigned"
  }, {
    alpha2: "LA",
    alpha3: "LAO",
    countryCallingCodes: ["+856"],
    currencies: ["LAK"],
    emoji: "🇱🇦",
    ioc: "LAO",
    languages: ["lao"],
    name: "Lao People's Democratic Republic",
    status: "assigned"
  }, {
    alpha2: "LB",
    alpha3: "LBN",
    countryCallingCodes: ["+961"],
    currencies: ["LBP"],
    emoji: "🇱🇧",
    ioc: "LIB",
    languages: ["ara", "hye"],
    name: "Lebanon",
    status: "assigned"
  }, {
    alpha2: "LC",
    alpha3: "LCA",
    countryCallingCodes: ["+1 758"],
    currencies: ["XCD"],
    emoji: "🇱🇨",
    ioc: "LCA",
    languages: ["eng"],
    name: "Saint Lucia",
    status: "assigned"
  }, {
    alpha2: "LI",
    alpha3: "LIE",
    countryCallingCodes: ["+423"],
    currencies: ["CHF"],
    emoji: "🇱🇮",
    ioc: "LIE",
    languages: ["deu"],
    name: "Liechtenstein",
    status: "assigned"
  }, {
    alpha2: "LK",
    alpha3: "LKA",
    countryCallingCodes: ["+94"],
    currencies: ["LKR"],
    emoji: "🇱🇰",
    ioc: "SRI",
    languages: ["sin", "tam"],
    name: "Sri Lanka",
    status: "assigned"
  }, {
    alpha2: "LR",
    alpha3: "LBR",
    countryCallingCodes: ["+231"],
    currencies: ["LRD"],
    emoji: "🇱🇷",
    ioc: "LBR",
    languages: ["eng"],
    name: "Liberia",
    status: "assigned"
  }, {
    alpha2: "LS",
    alpha3: "LSO",
    countryCallingCodes: ["+266"],
    currencies: ["LSL", "ZAR"],
    emoji: "🇱🇸",
    ioc: "LES",
    languages: ["eng", "sot"],
    name: "Lesotho",
    status: "assigned"
  }, {
    alpha2: "LT",
    alpha3: "LTU",
    countryCallingCodes: ["+370"],
    currencies: ["EUR"],
    emoji: "🇱🇹",
    ioc: "LTU",
    languages: ["lit"],
    name: "Lithuania",
    status: "assigned"
  }, {
    alpha2: "LU",
    alpha3: "LUX",
    countryCallingCodes: ["+352"],
    currencies: ["EUR"],
    emoji: "🇱🇺",
    ioc: "LUX",
    languages: ["fra", "deu", "ltz"],
    name: "Luxembourg",
    status: "assigned"
  }, {
    alpha2: "LV",
    alpha3: "LVA",
    countryCallingCodes: ["+371"],
    currencies: ["EUR"],
    emoji: "🇱🇻",
    ioc: "LAT",
    languages: ["lav"],
    name: "Latvia",
    status: "assigned"
  }, {
    alpha2: "LY",
    alpha3: "LBY",
    countryCallingCodes: ["+218"],
    currencies: ["LYD"],
    emoji: "🇱🇾",
    ioc: "LBA",
    languages: ["ara"],
    name: "Libya",
    status: "assigned"
  }, {
    alpha2: "MA",
    alpha3: "MAR",
    countryCallingCodes: ["+212"],
    currencies: ["MAD"],
    emoji: "🇲🇦",
    ioc: "MAR",
    languages: ["ara"],
    name: "Morocco",
    status: "assigned"
  }, {
    alpha2: "MC",
    alpha3: "MCO",
    countryCallingCodes: ["+377"],
    currencies: ["EUR"],
    emoji: "🇲🇨",
    ioc: "MON",
    languages: ["fra"],
    name: "Monaco",
    status: "assigned"
  }, {
    alpha2: "MD",
    alpha3: "MDA",
    countryCallingCodes: ["+373"],
    currencies: ["MDL"],
    emoji: "🇲🇩",
    ioc: "MDA",
    languages: ["ron"],
    name: "Moldova",
    status: "assigned"
  }, {
    alpha2: "ME",
    alpha3: "MNE",
    countryCallingCodes: ["+382"],
    currencies: ["EUR"],
    emoji: "🇲🇪",
    ioc: "MNE",
    languages: ["mot"],
    name: "Montenegro",
    status: "assigned"
  }, {
    alpha2: "MF",
    alpha3: "MAF",
    countryCallingCodes: ["+590"],
    currencies: ["EUR"],
    emoji: "🇲🇫",
    ioc: "",
    languages: ["fra"],
    name: "Saint Martin",
    status: "assigned"
  }, {
    alpha2: "MG",
    alpha3: "MDG",
    countryCallingCodes: ["+261"],
    currencies: ["MGA"],
    emoji: "🇲🇬",
    ioc: "MAD",
    languages: ["fra", "mlg"],
    name: "Madagascar",
    status: "assigned"
  }, {
    alpha2: "MH",
    alpha3: "MHL",
    countryCallingCodes: ["+692"],
    currencies: ["USD"],
    emoji: "🇲🇭",
    ioc: "MHL",
    languages: ["eng", "mah"],
    name: "Marshall Islands",
    status: "assigned"
  }, {
    alpha2: "MI",
    alpha3: "MID",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Midway Islands",
    status: "deleted"
  }, {
    alpha2: "MK",
    alpha3: "MKD",
    countryCallingCodes: ["+389"],
    currencies: ["MKD"],
    emoji: "🇲🇰",
    ioc: "MKD",
    languages: ["mkd"],
    name: "North Macedonia",
    status: "assigned"
  }, {
    alpha2: "ML",
    alpha3: "MLI",
    countryCallingCodes: ["+223"],
    currencies: ["XOF"],
    emoji: "🇲🇱",
    ioc: "MLI",
    languages: ["fra"],
    name: "Mali",
    status: "assigned"
  }, {
    alpha2: "MM",
    alpha3: "MMR",
    countryCallingCodes: ["+95"],
    currencies: ["MMK"],
    emoji: "🇲🇲",
    ioc: "MYA",
    languages: ["mya"],
    name: "Myanmar",
    status: "assigned"
  }, {
    alpha2: "MN",
    alpha3: "MNG",
    countryCallingCodes: ["+976"],
    currencies: ["MNT"],
    emoji: "🇲🇳",
    ioc: "MGL",
    languages: ["mon"],
    name: "Mongolia",
    status: "assigned"
  }, {
    alpha2: "MO",
    alpha3: "MAC",
    countryCallingCodes: ["+853"],
    currencies: ["MOP"],
    emoji: "🇲🇴",
    ioc: "MAC",
    languages: ["zho", "por"],
    name: "Macao",
    status: "assigned"
  }, {
    alpha2: "MP",
    alpha3: "MNP",
    countryCallingCodes: ["+1 670"],
    currencies: ["USD"],
    emoji: "🇲🇵",
    ioc: "",
    languages: ["eng"],
    name: "Northern Mariana Islands",
    status: "assigned"
  }, {
    alpha2: "MQ",
    alpha3: "MTQ",
    countryCallingCodes: ["+596"],
    currencies: ["EUR"],
    emoji: "🇲🇶",
    ioc: "",
    languages: [],
    name: "Martinique",
    status: "assigned"
  }, {
    alpha2: "MR",
    alpha3: "MRT",
    countryCallingCodes: ["+222"],
    currencies: ["MRO"],
    emoji: "🇲🇷",
    ioc: "MTN",
    languages: ["ara", "fra"],
    name: "Mauritania",
    status: "assigned"
  }, {
    alpha2: "MS",
    alpha3: "MSR",
    countryCallingCodes: ["+1 664"],
    currencies: ["XCD"],
    emoji: "🇲🇸",
    ioc: "",
    languages: [],
    name: "Montserrat",
    status: "assigned"
  }, {
    alpha2: "MT",
    alpha3: "MLT",
    countryCallingCodes: ["+356"],
    currencies: ["EUR"],
    emoji: "🇲🇹",
    ioc: "MLT",
    languages: ["mlt", "eng"],
    name: "Malta",
    status: "assigned"
  }, {
    alpha2: "MU",
    alpha3: "MUS",
    countryCallingCodes: ["+230"],
    currencies: ["MUR"],
    emoji: "🇲🇺",
    ioc: "MRI",
    languages: ["eng", "fra"],
    name: "Mauritius",
    status: "assigned"
  }, {
    alpha2: "MV",
    alpha3: "MDV",
    countryCallingCodes: ["+960"],
    currencies: ["MVR"],
    emoji: "🇲🇻",
    ioc: "MDV",
    languages: ["div"],
    name: "Maldives",
    status: "assigned"
  }, {
    alpha2: "MW",
    alpha3: "MWI",
    countryCallingCodes: ["+265"],
    currencies: ["MWK"],
    emoji: "🇲🇼",
    ioc: "MAW",
    languages: ["eng", "nya"],
    name: "Malawi",
    status: "assigned"
  }, {
    alpha2: "MX",
    alpha3: "MEX",
    countryCallingCodes: ["+52"],
    currencies: ["MXN", "MXV"],
    emoji: "🇲🇽",
    ioc: "MEX",
    languages: ["spa"],
    name: "Mexico",
    status: "assigned"
  }, {
    alpha2: "MY",
    alpha3: "MYS",
    countryCallingCodes: ["+60"],
    currencies: ["MYR"],
    emoji: "🇲🇾",
    ioc: "MAS",
    languages: ["msa", "eng"],
    name: "Malaysia",
    status: "assigned"
  }, {
    alpha2: "MZ",
    alpha3: "MOZ",
    countryCallingCodes: ["+258"],
    currencies: ["MZN"],
    emoji: "🇲🇿",
    ioc: "MOZ",
    languages: ["por"],
    name: "Mozambique",
    status: "assigned"
  }, {
    alpha2: "NA",
    alpha3: "NAM",
    countryCallingCodes: ["+264"],
    currencies: ["NAD", "ZAR"],
    emoji: "🇳🇦",
    ioc: "NAM",
    languages: ["eng"],
    name: "Namibia",
    status: "assigned"
  }, {
    alpha2: "NC",
    alpha3: "NCL",
    countryCallingCodes: ["+687"],
    currencies: ["XPF"],
    emoji: "🇳🇨",
    ioc: "",
    languages: ["fra"],
    name: "New Caledonia",
    status: "assigned"
  }, {
    alpha2: "NE",
    alpha3: "NER",
    countryCallingCodes: ["+227"],
    currencies: ["XOF"],
    emoji: "🇳🇪",
    ioc: "NIG",
    languages: ["fra"],
    name: "Niger",
    status: "assigned"
  }, {
    alpha2: "NF",
    alpha3: "NFK",
    countryCallingCodes: ["+672"],
    currencies: ["AUD"],
    emoji: "🇳🇫",
    ioc: "",
    languages: ["eng"],
    name: "Norfolk Island",
    status: "assigned"
  }, {
    alpha2: "NG",
    alpha3: "NGA",
    countryCallingCodes: ["+234"],
    currencies: ["NGN"],
    emoji: "🇳🇬",
    ioc: "NGR",
    languages: ["eng"],
    name: "Nigeria",
    status: "assigned"
  }, {
    alpha2: "NH",
    alpha3: "NHB",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "New Hebrides",
    status: "deleted"
  }, {
    alpha2: "NI",
    alpha3: "NIC",
    countryCallingCodes: ["+505"],
    currencies: ["NIO"],
    emoji: "🇳🇮",
    ioc: "NCA",
    languages: ["spa"],
    name: "Nicaragua",
    status: "assigned"
  }, {
    alpha2: "NL",
    alpha3: "NLD",
    countryCallingCodes: ["+31"],
    currencies: ["EUR"],
    emoji: "🇳🇱",
    ioc: "NED",
    languages: ["nld"],
    name: "Netherlands",
    status: "assigned"
  }, {
    alpha2: "NO",
    alpha3: "NOR",
    countryCallingCodes: ["+47"],
    currencies: ["NOK"],
    emoji: "🇳🇴",
    ioc: "NOR",
    languages: ["nor"],
    name: "Norway",
    status: "assigned"
  }, {
    alpha2: "NP",
    alpha3: "NPL",
    countryCallingCodes: ["+977"],
    currencies: ["NPR"],
    emoji: "🇳🇵",
    ioc: "NEP",
    languages: ["nep"],
    name: "Nepal",
    status: "assigned"
  }, {
    alpha2: "NQ",
    alpha3: "ATN",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Dronning Maud Land",
    status: "deleted"
  }, {
    alpha2: "NR",
    alpha3: "NRU",
    countryCallingCodes: ["+674"],
    currencies: ["AUD"],
    emoji: "🇳🇷",
    ioc: "NRU",
    languages: ["eng", "nau"],
    name: "Nauru",
    status: "assigned"
  }, {
    alpha2: "NT",
    alpha3: "NTZ",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Neutral Zone",
    status: "deleted"
  }, {
    alpha2: "NU",
    alpha3: "NIU",
    countryCallingCodes: ["+683"],
    currencies: ["NZD"],
    emoji: "🇳🇺",
    ioc: "",
    languages: ["eng"],
    name: "Niue",
    status: "assigned"
  }, {
    alpha2: "NZ",
    alpha3: "NZL",
    countryCallingCodes: ["+64"],
    currencies: ["NZD"],
    emoji: "🇳🇿",
    ioc: "NZL",
    languages: ["eng", "mri"],
    name: "New Zealand",
    status: "assigned"
  }, {
    alpha2: "OM",
    alpha3: "OMN",
    countryCallingCodes: ["+968"],
    currencies: ["OMR"],
    emoji: "🇴🇲",
    ioc: "OMA",
    languages: ["ara"],
    name: "Oman",
    status: "assigned"
  }, {
    alpha2: "PA",
    alpha3: "PAN",
    countryCallingCodes: ["+507"],
    currencies: ["PAB", "USD"],
    emoji: "🇵🇦",
    ioc: "PAN",
    languages: ["spa"],
    name: "Panama",
    status: "assigned"
  }, {
    alpha2: "PC",
    alpha3: "PCI",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Pacific Islands, Trust Territory of the",
    status: "deleted"
  }, {
    alpha2: "PE",
    alpha3: "PER",
    countryCallingCodes: ["+51"],
    currencies: ["PEN"],
    emoji: "🇵🇪",
    ioc: "PER",
    languages: ["spa", "aym", "que"],
    name: "Peru",
    status: "assigned"
  }, {
    alpha2: "PF",
    alpha3: "PYF",
    countryCallingCodes: ["+689"],
    currencies: ["XPF"],
    emoji: "🇵🇫",
    ioc: "",
    languages: ["fra"],
    name: "French Polynesia",
    status: "assigned"
  }, {
    alpha2: "PG",
    alpha3: "PNG",
    countryCallingCodes: ["+675"],
    currencies: ["PGK"],
    emoji: "🇵🇬",
    ioc: "PNG",
    languages: ["eng"],
    name: "Papua New Guinea",
    status: "assigned"
  }, {
    alpha2: "PH",
    alpha3: "PHL",
    countryCallingCodes: ["+63"],
    currencies: ["PHP"],
    emoji: "🇵🇭",
    ioc: "PHI",
    languages: ["eng"],
    name: "Philippines",
    status: "assigned"
  }, {
    alpha2: "PK",
    alpha3: "PAK",
    countryCallingCodes: ["+92"],
    currencies: ["PKR"],
    emoji: "🇵🇰",
    ioc: "PAK",
    languages: ["urd", "eng"],
    name: "Pakistan",
    status: "assigned"
  }, {
    alpha2: "PL",
    alpha3: "POL",
    countryCallingCodes: ["+48"],
    currencies: ["PLN"],
    emoji: "🇵🇱",
    ioc: "POL",
    languages: ["pol"],
    name: "Poland",
    status: "assigned"
  }, {
    alpha2: "PM",
    alpha3: "SPM",
    countryCallingCodes: ["+508"],
    currencies: ["EUR"],
    emoji: "🇵🇲",
    ioc: "",
    languages: ["eng"],
    name: "Saint Pierre And Miquelon",
    status: "assigned"
  }, {
    alpha2: "PN",
    alpha3: "PCN",
    countryCallingCodes: ["+872"],
    currencies: ["NZD"],
    emoji: "🇵🇳",
    ioc: "",
    languages: ["eng"],
    name: "Pitcairn",
    status: "assigned"
  }, {
    alpha2: "PR",
    alpha3: "PRI",
    countryCallingCodes: ["+1 787", "+1 939"],
    currencies: ["USD"],
    emoji: "🇵🇷",
    ioc: "PUR",
    languages: ["spa", "eng"],
    name: "Puerto Rico",
    status: "assigned"
  }, {
    alpha2: "PS",
    alpha3: "PSE",
    countryCallingCodes: ["+970"],
    currencies: ["JOD", "EGP", "ILS"],
    emoji: "🇵🇸",
    ioc: "PLE",
    languages: ["ara"],
    name: "Palestinian Territory, Occupied",
    status: "assigned"
  }, {
    alpha2: "PT",
    alpha3: "PRT",
    countryCallingCodes: ["+351"],
    currencies: ["EUR"],
    emoji: "🇵🇹",
    ioc: "POR",
    languages: ["por"],
    name: "Portugal",
    status: "assigned"
  }, {
    alpha2: "PU",
    alpha3: "PUS",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "U.S. Miscellaneous Pacific Islands",
    status: "deleted"
  }, {
    alpha2: "PW",
    alpha3: "PLW",
    countryCallingCodes: ["+680"],
    currencies: ["USD"],
    emoji: "🇵🇼",
    ioc: "PLW",
    languages: ["eng"],
    name: "Palau",
    status: "assigned"
  }, {
    alpha2: "PY",
    alpha3: "PRY",
    countryCallingCodes: ["+595"],
    currencies: ["PYG"],
    emoji: "🇵🇾",
    ioc: "PAR",
    languages: ["spa"],
    name: "Paraguay",
    status: "assigned"
  }, {
    alpha2: "PZ",
    alpha3: "PCZ",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Panama Canal Zone",
    status: "deleted"
  }, {
    alpha2: "QA",
    alpha3: "QAT",
    countryCallingCodes: ["+974"],
    currencies: ["QAR"],
    emoji: "🇶🇦",
    ioc: "QAT",
    languages: ["ara"],
    name: "Qatar",
    status: "assigned"
  }, {
    alpha2: "RE",
    alpha3: "REU",
    countryCallingCodes: ["+262"],
    currencies: ["EUR"],
    emoji: "🇷🇪",
    ioc: "",
    languages: ["fra"],
    name: "Reunion",
    status: "assigned"
  }, {
    alpha2: "RH",
    alpha3: "RHO",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Southern Rhodesia",
    status: "deleted"
  }, {
    alpha2: "RO",
    alpha3: "ROU",
    countryCallingCodes: ["+40"],
    currencies: ["RON"],
    emoji: "🇷🇴",
    ioc: "ROU",
    languages: ["ron"],
    name: "Romania",
    status: "assigned"
  }, {
    alpha2: "RS",
    alpha3: "SRB",
    countryCallingCodes: ["+381"],
    currencies: ["RSD"],
    emoji: "🇷🇸",
    ioc: "SRB",
    languages: ["srp"],
    name: "Serbia",
    status: "assigned"
  }, {
    alpha2: "RU",
    alpha3: "RUS",
    countryCallingCodes: ["+7", "+7 3", "+7 4", "+7 8"],
    currencies: ["RUB"],
    emoji: "🇷🇺",
    ioc: "RUS",
    languages: ["rus"],
    name: "Russia",
    status: "assigned"
  }, {
    alpha2: "RW",
    alpha3: "RWA",
    countryCallingCodes: ["+250"],
    currencies: ["RWF"],
    emoji: "🇷🇼",
    ioc: "RWA",
    languages: ["eng", "fra", "kin"],
    name: "Rwanda",
    status: "assigned"
  }, {
    alpha2: "SA",
    alpha3: "SAU",
    countryCallingCodes: ["+966"],
    currencies: ["SAR"],
    emoji: "🇸🇦",
    ioc: "KSA",
    languages: ["ara"],
    name: "Saudi Arabia",
    status: "assigned"
  }, {
    alpha2: "SB",
    alpha3: "SLB",
    countryCallingCodes: ["+677"],
    currencies: ["SBD"],
    emoji: "🇸🇧",
    ioc: "SOL",
    languages: ["eng"],
    name: "Solomon Islands",
    status: "assigned"
  }, {
    alpha2: "SC",
    alpha3: "SYC",
    countryCallingCodes: ["+248"],
    currencies: ["SCR"],
    emoji: "🇸🇨",
    ioc: "SEY",
    languages: ["eng", "fra"],
    name: "Seychelles",
    status: "assigned"
  }, {
    alpha2: "SD",
    alpha3: "SDN",
    countryCallingCodes: ["+249"],
    currencies: ["SDG"],
    emoji: "🇸🇩",
    ioc: "SUD",
    languages: ["ara", "eng"],
    name: "Sudan",
    status: "assigned"
  }, {
    alpha2: "SE",
    alpha3: "SWE",
    countryCallingCodes: ["+46"],
    currencies: ["SEK"],
    emoji: "🇸🇪",
    ioc: "SWE",
    languages: ["swe"],
    name: "Sweden",
    status: "assigned"
  }, {
    alpha2: "SG",
    alpha3: "SGP",
    countryCallingCodes: ["+65"],
    currencies: ["SGD"],
    emoji: "🇸🇬",
    ioc: "SGP",
    languages: ["eng", "zho", "msa", "tam"],
    name: "Singapore",
    status: "assigned"
  }, {
    alpha2: "SH",
    alpha3: "SHN",
    countryCallingCodes: ["+290"],
    currencies: ["SHP"],
    emoji: "🇸🇭",
    ioc: "",
    languages: ["eng"],
    name: "Saint Helena, Ascension And Tristan Da Cunha",
    status: "assigned"
  }, {
    alpha2: "SI",
    alpha3: "SVN",
    countryCallingCodes: ["+386"],
    currencies: ["EUR"],
    emoji: "🇸🇮",
    ioc: "SLO",
    languages: ["slv"],
    name: "Slovenia",
    status: "assigned"
  }, {
    alpha2: "SJ",
    alpha3: "SJM",
    countryCallingCodes: ["+47"],
    currencies: ["NOK"],
    emoji: "🇸🇯",
    ioc: "",
    languages: [],
    name: "Svalbard And Jan Mayen",
    status: "assigned"
  }, {
    alpha2: "SK",
    alpha3: "SVK",
    countryCallingCodes: ["+421"],
    currencies: ["EUR"],
    emoji: "🇸🇰",
    ioc: "SVK",
    languages: ["slk"],
    name: "Slovakia",
    status: "assigned"
  }, {
    alpha2: "SK",
    alpha3: "SKM",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Sikkim",
    status: "deleted"
  }, {
    alpha2: "SL",
    alpha3: "SLE",
    countryCallingCodes: ["+232"],
    currencies: ["SLL"],
    emoji: "🇸🇱",
    ioc: "SLE",
    languages: ["eng"],
    name: "Sierra Leone",
    status: "assigned"
  }, {
    alpha2: "SM",
    alpha3: "SMR",
    countryCallingCodes: ["+378"],
    currencies: ["EUR"],
    emoji: "🇸🇲",
    ioc: "SMR",
    languages: ["ita"],
    name: "San Marino",
    status: "assigned"
  }, {
    alpha2: "SN",
    alpha3: "SEN",
    countryCallingCodes: ["+221"],
    currencies: ["XOF"],
    emoji: "🇸🇳",
    ioc: "SEN",
    languages: ["fra"],
    name: "Senegal",
    status: "assigned"
  }, {
    alpha2: "SO",
    alpha3: "SOM",
    countryCallingCodes: ["+252"],
    currencies: ["SOS"],
    emoji: "🇸🇴",
    ioc: "SOM",
    languages: ["som"],
    name: "Somalia",
    status: "assigned"
  }, {
    alpha2: "SR",
    alpha3: "SUR",
    countryCallingCodes: ["+597"],
    currencies: ["SRD"],
    emoji: "🇸🇷",
    ioc: "SUR",
    languages: ["nld"],
    name: "Suriname",
    status: "assigned"
  }, {
    alpha2: "SS",
    alpha3: "SSD",
    countryCallingCodes: ["+211"],
    currencies: ["SSP"],
    emoji: "🇸🇸",
    ioc: "SSD",
    languages: ["eng"],
    name: "South Sudan",
    status: "assigned"
  }, {
    alpha2: "ST",
    alpha3: "STP",
    countryCallingCodes: ["+239"],
    currencies: ["STD"],
    emoji: "🇸🇹",
    ioc: "STP",
    languages: ["por"],
    name: "Sao Tome and Principe",
    status: "assigned"
  }, {
    alpha2: "SU",
    alpha3: "SUN",
    countryCallingCodes: [],
    currencies: ["RUB"],
    emoji: "",
    ioc: "",
    languages: ["rus"],
    name: "USSR",
    status: "reserved"
  }, {
    alpha2: "SV",
    alpha3: "SLV",
    countryCallingCodes: ["+503"],
    currencies: ["USD"],
    emoji: "🇸🇻",
    ioc: "ESA",
    languages: ["spa"],
    name: "El Salvador",
    status: "assigned"
  }, {
    alpha2: "SX",
    alpha3: "SXM",
    countryCallingCodes: ["+1 721"],
    currencies: ["ANG"],
    emoji: "🇸🇽",
    ioc: "",
    languages: ["nld"],
    name: "Sint Maarten",
    status: "assigned"
  }, {
    alpha2: "SY",
    alpha3: "SYR",
    countryCallingCodes: ["+963"],
    currencies: ["SYP"],
    emoji: "🇸🇾",
    ioc: "SYR",
    languages: ["ara"],
    name: "Syrian Arab Republic",
    status: "assigned"
  }, {
    alpha2: "SZ",
    alpha3: "SWZ",
    countryCallingCodes: ["+268"],
    currencies: ["SZL"],
    emoji: "🇸🇿",
    ioc: "SWZ",
    languages: ["eng", "ssw"],
    name: "Eswatini",
    status: "assigned"
  }, {
    alpha2: "TA",
    alpha3: "TAA",
    countryCallingCodes: ["+290"],
    currencies: ["GBP"],
    emoji: "🇹🇦",
    ioc: "",
    languages: [],
    name: "Tristan de Cunha",
    status: "reserved"
  }, {
    alpha2: "TC",
    alpha3: "TCA",
    countryCallingCodes: ["+1 649"],
    currencies: ["USD"],
    emoji: "🇹🇨",
    ioc: "",
    languages: ["eng"],
    name: "Turks And Caicos Islands",
    status: "assigned"
  }, {
    alpha2: "TD",
    alpha3: "TCD",
    countryCallingCodes: ["+235"],
    currencies: ["XAF"],
    emoji: "🇹🇩",
    ioc: "CHA",
    languages: ["ara", "fra"],
    name: "Chad",
    status: "assigned"
  }, {
    alpha2: "TF",
    alpha3: "ATF",
    countryCallingCodes: [],
    currencies: ["EUR"],
    emoji: "🇹🇫",
    ioc: "",
    languages: ["fra"],
    name: "French Southern Territories",
    status: "assigned"
  }, {
    alpha2: "TG",
    alpha3: "TGO",
    countryCallingCodes: ["+228"],
    currencies: ["XOF"],
    emoji: "🇹🇬",
    ioc: "TOG",
    languages: ["fra"],
    name: "Togo",
    status: "assigned"
  }, {
    alpha2: "TH",
    alpha3: "THA",
    countryCallingCodes: ["+66"],
    currencies: ["THB"],
    emoji: "🇹🇭",
    ioc: "THA",
    languages: ["tha"],
    name: "Thailand",
    status: "assigned"
  }, {
    alpha2: "TJ",
    alpha3: "TJK",
    countryCallingCodes: ["+992"],
    currencies: ["TJS"],
    emoji: "🇹🇯",
    ioc: "TJK",
    languages: ["tgk", "rus"],
    name: "Tajikistan",
    status: "assigned"
  }, {
    alpha2: "TK",
    alpha3: "TKL",
    countryCallingCodes: ["+690"],
    currencies: ["NZD"],
    emoji: "🇹🇰",
    ioc: "",
    languages: ["eng"],
    name: "Tokelau",
    status: "assigned"
  }, {
    alpha2: "TL",
    alpha3: "TLS",
    countryCallingCodes: ["+670"],
    currencies: ["USD"],
    emoji: "🇹🇱",
    ioc: "TLS",
    languages: ["por"],
    name: "Timor-Leste, Democratic Republic of",
    status: "assigned"
  }, {
    alpha2: "TM",
    alpha3: "TKM",
    countryCallingCodes: ["+993"],
    currencies: ["TMT"],
    emoji: "🇹🇲",
    ioc: "TKM",
    languages: ["tuk", "rus"],
    name: "Turkmenistan",
    status: "assigned"
  }, {
    alpha2: "TN",
    alpha3: "TUN",
    countryCallingCodes: ["+216"],
    currencies: ["TND"],
    emoji: "🇹🇳",
    ioc: "TUN",
    languages: ["ara"],
    name: "Tunisia",
    status: "assigned"
  }, {
    alpha2: "TO",
    alpha3: "TON",
    countryCallingCodes: ["+676"],
    currencies: ["TOP"],
    emoji: "🇹🇴",
    ioc: "TGA",
    languages: ["eng"],
    name: "Tonga",
    status: "assigned"
  }, {
    alpha2: "TP",
    alpha3: "TMP",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "East Timor",
    status: "deleted"
  }, {
    alpha2: "TR",
    alpha3: "TUR",
    countryCallingCodes: ["+90"],
    currencies: ["TRY"],
    emoji: "🇹🇷",
    ioc: "TUR",
    languages: ["tur"],
    name: "Turkey",
    status: "assigned"
  }, {
    alpha2: "TT",
    alpha3: "TTO",
    countryCallingCodes: ["+1 868"],
    currencies: ["TTD"],
    emoji: "🇹🇹",
    ioc: "TTO",
    languages: ["eng"],
    name: "Trinidad And Tobago",
    status: "assigned"
  }, {
    alpha2: "TV",
    alpha3: "TUV",
    countryCallingCodes: ["+688"],
    currencies: ["AUD"],
    emoji: "🇹🇻",
    ioc: "TUV",
    languages: ["eng"],
    name: "Tuvalu",
    status: "assigned"
  }, {
    alpha2: "TW",
    alpha3: "TWN",
    countryCallingCodes: ["+886"],
    currencies: ["TWD"],
    emoji: "🇹🇼",
    ioc: "TPE",
    languages: ["zho"],
    name: "Taiwan",
    status: "assigned"
  }, {
    alpha2: "TZ",
    alpha3: "TZA",
    countryCallingCodes: ["+255"],
    currencies: ["TZS"],
    emoji: "🇹🇿",
    ioc: "TAN",
    languages: ["swa", "eng"],
    name: "Tanzania, United Republic Of",
    status: "assigned"
  }, {
    alpha2: "UA",
    alpha3: "UKR",
    countryCallingCodes: ["+380"],
    currencies: ["UAH"],
    emoji: "🇺🇦",
    ioc: "UKR",
    languages: ["ukr", "rus"],
    name: "Ukraine",
    status: "assigned"
  }, {
    alpha2: "UG",
    alpha3: "UGA",
    countryCallingCodes: ["+256"],
    currencies: ["UGX"],
    emoji: "🇺🇬",
    ioc: "UGA",
    languages: ["eng", "swa"],
    name: "Uganda",
    status: "assigned"
  }, {
    alpha2: "UM",
    alpha3: "UMI",
    countryCallingCodes: ["+1"],
    currencies: ["USD"],
    emoji: "🇺🇲",
    ioc: "",
    languages: ["eng"],
    name: "United States Minor Outlying Islands",
    status: "assigned"
  }, {
    alpha2: "US",
    alpha3: "USA",
    countryCallingCodes: ["+1"],
    currencies: ["USD"],
    emoji: "🇺🇸",
    ioc: "USA",
    languages: ["eng"],
    name: "United States",
    status: "assigned"
  }, {
    alpha2: "UY",
    alpha3: "URY",
    countryCallingCodes: ["+598"],
    currencies: ["UYU", "UYI"],
    emoji: "🇺🇾",
    ioc: "URU",
    languages: ["spa"],
    name: "Uruguay",
    status: "assigned"
  }, {
    alpha2: "UZ",
    alpha3: "UZB",
    countryCallingCodes: ["+998"],
    currencies: ["UZS"],
    emoji: "🇺🇿",
    ioc: "UZB",
    languages: ["uzb", "rus"],
    name: "Uzbekistan",
    status: "assigned"
  }, {
    alpha2: "VA",
    alpha3: "VAT",
    countryCallingCodes: ["+379", "+39"],
    currencies: ["EUR"],
    emoji: "🇻🇦",
    ioc: "",
    languages: ["ita"],
    name: "Vatican City State",
    status: "assigned"
  }, {
    alpha2: "VC",
    alpha3: "VCT",
    countryCallingCodes: ["+1 784"],
    currencies: ["XCD"],
    emoji: "🇻🇨",
    ioc: "VIN",
    languages: ["eng"],
    name: "Saint Vincent And The Grenadines",
    status: "assigned"
  }, {
    alpha2: "VD",
    alpha3: "VDR",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Viet-Nam, Democratic Republic of",
    status: "deleted"
  }, {
    alpha2: "VE",
    alpha3: "VEN",
    countryCallingCodes: ["+58"],
    currencies: ["VEF"],
    emoji: "🇻🇪",
    ioc: "VEN",
    languages: ["spa"],
    name: "Venezuela, Bolivarian Republic Of",
    status: "assigned"
  }, {
    alpha2: "VG",
    alpha3: "VGB",
    countryCallingCodes: ["+1 284"],
    currencies: ["USD"],
    emoji: "🇻🇬",
    ioc: "IVB",
    languages: ["eng"],
    name: "Virgin Islands (British)",
    status: "assigned"
  }, {
    alpha2: "VI",
    alpha3: "VIR",
    countryCallingCodes: ["+1 340"],
    currencies: ["USD"],
    emoji: "🇻🇮",
    ioc: "ISV",
    languages: ["eng"],
    name: "Virgin Islands (US)",
    status: "assigned"
  }, {
    alpha2: "VN",
    alpha3: "VNM",
    countryCallingCodes: ["+84"],
    currencies: ["VND"],
    emoji: "🇻🇳",
    ioc: "VIE",
    languages: ["vie"],
    name: "VietNam",
    status: "assigned"
  }, {
    alpha2: "VU",
    alpha3: "VUT",
    countryCallingCodes: ["+678"],
    currencies: ["VUV"],
    emoji: "🇻🇺",
    ioc: "VAN",
    languages: ["bis", "eng", "fra"],
    name: "Vanuatu",
    status: "assigned"
  }, {
    alpha2: "WF",
    alpha3: "WLF",
    countryCallingCodes: ["+681"],
    currencies: ["XPF"],
    emoji: "🇼🇫",
    ioc: "",
    languages: ["fra"],
    name: "Wallis And Futuna",
    status: "assigned"
  }, {
    alpha2: "WK",
    alpha3: "WAK",
    countryCallingCodes: [],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Wake Island",
    status: "deleted"
  }, {
    alpha2: "WS",
    alpha3: "WSM",
    countryCallingCodes: ["+685"],
    currencies: ["WST"],
    emoji: "🇼🇸",
    ioc: "SAM",
    languages: ["eng", "smo"],
    name: "Samoa",
    status: "assigned"
  }, {
    alpha2: "XK",
    alpha3: "XKX",
    countryCallingCodes: ["+383"],
    currencies: ["EUR"],
    emoji: "🇽🇰",
    ioc: "KOS",
    languages: ["sqi", "srp", "bos", "tur", "rom"],
    name: "Kosovo",
    status: "user assigned"
  }, {
    alpha2: "YD",
    alpha3: "YMD",
    countryCallingCodes: ["+967"],
    currencies: [],
    ioc: "🇾🇪",
    languages: [],
    name: "Yemen, Democratic",
    status: "deleted"
  }, {
    alpha2: "YE",
    alpha3: "YEM",
    countryCallingCodes: ["+967"],
    currencies: ["YER"],
    emoji: "🇾🇪",
    ioc: "YEM",
    languages: ["ara"],
    name: "Yemen",
    status: "assigned"
  }, {
    alpha2: "YT",
    alpha3: "MYT",
    countryCallingCodes: ["+262"],
    currencies: ["EUR"],
    emoji: "🇾🇹",
    ioc: "",
    languages: ["fra"],
    name: "Mayotte",
    status: "assigned"
  }, {
    alpha2: "YU",
    alpha3: "YUG",
    countryCallingCodes: ["+38"],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Yugoslavia",
    status: "deleted"
  }, {
    alpha2: "ZA",
    alpha3: "ZAF",
    countryCallingCodes: ["+27"],
    currencies: ["ZAR"],
    emoji: "🇿🇦",
    ioc: "RSA",
    languages: ["afr", "eng", "nbl", "som", "tso", "ven", "xho", "zul"],
    name: "South Africa",
    status: "assigned"
  }, {
    alpha2: "ZM",
    alpha3: "ZMB",
    countryCallingCodes: ["+260"],
    currencies: ["ZMW"],
    emoji: "🇿🇲",
    ioc: "ZAM",
    languages: ["eng"],
    name: "Zambia",
    status: "assigned"
  }, {
    alpha2: "ZR",
    alpha3: "ZAR",
    countryCallingCodes: ["+243"],
    currencies: [],
    ioc: "",
    languages: [],
    name: "Zaire",
    status: "deleted"
  }, {
    alpha2: "ZW",
    alpha3: "ZWE",
    countryCallingCodes: ["+263"],
    currencies: ["USD", "ZAR", "BWP", "GBP", "EUR"],
    emoji: "🇿🇼",
    ioc: "ZIM",
    languages: ["eng", "sna", "nde"],
    name: "Zimbabwe",
    status: "assigned"
  }];
})(lf);
var cf = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, e.default = [{
    code: "AED",
    decimals: 2,
    name: "United Arab Emirates dirham",
    number: "784"
  }, {
    code: "AFN",
    decimals: 2,
    name: "Afghan afghani",
    number: "971"
  }, {
    code: "ALL",
    decimals: 2,
    name: "Albanian lek",
    number: "8"
  }, {
    code: "AMD",
    decimals: 2,
    name: "Armenian dram",
    number: "51"
  }, {
    code: "ANG",
    decimals: 2,
    name: "Netherlands Antillean guilder",
    number: "532"
  }, {
    code: "AOA",
    decimals: 2,
    name: "Angolan kwanza",
    number: "973"
  }, {
    code: "ARS",
    decimals: 2,
    name: "Argentine peso",
    number: "32"
  }, {
    code: "AUD",
    decimals: 2,
    name: "Australian dollar",
    number: "36"
  }, {
    code: "AWG",
    decimals: 2,
    name: "Aruban florin",
    number: "533"
  }, {
    code: "AZN",
    decimals: 2,
    name: "Azerbaijani manat",
    number: "944"
  }, {
    code: "BAM",
    decimals: 2,
    name: "Bosnia and Herzegovina convertible mark",
    number: "977"
  }, {
    code: "BBD",
    decimals: 2,
    name: "Barbados dollar",
    number: "52"
  }, {
    code: "BDT",
    decimals: 2,
    name: "Bangladeshi taka",
    number: "50"
  }, {
    code: "BGN",
    decimals: 2,
    name: "Bulgarian lev",
    number: "975"
  }, {
    code: "BHD",
    decimals: 3,
    name: "Bahraini dinar",
    number: "48"
  }, {
    code: "BIF",
    decimals: 0,
    name: "Burundian franc",
    number: "108"
  }, {
    code: "BMD",
    decimals: 2,
    name: "Bermudian dollar (customarily known as Bermuda dollar)",
    number: "60"
  }, {
    code: "BND",
    decimals: 2,
    name: "Brunei dollar",
    number: "96"
  }, {
    code: "BOB",
    decimals: 2,
    name: "Boliviano",
    number: "68"
  }, {
    code: "BOV",
    decimals: 2,
    name: "Bolivian Mvdol (funds code)",
    number: "984"
  }, {
    code: "BRL",
    decimals: 2,
    name: "Brazilian real",
    number: "986"
  }, {
    code: "BSD",
    decimals: 2,
    name: "Bahamian dollar",
    number: "44"
  }, {
    code: "BTN",
    decimals: 2,
    name: "Bhutanese ngultrum",
    number: "64"
  }, {
    code: "BWP",
    decimals: 2,
    name: "Botswana pula",
    number: "72"
  }, {
    code: "BYN",
    decimals: 0,
    name: "Belarusian ruble",
    number: "974"
  }, {
    code: "BZD",
    decimals: 2,
    name: "Belize dollar",
    number: "84"
  }, {
    code: "CAD",
    decimals: 2,
    name: "Canadian dollar",
    number: "124"
  }, {
    code: "CDF",
    decimals: 2,
    name: "Congolese franc",
    number: "976"
  }, {
    code: "CHE",
    decimals: 2,
    name: "WIR Euro (complementary currency)",
    number: "947"
  }, {
    code: "CHF",
    decimals: 2,
    name: "Swiss franc",
    number: "756"
  }, {
    code: "CHW",
    decimals: 2,
    name: "WIR Franc (complementary currency)",
    number: "948"
  }, {
    code: "CLF",
    decimals: 0,
    name: "Unidad de Fomento (funds code)",
    number: "990"
  }, {
    code: "CLP",
    decimals: 0,
    name: "Chilean peso",
    number: "152"
  }, {
    code: "CNY",
    decimals: 2,
    name: "Chinese yuan",
    number: "156"
  }, {
    code: "COP",
    decimals: 2,
    name: "Colombian peso",
    number: "170"
  }, {
    code: "COU",
    decimals: 2,
    name: "Unidad de Valor Real",
    number: "970"
  }, {
    code: "CRC",
    decimals: 2,
    name: "Costa Rican colon",
    number: "188"
  }, {
    code: "CUC",
    decimals: 2,
    name: "Cuban convertible peso",
    number: "931"
  }, {
    code: "CUP",
    decimals: 2,
    name: "Cuban peso",
    number: "192"
  }, {
    code: "CVE",
    decimals: 0,
    name: "Cape Verde escudo",
    number: "132"
  }, {
    code: "CZK",
    decimals: 2,
    name: "Czech koruna",
    number: "203"
  }, {
    code: "DJF",
    decimals: 0,
    name: "Djiboutian franc",
    number: "262"
  }, {
    code: "DKK",
    decimals: 2,
    name: "Danish krone",
    number: "208"
  }, {
    code: "DOP",
    decimals: 2,
    name: "Dominican peso",
    number: "214"
  }, {
    code: "DZD",
    decimals: 2,
    name: "Algerian dinar",
    number: "12"
  }, {
    code: "EGP",
    decimals: 2,
    name: "Egyptian pound",
    number: "818"
  }, {
    code: "ERN",
    decimals: 2,
    name: "Eritrean nakfa",
    number: "232"
  }, {
    code: "ETB",
    decimals: 2,
    name: "Ethiopian birr",
    number: "230"
  }, {
    code: "EUR",
    decimals: 2,
    name: "Euro",
    number: "978"
  }, {
    code: "FJD",
    decimals: 2,
    name: "Fiji dollar",
    number: "242"
  }, {
    code: "FKP",
    decimals: 2,
    name: "Falkland Islands pound",
    number: "238"
  }, {
    code: "GBP",
    decimals: 2,
    name: "Pound sterling",
    number: "826"
  }, {
    code: "GEL",
    decimals: 2,
    name: "Georgian lari",
    number: "981"
  }, {
    code: "GHS",
    decimals: 2,
    name: "Ghanaian cedi",
    number: "936"
  }, {
    code: "GIP",
    decimals: 2,
    name: "Gibraltar pound",
    number: "292"
  }, {
    code: "GMD",
    decimals: 2,
    name: "Gambian dalasi",
    number: "270"
  }, {
    code: "GNF",
    decimals: 0,
    name: "Guinean franc",
    number: "324"
  }, {
    code: "GTQ",
    decimals: 2,
    name: "Guatemalan quetzal",
    number: "320"
  }, {
    code: "GYD",
    decimals: 2,
    name: "Guyanese dollar",
    number: "328"
  }, {
    code: "HKD",
    decimals: 2,
    name: "Hong Kong dollar",
    number: "344"
  }, {
    code: "HNL",
    decimals: 2,
    name: "Honduran lempira",
    number: "340"
  }, {
    code: "HRK",
    decimals: 2,
    name: "Croatian kuna",
    number: "191"
  }, {
    code: "HTG",
    decimals: 2,
    name: "Haitian gourde",
    number: "332"
  }, {
    code: "HUF",
    decimals: 2,
    name: "Hungarian forint",
    number: "348"
  }, {
    code: "IDR",
    decimals: 2,
    name: "Indonesian rupiah",
    number: "360"
  }, {
    code: "ILS",
    decimals: 2,
    name: "Israeli new shekel",
    number: "376"
  }, {
    code: "INR",
    decimals: 2,
    name: "Indian rupee",
    number: "356"
  }, {
    code: "IQD",
    decimals: 3,
    name: "Iraqi dinar",
    number: "368"
  }, {
    code: "IRR",
    decimals: 0,
    name: "Iranian rial",
    number: "364"
  }, {
    code: "ISK",
    decimals: 0,
    name: "Icelandic króna",
    number: "352"
  }, {
    code: "JMD",
    decimals: 2,
    name: "Jamaican dollar",
    number: "388"
  }, {
    code: "JOD",
    decimals: 3,
    name: "Jordanian dinar",
    number: "400"
  }, {
    code: "JPY",
    decimals: 0,
    name: "Japanese yen",
    number: "392"
  }, {
    code: "KES",
    decimals: 2,
    name: "Kenyan shilling",
    number: "404"
  }, {
    code: "KGS",
    decimals: 2,
    name: "Kyrgyzstani som",
    number: "417"
  }, {
    code: "KHR",
    decimals: 2,
    name: "Cambodian riel",
    number: "116"
  }, {
    code: "KMF",
    decimals: 0,
    name: "Comoro franc",
    number: "174"
  }, {
    code: "KPW",
    decimals: 0,
    name: "North Korean won",
    number: "408"
  }, {
    code: "KRW",
    decimals: 0,
    name: "South Korean won",
    number: "410"
  }, {
    code: "KWD",
    decimals: 3,
    name: "Kuwaiti dinar",
    number: "414"
  }, {
    code: "KYD",
    decimals: 2,
    name: "Cayman Islands dollar",
    number: "136"
  }, {
    code: "KZT",
    decimals: 2,
    name: "Kazakhstani tenge",
    number: "398"
  }, {
    code: "LAK",
    decimals: 0,
    name: "Lao kip",
    number: "418"
  }, {
    code: "LBP",
    decimals: 0,
    name: "Lebanese pound",
    number: "422"
  }, {
    code: "LKR",
    decimals: 2,
    name: "Sri Lankan rupee",
    number: "144"
  }, {
    code: "LRD",
    decimals: 2,
    name: "Liberian dollar",
    number: "430"
  }, {
    code: "LSL",
    decimals: 2,
    name: "Lesotho loti",
    number: "426"
  }, {
    code: "EUR",
    decimals: 2,
    name: "Lithuanian litas",
    number: "440"
  }, {
    code: "LVL",
    decimals: 2,
    name: "Latvian lats",
    number: "428"
  }, {
    code: "LYD",
    decimals: 3,
    name: "Libyan dinar",
    number: "434"
  }, {
    code: "MAD",
    decimals: 2,
    name: "Moroccan dirham",
    number: "504"
  }, {
    code: "MDL",
    decimals: 2,
    name: "Moldovan leu",
    number: "498"
  }, {
    code: "MGA",
    decimals: 0,
    name: "Malagasy ariary",
    number: "969"
  }, {
    code: "MKD",
    decimals: 0,
    name: "Macedonian denar",
    number: "807"
  }, {
    code: "MMK",
    decimals: 0,
    name: "Myanma kyat",
    number: "104"
  }, {
    code: "MNT",
    decimals: 2,
    name: "Mongolian tugrik",
    number: "496"
  }, {
    code: "MOP",
    decimals: 2,
    name: "Macanese pataca",
    number: "446"
  }, {
    code: "MRO",
    decimals: 0,
    name: "Mauritanian ouguiya",
    number: "478"
  }, {
    code: "MUR",
    decimals: 2,
    name: "Mauritian rupee",
    number: "480"
  }, {
    code: "MVR",
    decimals: 2,
    name: "Maldivian rufiyaa",
    number: "462"
  }, {
    code: "MWK",
    decimals: 2,
    name: "Malawian kwacha",
    number: "454"
  }, {
    code: "MXN",
    decimals: 2,
    name: "Mexican peso",
    number: "484"
  }, {
    code: "MXV",
    decimals: 2,
    name: "Mexican Unidad de Inversion (UDI) (funds code)",
    number: "979"
  }, {
    code: "MYR",
    decimals: 2,
    name: "Malaysian ringgit",
    number: "458"
  }, {
    code: "MZN",
    decimals: 2,
    name: "Mozambican metical",
    number: "943"
  }, {
    code: "NAD",
    decimals: 2,
    name: "Namibian dollar",
    number: "516"
  }, {
    code: "NGN",
    decimals: 2,
    name: "Nigerian naira",
    number: "566"
  }, {
    code: "NIO",
    decimals: 2,
    name: "Nicaraguan córdoba",
    number: "558"
  }, {
    code: "NOK",
    decimals: 2,
    name: "Norwegian krone",
    number: "578"
  }, {
    code: "NPR",
    decimals: 2,
    name: "Nepalese rupee",
    number: "524"
  }, {
    code: "NZD",
    decimals: 2,
    name: "New Zealand dollar",
    number: "554"
  }, {
    code: "OMR",
    decimals: 3,
    name: "Omani rial",
    number: "512"
  }, {
    code: "PAB",
    decimals: 2,
    name: "Panamanian balboa",
    number: "590"
  }, {
    code: "PEN",
    decimals: 2,
    name: "Peruvian nuevo sol",
    number: "604"
  }, {
    code: "PGK",
    decimals: 2,
    name: "Papua New Guinean kina",
    number: "598"
  }, {
    code: "PHP",
    decimals: 2,
    name: "Philippine peso",
    number: "608"
  }, {
    code: "PKR",
    decimals: 2,
    name: "Pakistani rupee",
    number: "586"
  }, {
    code: "PLN",
    decimals: 2,
    name: "Polish złoty",
    number: "985"
  }, {
    code: "PYG",
    decimals: 0,
    name: "Paraguayan guaraní",
    number: "600"
  }, {
    code: "QAR",
    decimals: 2,
    name: "Qatari riyal",
    number: "634"
  }, {
    code: "RON",
    decimals: 2,
    name: "Romanian new leu",
    number: "946"
  }, {
    code: "RSD",
    decimals: 2,
    name: "Serbian dinar",
    number: "941"
  }, {
    code: "RUB",
    decimals: 2,
    name: "Russian rouble",
    number: "643"
  }, {
    code: "RWF",
    decimals: 0,
    name: "Rwandan franc",
    number: "646"
  }, {
    code: "SAR",
    decimals: 2,
    name: "Saudi riyal",
    number: "682"
  }, {
    code: "SBD",
    decimals: 2,
    name: "Solomon Islands dollar",
    number: "90"
  }, {
    code: "SCR",
    decimals: 2,
    name: "Seychelles rupee",
    number: "690"
  }, {
    code: "SDG",
    decimals: 2,
    name: "Sudanese pound",
    number: "938"
  }, {
    code: "SEK",
    decimals: 2,
    name: "Swedish krona/kronor",
    number: "752"
  }, {
    code: "SGD",
    decimals: 2,
    name: "Singapore dollar",
    number: "702"
  }, {
    code: "SHP",
    decimals: 2,
    name: "Saint Helena pound",
    number: "654"
  }, {
    code: "SLL",
    decimals: 0,
    name: "Sierra Leonean leone",
    number: "694"
  }, {
    code: "SOS",
    decimals: 2,
    name: "Somali shilling",
    number: "706"
  }, {
    code: "SRD",
    decimals: 2,
    name: "Surinamese dollar",
    number: "968"
  }, {
    code: "SSP",
    decimals: 2,
    name: "South Sudanese pound",
    number: "728"
  }, {
    code: "STD",
    decimals: 0,
    name: "São Tomé and Príncipe dobra",
    number: "678"
  }, {
    code: "SYP",
    decimals: 2,
    name: "Syrian pound",
    number: "760"
  }, {
    code: "SZL",
    decimals: 2,
    name: "Swazi lilangeni",
    number: "748"
  }, {
    code: "THB",
    decimals: 2,
    name: "Thai baht",
    number: "764"
  }, {
    code: "TJS",
    decimals: 2,
    name: "Tajikistani somoni",
    number: "972"
  }, {
    code: "TMT",
    decimals: 2,
    name: "Turkmenistani manat",
    number: "934"
  }, {
    code: "TND",
    decimals: 3,
    name: "Tunisian dinar",
    number: "788"
  }, {
    code: "TOP",
    decimals: 2,
    name: "Tongan paʻanga",
    number: "776"
  }, {
    code: "TRY",
    decimals: 2,
    name: "Turkish lira",
    number: "949"
  }, {
    code: "TTD",
    decimals: 2,
    name: "Trinidad and Tobago dollar",
    number: "780"
  }, {
    code: "TWD",
    decimals: 2,
    name: "New Taiwan dollar",
    number: "901"
  }, {
    code: "TZS",
    decimals: 2,
    name: "Tanzanian shilling",
    number: "834"
  }, {
    code: "UAH",
    decimals: 2,
    name: "Ukrainian hryvnia",
    number: "980"
  }, {
    code: "UGX",
    decimals: 2,
    name: "Ugandan shilling",
    number: "800"
  }, {
    code: "USD",
    decimals: 2,
    name: "United States dollar",
    number: "840"
  }, {
    code: "USN",
    decimals: 2,
    name: "United States dollar (next day) (funds code)",
    number: "997"
  }, {
    code: "USS",
    decimals: 2,
    name: "United States dollar (same day) (funds code) (one source[who?] claims it is no longer used, but it is still on the ISO 4217-MA list)",
    number: "998"
  }, {
    code: "UYI",
    decimals: 0,
    name: "Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)",
    number: "940"
  }, {
    code: "UYU",
    decimals: 2,
    name: "Uruguayan peso",
    number: "858"
  }, {
    code: "UZS",
    decimals: 2,
    name: "Uzbekistan som",
    number: "860"
  }, {
    code: "VEF",
    decimals: 2,
    name: "Venezuelan bolívar fuerte",
    number: "937"
  }, {
    code: "VND",
    decimals: 0,
    name: "Vietnamese dong",
    number: "704"
  }, {
    code: "VUV",
    decimals: 0,
    name: "Vanuatu vatu",
    number: "548"
  }, {
    code: "WST",
    decimals: 2,
    name: "Samoan tala",
    number: "882"
  }, {
    code: "XAF",
    decimals: 0,
    name: "CFA franc BEAC",
    number: "950"
  }, {
    code: "XAG",
    decimals: null,
    name: "Silver (one troy ounce)",
    number: "961"
  }, {
    code: "XAU",
    decimals: null,
    name: "Gold (one troy ounce)",
    number: "959"
  }, {
    code: "XBA",
    decimals: null,
    name: "European Composite Unit (EURCO) (bond market unit)",
    number: "955"
  }, {
    code: "XBB",
    decimals: null,
    name: "European Monetary Unit (E.M.U.-6) (bond market unit)",
    number: "956"
  }, {
    code: "XBC",
    decimals: null,
    name: "European Unit of Account 9 (E.U.A.-9) (bond market unit)",
    number: "957"
  }, {
    code: "XBD",
    decimals: null,
    name: "European Unit of Account 17 (E.U.A.-17) (bond market unit)",
    number: "958"
  }, {
    code: "XCD",
    decimals: 2,
    name: "East Caribbean dollar",
    number: "951"
  }, {
    code: "XDR",
    decimals: null,
    name: "Special drawing rights",
    number: "960"
  }, {
    code: "XFU",
    decimals: null,
    name: "UIC franc (special settlement currency)",
    number: "Nil"
  }, {
    code: "XOF",
    decimals: 0,
    name: "CFA franc BCEAO",
    number: "952"
  }, {
    code: "XPD",
    decimals: null,
    name: "Palladium (one troy ounce)",
    number: "964"
  }, {
    code: "XPF",
    decimals: 0,
    name: "CFP franc",
    number: "953"
  }, {
    code: "XPT",
    decimals: null,
    name: "Platinum (one troy ounce)",
    number: "962"
  }, {
    code: "XTS",
    decimals: null,
    name: "Code reserved for testing purposes",
    number: "963"
  }, {
    code: "XXX",
    decimals: null,
    name: "No currency",
    number: "999"
  }, {
    code: "YER",
    decimals: 2,
    name: "Yemeni rial",
    number: "886"
  }, {
    code: "ZAR",
    decimals: 2,
    name: "South African rand",
    number: "710"
  }, {
    code: "ZMW",
    decimals: 2,
    name: "Zambian kwacha",
    number: "967"
  }, {
    code: "EEK",
    decimals: 2,
    name: "Estonian kroon",
    number: "233"
  }];
})(cf);
var df = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, e.default = [{
    alpha2: "aa",
    alpha3: "aar",
    bibliographic: "",
    name: "Afar"
  }, {
    alpha2: "ab",
    alpha3: "abk",
    bibliographic: "",
    name: "Abkhazian"
  }, {
    alpha2: "",
    alpha3: "ace",
    bibliographic: "",
    name: "Achinese"
  }, {
    alpha2: "",
    alpha3: "ach",
    bibliographic: "",
    name: "Acoli"
  }, {
    alpha2: "",
    alpha3: "ada",
    bibliographic: "",
    name: "Adangme"
  }, {
    alpha2: "",
    alpha3: "ady",
    bibliographic: "",
    name: "Adygei"
  }, {
    alpha2: "",
    alpha3: "ady",
    bibliographic: "",
    name: "Adyghe"
  }, {
    alpha2: "",
    alpha3: "afa",
    bibliographic: "",
    name: "Afro-Asiatic languages"
  }, {
    alpha2: "",
    alpha3: "afh",
    bibliographic: "",
    name: "Afrihili"
  }, {
    alpha2: "af",
    alpha3: "afr",
    bibliographic: "",
    name: "Afrikaans"
  }, {
    alpha2: "",
    alpha3: "ain",
    bibliographic: "",
    name: "Ainu"
  }, {
    alpha2: "ak",
    alpha3: "aka",
    bibliographic: "",
    name: "Akan"
  }, {
    alpha2: "",
    alpha3: "akk",
    bibliographic: "",
    name: "Akkadian"
  }, {
    alpha2: "",
    alpha3: "ale",
    bibliographic: "",
    name: "Aleut"
  }, {
    alpha2: "",
    alpha3: "alg",
    bibliographic: "",
    name: "Algonquian languages"
  }, {
    alpha2: "",
    alpha3: "alt",
    bibliographic: "",
    name: "Southern Altai"
  }, {
    alpha2: "am",
    alpha3: "amh",
    bibliographic: "",
    name: "Amharic"
  }, {
    alpha2: "",
    alpha3: "ang",
    bibliographic: "",
    name: "English, Old (ca.450-1100)"
  }, {
    alpha2: "",
    alpha3: "anp",
    bibliographic: "",
    name: "Angika"
  }, {
    alpha2: "",
    alpha3: "apa",
    bibliographic: "",
    name: "Apache languages"
  }, {
    alpha2: "ar",
    alpha3: "ara",
    bibliographic: "",
    name: "Arabic"
  }, {
    alpha2: "",
    alpha3: "arc",
    bibliographic: "",
    name: "Imperial Aramaic (700-300 BCE)"
  }, {
    alpha2: "",
    alpha3: "arc",
    bibliographic: "",
    name: "Official Aramaic (700-300 BCE)"
  }, {
    alpha2: "an",
    alpha3: "arg",
    bibliographic: "",
    name: "Aragonese"
  }, {
    alpha2: "",
    alpha3: "arn",
    bibliographic: "",
    name: "Mapuche"
  }, {
    alpha2: "",
    alpha3: "arn",
    bibliographic: "",
    name: "Mapudungun"
  }, {
    alpha2: "",
    alpha3: "arp",
    bibliographic: "",
    name: "Arapaho"
  }, {
    alpha2: "",
    alpha3: "art",
    bibliographic: "",
    name: "Artificial languages"
  }, {
    alpha2: "",
    alpha3: "arw",
    bibliographic: "",
    name: "Arawak"
  }, {
    alpha2: "as",
    alpha3: "asm",
    bibliographic: "",
    name: "Assamese"
  }, {
    alpha2: "",
    alpha3: "ast",
    bibliographic: "",
    name: "Asturian"
  }, {
    alpha2: "",
    alpha3: "ast",
    bibliographic: "",
    name: "Asturleonese"
  }, {
    alpha2: "",
    alpha3: "ast",
    bibliographic: "",
    name: "Bable"
  }, {
    alpha2: "",
    alpha3: "ast",
    bibliographic: "",
    name: "Leonese"
  }, {
    alpha2: "",
    alpha3: "ath",
    bibliographic: "",
    name: "Athapascan languages"
  }, {
    alpha2: "",
    alpha3: "aus",
    bibliographic: "",
    name: "Australian languages"
  }, {
    alpha2: "av",
    alpha3: "ava",
    bibliographic: "",
    name: "Avaric"
  }, {
    alpha2: "ae",
    alpha3: "ave",
    bibliographic: "",
    name: "Avestan"
  }, {
    alpha2: "",
    alpha3: "awa",
    bibliographic: "",
    name: "Awadhi"
  }, {
    alpha2: "ay",
    alpha3: "aym",
    bibliographic: "",
    name: "Aymara"
  }, {
    alpha2: "az",
    alpha3: "aze",
    bibliographic: "",
    name: "Azerbaijani"
  }, {
    alpha2: "",
    alpha3: "bad",
    bibliographic: "",
    name: "Banda languages"
  }, {
    alpha2: "",
    alpha3: "bai",
    bibliographic: "",
    name: "Bamileke languages"
  }, {
    alpha2: "ba",
    alpha3: "bak",
    bibliographic: "",
    name: "Bashkir"
  }, {
    alpha2: "",
    alpha3: "bal",
    bibliographic: "",
    name: "Baluchi"
  }, {
    alpha2: "bm",
    alpha3: "bam",
    bibliographic: "",
    name: "Bambara"
  }, {
    alpha2: "",
    alpha3: "ban",
    bibliographic: "",
    name: "Balinese"
  }, {
    alpha2: "",
    alpha3: "bas",
    bibliographic: "",
    name: "Basa"
  }, {
    alpha2: "",
    alpha3: "bat",
    bibliographic: "",
    name: "Baltic languages"
  }, {
    alpha2: "",
    alpha3: "bej",
    bibliographic: "",
    name: "Bedawiyet"
  }, {
    alpha2: "",
    alpha3: "bej",
    bibliographic: "",
    name: "Beja"
  }, {
    alpha2: "be",
    alpha3: "bel",
    bibliographic: "",
    name: "Belarusian"
  }, {
    alpha2: "",
    alpha3: "bem",
    bibliographic: "",
    name: "Bemba"
  }, {
    alpha2: "bn",
    alpha3: "ben",
    bibliographic: "",
    name: "Bengali"
  }, {
    alpha2: "",
    alpha3: "ber",
    bibliographic: "",
    name: "Berber languages"
  }, {
    alpha2: "",
    alpha3: "bho",
    bibliographic: "",
    name: "Bhojpuri"
  }, {
    alpha2: "bh",
    alpha3: "bih",
    bibliographic: "",
    name: "Bihari languages"
  }, {
    alpha2: "",
    alpha3: "bik",
    bibliographic: "",
    name: "Bikol"
  }, {
    alpha2: "",
    alpha3: "bin",
    bibliographic: "",
    name: "Bini"
  }, {
    alpha2: "",
    alpha3: "bin",
    bibliographic: "",
    name: "Edo"
  }, {
    alpha2: "bi",
    alpha3: "bis",
    bibliographic: "",
    name: "Bislama"
  }, {
    alpha2: "",
    alpha3: "bla",
    bibliographic: "",
    name: "Siksika"
  }, {
    alpha2: "",
    alpha3: "bnt",
    bibliographic: "",
    name: "Bantu languages"
  }, {
    alpha2: "bo",
    alpha3: "bod",
    bibliographic: "tib",
    name: "Tibetan"
  }, {
    alpha2: "bs",
    alpha3: "bos",
    bibliographic: "",
    name: "Bosnian"
  }, {
    alpha2: "",
    alpha3: "bra",
    bibliographic: "",
    name: "Braj"
  }, {
    alpha2: "br",
    alpha3: "bre",
    bibliographic: "",
    name: "Breton"
  }, {
    alpha2: "",
    alpha3: "btk",
    bibliographic: "",
    name: "Batak languages"
  }, {
    alpha2: "",
    alpha3: "bua",
    bibliographic: "",
    name: "Buriat"
  }, {
    alpha2: "",
    alpha3: "bug",
    bibliographic: "",
    name: "Buginese"
  }, {
    alpha2: "bg",
    alpha3: "bul",
    bibliographic: "",
    name: "Bulgarian"
  }, {
    alpha2: "",
    alpha3: "byn",
    bibliographic: "",
    name: "Bilin"
  }, {
    alpha2: "",
    alpha3: "byn",
    bibliographic: "",
    name: "Blin"
  }, {
    alpha2: "",
    alpha3: "cad",
    bibliographic: "",
    name: "Caddo"
  }, {
    alpha2: "",
    alpha3: "cai",
    bibliographic: "",
    name: "Central American Indian languages"
  }, {
    alpha2: "",
    alpha3: "car",
    bibliographic: "",
    name: "Galibi Carib"
  }, {
    alpha2: "ca",
    alpha3: "cat",
    bibliographic: "",
    name: "Catalan"
  }, {
    alpha2: "ca",
    alpha3: "cat",
    bibliographic: "",
    name: "Valencian"
  }, {
    alpha2: "",
    alpha3: "cau",
    bibliographic: "",
    name: "Caucasian languages"
  }, {
    alpha2: "",
    alpha3: "ceb",
    bibliographic: "",
    name: "Cebuano"
  }, {
    alpha2: "",
    alpha3: "cel",
    bibliographic: "",
    name: "Celtic languages"
  }, {
    alpha2: "cs",
    alpha3: "ces",
    bibliographic: "cze",
    name: "Czech"
  }, {
    alpha2: "ch",
    alpha3: "cha",
    bibliographic: "",
    name: "Chamorro"
  }, {
    alpha2: "",
    alpha3: "chb",
    bibliographic: "",
    name: "Chibcha"
  }, {
    alpha2: "ce",
    alpha3: "che",
    bibliographic: "",
    name: "Chechen"
  }, {
    alpha2: "",
    alpha3: "chg",
    bibliographic: "",
    name: "Chagatai"
  }, {
    alpha2: "",
    alpha3: "chk",
    bibliographic: "",
    name: "Chuukese"
  }, {
    alpha2: "",
    alpha3: "chm",
    bibliographic: "",
    name: "Mari"
  }, {
    alpha2: "",
    alpha3: "chn",
    bibliographic: "",
    name: "Chinook jargon"
  }, {
    alpha2: "",
    alpha3: "cho",
    bibliographic: "",
    name: "Choctaw"
  }, {
    alpha2: "",
    alpha3: "chp",
    bibliographic: "",
    name: "Chipewyan"
  }, {
    alpha2: "",
    alpha3: "chp",
    bibliographic: "",
    name: "Dene Suline"
  }, {
    alpha2: "",
    alpha3: "chr",
    bibliographic: "",
    name: "Cherokee"
  }, {
    alpha2: "cu",
    alpha3: "chu",
    bibliographic: "",
    name: "Church Slavic"
  }, {
    alpha2: "cu",
    alpha3: "chu",
    bibliographic: "",
    name: "Church Slavonic"
  }, {
    alpha2: "cu",
    alpha3: "chu",
    bibliographic: "",
    name: "Old Bulgarian"
  }, {
    alpha2: "cu",
    alpha3: "chu",
    bibliographic: "",
    name: "Old Church Slavonic"
  }, {
    alpha2: "cu",
    alpha3: "chu",
    bibliographic: "",
    name: "Old Slavonic"
  }, {
    alpha2: "cv",
    alpha3: "chv",
    bibliographic: "",
    name: "Chuvash"
  }, {
    alpha2: "",
    alpha3: "chy",
    bibliographic: "",
    name: "Cheyenne"
  }, {
    alpha2: "",
    alpha3: "cmc",
    bibliographic: "",
    name: "Chamic languages"
  }, {
    alpha2: "",
    alpha3: "cop",
    bibliographic: "",
    name: "Coptic"
  }, {
    alpha2: "kw",
    alpha3: "cor",
    bibliographic: "",
    name: "Cornish"
  }, {
    alpha2: "co",
    alpha3: "cos",
    bibliographic: "",
    name: "Corsican"
  }, {
    alpha2: "",
    alpha3: "cpe",
    bibliographic: "",
    name: "Creoles and pidgins, English based"
  }, {
    alpha2: "",
    alpha3: "cpf",
    bibliographic: "",
    name: "Creoles and pidgins, French-based"
  }, {
    alpha2: "",
    alpha3: "cpp",
    bibliographic: "",
    name: "Creoles and pidgins, Portuguese-based"
  }, {
    alpha2: "cr",
    alpha3: "cre",
    bibliographic: "",
    name: "Cree"
  }, {
    alpha2: "",
    alpha3: "crh",
    bibliographic: "",
    name: "Crimean Tatar"
  }, {
    alpha2: "",
    alpha3: "crh",
    bibliographic: "",
    name: "Crimean Turkish"
  }, {
    alpha2: "",
    alpha3: "crp",
    bibliographic: "",
    name: "Creoles and pidgins"
  }, {
    alpha2: "",
    alpha3: "csb",
    bibliographic: "",
    name: "Kashubian"
  }, {
    alpha2: "",
    alpha3: "cus",
    bibliographic: "",
    name: "Cushitic languages"
  }, {
    alpha2: "cy",
    alpha3: "cym",
    bibliographic: "wel",
    name: "Welsh"
  }, {
    alpha2: "",
    alpha3: "dak",
    bibliographic: "",
    name: "Dakota"
  }, {
    alpha2: "da",
    alpha3: "dan",
    bibliographic: "",
    name: "Danish"
  }, {
    alpha2: "",
    alpha3: "dar",
    bibliographic: "",
    name: "Dargwa"
  }, {
    alpha2: "",
    alpha3: "day",
    bibliographic: "",
    name: "Land Dayak languages"
  }, {
    alpha2: "",
    alpha3: "del",
    bibliographic: "",
    name: "Delaware"
  }, {
    alpha2: "",
    alpha3: "den",
    bibliographic: "",
    name: "Slave (Athapascan)"
  }, {
    alpha2: "de",
    alpha3: "deu",
    bibliographic: "ger",
    name: "German"
  }, {
    alpha2: "",
    alpha3: "dgr",
    bibliographic: "",
    name: "Dogrib"
  }, {
    alpha2: "",
    alpha3: "din",
    bibliographic: "",
    name: "Dinka"
  }, {
    alpha2: "dv",
    alpha3: "div",
    bibliographic: "",
    name: "Dhivehi"
  }, {
    alpha2: "dv",
    alpha3: "div",
    bibliographic: "",
    name: "Divehi"
  }, {
    alpha2: "dv",
    alpha3: "div",
    bibliographic: "",
    name: "Maldivian"
  }, {
    alpha2: "",
    alpha3: "doi",
    bibliographic: "",
    name: "Dogri"
  }, {
    alpha2: "",
    alpha3: "dra",
    bibliographic: "",
    name: "Dravidian languages"
  }, {
    alpha2: "",
    alpha3: "dsb",
    bibliographic: "",
    name: "Lower Sorbian"
  }, {
    alpha2: "",
    alpha3: "dua",
    bibliographic: "",
    name: "Duala"
  }, {
    alpha2: "",
    alpha3: "dum",
    bibliographic: "",
    name: "Dutch, Middle (ca.1050-1350)"
  }, {
    alpha2: "",
    alpha3: "dyu",
    bibliographic: "",
    name: "Dyula"
  }, {
    alpha2: "dz",
    alpha3: "dzo",
    bibliographic: "",
    name: "Dzongkha"
  }, {
    alpha2: "",
    alpha3: "efi",
    bibliographic: "",
    name: "Efik"
  }, {
    alpha2: "",
    alpha3: "egy",
    bibliographic: "",
    name: "Egyptian (Ancient)"
  }, {
    alpha2: "",
    alpha3: "eka",
    bibliographic: "",
    name: "Ekajuk"
  }, {
    alpha2: "el",
    alpha3: "ell",
    bibliographic: "gre",
    name: "Greek"
  }, {
    alpha2: "",
    alpha3: "elx",
    bibliographic: "",
    name: "Elamite"
  }, {
    alpha2: "en",
    alpha3: "eng",
    bibliographic: "",
    name: "English"
  }, {
    alpha2: "",
    alpha3: "enm",
    bibliographic: "",
    name: "English, Middle (1100-1500)"
  }, {
    alpha2: "eo",
    alpha3: "epo",
    bibliographic: "",
    name: "Esperanto"
  }, {
    alpha2: "et",
    alpha3: "est",
    bibliographic: "",
    name: "Estonian"
  }, {
    alpha2: "eu",
    alpha3: "eus",
    bibliographic: "baq",
    name: "Basque"
  }, {
    alpha2: "ee",
    alpha3: "ewe",
    bibliographic: "",
    name: "Ewe"
  }, {
    alpha2: "",
    alpha3: "ewo",
    bibliographic: "",
    name: "Ewondo"
  }, {
    alpha2: "",
    alpha3: "fan",
    bibliographic: "",
    name: "Fang"
  }, {
    alpha2: "fo",
    alpha3: "fao",
    bibliographic: "",
    name: "Faroese"
  }, {
    alpha2: "fa",
    alpha3: "fas",
    bibliographic: "per",
    name: "Persian"
  }, {
    alpha2: "",
    alpha3: "fat",
    bibliographic: "",
    name: "Fanti"
  }, {
    alpha2: "fj",
    alpha3: "fij",
    bibliographic: "",
    name: "Fijian"
  }, {
    alpha2: "",
    alpha3: "fil",
    bibliographic: "",
    name: "Filipino"
  }, {
    alpha2: "",
    alpha3: "fil",
    bibliographic: "",
    name: "Pilipino"
  }, {
    alpha2: "fi",
    alpha3: "fin",
    bibliographic: "",
    name: "Finnish"
  }, {
    alpha2: "",
    alpha3: "fiu",
    bibliographic: "",
    name: "Finno-Ugrian languages"
  }, {
    alpha2: "",
    alpha3: "fon",
    bibliographic: "",
    name: "Fon"
  }, {
    alpha2: "fr",
    alpha3: "fra",
    bibliographic: "fre",
    name: "French"
  }, {
    alpha2: "",
    alpha3: "frm",
    bibliographic: "",
    name: "French, Middle (ca.1400-1600)"
  }, {
    alpha2: "",
    alpha3: "fro",
    bibliographic: "",
    name: "French, Old (842-ca.1400)"
  }, {
    alpha2: "",
    alpha3: "frr",
    bibliographic: "",
    name: "Northern Frisian"
  }, {
    alpha2: "",
    alpha3: "frs",
    bibliographic: "",
    name: "Eastern Frisian"
  }, {
    alpha2: "fy",
    alpha3: "fry",
    bibliographic: "",
    name: "Western Frisian"
  }, {
    alpha2: "ff",
    alpha3: "ful",
    bibliographic: "",
    name: "Fulah"
  }, {
    alpha2: "",
    alpha3: "fur",
    bibliographic: "",
    name: "Friulian"
  }, {
    alpha2: "",
    alpha3: "gaa",
    bibliographic: "",
    name: "Ga"
  }, {
    alpha2: "",
    alpha3: "gay",
    bibliographic: "",
    name: "Gayo"
  }, {
    alpha2: "",
    alpha3: "gba",
    bibliographic: "",
    name: "Gbaya"
  }, {
    alpha2: "",
    alpha3: "gem",
    bibliographic: "",
    name: "Germanic languages"
  }, {
    alpha2: "",
    alpha3: "gez",
    bibliographic: "",
    name: "Geez"
  }, {
    alpha2: "",
    alpha3: "gil",
    bibliographic: "",
    name: "Gilbertese"
  }, {
    alpha2: "gd",
    alpha3: "gla",
    bibliographic: "",
    name: "Gaelic"
  }, {
    alpha2: "gd",
    alpha3: "gla",
    bibliographic: "",
    name: "Scottish Gaelic"
  }, {
    alpha2: "ga",
    alpha3: "gle",
    bibliographic: "",
    name: "Irish"
  }, {
    alpha2: "gl",
    alpha3: "glg",
    bibliographic: "",
    name: "Galician"
  }, {
    alpha2: "gv",
    alpha3: "glv",
    bibliographic: "",
    name: "Manx"
  }, {
    alpha2: "",
    alpha3: "gmh",
    bibliographic: "",
    name: "German, Middle High (ca.1050-1500)"
  }, {
    alpha2: "",
    alpha3: "goh",
    bibliographic: "",
    name: "German, Old High (ca.750-1050)"
  }, {
    alpha2: "",
    alpha3: "gon",
    bibliographic: "",
    name: "Gondi"
  }, {
    alpha2: "",
    alpha3: "gor",
    bibliographic: "",
    name: "Gorontalo"
  }, {
    alpha2: "",
    alpha3: "got",
    bibliographic: "",
    name: "Gothic"
  }, {
    alpha2: "",
    alpha3: "grb",
    bibliographic: "",
    name: "Grebo"
  }, {
    alpha2: "",
    alpha3: "grc",
    bibliographic: "",
    name: "Greek, Ancient (to 1453)"
  }, {
    alpha2: "gn",
    alpha3: "grn",
    bibliographic: "",
    name: "Guarani"
  }, {
    alpha2: "",
    alpha3: "gsw",
    bibliographic: "",
    name: "Alemannic"
  }, {
    alpha2: "",
    alpha3: "gsw",
    bibliographic: "",
    name: "Alsatian"
  }, {
    alpha2: "",
    alpha3: "gsw",
    bibliographic: "",
    name: "Swiss German"
  }, {
    alpha2: "gu",
    alpha3: "guj",
    bibliographic: "",
    name: "Gujarati"
  }, {
    alpha2: "",
    alpha3: "gwi",
    bibliographic: "",
    name: "Gwich'in"
  }, {
    alpha2: "",
    alpha3: "hai",
    bibliographic: "",
    name: "Haida"
  }, {
    alpha2: "ht",
    alpha3: "hat",
    bibliographic: "",
    name: "Haitian"
  }, {
    alpha2: "ht",
    alpha3: "hat",
    bibliographic: "",
    name: "Haitian Creole"
  }, {
    alpha2: "ha",
    alpha3: "hau",
    bibliographic: "",
    name: "Hausa"
  }, {
    alpha2: "",
    alpha3: "haw",
    bibliographic: "",
    name: "Hawaiian"
  }, {
    alpha2: "he",
    alpha3: "heb",
    bibliographic: "",
    name: "Hebrew"
  }, {
    alpha2: "hz",
    alpha3: "her",
    bibliographic: "",
    name: "Herero"
  }, {
    alpha2: "",
    alpha3: "hil",
    bibliographic: "",
    name: "Hiligaynon"
  }, {
    alpha2: "",
    alpha3: "him",
    bibliographic: "",
    name: "Himachali languages"
  }, {
    alpha2: "",
    alpha3: "him",
    bibliographic: "",
    name: "Western Pahari languages"
  }, {
    alpha2: "hi",
    alpha3: "hin",
    bibliographic: "",
    name: "Hindi"
  }, {
    alpha2: "",
    alpha3: "hit",
    bibliographic: "",
    name: "Hittite"
  }, {
    alpha2: "",
    alpha3: "hmn",
    bibliographic: "",
    name: "Hmong"
  }, {
    alpha2: "",
    alpha3: "hmn",
    bibliographic: "",
    name: "Mong"
  }, {
    alpha2: "ho",
    alpha3: "hmo",
    bibliographic: "",
    name: "Hiri Motu"
  }, {
    alpha2: "hr",
    alpha3: "hrv",
    bibliographic: "",
    name: "Croatian"
  }, {
    alpha2: "",
    alpha3: "hsb",
    bibliographic: "",
    name: "Upper Sorbian"
  }, {
    alpha2: "hu",
    alpha3: "hun",
    bibliographic: "",
    name: "Hungarian"
  }, {
    alpha2: "",
    alpha3: "hup",
    bibliographic: "",
    name: "Hupa"
  }, {
    alpha2: "hy",
    alpha3: "hye",
    bibliographic: "arm",
    name: "Armenian"
  }, {
    alpha2: "",
    alpha3: "iba",
    bibliographic: "",
    name: "Iban"
  }, {
    alpha2: "ig",
    alpha3: "ibo",
    bibliographic: "",
    name: "Igbo"
  }, {
    alpha2: "io",
    alpha3: "ido",
    bibliographic: "",
    name: "Ido"
  }, {
    alpha2: "ii",
    alpha3: "iii",
    bibliographic: "",
    name: "Nuosu"
  }, {
    alpha2: "ii",
    alpha3: "iii",
    bibliographic: "",
    name: "Sichuan Yi"
  }, {
    alpha2: "",
    alpha3: "ijo",
    bibliographic: "",
    name: "Ijo languages"
  }, {
    alpha2: "iu",
    alpha3: "iku",
    bibliographic: "",
    name: "Inuktitut"
  }, {
    alpha2: "ie",
    alpha3: "ile",
    bibliographic: "",
    name: "Interlingue"
  }, {
    alpha2: "ie",
    alpha3: "ile",
    bibliographic: "",
    name: "Occidental"
  }, {
    alpha2: "",
    alpha3: "ilo",
    bibliographic: "",
    name: "Iloko"
  }, {
    alpha2: "ia",
    alpha3: "ina",
    bibliographic: "",
    name: "Interlingua (International Auxiliary Language Association)"
  }, {
    alpha2: "",
    alpha3: "inc",
    bibliographic: "",
    name: "Indic languages"
  }, {
    alpha2: "id",
    alpha3: "ind",
    bibliographic: "",
    name: "Indonesian"
  }, {
    alpha2: "",
    alpha3: "ine",
    bibliographic: "",
    name: "Indo-European languages"
  }, {
    alpha2: "",
    alpha3: "inh",
    bibliographic: "",
    name: "Ingush"
  }, {
    alpha2: "ik",
    alpha3: "ipk",
    bibliographic: "",
    name: "Inupiaq"
  }, {
    alpha2: "",
    alpha3: "ira",
    bibliographic: "",
    name: "Iranian languages"
  }, {
    alpha2: "",
    alpha3: "iro",
    bibliographic: "",
    name: "Iroquoian languages"
  }, {
    alpha2: "is",
    alpha3: "isl",
    bibliographic: "ice",
    name: "Icelandic"
  }, {
    alpha2: "it",
    alpha3: "ita",
    bibliographic: "",
    name: "Italian"
  }, {
    alpha2: "jv",
    alpha3: "jav",
    bibliographic: "",
    name: "Javanese"
  }, {
    alpha2: "",
    alpha3: "jbo",
    bibliographic: "",
    name: "Lojban"
  }, {
    alpha2: "ja",
    alpha3: "jpn",
    bibliographic: "",
    name: "Japanese"
  }, {
    alpha2: "",
    alpha3: "jpr",
    bibliographic: "",
    name: "Judeo-Persian"
  }, {
    alpha2: "",
    alpha3: "jrb",
    bibliographic: "",
    name: "Judeo-Arabic"
  }, {
    alpha2: "",
    alpha3: "kaa",
    bibliographic: "",
    name: "Kara-Kalpak"
  }, {
    alpha2: "",
    alpha3: "kab",
    bibliographic: "",
    name: "Kabyle"
  }, {
    alpha2: "",
    alpha3: "kac",
    bibliographic: "",
    name: "Jingpho"
  }, {
    alpha2: "",
    alpha3: "kac",
    bibliographic: "",
    name: "Kachin"
  }, {
    alpha2: "kl",
    alpha3: "kal",
    bibliographic: "",
    name: "Greenlandic"
  }, {
    alpha2: "kl",
    alpha3: "kal",
    bibliographic: "",
    name: "Kalaallisut"
  }, {
    alpha2: "",
    alpha3: "kam",
    bibliographic: "",
    name: "Kamba"
  }, {
    alpha2: "kn",
    alpha3: "kan",
    bibliographic: "",
    name: "Kannada"
  }, {
    alpha2: "",
    alpha3: "kar",
    bibliographic: "",
    name: "Karen languages"
  }, {
    alpha2: "ks",
    alpha3: "kas",
    bibliographic: "",
    name: "Kashmiri"
  }, {
    alpha2: "ka",
    alpha3: "kat",
    bibliographic: "geo",
    name: "Georgian"
  }, {
    alpha2: "kr",
    alpha3: "kau",
    bibliographic: "",
    name: "Kanuri"
  }, {
    alpha2: "",
    alpha3: "kaw",
    bibliographic: "",
    name: "Kawi"
  }, {
    alpha2: "kk",
    alpha3: "kaz",
    bibliographic: "",
    name: "Kazakh"
  }, {
    alpha2: "",
    alpha3: "kbd",
    bibliographic: "",
    name: "Kabardian"
  }, {
    alpha2: "",
    alpha3: "kha",
    bibliographic: "",
    name: "Khasi"
  }, {
    alpha2: "",
    alpha3: "khi",
    bibliographic: "",
    name: "Khoisan languages"
  }, {
    alpha2: "km",
    alpha3: "khm",
    bibliographic: "",
    name: "Central Khmer"
  }, {
    alpha2: "",
    alpha3: "kho",
    bibliographic: "",
    name: "Khotanese"
  }, {
    alpha2: "",
    alpha3: "kho",
    bibliographic: "",
    name: "Sakan"
  }, {
    alpha2: "ki",
    alpha3: "kik",
    bibliographic: "",
    name: "Gikuyu"
  }, {
    alpha2: "ki",
    alpha3: "kik",
    bibliographic: "",
    name: "Kikuyu"
  }, {
    alpha2: "rw",
    alpha3: "kin",
    bibliographic: "",
    name: "Kinyarwanda"
  }, {
    alpha2: "ky",
    alpha3: "kir",
    bibliographic: "",
    name: "Kirghiz"
  }, {
    alpha2: "ky",
    alpha3: "kir",
    bibliographic: "",
    name: "Kyrgyz"
  }, {
    alpha2: "",
    alpha3: "kmb",
    bibliographic: "",
    name: "Kimbundu"
  }, {
    alpha2: "",
    alpha3: "kok",
    bibliographic: "",
    name: "Konkani"
  }, {
    alpha2: "kv",
    alpha3: "kom",
    bibliographic: "",
    name: "Komi"
  }, {
    alpha2: "kg",
    alpha3: "kon",
    bibliographic: "",
    name: "Kongo"
  }, {
    alpha2: "ko",
    alpha3: "kor",
    bibliographic: "",
    name: "Korean"
  }, {
    alpha2: "",
    alpha3: "kos",
    bibliographic: "",
    name: "Kosraean"
  }, {
    alpha2: "",
    alpha3: "kpe",
    bibliographic: "",
    name: "Kpelle"
  }, {
    alpha2: "",
    alpha3: "krc",
    bibliographic: "",
    name: "Karachay-Balkar"
  }, {
    alpha2: "",
    alpha3: "krl",
    bibliographic: "",
    name: "Karelian"
  }, {
    alpha2: "",
    alpha3: "kro",
    bibliographic: "",
    name: "Kru languages"
  }, {
    alpha2: "",
    alpha3: "kru",
    bibliographic: "",
    name: "Kurukh"
  }, {
    alpha2: "kj",
    alpha3: "kua",
    bibliographic: "",
    name: "Kuanyama"
  }, {
    alpha2: "kj",
    alpha3: "kua",
    bibliographic: "",
    name: "Kwanyama"
  }, {
    alpha2: "",
    alpha3: "kum",
    bibliographic: "",
    name: "Kumyk"
  }, {
    alpha2: "ku",
    alpha3: "kur",
    bibliographic: "",
    name: "Kurdish"
  }, {
    alpha2: "",
    alpha3: "kut",
    bibliographic: "",
    name: "Kutenai"
  }, {
    alpha2: "",
    alpha3: "lad",
    bibliographic: "",
    name: "Ladino"
  }, {
    alpha2: "",
    alpha3: "lah",
    bibliographic: "",
    name: "Lahnda"
  }, {
    alpha2: "",
    alpha3: "lam",
    bibliographic: "",
    name: "Lamba"
  }, {
    alpha2: "lo",
    alpha3: "lao",
    bibliographic: "",
    name: "Lao"
  }, {
    alpha2: "la",
    alpha3: "lat",
    bibliographic: "",
    name: "Latin"
  }, {
    alpha2: "lv",
    alpha3: "lav",
    bibliographic: "",
    name: "Latvian"
  }, {
    alpha2: "",
    alpha3: "lez",
    bibliographic: "",
    name: "Lezghian"
  }, {
    alpha2: "li",
    alpha3: "lim",
    bibliographic: "",
    name: "Limburgan"
  }, {
    alpha2: "li",
    alpha3: "lim",
    bibliographic: "",
    name: "Limburger"
  }, {
    alpha2: "li",
    alpha3: "lim",
    bibliographic: "",
    name: "Limburgish"
  }, {
    alpha2: "ln",
    alpha3: "lin",
    bibliographic: "",
    name: "Lingala"
  }, {
    alpha2: "lt",
    alpha3: "lit",
    bibliographic: "",
    name: "Lithuanian"
  }, {
    alpha2: "",
    alpha3: "lol",
    bibliographic: "",
    name: "Mongo"
  }, {
    alpha2: "",
    alpha3: "loz",
    bibliographic: "",
    name: "Lozi"
  }, {
    alpha2: "lb",
    alpha3: "ltz",
    bibliographic: "",
    name: "Letzeburgesch"
  }, {
    alpha2: "lb",
    alpha3: "ltz",
    bibliographic: "",
    name: "Luxembourgish"
  }, {
    alpha2: "",
    alpha3: "lua",
    bibliographic: "",
    name: "Luba-Lulua"
  }, {
    alpha2: "lu",
    alpha3: "lub",
    bibliographic: "",
    name: "Luba-Katanga"
  }, {
    alpha2: "lg",
    alpha3: "lug",
    bibliographic: "",
    name: "Ganda"
  }, {
    alpha2: "",
    alpha3: "lui",
    bibliographic: "",
    name: "Luiseno"
  }, {
    alpha2: "",
    alpha3: "lun",
    bibliographic: "",
    name: "Lunda"
  }, {
    alpha2: "",
    alpha3: "luo",
    bibliographic: "",
    name: "Luo (Kenya and Tanzania)"
  }, {
    alpha2: "",
    alpha3: "lus",
    bibliographic: "",
    name: "Lushai"
  }, {
    alpha2: "",
    alpha3: "mad",
    bibliographic: "",
    name: "Madurese"
  }, {
    alpha2: "",
    alpha3: "mag",
    bibliographic: "",
    name: "Magahi"
  }, {
    alpha2: "mh",
    alpha3: "mah",
    bibliographic: "",
    name: "Marshallese"
  }, {
    alpha2: "",
    alpha3: "mai",
    bibliographic: "",
    name: "Maithili"
  }, {
    alpha2: "",
    alpha3: "mak",
    bibliographic: "",
    name: "Makasar"
  }, {
    alpha2: "ml",
    alpha3: "mal",
    bibliographic: "",
    name: "Malayalam"
  }, {
    alpha2: "",
    alpha3: "man",
    bibliographic: "",
    name: "Mandingo"
  }, {
    alpha2: "",
    alpha3: "map",
    bibliographic: "",
    name: "Austronesian languages"
  }, {
    alpha2: "mr",
    alpha3: "mar",
    bibliographic: "",
    name: "Marathi"
  }, {
    alpha2: "",
    alpha3: "mas",
    bibliographic: "",
    name: "Masai"
  }, {
    alpha2: "",
    alpha3: "mdf",
    bibliographic: "",
    name: "Moksha"
  }, {
    alpha2: "",
    alpha3: "mdr",
    bibliographic: "",
    name: "Mandar"
  }, {
    alpha2: "",
    alpha3: "men",
    bibliographic: "",
    name: "Mende"
  }, {
    alpha2: "",
    alpha3: "mga",
    bibliographic: "",
    name: "Irish, Middle (900-1200)"
  }, {
    alpha2: "",
    alpha3: "mic",
    bibliographic: "",
    name: "Mi'kmaq"
  }, {
    alpha2: "",
    alpha3: "mic",
    bibliographic: "",
    name: "Micmac"
  }, {
    alpha2: "",
    alpha3: "min",
    bibliographic: "",
    name: "Minangkabau"
  }, {
    alpha2: "",
    alpha3: "mis",
    bibliographic: "",
    name: "Uncoded languages"
  }, {
    alpha2: "mk",
    alpha3: "mkd",
    bibliographic: "mac",
    name: "Macedonian"
  }, {
    alpha2: "",
    alpha3: "mkh",
    bibliographic: "",
    name: "Mon-Khmer languages"
  }, {
    alpha2: "mg",
    alpha3: "mlg",
    bibliographic: "",
    name: "Malagasy"
  }, {
    alpha2: "mt",
    alpha3: "mlt",
    bibliographic: "",
    name: "Maltese"
  }, {
    alpha2: "",
    alpha3: "mnc",
    bibliographic: "",
    name: "Manchu"
  }, {
    alpha2: "",
    alpha3: "mni",
    bibliographic: "",
    name: "Manipuri"
  }, {
    alpha2: "",
    alpha3: "mno",
    bibliographic: "",
    name: "Manobo languages"
  }, {
    alpha2: "",
    alpha3: "moh",
    bibliographic: "",
    name: "Mohawk"
  }, {
    alpha2: "mn",
    alpha3: "mon",
    bibliographic: "",
    name: "Mongolian"
  }, {
    alpha2: "",
    alpha3: "mos",
    bibliographic: "",
    name: "Mossi"
  }, {
    alpha2: "",
    alpha3: "mot",
    bibliographic: "",
    name: "Montenegrin"
  }, {
    alpha2: "mi",
    alpha3: "mri",
    bibliographic: "mao",
    name: "Maori"
  }, {
    alpha2: "ms",
    alpha3: "msa",
    bibliographic: "may",
    name: "Malay"
  }, {
    alpha2: "",
    alpha3: "mul",
    bibliographic: "",
    name: "Multiple languages"
  }, {
    alpha2: "",
    alpha3: "mun",
    bibliographic: "",
    name: "Munda languages"
  }, {
    alpha2: "",
    alpha3: "mus",
    bibliographic: "",
    name: "Creek"
  }, {
    alpha2: "",
    alpha3: "mwl",
    bibliographic: "",
    name: "Mirandese"
  }, {
    alpha2: "",
    alpha3: "mwr",
    bibliographic: "",
    name: "Marwari"
  }, {
    alpha2: "my",
    alpha3: "mya",
    bibliographic: "bur",
    name: "Burmese"
  }, {
    alpha2: "",
    alpha3: "myn",
    bibliographic: "",
    name: "Mayan languages"
  }, {
    alpha2: "",
    alpha3: "myv",
    bibliographic: "",
    name: "Erzya"
  }, {
    alpha2: "",
    alpha3: "nah",
    bibliographic: "",
    name: "Nahuatl languages"
  }, {
    alpha2: "",
    alpha3: "nai",
    bibliographic: "",
    name: "North American Indian languages"
  }, {
    alpha2: "",
    alpha3: "nap",
    bibliographic: "",
    name: "Neapolitan"
  }, {
    alpha2: "na",
    alpha3: "nau",
    bibliographic: "",
    name: "Nauru"
  }, {
    alpha2: "nv",
    alpha3: "nav",
    bibliographic: "",
    name: "Navaho"
  }, {
    alpha2: "nv",
    alpha3: "nav",
    bibliographic: "",
    name: "Navajo"
  }, {
    alpha2: "nr",
    alpha3: "nbl",
    bibliographic: "",
    name: "Ndebele, South"
  }, {
    alpha2: "nr",
    alpha3: "nbl",
    bibliographic: "",
    name: "South Ndebele"
  }, {
    alpha2: "nd",
    alpha3: "nde",
    bibliographic: "",
    name: "Ndebele, North"
  }, {
    alpha2: "nd",
    alpha3: "nde",
    bibliographic: "",
    name: "North Ndebele"
  }, {
    alpha2: "ng",
    alpha3: "ndo",
    bibliographic: "",
    name: "Ndonga"
  }, {
    alpha2: "",
    alpha3: "nds",
    bibliographic: "",
    name: "German, Low"
  }, {
    alpha2: "",
    alpha3: "nds",
    bibliographic: "",
    name: "Low German"
  }, {
    alpha2: "",
    alpha3: "nds",
    bibliographic: "",
    name: "Low Saxon"
  }, {
    alpha2: "",
    alpha3: "nds",
    bibliographic: "",
    name: "Saxon, Low"
  }, {
    alpha2: "ne",
    alpha3: "nep",
    bibliographic: "",
    name: "Nepali"
  }, {
    alpha2: "",
    alpha3: "new",
    bibliographic: "",
    name: "Nepal Bhasa"
  }, {
    alpha2: "",
    alpha3: "new",
    bibliographic: "",
    name: "Newari"
  }, {
    alpha2: "",
    alpha3: "nia",
    bibliographic: "",
    name: "Nias"
  }, {
    alpha2: "",
    alpha3: "nic",
    bibliographic: "",
    name: "Niger-Kordofanian languages"
  }, {
    alpha2: "",
    alpha3: "niu",
    bibliographic: "",
    name: "Niuean"
  }, {
    alpha2: "",
    alpha3: "",
    bibliographic: "dut",
    name: "Flemish"
  }, {
    alpha2: "nl",
    alpha3: "nld",
    bibliographic: "dut",
    name: "Dutch"
  }, {
    alpha2: "nn",
    alpha3: "nno",
    bibliographic: "",
    name: "Norwegian Nynorsk"
  }, {
    alpha2: "nn",
    alpha3: "nno",
    bibliographic: "",
    name: "Nynorsk, Norwegian"
  }, {
    alpha2: "nb",
    alpha3: "nob",
    bibliographic: "",
    name: "Bokmål, Norwegian"
  }, {
    alpha2: "nb",
    alpha3: "nob",
    bibliographic: "",
    name: "Norwegian Bokmål"
  }, {
    alpha2: "",
    alpha3: "nog",
    bibliographic: "",
    name: "Nogai"
  }, {
    alpha2: "",
    alpha3: "non",
    bibliographic: "",
    name: "Norse, Old"
  }, {
    alpha2: "no",
    alpha3: "nor",
    bibliographic: "",
    name: "Norwegian"
  }, {
    alpha2: "",
    alpha3: "nqo",
    bibliographic: "",
    name: "N'Ko"
  }, {
    alpha2: "",
    alpha3: "nso",
    bibliographic: "",
    name: "Northern Sotho"
  }, {
    alpha2: "",
    alpha3: "nso",
    bibliographic: "",
    name: "Pedi"
  }, {
    alpha2: "",
    alpha3: "nso",
    bibliographic: "",
    name: "Sepedi"
  }, {
    alpha2: "",
    alpha3: "nso",
    bibliographic: "",
    name: "Sotho, Northern"
  }, {
    alpha2: "",
    alpha3: "nub",
    bibliographic: "",
    name: "Nubian languages"
  }, {
    alpha2: "",
    alpha3: "nwc",
    bibliographic: "",
    name: "Classical Nepal Bhasa"
  }, {
    alpha2: "",
    alpha3: "nwc",
    bibliographic: "",
    name: "Classical Newari"
  }, {
    alpha2: "",
    alpha3: "nwc",
    bibliographic: "",
    name: "Old Newari"
  }, {
    alpha2: "ny",
    alpha3: "nya",
    bibliographic: "",
    name: "Chewa"
  }, {
    alpha2: "ny",
    alpha3: "nya",
    bibliographic: "",
    name: "Chichewa"
  }, {
    alpha2: "ny",
    alpha3: "nya",
    bibliographic: "",
    name: "Nyanja"
  }, {
    alpha2: "",
    alpha3: "nym",
    bibliographic: "",
    name: "Nyamwezi"
  }, {
    alpha2: "",
    alpha3: "nyn",
    bibliographic: "",
    name: "Nyankole"
  }, {
    alpha2: "",
    alpha3: "nyo",
    bibliographic: "",
    name: "Nyoro"
  }, {
    alpha2: "",
    alpha3: "nzi",
    bibliographic: "",
    name: "Nzima"
  }, {
    alpha2: "oc",
    alpha3: "oci",
    bibliographic: "",
    name: "Occitan (post 1500)"
  }, {
    alpha2: "oj",
    alpha3: "oji",
    bibliographic: "",
    name: "Ojibwa"
  }, {
    alpha2: "or",
    alpha3: "ori",
    bibliographic: "",
    name: "Oriya"
  }, {
    alpha2: "om",
    alpha3: "orm",
    bibliographic: "",
    name: "Oromo"
  }, {
    alpha2: "",
    alpha3: "osa",
    bibliographic: "",
    name: "Osage"
  }, {
    alpha2: "os",
    alpha3: "oss",
    bibliographic: "",
    name: "Ossetian"
  }, {
    alpha2: "os",
    alpha3: "oss",
    bibliographic: "",
    name: "Ossetic"
  }, {
    alpha2: "",
    alpha3: "ota",
    bibliographic: "",
    name: "Turkish, Ottoman (1500-1928)"
  }, {
    alpha2: "",
    alpha3: "oto",
    bibliographic: "",
    name: "Otomian languages"
  }, {
    alpha2: "",
    alpha3: "paa",
    bibliographic: "",
    name: "Papuan languages"
  }, {
    alpha2: "",
    alpha3: "pag",
    bibliographic: "",
    name: "Pangasinan"
  }, {
    alpha2: "",
    alpha3: "pal",
    bibliographic: "",
    name: "Pahlavi"
  }, {
    alpha2: "",
    alpha3: "pam",
    bibliographic: "",
    name: "Kapampangan"
  }, {
    alpha2: "",
    alpha3: "pam",
    bibliographic: "",
    name: "Pampanga"
  }, {
    alpha2: "pa",
    alpha3: "pan",
    bibliographic: "",
    name: "Panjabi"
  }, {
    alpha2: "pa",
    alpha3: "pan",
    bibliographic: "",
    name: "Punjabi"
  }, {
    alpha2: "",
    alpha3: "pap",
    bibliographic: "",
    name: "Papiamento"
  }, {
    alpha2: "",
    alpha3: "pau",
    bibliographic: "",
    name: "Palauan"
  }, {
    alpha2: "",
    alpha3: "peo",
    bibliographic: "",
    name: "Persian, Old (ca.600-400 B.C.)"
  }, {
    alpha2: "",
    alpha3: "phi",
    bibliographic: "",
    name: "Philippine languages"
  }, {
    alpha2: "",
    alpha3: "phn",
    bibliographic: "",
    name: "Phoenician"
  }, {
    alpha2: "pi",
    alpha3: "pli",
    bibliographic: "",
    name: "Pali"
  }, {
    alpha2: "pl",
    alpha3: "pol",
    bibliographic: "",
    name: "Polish"
  }, {
    alpha2: "",
    alpha3: "pon",
    bibliographic: "",
    name: "Pohnpeian"
  }, {
    alpha2: "pt",
    alpha3: "por",
    bibliographic: "",
    name: "Portuguese"
  }, {
    alpha2: "",
    alpha3: "pra",
    bibliographic: "",
    name: "Prakrit languages"
  }, {
    alpha2: "",
    alpha3: "pro",
    bibliographic: "",
    name: "Occitan, Old (to 1500)"
  }, {
    alpha2: "",
    alpha3: "pro",
    bibliographic: "",
    name: "Provençal, Old (to 1500)"
  }, {
    alpha2: "ps",
    alpha3: "pus",
    bibliographic: "",
    name: "Pashto"
  }, {
    alpha2: "ps",
    alpha3: "pus",
    bibliographic: "",
    name: "Pushto"
  }, {
    alpha2: "qu",
    alpha3: "que",
    bibliographic: "",
    name: "Quechua"
  }, {
    alpha2: "",
    alpha3: "raj",
    bibliographic: "",
    name: "Rajasthani"
  }, {
    alpha2: "",
    alpha3: "rap",
    bibliographic: "",
    name: "Rapanui"
  }, {
    alpha2: "",
    alpha3: "rar",
    bibliographic: "",
    name: "Cook Islands Maori"
  }, {
    alpha2: "",
    alpha3: "rar",
    bibliographic: "",
    name: "Rarotongan"
  }, {
    alpha2: "",
    alpha3: "roa",
    bibliographic: "",
    name: "Romance languages"
  }, {
    alpha2: "rm",
    alpha3: "roh",
    bibliographic: "",
    name: "Romansh"
  }, {
    alpha2: "",
    alpha3: "rom",
    bibliographic: "",
    name: "Romany"
  }, {
    alpha2: "ro",
    alpha3: "ron",
    bibliographic: "rum",
    name: "Moldavian"
  }, {
    alpha2: "ro",
    alpha3: "ron",
    bibliographic: "rum",
    name: "Romanian"
  }, {
    alpha2: "rn",
    alpha3: "run",
    bibliographic: "",
    name: "Rundi"
  }, {
    alpha2: "",
    alpha3: "rup",
    bibliographic: "",
    name: "Aromanian"
  }, {
    alpha2: "",
    alpha3: "rup",
    bibliographic: "",
    name: "Arumanian"
  }, {
    alpha2: "",
    alpha3: "rup",
    bibliographic: "",
    name: "Macedo-Romanian"
  }, {
    alpha2: "ru",
    alpha3: "rus",
    bibliographic: "",
    name: "Russian"
  }, {
    alpha2: "",
    alpha3: "sad",
    bibliographic: "",
    name: "Sandawe"
  }, {
    alpha2: "sg",
    alpha3: "sag",
    bibliographic: "",
    name: "Sango"
  }, {
    alpha2: "",
    alpha3: "sah",
    bibliographic: "",
    name: "Yakut"
  }, {
    alpha2: "",
    alpha3: "sai",
    bibliographic: "",
    name: "South American Indian languages"
  }, {
    alpha2: "",
    alpha3: "sal",
    bibliographic: "",
    name: "Salishan languages"
  }, {
    alpha2: "",
    alpha3: "sam",
    bibliographic: "",
    name: "Samaritan Aramaic"
  }, {
    alpha2: "sa",
    alpha3: "san",
    bibliographic: "",
    name: "Sanskrit"
  }, {
    alpha2: "",
    alpha3: "sas",
    bibliographic: "",
    name: "Sasak"
  }, {
    alpha2: "",
    alpha3: "sat",
    bibliographic: "",
    name: "Santali"
  }, {
    alpha2: "",
    alpha3: "scn",
    bibliographic: "",
    name: "Sicilian"
  }, {
    alpha2: "",
    alpha3: "sco",
    bibliographic: "",
    name: "Scots"
  }, {
    alpha2: "",
    alpha3: "sel",
    bibliographic: "",
    name: "Selkup"
  }, {
    alpha2: "",
    alpha3: "sem",
    bibliographic: "",
    name: "Semitic languages"
  }, {
    alpha2: "",
    alpha3: "sga",
    bibliographic: "",
    name: "Irish, Old (to 900)"
  }, {
    alpha2: "",
    alpha3: "sgn",
    bibliographic: "",
    name: "Sign Languages"
  }, {
    alpha2: "",
    alpha3: "shn",
    bibliographic: "",
    name: "Shan"
  }, {
    alpha2: "",
    alpha3: "sid",
    bibliographic: "",
    name: "Sidamo"
  }, {
    alpha2: "si",
    alpha3: "sin",
    bibliographic: "",
    name: "Sinhala"
  }, {
    alpha2: "si",
    alpha3: "sin",
    bibliographic: "",
    name: "Sinhalese"
  }, {
    alpha2: "",
    alpha3: "sio",
    bibliographic: "",
    name: "Siouan languages"
  }, {
    alpha2: "",
    alpha3: "sit",
    bibliographic: "",
    name: "Sino-Tibetan languages"
  }, {
    alpha2: "",
    alpha3: "sla",
    bibliographic: "",
    name: "Slavic languages"
  }, {
    alpha2: "sk",
    alpha3: "slk",
    bibliographic: "slo",
    name: "Slovak"
  }, {
    alpha2: "sl",
    alpha3: "slv",
    bibliographic: "",
    name: "Slovenian"
  }, {
    alpha2: "",
    alpha3: "sma",
    bibliographic: "",
    name: "Southern Sami"
  }, {
    alpha2: "se",
    alpha3: "sme",
    bibliographic: "",
    name: "Northern Sami"
  }, {
    alpha2: "",
    alpha3: "smi",
    bibliographic: "",
    name: "Sami languages"
  }, {
    alpha2: "",
    alpha3: "smj",
    bibliographic: "",
    name: "Lule Sami"
  }, {
    alpha2: "",
    alpha3: "smn",
    bibliographic: "",
    name: "Inari Sami"
  }, {
    alpha2: "sm",
    alpha3: "smo",
    bibliographic: "",
    name: "Samoan"
  }, {
    alpha2: "",
    alpha3: "sms",
    bibliographic: "",
    name: "Skolt Sami"
  }, {
    alpha2: "sn",
    alpha3: "sna",
    bibliographic: "",
    name: "Shona"
  }, {
    alpha2: "sd",
    alpha3: "snd",
    bibliographic: "",
    name: "Sindhi"
  }, {
    alpha2: "",
    alpha3: "snk",
    bibliographic: "",
    name: "Soninke"
  }, {
    alpha2: "",
    alpha3: "sog",
    bibliographic: "",
    name: "Sogdian"
  }, {
    alpha2: "so",
    alpha3: "som",
    bibliographic: "",
    name: "Somali"
  }, {
    alpha2: "",
    alpha3: "son",
    bibliographic: "",
    name: "Songhai languages"
  }, {
    alpha2: "st",
    alpha3: "sot",
    bibliographic: "",
    name: "Sotho, Southern"
  }, {
    alpha2: "es",
    alpha3: "spa",
    bibliographic: "",
    name: "Castilian"
  }, {
    alpha2: "es",
    alpha3: "spa",
    bibliographic: "",
    name: "Spanish"
  }, {
    alpha2: "sq",
    alpha3: "sqi",
    bibliographic: "alb",
    name: "Albanian"
  }, {
    alpha2: "sc",
    alpha3: "srd",
    bibliographic: "",
    name: "Sardinian"
  }, {
    alpha2: "",
    alpha3: "srn",
    bibliographic: "",
    name: "Sranan Tongo"
  }, {
    alpha2: "sr",
    alpha3: "srp",
    bibliographic: "",
    name: "Serbian"
  }, {
    alpha2: "",
    alpha3: "srr",
    bibliographic: "",
    name: "Serer"
  }, {
    alpha2: "",
    alpha3: "ssa",
    bibliographic: "",
    name: "Nilo-Saharan languages"
  }, {
    alpha2: "ss",
    alpha3: "ssw",
    bibliographic: "",
    name: "Swati"
  }, {
    alpha2: "",
    alpha3: "suk",
    bibliographic: "",
    name: "Sukuma"
  }, {
    alpha2: "su",
    alpha3: "sun",
    bibliographic: "",
    name: "Sundanese"
  }, {
    alpha2: "",
    alpha3: "sus",
    bibliographic: "",
    name: "Susu"
  }, {
    alpha2: "",
    alpha3: "sux",
    bibliographic: "",
    name: "Sumerian"
  }, {
    alpha2: "sw",
    alpha3: "swa",
    bibliographic: "",
    name: "Swahili"
  }, {
    alpha2: "sv",
    alpha3: "swe",
    bibliographic: "",
    name: "Swedish"
  }, {
    alpha2: "",
    alpha3: "syc",
    bibliographic: "",
    name: "Classical Syriac"
  }, {
    alpha2: "",
    alpha3: "syr",
    bibliographic: "",
    name: "Syriac"
  }, {
    alpha2: "ty",
    alpha3: "tah",
    bibliographic: "",
    name: "Tahitian"
  }, {
    alpha2: "",
    alpha3: "tai",
    bibliographic: "",
    name: "Tai languages"
  }, {
    alpha2: "ta",
    alpha3: "tam",
    bibliographic: "",
    name: "Tamil"
  }, {
    alpha2: "tt",
    alpha3: "tat",
    bibliographic: "",
    name: "Tatar"
  }, {
    alpha2: "te",
    alpha3: "tel",
    bibliographic: "",
    name: "Telugu"
  }, {
    alpha2: "",
    alpha3: "tem",
    bibliographic: "",
    name: "Timne"
  }, {
    alpha2: "",
    alpha3: "ter",
    bibliographic: "",
    name: "Tereno"
  }, {
    alpha2: "",
    alpha3: "tet",
    bibliographic: "",
    name: "Tetum"
  }, {
    alpha2: "tg",
    alpha3: "tgk",
    bibliographic: "",
    name: "Tajik"
  }, {
    alpha2: "tl",
    alpha3: "tgl",
    bibliographic: "",
    name: "Tagalog"
  }, {
    alpha2: "th",
    alpha3: "tha",
    bibliographic: "",
    name: "Thai"
  }, {
    alpha2: "",
    alpha3: "tig",
    bibliographic: "",
    name: "Tigre"
  }, {
    alpha2: "ti",
    alpha3: "tir",
    bibliographic: "",
    name: "Tigrinya"
  }, {
    alpha2: "",
    alpha3: "tiv",
    bibliographic: "",
    name: "Tiv"
  }, {
    alpha2: "",
    alpha3: "tkl",
    bibliographic: "",
    name: "Tokelau"
  }, {
    alpha2: "",
    alpha3: "tlh",
    bibliographic: "",
    name: "Klingon"
  }, {
    alpha2: "",
    alpha3: "tlh",
    bibliographic: "",
    name: "tlhIngan-Hol"
  }, {
    alpha2: "",
    alpha3: "tli",
    bibliographic: "",
    name: "Tlingit"
  }, {
    alpha2: "",
    alpha3: "tmh",
    bibliographic: "",
    name: "Tamashek"
  }, {
    alpha2: "",
    alpha3: "tog",
    bibliographic: "",
    name: "Tonga (Nyasa)"
  }, {
    alpha2: "to",
    alpha3: "ton",
    bibliographic: "",
    name: "Tonga (Tonga Islands)"
  }, {
    alpha2: "",
    alpha3: "tpi",
    bibliographic: "",
    name: "Tok Pisin"
  }, {
    alpha2: "",
    alpha3: "tsi",
    bibliographic: "",
    name: "Tsimshian"
  }, {
    alpha2: "tn",
    alpha3: "tsn",
    bibliographic: "",
    name: "Tswana"
  }, {
    alpha2: "ts",
    alpha3: "tso",
    bibliographic: "",
    name: "Tsonga"
  }, {
    alpha2: "tk",
    alpha3: "tuk",
    bibliographic: "",
    name: "Turkmen"
  }, {
    alpha2: "",
    alpha3: "tum",
    bibliographic: "",
    name: "Tumbuka"
  }, {
    alpha2: "",
    alpha3: "tup",
    bibliographic: "",
    name: "Tupi languages"
  }, {
    alpha2: "tr",
    alpha3: "tur",
    bibliographic: "",
    name: "Turkish"
  }, {
    alpha2: "",
    alpha3: "tut",
    bibliographic: "",
    name: "Altaic languages"
  }, {
    alpha2: "",
    alpha3: "tvl",
    bibliographic: "",
    name: "Tuvalu"
  }, {
    alpha2: "tw",
    alpha3: "twi",
    bibliographic: "",
    name: "Twi"
  }, {
    alpha2: "",
    alpha3: "tyv",
    bibliographic: "",
    name: "Tuvinian"
  }, {
    alpha2: "",
    alpha3: "udm",
    bibliographic: "",
    name: "Udmurt"
  }, {
    alpha2: "",
    alpha3: "uga",
    bibliographic: "",
    name: "Ugaritic"
  }, {
    alpha2: "ug",
    alpha3: "uig",
    bibliographic: "",
    name: "Uighur"
  }, {
    alpha2: "ug",
    alpha3: "uig",
    bibliographic: "",
    name: "Uyghur"
  }, {
    alpha2: "uk",
    alpha3: "ukr",
    bibliographic: "",
    name: "Ukrainian"
  }, {
    alpha2: "",
    alpha3: "umb",
    bibliographic: "",
    name: "Umbundu"
  }, {
    alpha2: "",
    alpha3: "und",
    bibliographic: "",
    name: "Undetermined"
  }, {
    alpha2: "ur",
    alpha3: "urd",
    bibliographic: "",
    name: "Urdu"
  }, {
    alpha2: "uz",
    alpha3: "uzb",
    bibliographic: "",
    name: "Uzbek"
  }, {
    alpha2: "",
    alpha3: "vai",
    bibliographic: "",
    name: "Vai"
  }, {
    alpha2: "ve",
    alpha3: "ven",
    bibliographic: "",
    name: "Venda"
  }, {
    alpha2: "vi",
    alpha3: "vie",
    bibliographic: "",
    name: "Vietnamese"
  }, {
    alpha2: "vo",
    alpha3: "vol",
    bibliographic: "",
    name: "Volapük"
  }, {
    alpha2: "",
    alpha3: "vot",
    bibliographic: "",
    name: "Votic"
  }, {
    alpha2: "",
    alpha3: "wak",
    bibliographic: "",
    name: "Wakashan languages"
  }, {
    alpha2: "",
    alpha3: "wal",
    bibliographic: "",
    name: "Wolaitta"
  }, {
    alpha2: "",
    alpha3: "wal",
    bibliographic: "",
    name: "Wolaytta"
  }, {
    alpha2: "",
    alpha3: "war",
    bibliographic: "",
    name: "Waray"
  }, {
    alpha2: "",
    alpha3: "was",
    bibliographic: "",
    name: "Washo"
  }, {
    alpha2: "",
    alpha3: "wen",
    bibliographic: "",
    name: "Sorbian languages"
  }, {
    alpha2: "wa",
    alpha3: "wln",
    bibliographic: "",
    name: "Walloon"
  }, {
    alpha2: "wo",
    alpha3: "wol",
    bibliographic: "",
    name: "Wolof"
  }, {
    alpha2: "",
    alpha3: "xal",
    bibliographic: "",
    name: "Kalmyk"
  }, {
    alpha2: "",
    alpha3: "xal",
    bibliographic: "",
    name: "Oirat"
  }, {
    alpha2: "xh",
    alpha3: "xho",
    bibliographic: "",
    name: "Xhosa"
  }, {
    alpha2: "",
    alpha3: "yao",
    bibliographic: "",
    name: "Yao"
  }, {
    alpha2: "",
    alpha3: "yap",
    bibliographic: "",
    name: "Yapese"
  }, {
    alpha2: "yi",
    alpha3: "yid",
    bibliographic: "",
    name: "Yiddish"
  }, {
    alpha2: "yo",
    alpha3: "yor",
    bibliographic: "",
    name: "Yoruba"
  }, {
    alpha2: "",
    alpha3: "ypk",
    bibliographic: "",
    name: "Yupik languages"
  }, {
    alpha2: "",
    alpha3: "zap",
    bibliographic: "",
    name: "Zapotec"
  }, {
    alpha2: "",
    alpha3: "zbl",
    bibliographic: "",
    name: "Bliss"
  }, {
    alpha2: "",
    alpha3: "zbl",
    bibliographic: "",
    name: "Blissymbolics"
  }, {
    alpha2: "",
    alpha3: "zbl",
    bibliographic: "",
    name: "Blissymbols"
  }, {
    alpha2: "",
    alpha3: "zen",
    bibliographic: "",
    name: "Zenaga"
  }, {
    alpha2: "",
    alpha3: "zgh",
    bibliographic: "",
    name: "Standard Moroccan Tamazight"
  }, {
    alpha2: "za",
    alpha3: "zha",
    bibliographic: "",
    name: "Chuang"
  }, {
    alpha2: "za",
    alpha3: "zha",
    bibliographic: "",
    name: "Zhuang"
  }, {
    alpha2: "zh",
    alpha3: "zho",
    bibliographic: "chi",
    name: "Chinese"
  }, {
    alpha2: "",
    alpha3: "znd",
    bibliographic: "",
    name: "Zande languages"
  }, {
    alpha2: "zu",
    alpha3: "zul",
    bibliographic: "",
    name: "Zulu"
  }, {
    alpha2: "",
    alpha3: "zun",
    bibliographic: "",
    name: "Zuni"
  }, {
    alpha2: "",
    alpha3: "zxx",
    bibliographic: "",
    name: "No linguistic content"
  }, {
    alpha2: "",
    alpha3: "zxx",
    bibliographic: "",
    name: "Not applicable"
  }, {
    alpha2: "",
    alpha3: "zza",
    bibliographic: "",
    name: "Dimili"
  }, {
    alpha2: "",
    alpha3: "zza",
    bibliographic: "",
    name: "Dimli"
  }, {
    alpha2: "",
    alpha3: "zza",
    bibliographic: "",
    name: "Kirdki"
  }, {
    alpha2: "",
    alpha3: "zza",
    bibliographic: "",
    name: "Kirmanjki"
  }, {
    alpha2: "",
    alpha3: "zza",
    bibliographic: "",
    name: "Zaza"
  }, {
    alpha2: "",
    alpha3: "zza",
    bibliographic: "",
    name: "Zazaki"
  }];
})(df);
var uf = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = function(r, o) {
    var i = Object.entries(o);
    return r.filter(function(s) {
      return i.filter(function(c) {
        var u = s[c[0]];
        return Array.isArray(u) ? u.indexOf(c[1]) >= 0 : u.toLowerCase() === c[1].toLowerCase();
      }).length === i.length;
    });
  }, n = function(r) {
    return {
      countries: t.bind(null, r.countries),
      currencies: t.bind(null, r.currencies),
      languages: t.bind(null, r.languages)
    };
  };
  e.default = n;
})(uf);
(function(e) {
  function t(b) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function($) {
      return typeof $;
    } : function($) {
      return $ && typeof Symbol == "function" && $.constructor === Symbol && $ !== Symbol.prototype ? "symbol" : typeof $;
    }, t(b);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.callingCountries = e.callingCodes = void 0, Object.defineProperty(e, "continents", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), e.currencies = e.countries = void 0, Object.defineProperty(e, "currencySymbolMap", {
    enumerable: !0,
    get: function() {
      return n.currencySymbolMap;
    }
  }), Object.defineProperty(e, "getNameFromCurrency", {
    enumerable: !0,
    get: function() {
      return n.getNameFromCurrency;
    }
  }), Object.defineProperty(e, "getSafeNameFromCurrency", {
    enumerable: !0,
    get: function() {
      return n.getSafeNameFromCurrency;
    }
  }), Object.defineProperty(e, "getSafeSymbolFromCurrency", {
    enumerable: !0,
    get: function() {
      return n.getSafeSymbolFromCurrency;
    }
  }), Object.defineProperty(e, "getSymbolFromCurrency", {
    enumerable: !0,
    get: function() {
      return n.getSymbolFromCurrency;
    }
  }), e.regions = e.lookup = e.languages = void 0;
  var n = cn, a = m(sf), r = p(ae);
  e.regions = r;
  var o = m(lf), i = m(cf), s = m(df), c = m(uf);
  function u(b) {
    if (typeof WeakMap != "function") return null;
    var $ = /* @__PURE__ */ new WeakMap(), x = /* @__PURE__ */ new WeakMap();
    return (u = function(S) {
      return S ? x : $;
    })(b);
  }
  function p(b, $) {
    if (b && b.__esModule) return b;
    if (b === null || t(b) != "object" && typeof b != "function") return { default: b };
    var x = u($);
    if (x && x.has(b)) return x.get(b);
    var w = { __proto__: null }, S = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var P in b) if (P !== "default" && {}.hasOwnProperty.call(b, P)) {
      var C = S ? Object.getOwnPropertyDescriptor(b, P) : null;
      C && (C.get || C.set) ? Object.defineProperty(w, P, C) : w[P] = b[P];
    }
    return w.default = b, x && x.set(b, w), w;
  }
  function m(b) {
    return b && b.__esModule ? b : { default: b };
  }
  var f = e.countries = {
    all: o.default
  };
  o.default.forEach(function(b) {
    var $ = f[b.alpha2] || {}, x = $.status;
    (!x || x === "deleted") && (f[b.alpha2] = b);
    var w = f[b.alpha3] || {}, S = w.status;
    (!S || S === "deleted") && (f[b.alpha3] = b);
  });
  var h = e.currencies = {
    all: i.default
  };
  i.default.forEach(function(b) {
    var $ = (0, n.getSymbolFromCurrency)(b.code);
    $ === "?" && ($ = b.code);
    var x = Object.assign(b, {
      symbol: $
    });
    h[b.code] = x;
  });
  var v = e.languages = {
    all: s.default
  };
  s.default.forEach(function(b) {
    v[b.alpha2] = b, v[b.bibliographic] = b, v[b.alpha3] = b;
  }), e.lookup = (0, c.default)({
    countries: o.default,
    currencies: i.default,
    languages: s.default
  });
  var g = e.callingCountries = {
    all: []
  }, y = o.default.reduce(function(b, $) {
    var x = $.countryCallingCodes, w = $.alpha2, S = $.alpha3;
    return x && x.length && (g.all.push($), g[w] = $, g[S] = $, x.forEach(function(P) {
      b.indexOf(P) === -1 && b.push(P);
    })), b;
  }, []);
  delete g[""], y.sort(function(b, $) {
    var x = function(C) {
      return +C;
    }, w = b.split(" ").map(x), S = $.split(" ").map(x);
    return w[0] < S[0] ? -1 : w[0] > S[0] ? 1 : w[1] === void 0 && S[1] !== void 0 ? -1 : w[1] !== void 0 && S[1] === void 0 ? 1 : w[1] < S[1] ? -1 : w[1] > S[1] ? 1 : 0;
  }), e.callingCodes = {
    all: y
  };
})(Fr);
const pf = ({
  options: e = Fr.countries.all.filter(
    (p) => p.emoji && p.status !== "deleted" && p.ioc !== "PRK"
  ),
  onChange: t,
  defaultValue: n,
  disabled: a = !1,
  placeholder: r = "Select a country",
  slim: o = !1,
  inline: i = !1,
  className: s,
  ...c
}, u) => {
  const [p, m] = He(!1), [f, h] = He(
    void 0
  );
  Yr(() => {
    if (n) {
      const y = e.find(
        (b) => b.alpha2 === n
      );
      h(y || void 0);
    } else
      h(void 0);
  }, [n, e]);
  const v = hn(
    (y) => {
      h(y), t == null || t(y), m(!1);
    },
    [t]
  ), g = R(
    "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
    o === !0 && "w-20",
    i && "rounded-r-none border-r-0 gap-1 pr-1 w-min"
  );
  return /* @__PURE__ */ l.jsxs(m4, { open: p, onOpenChange: m, children: [
    /* @__PURE__ */ l.jsxs(
      f4,
      {
        ref: u,
        className: `${g} ${s}`,
        disabled: a,
        ...c,
        children: [
          f ? /* @__PURE__ */ l.jsxs("div", { className: `flex items-center ${i ? "" : "w-0"} flex-grow  gap-2 overflow-hidden`, children: [
            /* @__PURE__ */ l.jsx("div", { className: "inline-flex items-center justify-center w-5 h-5 shrink-0 overflow-hidden rounded-full", children: /* @__PURE__ */ l.jsx(
              Ni,
              {
                countryCode: f.alpha2.toLowerCase(),
                height: 20
              }
            ) }),
            o === !1 && !i && /* @__PURE__ */ l.jsx("span", { className: "overflow-hidden text-ellipsis whitespace-nowrap", children: f.name })
          ] }) : /* @__PURE__ */ l.jsx("span", { children: o === !1 && !i ? r || h.name : /* @__PURE__ */ l.jsx(vc, { size: 20 }) }),
          /* @__PURE__ */ l.jsx(qr, { size: 16 })
        ]
      }
    ),
    /* @__PURE__ */ l.jsx(
      nf,
      {
        collisionPadding: 10,
        side: "bottom",
        className: "min-w-[--radix-popper-anchor-width] p-0",
        children: /* @__PURE__ */ l.jsx(Bm, { className: "w-full max-h-[200px] sm:max-h-[270px]", children: /* @__PURE__ */ l.jsxs(Gm, { children: [
          /* @__PURE__ */ l.jsx("div", { className: "sticky top-0 z-10 bg-popover", children: /* @__PURE__ */ l.jsx(Um, { placeholder: "Search country..." }) }),
          /* @__PURE__ */ l.jsx(Hm, { children: "No country found." }),
          /* @__PURE__ */ l.jsx(Wm, { children: e.filter((y) => y.name).map((y, b) => /* @__PURE__ */ l.jsxs(
            Vm,
            {
              className: "flex items-center w-full gap-2",
              onSelect: () => v(y),
              children: [
                /* @__PURE__ */ l.jsxs("div", { className: "flex flex-grow w-0 space-x-2 overflow-hidden", children: [
                  /* @__PURE__ */ l.jsx("div", { className: "inline-flex items-center justify-center w-5 h-5 shrink-0 overflow-hidden rounded-full", children: /* @__PURE__ */ l.jsx(
                    Ni,
                    {
                      countryCode: y.alpha2.toLowerCase(),
                      height: 20
                    }
                  ) }),
                  /* @__PURE__ */ l.jsx("span", { className: "overflow-hidden text-ellipsis whitespace-nowrap", children: y.name })
                ] }),
                /* @__PURE__ */ l.jsx(
                  ih,
                  {
                    className: R(
                      "ml-auto h-4 w-4 shrink-0",
                      y.name === (f == null ? void 0 : f.name) ? "opacity-100" : "opacity-0"
                    )
                  }
                )
              ]
            },
            b
          )) })
        ] }) })
      }
    )
  ] });
};
pf.displayName = "CountryDropdownComponent";
const XC = Je(pf), x4 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function mf(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(x4), e.apply(this, n);
}
function Fl(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), a = t[0].split("."), r = 0; r < 3; r++) {
    var o = Number(n[r]), i = Number(a[r]);
    if (o > i) return 1;
    if (i > o) return -1;
    if (!isNaN(o) && isNaN(i)) return 1;
    if (isNaN(o) && !isNaN(i)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var w4 = {}.constructor;
function Hn(e) {
  return e != null && e.constructor === w4;
}
function Ai(e) {
  "@babel/helpers - typeof";
  return Ai = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ai(e);
}
function Oo(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function C4(e, t) {
  for (var n = 0; n < t.length; n++) {
    var a = t[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function jo(e, t, n) {
  return t && C4(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var S4 = "1.2.0", E4 = "1.7.35", Bl = " ext. ", R4 = /^\d+$/, Ue = /* @__PURE__ */ function() {
  function e(t) {
    Oo(this, e), ff(t), this.metadata = t, hf.call(this, t);
  }
  return jo(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var a = this.countryCallingCodes()[n];
        if (a && a.length === 1 && a[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, a) {
      if (n && R4.test(n) && (a = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new Ul(this.getCountryMetadata(n), this);
      } else if (a) {
        if (!this.hasCallingCode(a))
          throw new Error("Unknown calling code: ".concat(a));
        this.numberingPlan = new Ul(this.getNumberingPlanMetadata(a), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var a = this.countryCallingCodes()[n];
      if (a)
        return a.length === 1 && a[0].length === 3 ? void 0 : a;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var a = this.getCountryCodesForCallingCode(n);
      if (a)
        return a[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var a = this.getCountryCodeForCallingCode(n);
      if (a)
        return this.getCountryMetadata(a);
      if (this.nonGeographic()) {
        var r = this.nonGeographic()[n];
        if (r)
          return r;
      } else {
        var o = this.countryCallingCodes()[n];
        if (o && o.length === 1 && o[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Ul = /* @__PURE__ */ function() {
  function e(t, n) {
    Oo(this, e), this.globalMetadataObject = n, this.metadata = t, hf.call(this, n.metadata);
  }
  return jo(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, a = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return a.map(function(r) {
        return new N4(r, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && Gl(this.types(), n))
        return new P4(Gl(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Bl : this.metadata[13] || Bl;
    }
  }]), e;
}(), N4 = /* @__PURE__ */ function() {
  function e(t, n) {
    Oo(this, e), this._format = t, this.metadata = n;
  }
  return jo(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !A4.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), A4 = /^\(?\$1\)?$/, P4 = /* @__PURE__ */ function() {
  function e(t, n) {
    Oo(this, e), this.type = t, this.metadata = n;
  }
  return jo(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Gl(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function ff(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Hn(e) || !Hn(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Hn(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + _4(e) + ": " + e, "."));
}
var _4 = function(t) {
  return Ai(t);
};
function Ys(e, t) {
  if (t = new Ue(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function T4(e, t) {
  return t.countries.hasOwnProperty(e);
}
function hf(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? Fl(t, S4) === -1 ? this.v2 = !0 : Fl(t, E4) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function Xs(e, t) {
  return k4(e, void 0, t);
}
function k4(e, t, n) {
  var a = n.type(t), r = a && a.possibleLengths() || n.possibleLengths();
  if (!r)
    return "IS_POSSIBLE";
  var o = e.length, i = r[0];
  return i === o ? "IS_POSSIBLE" : i > o ? "TOO_SHORT" : r[r.length - 1] < o ? "TOO_LONG" : r.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function O4(e, t, n) {
  if (t === void 0 && (t = {}), n = new Ue(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return gf(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function gf(e, t) {
  switch (Xs(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Dt(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function j4(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = M4(e)) || t) {
    n && (e = n);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function M4(e, t) {
  if (e) {
    if (typeof e == "string") return Hl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Hl(e, t);
  }
}
function Hl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = new Array(t); n < t; n++)
    a[n] = e[n];
  return a;
}
var I4 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function qs(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new Ue(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var a = t.v2 ? e.nationalNumber : e.phone;
    if (Dt(a, n.nationalNumberPattern())) {
      if (Qo(a, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Qo(a, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var r = j4(I4), o; !(o = r()).done; ) {
        var i = o.value;
        if (Qo(a, i, n))
          return i;
      }
    }
  }
}
function Qo(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : Dt(e, t.pattern());
}
function D4(e, t, n) {
  if (t = t || {}, n = new Ue(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return qs(e, t, n.metadata) !== void 0;
  var a = t.v2 ? e.nationalNumber : e.phone;
  return Dt(a, n.nationalNumberPattern());
}
function L4(e, t, n) {
  var a = new Ue(n), r = a.getCountryCodesForCallingCode(e);
  return r ? r.filter(function(o) {
    return F4(t, o, n);
  }) : [];
}
function F4(e, t, n) {
  var a = new Ue(n);
  return a.selectNumberingPlan(t), a.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var Js = 2, B4 = 17, U4 = 3, ut = "0-9０-９٠-٩۰-۹", G4 = "-‐-―−ー－", H4 = "／/", W4 = "．.", V4 = "  ­​⁠　", z4 = "()（）［］\\[\\]", K4 = "~⁓∼～", Br = "".concat(G4).concat(H4).concat(W4).concat(V4).concat(z4).concat(K4), Qs = "+＋", Z4 = new RegExp("([" + ut + "])");
function Y4(e, t, n, a) {
  if (t) {
    var r = new Ue(a);
    r.selectNumberingPlan(t, n);
    var o = new RegExp(r.IDDPrefix());
    if (e.search(o) === 0) {
      e = e.slice(e.match(o)[0].length);
      var i = e.match(Z4);
      if (!(i && i[1] != null && i[1].length > 0 && i[1] === "0"))
        return e;
    }
  }
}
function X4(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), a = n.exec(e);
    if (a) {
      var r, o, i = a.length - 1, s = i > 0 && a[i];
      if (t.nationalPrefixTransformRule() && s)
        r = e.replace(n, t.nationalPrefixTransformRule()), i > 1 && (o = a[1]);
      else {
        var c = a[0];
        r = e.slice(c.length), s && (o = a[1]);
      }
      var u;
      if (s) {
        var p = e.indexOf(a[1]), m = e.slice(0, p);
        m === t.numberingPlan.nationalPrefix() && (u = t.numberingPlan.nationalPrefix());
      } else
        u = a[0];
      return {
        nationalNumber: r,
        nationalPrefix: u,
        carrierCode: o
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Pi(e, t) {
  var n = X4(e, t), a = n.carrierCode, r = n.nationalNumber;
  if (r !== e) {
    if (!q4(e, r, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !J4(r, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: r,
    carrierCode: a
  };
}
function q4(e, t, n) {
  return !(Dt(e, n.nationalNumberPattern()) && !Dt(t, n.nationalNumberPattern()));
}
function J4(e, t) {
  switch (Xs(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Q4(e, t, n, a) {
  var r = t ? Ys(t, a) : n;
  if (e.indexOf(r) === 0) {
    a = new Ue(a), a.selectNumberingPlan(t, n);
    var o = e.slice(r.length), i = Pi(o, a), s = i.nationalNumber, c = Pi(e, a), u = c.nationalNumber;
    if (!Dt(u, a.nationalNumberPattern()) && Dt(s, a.nationalNumberPattern()) || Xs(u, a) === "TOO_LONG")
      return {
        countryCallingCode: r,
        number: o
      };
  }
  return {
    number: e
  };
}
function bf(e, t, n, a) {
  if (!e)
    return {};
  var r;
  if (e[0] !== "+") {
    var o = Y4(e, t, n, a);
    if (o && o !== e)
      r = !0, e = "+" + o;
    else {
      if (t || n) {
        var i = Q4(e, t, n, a), s = i.countryCallingCode, c = i.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: c
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  a = new Ue(a);
  for (var u = 2; u - 1 <= U4 && u <= e.length; ) {
    var p = e.slice(1, u);
    if (a.hasCallingCode(p))
      return a.selectNumberingPlan(p), {
        countryCallingCodeSource: r ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: p,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function e9(e) {
  return e.replace(new RegExp("[".concat(Br, "]+"), "g"), " ").trim();
}
var t9 = /(\$\d)/;
function n9(e, t, n) {
  var a = n.useInternationalFormat, r = n.withNationalPrefix, o = e.replace(new RegExp(t.pattern()), a ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    r && t.nationalPrefixFormattingRule() ? t.format().replace(t9, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return a ? e9(o) : o;
}
var a9 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function r9(e, t, n) {
  var a = new Ue(n);
  if (a.selectNumberingPlan(e, t), a.defaultIDDPrefix())
    return a.defaultIDDPrefix();
  if (a9.test(a.IDDPrefix()))
    return a.IDDPrefix();
}
var o9 = ";ext=", jn = function(t) {
  return "([".concat(ut, "]{1,").concat(t, "})");
};
function vf(e) {
  var t = "20", n = "15", a = "9", r = "6", o = "[  \\t,]*", i = "[:\\.．]?[  \\t,-]*", s = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", u = "(?:[xｘ#＃~～]|int|ｉｎｔ)", p = "[- ]+", m = "[  \\t]*", f = "(?:,{2}|;)", h = o9 + jn(t), v = o + c + i + jn(t) + s, g = o + u + i + jn(a) + s, y = p + jn(r) + "#", b = m + f + i + jn(n) + s, $ = m + "(?:,)+" + i + jn(a) + s;
  return h + "|" + v + "|" + g + "|" + y + "|" + b + "|" + $;
}
var i9 = "[" + ut + "]{" + Js + "}", s9 = "[" + Qs + "]{0,1}(?:[" + Br + "]*[" + ut + "]){3,}[" + Br + ut + "]*", l9 = new RegExp("^[" + Qs + "]{0,1}(?:[" + Br + "]*[" + ut + "]){1,2}$", "i"), c9 = s9 + // Phone number extensions
"(?:" + vf() + ")?", d9 = new RegExp(
  // Either a short two-digit-only phone number
  "^" + i9 + "$|^" + c9 + "$",
  "i"
);
function u9(e) {
  return e.length >= Js && d9.test(e);
}
function p9(e) {
  return l9.test(e);
}
function m9(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function f9(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = h9(e)) || t) {
    n && (e = n);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h9(e, t) {
  if (e) {
    if (typeof e == "string") return Wl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Wl(e, t);
  }
}
function Wl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = new Array(t); n < t; n++)
    a[n] = e[n];
  return a;
}
function Vl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function zl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vl(Object(n), !0).forEach(function(a) {
      g9(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vl(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function g9(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Kl = {
  formatExtension: function(t, n, a) {
    return "".concat(t).concat(a.ext()).concat(n);
  }
};
function b9(e, t, n, a) {
  if (n ? n = zl(zl({}, Kl), n) : n = Kl, a = new Ue(a), e.country && e.country !== "001") {
    if (!a.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    a.country(e.country);
  } else if (e.countryCallingCode)
    a.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var r = a.countryCallingCode(), o = n.v2 ? e.nationalNumber : e.phone, i;
  switch (t) {
    case "NATIONAL":
      return o ? (i = Ur(o, e.carrierCode, "NATIONAL", a, n), ei(i, e.ext, a, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return o ? (i = Ur(o, null, "INTERNATIONAL", a, n), i = "+".concat(r, " ").concat(i), ei(i, e.ext, a, n.formatExtension)) : "+".concat(r);
    case "E.164":
      return "+".concat(r).concat(o);
    case "RFC3966":
      return m9({
        number: "+".concat(r).concat(o),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = y9(o, e.carrierCode, r, n.fromCountry, a);
      return ei(s, e.ext, a, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function Ur(e, t, n, a, r) {
  var o = v9(a.formats(), e);
  return o ? n9(e, o, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(o.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && r && r.nationalPrefix === !1),
    carrierCode: t,
    metadata: a
  }) : e;
}
function v9(e, t) {
  for (var n = f9(e), a; !(a = n()).done; ) {
    var r = a.value;
    if (r.leadingDigitsPatterns().length > 0) {
      var o = r.leadingDigitsPatterns()[r.leadingDigitsPatterns().length - 1];
      if (t.search(o) !== 0)
        continue;
    }
    if (Dt(t, r.pattern()))
      return r;
  }
}
function ei(e, t, n, a) {
  return t ? a(e, t, n) : e;
}
function y9(e, t, n, a, r) {
  var o = Ys(a, r.metadata);
  if (o === n) {
    var i = Ur(e, t, "NATIONAL", r);
    return n === "1" ? n + " " + i : i;
  }
  var s = r9(a, void 0, r.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(Ur(e, null, "INTERNATIONAL", r));
}
function Zl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function Yl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zl(Object(n), !0).forEach(function(a) {
      $9(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zl(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function $9(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function x9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function w9(e, t) {
  for (var n = 0; n < t.length; n++) {
    var a = t[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function C9(e, t, n) {
  return t && w9(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var S9 = /* @__PURE__ */ function() {
  function e(t, n, a) {
    if (x9(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !n)
        throw new TypeError("`metadata` argument not passed");
      if (Hn(n) && Hn(n.countries)) {
        a = n;
        var r = t;
        if (!N9.test(r))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var o = bf(r, void 0, void 0, a), i = o.countryCallingCode, s = o.number;
        if (n = s, t = i, !n)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!n)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof n != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    ff(a);
    var c = R9(t, a), u = c.country, p = c.countryCallingCode;
    this.country = u, this.countryCallingCode = p, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return a;
    };
  }
  return C9(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : L4(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return O4(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return D4(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new Ue(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return qs(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, a) {
      return b9(this, n, a ? Yl(Yl({}, a), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), E9 = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function R9(e, t) {
  var n, a, r = new Ue(t);
  return E9(e) ? (n = e, r.selectNumberingPlan(n), a = r.countryCallingCode()) : a = e, {
    country: n,
    countryCallingCode: a
  };
}
var N9 = /^\+\d+$/;
function _i(e) {
  "@babel/helpers - typeof";
  return _i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _i(e);
}
function A9(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function P9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _a(e, t);
}
function T9(e) {
  var t = $f();
  return function() {
    var a = Ta(e), r;
    if (t) {
      var o = Ta(this).constructor;
      r = Reflect.construct(a, arguments, o);
    } else
      r = a.apply(this, arguments);
    return k9(this, r);
  };
}
function k9(e, t) {
  if (t && (_i(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yf(e);
}
function yf(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ti(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Ti = function(a) {
    if (a === null || !O9(a)) return a;
    if (typeof a != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(a)) return t.get(a);
      t.set(a, r);
    }
    function r() {
      return Sr(a, arguments, Ta(this).constructor);
    }
    return r.prototype = Object.create(a.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), _a(r, a);
  }, Ti(e);
}
function Sr(e, t, n) {
  return $f() ? Sr = Reflect.construct : Sr = function(r, o, i) {
    var s = [null];
    s.push.apply(s, o);
    var c = Function.bind.apply(r, s), u = new c();
    return i && _a(u, i.prototype), u;
  }, Sr.apply(null, arguments);
}
function $f() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function O9(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function _a(e, t) {
  return _a = Object.setPrototypeOf || function(a, r) {
    return a.__proto__ = r, a;
  }, _a(e, t);
}
function Ta(e) {
  return Ta = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ta(e);
}
var Tt = /* @__PURE__ */ function(e) {
  _9(n, e);
  var t = T9(n);
  function n(a) {
    var r;
    return P9(this, n), r = t.call(this, a), Object.setPrototypeOf(yf(r), n.prototype), r.name = r.constructor.name, r;
  }
  return A9(n);
}(/* @__PURE__ */ Ti(Error)), Xl = new RegExp("(?:" + vf() + ")$", "i");
function j9(e) {
  var t = e.search(Xl);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), a = e.match(Xl), r = 1; r < a.length; ) {
    if (a[r])
      return {
        number: n,
        ext: a[r]
      };
    r++;
  }
}
var M9 = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function I9(e) {
  return M9[e];
}
function D9(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = L9(e)) || t) {
    n && (e = n);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function L9(e, t) {
  if (e) {
    if (typeof e == "string") return ql(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ql(e, t);
  }
}
function ql(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = new Array(t); n < t; n++)
    a[n] = e[n];
  return a;
}
function Jl(e) {
  for (var t = "", n = D9(e.split("")), a; !(a = n()).done; ) {
    var r = a.value;
    t += F9(r, t) || "";
  }
  return t;
}
function F9(e, t, n) {
  return e === "+" ? t ? void 0 : "+" : I9(e);
}
function B9(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = U9(e)) || t) {
    n && (e = n);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function U9(e, t) {
  if (e) {
    if (typeof e == "string") return Ql(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ql(e, t);
  }
}
function Ql(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = new Array(t); n < t; n++)
    a[n] = e[n];
  return a;
}
function G9(e, t) {
  var n = t.countries, a = t.metadata;
  a = new Ue(a);
  for (var r = B9(n), o; !(o = r()).done; ) {
    var i = o.value;
    if (a.country(i), a.leadingDigits()) {
      if (e && e.search(a.leadingDigits()) === 0)
        return i;
    } else if (qs({
      phone: e,
      country: i
    }, void 0, a.metadata))
      return i;
  }
}
function H9(e, t) {
  var n = t.nationalNumber, a = t.defaultCountry, r = t.metadata, o = r.getCountryCodesForCallingCode(e);
  if (o)
    return o.length === 1 ? o[0] : G9(n, {
      countries: o,
      defaultCountry: a,
      metadata: r.metadata
    });
}
var xf = "+", W9 = "[\\-\\.\\(\\)]?", ec = "([" + ut + "]|" + W9 + ")", V9 = "^\\" + xf + ec + "*[" + ut + "]" + ec + "*$", z9 = new RegExp(V9, "g"), ki = ut, K9 = "[" + ki + "]+((\\-)*[" + ki + "])*", Z9 = "a-zA-Z", Y9 = "[" + Z9 + "]+((\\-)*[" + ki + "])*", X9 = "^(" + K9 + "\\.)*" + Y9 + "\\.?$", q9 = new RegExp(X9, "g"), tc = "tel:", Oi = ";phone-context=", J9 = ";isub=";
function Q9(e) {
  var t = e.indexOf(Oi);
  if (t < 0)
    return null;
  var n = t + Oi.length;
  if (n >= e.length)
    return "";
  var a = e.indexOf(";", n);
  return a >= 0 ? e.substring(n, a) : e.substring(n);
}
function ex(e) {
  return e === null ? !0 : e.length === 0 ? !1 : z9.test(e) || q9.test(e);
}
function tx(e, t) {
  var n = t.extractFormattedPhoneNumber, a = Q9(e);
  if (!ex(a))
    throw new Tt("NOT_A_NUMBER");
  var r;
  if (a === null)
    r = n(e) || "";
  else {
    r = "", a.charAt(0) === xf && (r += a);
    var o = e.indexOf(tc), i;
    o >= 0 ? i = o + tc.length : i = 0;
    var s = e.indexOf(Oi);
    r += e.substring(i, s);
  }
  var c = r.indexOf(J9);
  if (c > 0 && (r = r.substring(0, c)), r !== "")
    return r;
}
var nx = 250, ax = new RegExp("[" + Qs + ut + "]"), rx = new RegExp("[^" + ut + "#]+$");
function ox(e, t, n) {
  if (t = t || {}, n = new Ue(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new Tt("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var a = sx(e, t.v2, t.extract), r = a.number, o = a.ext, i = a.error;
  if (!r) {
    if (t.v2)
      throw i === "TOO_SHORT" ? new Tt("TOO_SHORT") : new Tt("NOT_A_NUMBER");
    return {};
  }
  var s = cx(r, t.defaultCountry, t.defaultCallingCode, n), c = s.country, u = s.nationalNumber, p = s.countryCallingCode, m = s.countryCallingCodeSource, f = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Tt("INVALID_COUNTRY");
    return {};
  }
  if (!u || u.length < Js) {
    if (t.v2)
      throw new Tt("TOO_SHORT");
    return {};
  }
  if (u.length > B4) {
    if (t.v2)
      throw new Tt("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var h = new S9(p, u, n.metadata);
    return c && (h.country = c), f && (h.carrierCode = f), o && (h.ext = o), h.__countryCallingCodeSource = m, h;
  }
  var v = (t.extended ? n.hasSelectedNumberingPlan() : c) ? Dt(u, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: c,
    countryCallingCode: p,
    carrierCode: f,
    valid: v,
    possible: v ? !0 : !!(t.extended === !0 && n.possibleLengths() && gf(u, n)),
    phone: u,
    ext: o
  } : v ? lx(c, u, o) : {};
}
function ix(e, t, n) {
  if (e) {
    if (e.length > nx) {
      if (n)
        throw new Tt("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var a = e.search(ax);
    if (!(a < 0))
      return e.slice(a).replace(rx, "");
  }
}
function sx(e, t, n) {
  var a = tx(e, {
    extractFormattedPhoneNumber: function(i) {
      return ix(i, n, t);
    }
  });
  if (!a)
    return {};
  if (!u9(a))
    return p9(a) ? {
      error: "TOO_SHORT"
    } : {};
  var r = j9(a);
  return r.ext ? r : {
    number: a
  };
}
function lx(e, t, n) {
  var a = {
    country: e,
    phone: t
  };
  return n && (a.ext = n), a;
}
function cx(e, t, n, a) {
  var r = bf(Jl(e), t, n, a.metadata), o = r.countryCallingCodeSource, i = r.countryCallingCode, s = r.number, c;
  if (i)
    a.selectNumberingPlan(i);
  else if (s && (t || n))
    a.selectNumberingPlan(t, n), t && (c = t), i = n || Ys(t, a.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: o,
      countryCallingCode: i
    };
  var u = Pi(Jl(s), a), p = u.nationalNumber, m = u.carrierCode, f = H9(i, {
    nationalNumber: p,
    defaultCountry: t,
    metadata: a
  });
  return f && (c = f, f === "001" || a.country(c)), {
    country: c,
    countryCallingCode: i,
    countryCallingCodeSource: o,
    nationalNumber: p,
    carrierCode: m
  };
}
function nc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function ac(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nc(Object(n), !0).forEach(function(a) {
      dx(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nc(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function dx(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ux(e, t, n) {
  return ox(e, ac(ac({}, t), {}, {
    v2: !0
  }), n);
}
function rc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function px(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rc(Object(n), !0).forEach(function(a) {
      mx(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rc(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function mx(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function fx(e, t) {
  return vx(e) || bx(e, t) || gx(e, t) || hx();
}
function hx() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gx(e, t) {
  if (e) {
    if (typeof e == "string") return oc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return oc(e, t);
  }
}
function oc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, a = new Array(t); n < t; n++)
    a[n] = e[n];
  return a;
}
function bx(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var a = [], r = !0, o = !1, i, s;
    try {
      for (n = n.call(e); !(r = (i = n.next()).done) && (a.push(i.value), !(t && a.length === t)); r = !0)
        ;
    } catch (c) {
      o = !0, s = c;
    } finally {
      try {
        !r && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return a;
  }
}
function vx(e) {
  if (Array.isArray(e)) return e;
}
function wf(e) {
  var t = Array.prototype.slice.call(e), n = fx(t, 4), a = n[0], r = n[1], o = n[2], i = n[3], s, c, u;
  if (typeof a == "string")
    s = a;
  else throw new TypeError("A text for parsing must be a string.");
  if (!r || typeof r == "string")
    i ? (c = o, u = i) : (c = void 0, u = o), r && (c = px({
      defaultCountry: r
    }, c));
  else if (Hn(r))
    o ? (c = r, u = o) : u = r;
  else throw new Error("Invalid second argument: ".concat(r));
  return {
    text: s,
    options: c,
    metadata: u
  };
}
function ic(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function sc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ic(Object(n), !0).forEach(function(a) {
      yx(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ic(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function yx(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Cf(e, t, n) {
  t && t.defaultCountry && !T4(t.defaultCountry, n) && (t = sc(sc({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return ux(e, t, n);
  } catch (a) {
    if (!(a instanceof Tt)) throw a;
  }
}
function $x() {
  var e = wf(arguments), t = e.text, n = e.options, a = e.metadata;
  return Cf(t, n, a);
}
function lc(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, a);
  }
  return n;
}
function cc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lc(Object(n), !0).forEach(function(a) {
      xx(e, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lc(Object(n)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(n, a));
    });
  }
  return e;
}
function xx(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function wx() {
  var e = wf(arguments), t = e.text, n = e.options, a = e.metadata;
  n = cc(cc({}, n), {}, {
    extract: !1
  });
  var r = Cf(t, n, a);
  return r && r.isValid() || !1;
}
function Cx() {
  return mf($x, arguments);
}
function Sx() {
  return mf(wx, arguments);
}
var he;
(function(e) {
  e.assertEqual = (r) => r;
  function t(r) {
  }
  e.assertIs = t;
  function n(r) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (r) => {
    const o = {};
    for (const i of r)
      o[i] = i;
    return o;
  }, e.getValidEnumValues = (r) => {
    const o = e.objectKeys(r).filter((s) => typeof r[r[s]] != "number"), i = {};
    for (const s of o)
      i[s] = r[s];
    return e.objectValues(i);
  }, e.objectValues = (r) => e.objectKeys(r).map(function(o) {
    return r[o];
  }), e.objectKeys = typeof Object.keys == "function" ? (r) => Object.keys(r) : (r) => {
    const o = [];
    for (const i in r)
      Object.prototype.hasOwnProperty.call(r, i) && o.push(i);
    return o;
  }, e.find = (r, o) => {
    for (const i of r)
      if (o(i))
        return i;
  }, e.isInteger = typeof Number.isInteger == "function" ? (r) => Number.isInteger(r) : (r) => typeof r == "number" && isFinite(r) && Math.floor(r) === r;
  function a(r, o = " | ") {
    return r.map((i) => typeof i == "string" ? `'${i}'` : i).join(o);
  }
  e.joinValues = a, e.jsonStringifyReplacer = (r, o) => typeof o == "bigint" ? o.toString() : o;
})(he || (he = {}));
var ji;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(ji || (ji = {}));
const Z = he.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), kt = (e) => {
  switch (typeof e) {
    case "undefined":
      return Z.undefined;
    case "string":
      return Z.string;
    case "number":
      return isNaN(e) ? Z.nan : Z.number;
    case "boolean":
      return Z.boolean;
    case "function":
      return Z.function;
    case "bigint":
      return Z.bigint;
    case "symbol":
      return Z.symbol;
    case "object":
      return Array.isArray(e) ? Z.array : e === null ? Z.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Z.promise : typeof Map < "u" && e instanceof Map ? Z.map : typeof Set < "u" && e instanceof Set ? Z.set : typeof Date < "u" && e instanceof Date ? Z.date : Z.object;
    default:
      return Z.unknown;
  }
}, O = he.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Ex = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class qe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(t) {
    super(), this.issues = [], this.addIssue = (a) => {
      this.issues = [...this.issues, a];
    }, this.addIssues = (a = []) => {
      this.issues = [...this.issues, ...a];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  format(t) {
    const n = t || function(o) {
      return o.message;
    }, a = { _errors: [] }, r = (o) => {
      for (const i of o.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(r);
        else if (i.code === "invalid_return_type")
          r(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          r(i.argumentsError);
        else if (i.path.length === 0)
          a._errors.push(n(i));
        else {
          let s = a, c = 0;
          for (; c < i.path.length; ) {
            const u = i.path[c];
            c === i.path.length - 1 ? (s[u] = s[u] || { _errors: [] }, s[u]._errors.push(n(i))) : s[u] = s[u] || { _errors: [] }, s = s[u], c++;
          }
        }
    };
    return r(this), a;
  }
  static assert(t) {
    if (!(t instanceof qe))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, he.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, a = [];
    for (const r of this.issues)
      r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(t(r))) : a.push(t(r));
    return { formErrors: a, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
qe.create = (e) => new qe(e);
const Qn = (e, t) => {
  let n;
  switch (e.code) {
    case O.invalid_type:
      e.received === Z.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case O.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, he.jsonStringifyReplacer)}`;
      break;
    case O.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${he.joinValues(e.keys, ", ")}`;
      break;
    case O.invalid_union:
      n = "Invalid input";
      break;
    case O.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${he.joinValues(e.options)}`;
      break;
    case O.invalid_enum_value:
      n = `Invalid enum value. Expected ${he.joinValues(e.options)}, received '${e.received}'`;
      break;
    case O.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case O.invalid_return_type:
      n = "Invalid function return type";
      break;
    case O.invalid_date:
      n = "Invalid date";
      break;
    case O.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : he.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case O.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case O.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case O.custom:
      n = "Invalid input";
      break;
    case O.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case O.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case O.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, he.assertNever(e);
  }
  return { message: n };
};
let Sf = Qn;
function Rx(e) {
  Sf = e;
}
function Gr() {
  return Sf;
}
const Hr = (e) => {
  const { data: t, path: n, errorMaps: a, issueData: r } = e, o = [...n, ...r.path || []], i = {
    ...r,
    path: o
  };
  if (r.message !== void 0)
    return {
      ...r,
      path: o,
      message: r.message
    };
  let s = "";
  const c = a.filter((u) => !!u).slice().reverse();
  for (const u of c)
    s = u(i, { data: t, defaultError: s }).message;
  return {
    ...r,
    path: o,
    message: s
  };
}, Nx = [];
function H(e, t) {
  const n = Gr(), a = Hr({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      // contextual error map is first priority
      e.schemaErrorMap,
      // then schema-bound map if available
      n,
      // then global override map
      n === Qn ? void 0 : Qn
      // then global default map
    ].filter((r) => !!r)
  });
  e.common.issues.push(a);
}
class Ie {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const a = [];
    for (const r of n) {
      if (r.status === "aborted")
        return ie;
      r.status === "dirty" && t.dirty(), a.push(r.value);
    }
    return { status: t.value, value: a };
  }
  static async mergeObjectAsync(t, n) {
    const a = [];
    for (const r of n) {
      const o = await r.key, i = await r.value;
      a.push({
        key: o,
        value: i
      });
    }
    return Ie.mergeObjectSync(t, a);
  }
  static mergeObjectSync(t, n) {
    const a = {};
    for (const r of n) {
      const { key: o, value: i } = r;
      if (o.status === "aborted" || i.status === "aborted")
        return ie;
      o.status === "dirty" && t.dirty(), i.status === "dirty" && t.dirty(), o.value !== "__proto__" && (typeof i.value < "u" || r.alwaysSet) && (a[o.value] = i.value);
    }
    return { status: t.value, value: a };
  }
}
const ie = Object.freeze({
  status: "aborted"
}), Fn = (e) => ({ status: "dirty", value: e }), Be = (e) => ({ status: "valid", value: e }), Mi = (e) => e.status === "aborted", Ii = (e) => e.status === "dirty", Cn = (e) => e.status === "valid", ka = (e) => typeof Promise < "u" && e instanceof Promise;
function Wr(e, t, n, a) {
  if (typeof t == "function" ? e !== t || !a : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function Ef(e, t, n, a, r) {
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, n), n;
}
var J;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(J || (J = {}));
var wa, Ca;
class Ct {
  constructor(t, n, a, r) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = a, this._key = r;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const dc = (e, t) => {
  if (Cn(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new qe(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function ce(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: a, description: r } = e;
  if (t && (n || a))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: r } : { errorMap: (i, s) => {
    var c, u;
    const { message: p } = e;
    return i.code === "invalid_enum_value" ? { message: p ?? s.defaultError } : typeof s.data > "u" ? { message: (c = p ?? a) !== null && c !== void 0 ? c : s.defaultError } : i.code !== "invalid_type" ? { message: s.defaultError } : { message: (u = p ?? n) !== null && u !== void 0 ? u : s.defaultError };
  }, description: r };
}
class pe {
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return kt(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: kt(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Ie(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: kt(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (ka(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const a = this.safeParse(t, n);
    if (a.success)
      return a.data;
    throw a.error;
  }
  safeParse(t, n) {
    var a;
    const r = {
      common: {
        issues: [],
        async: (a = n == null ? void 0 : n.async) !== null && a !== void 0 ? a : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: kt(t)
    }, o = this._parseSync({ data: t, path: r.path, parent: r });
    return dc(r, o);
  }
  "~validate"(t) {
    var n, a;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: kt(t)
    };
    if (!this["~standard"].async)
      try {
        const o = this._parseSync({ data: t, path: [], parent: r });
        return Cn(o) ? {
          value: o.value
        } : {
          issues: r.common.issues
        };
      } catch (o) {
        !((a = (n = o == null ? void 0 : o.message) === null || n === void 0 ? void 0 : n.toLowerCase()) === null || a === void 0) && a.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: t, path: [], parent: r }).then((o) => Cn(o) ? {
      value: o.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(t, n) {
    const a = await this.safeParseAsync(t, n);
    if (a.success)
      return a.data;
    throw a.error;
  }
  async safeParseAsync(t, n) {
    const a = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: kt(t)
    }, r = this._parse({ data: t, path: a.path, parent: a }), o = await (ka(r) ? r : Promise.resolve(r));
    return dc(a, o);
  }
  refine(t, n) {
    const a = (r) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(r) : n;
    return this._refinement((r, o) => {
      const i = t(r), s = () => o.addIssue({
        code: O.custom,
        ...a(r)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((c) => c ? !0 : (s(), !1)) : i ? !0 : (s(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((a, r) => t(a) ? !0 : (r.addIssue(typeof n == "function" ? n(a, r) : n), !1));
  }
  _refinement(t) {
    return new pt({
      schema: this,
      typeName: re.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (n) => this["~validate"](n)
    };
  }
  optional() {
    return xt.create(this, this._def);
  }
  nullable() {
    return tn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return st.create(this);
  }
  promise() {
    return ta.create(this, this._def);
  }
  or(t) {
    return Ia.create([this, t], this._def);
  }
  and(t) {
    return Da.create(this, t, this._def);
  }
  transform(t) {
    return new pt({
      ...ce(this._def),
      schema: this,
      typeName: re.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Ga({
      ...ce(this._def),
      innerType: this,
      defaultValue: n,
      typeName: re.ZodDefault
    });
  }
  brand() {
    return new el({
      typeName: re.ZodBranded,
      type: this,
      ...ce(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Ha({
      ...ce(this._def),
      innerType: this,
      catchValue: n,
      typeName: re.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return cr.create(this, t);
  }
  readonly() {
    return Wa.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Ax = /^c[^\s-]{8,}$/i, Px = /^[0-9a-z]+$/, _x = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Tx = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, kx = /^[a-z0-9_-]{21}$/i, Ox = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, jx = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Mx = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Ix = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let ti;
const Dx = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Lx = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Fx = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Bx = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Ux = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Gx = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Rf = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Hx = new RegExp(`^${Rf}$`);
function Nf(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function Wx(e) {
  return new RegExp(`^${Nf(e)}$`);
}
function Af(e) {
  let t = `${Rf}T${Nf(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function Vx(e, t) {
  return !!((t === "v4" || !t) && Dx.test(e) || (t === "v6" || !t) && Fx.test(e));
}
function zx(e, t) {
  if (!Ox.test(e))
    return !1;
  try {
    const [n] = e.split("."), a = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), r = JSON.parse(atob(a));
    return !(typeof r != "object" || r === null || !r.typ || !r.alg || t && r.alg !== t);
  } catch {
    return !1;
  }
}
function Kx(e, t) {
  return !!((t === "v4" || !t) && Lx.test(e) || (t === "v6" || !t) && Bx.test(e));
}
class it extends pe {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Z.string) {
      const o = this._getOrReturnCtx(t);
      return H(o, {
        code: O.invalid_type,
        expected: Z.string,
        received: o.parsedType
      }), ie;
    }
    const a = new Ie();
    let r;
    for (const o of this._def.checks)
      if (o.kind === "min")
        t.data.length < o.value && (r = this._getOrReturnCtx(t, r), H(r, {
          code: O.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), a.dirty());
      else if (o.kind === "max")
        t.data.length > o.value && (r = this._getOrReturnCtx(t, r), H(r, {
          code: O.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: o.message
        }), a.dirty());
      else if (o.kind === "length") {
        const i = t.data.length > o.value, s = t.data.length < o.value;
        (i || s) && (r = this._getOrReturnCtx(t, r), i ? H(r, {
          code: O.too_big,
          maximum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }) : s && H(r, {
          code: O.too_small,
          minimum: o.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: o.message
        }), a.dirty());
      } else if (o.kind === "email")
        Mx.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
          validation: "email",
          code: O.invalid_string,
          message: o.message
        }), a.dirty());
      else if (o.kind === "emoji")
        ti || (ti = new RegExp(Ix, "u")), ti.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
          validation: "emoji",
          code: O.invalid_string,
          message: o.message
        }), a.dirty());
      else if (o.kind === "uuid")
        Tx.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
          validation: "uuid",
          code: O.invalid_string,
          message: o.message
        }), a.dirty());
      else if (o.kind === "nanoid")
        kx.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
          validation: "nanoid",
          code: O.invalid_string,
          message: o.message
        }), a.dirty());
      else if (o.kind === "cuid")
        Ax.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
          validation: "cuid",
          code: O.invalid_string,
          message: o.message
        }), a.dirty());
      else if (o.kind === "cuid2")
        Px.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
          validation: "cuid2",
          code: O.invalid_string,
          message: o.message
        }), a.dirty());
      else if (o.kind === "ulid")
        _x.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
          validation: "ulid",
          code: O.invalid_string,
          message: o.message
        }), a.dirty());
      else if (o.kind === "url")
        try {
          new URL(t.data);
        } catch {
          r = this._getOrReturnCtx(t, r), H(r, {
            validation: "url",
            code: O.invalid_string,
            message: o.message
          }), a.dirty();
        }
      else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
        validation: "regex",
        code: O.invalid_string,
        message: o.message
      }), a.dirty())) : o.kind === "trim" ? t.data = t.data.trim() : o.kind === "includes" ? t.data.includes(o.value, o.position) || (r = this._getOrReturnCtx(t, r), H(r, {
        code: O.invalid_string,
        validation: { includes: o.value, position: o.position },
        message: o.message
      }), a.dirty()) : o.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : o.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : o.kind === "startsWith" ? t.data.startsWith(o.value) || (r = this._getOrReturnCtx(t, r), H(r, {
        code: O.invalid_string,
        validation: { startsWith: o.value },
        message: o.message
      }), a.dirty()) : o.kind === "endsWith" ? t.data.endsWith(o.value) || (r = this._getOrReturnCtx(t, r), H(r, {
        code: O.invalid_string,
        validation: { endsWith: o.value },
        message: o.message
      }), a.dirty()) : o.kind === "datetime" ? Af(o).test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
        code: O.invalid_string,
        validation: "datetime",
        message: o.message
      }), a.dirty()) : o.kind === "date" ? Hx.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
        code: O.invalid_string,
        validation: "date",
        message: o.message
      }), a.dirty()) : o.kind === "time" ? Wx(o).test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
        code: O.invalid_string,
        validation: "time",
        message: o.message
      }), a.dirty()) : o.kind === "duration" ? jx.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
        validation: "duration",
        code: O.invalid_string,
        message: o.message
      }), a.dirty()) : o.kind === "ip" ? Vx(t.data, o.version) || (r = this._getOrReturnCtx(t, r), H(r, {
        validation: "ip",
        code: O.invalid_string,
        message: o.message
      }), a.dirty()) : o.kind === "jwt" ? zx(t.data, o.alg) || (r = this._getOrReturnCtx(t, r), H(r, {
        validation: "jwt",
        code: O.invalid_string,
        message: o.message
      }), a.dirty()) : o.kind === "cidr" ? Kx(t.data, o.version) || (r = this._getOrReturnCtx(t, r), H(r, {
        validation: "cidr",
        code: O.invalid_string,
        message: o.message
      }), a.dirty()) : o.kind === "base64" ? Ux.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
        validation: "base64",
        code: O.invalid_string,
        message: o.message
      }), a.dirty()) : o.kind === "base64url" ? Gx.test(t.data) || (r = this._getOrReturnCtx(t, r), H(r, {
        validation: "base64url",
        code: O.invalid_string,
        message: o.message
      }), a.dirty()) : he.assertNever(o);
    return { status: a.value, value: t.data };
  }
  _regex(t, n, a) {
    return this.refinement((r) => t.test(r), {
      validation: n,
      code: O.invalid_string,
      ...J.errToObj(a)
    });
  }
  _addCheck(t) {
    return new it({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...J.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...J.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...J.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...J.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...J.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...J.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...J.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...J.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...J.errToObj(t) });
  }
  base64url(t) {
    return this._addCheck({
      kind: "base64url",
      ...J.errToObj(t)
    });
  }
  jwt(t) {
    return this._addCheck({ kind: "jwt", ...J.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...J.errToObj(t) });
  }
  cidr(t) {
    return this._addCheck({ kind: "cidr", ...J.errToObj(t) });
  }
  datetime(t) {
    var n, a;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      local: (a = t == null ? void 0 : t.local) !== null && a !== void 0 ? a : !1,
      ...J.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...J.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...J.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...J.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...J.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...J.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...J.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...J.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...J.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...J.errToObj(n)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(t) {
    return this.min(1, J.errToObj(t));
  }
  trim() {
    return new it({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new it({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new it({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((t) => t.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((t) => t.kind === "base64url");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
it.create = (e) => {
  var t;
  return new it({
    checks: [],
    typeName: re.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...ce(e)
  });
};
function Zx(e, t) {
  const n = (e.toString().split(".")[1] || "").length, a = (t.toString().split(".")[1] || "").length, r = n > a ? n : a, o = parseInt(e.toFixed(r).replace(".", "")), i = parseInt(t.toFixed(r).replace(".", ""));
  return o % i / Math.pow(10, r);
}
class Jt extends pe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Z.number) {
      const o = this._getOrReturnCtx(t);
      return H(o, {
        code: O.invalid_type,
        expected: Z.number,
        received: o.parsedType
      }), ie;
    }
    let a;
    const r = new Ie();
    for (const o of this._def.checks)
      o.kind === "int" ? he.isInteger(t.data) || (a = this._getOrReturnCtx(t, a), H(a, {
        code: O.invalid_type,
        expected: "integer",
        received: "float",
        message: o.message
      }), r.dirty()) : o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (a = this._getOrReturnCtx(t, a), H(a, {
        code: O.too_small,
        minimum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), r.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (a = this._getOrReturnCtx(t, a), H(a, {
        code: O.too_big,
        maximum: o.value,
        type: "number",
        inclusive: o.inclusive,
        exact: !1,
        message: o.message
      }), r.dirty()) : o.kind === "multipleOf" ? Zx(t.data, o.value) !== 0 && (a = this._getOrReturnCtx(t, a), H(a, {
        code: O.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), r.dirty()) : o.kind === "finite" ? Number.isFinite(t.data) || (a = this._getOrReturnCtx(t, a), H(a, {
        code: O.not_finite,
        message: o.message
      }), r.dirty()) : he.assertNever(o);
    return { status: r.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, J.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, J.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, J.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, J.toString(n));
  }
  setLimit(t, n, a, r) {
    return new Jt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: a,
          message: J.toString(r)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Jt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: J.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: J.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: J.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: J.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: J.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: J.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: J.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: J.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: J.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && he.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const a of this._def.checks) {
      if (a.kind === "finite" || a.kind === "int" || a.kind === "multipleOf")
        return !0;
      a.kind === "min" ? (n === null || a.value > n) && (n = a.value) : a.kind === "max" && (t === null || a.value < t) && (t = a.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Jt.create = (e) => new Jt({
  checks: [],
  typeName: re.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...ce(e)
});
class Qt extends pe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce)
      try {
        t.data = BigInt(t.data);
      } catch {
        return this._getInvalidInput(t);
      }
    if (this._getType(t) !== Z.bigint)
      return this._getInvalidInput(t);
    let a;
    const r = new Ie();
    for (const o of this._def.checks)
      o.kind === "min" ? (o.inclusive ? t.data < o.value : t.data <= o.value) && (a = this._getOrReturnCtx(t, a), H(a, {
        code: O.too_small,
        type: "bigint",
        minimum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), r.dirty()) : o.kind === "max" ? (o.inclusive ? t.data > o.value : t.data >= o.value) && (a = this._getOrReturnCtx(t, a), H(a, {
        code: O.too_big,
        type: "bigint",
        maximum: o.value,
        inclusive: o.inclusive,
        message: o.message
      }), r.dirty()) : o.kind === "multipleOf" ? t.data % o.value !== BigInt(0) && (a = this._getOrReturnCtx(t, a), H(a, {
        code: O.not_multiple_of,
        multipleOf: o.value,
        message: o.message
      }), r.dirty()) : he.assertNever(o);
    return { status: r.value, value: t.data };
  }
  _getInvalidInput(t) {
    const n = this._getOrReturnCtx(t);
    return H(n, {
      code: O.invalid_type,
      expected: Z.bigint,
      received: n.parsedType
    }), ie;
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, J.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, J.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, J.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, J.toString(n));
  }
  setLimit(t, n, a, r) {
    return new Qt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: a,
          message: J.toString(r)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Qt({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: J.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: J.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: J.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: J.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: J.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Qt.create = (e) => {
  var t;
  return new Qt({
    checks: [],
    typeName: re.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...ce(e)
  });
};
class Oa extends pe {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Z.boolean) {
      const a = this._getOrReturnCtx(t);
      return H(a, {
        code: O.invalid_type,
        expected: Z.boolean,
        received: a.parsedType
      }), ie;
    }
    return Be(t.data);
  }
}
Oa.create = (e) => new Oa({
  typeName: re.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...ce(e)
});
class Sn extends pe {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Z.date) {
      const o = this._getOrReturnCtx(t);
      return H(o, {
        code: O.invalid_type,
        expected: Z.date,
        received: o.parsedType
      }), ie;
    }
    if (isNaN(t.data.getTime())) {
      const o = this._getOrReturnCtx(t);
      return H(o, {
        code: O.invalid_date
      }), ie;
    }
    const a = new Ie();
    let r;
    for (const o of this._def.checks)
      o.kind === "min" ? t.data.getTime() < o.value && (r = this._getOrReturnCtx(t, r), H(r, {
        code: O.too_small,
        message: o.message,
        inclusive: !0,
        exact: !1,
        minimum: o.value,
        type: "date"
      }), a.dirty()) : o.kind === "max" ? t.data.getTime() > o.value && (r = this._getOrReturnCtx(t, r), H(r, {
        code: O.too_big,
        message: o.message,
        inclusive: !0,
        exact: !1,
        maximum: o.value,
        type: "date"
      }), a.dirty()) : he.assertNever(o);
    return {
      status: a.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Sn({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: J.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: J.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
Sn.create = (e) => new Sn({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: re.ZodDate,
  ...ce(e)
});
class Vr extends pe {
  _parse(t) {
    if (this._getType(t) !== Z.symbol) {
      const a = this._getOrReturnCtx(t);
      return H(a, {
        code: O.invalid_type,
        expected: Z.symbol,
        received: a.parsedType
      }), ie;
    }
    return Be(t.data);
  }
}
Vr.create = (e) => new Vr({
  typeName: re.ZodSymbol,
  ...ce(e)
});
class ja extends pe {
  _parse(t) {
    if (this._getType(t) !== Z.undefined) {
      const a = this._getOrReturnCtx(t);
      return H(a, {
        code: O.invalid_type,
        expected: Z.undefined,
        received: a.parsedType
      }), ie;
    }
    return Be(t.data);
  }
}
ja.create = (e) => new ja({
  typeName: re.ZodUndefined,
  ...ce(e)
});
class Ma extends pe {
  _parse(t) {
    if (this._getType(t) !== Z.null) {
      const a = this._getOrReturnCtx(t);
      return H(a, {
        code: O.invalid_type,
        expected: Z.null,
        received: a.parsedType
      }), ie;
    }
    return Be(t.data);
  }
}
Ma.create = (e) => new Ma({
  typeName: re.ZodNull,
  ...ce(e)
});
class ea extends pe {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return Be(t.data);
  }
}
ea.create = (e) => new ea({
  typeName: re.ZodAny,
  ...ce(e)
});
class gn extends pe {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return Be(t.data);
  }
}
gn.create = (e) => new gn({
  typeName: re.ZodUnknown,
  ...ce(e)
});
class Lt extends pe {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return H(n, {
      code: O.invalid_type,
      expected: Z.never,
      received: n.parsedType
    }), ie;
  }
}
Lt.create = (e) => new Lt({
  typeName: re.ZodNever,
  ...ce(e)
});
class zr extends pe {
  _parse(t) {
    if (this._getType(t) !== Z.undefined) {
      const a = this._getOrReturnCtx(t);
      return H(a, {
        code: O.invalid_type,
        expected: Z.void,
        received: a.parsedType
      }), ie;
    }
    return Be(t.data);
  }
}
zr.create = (e) => new zr({
  typeName: re.ZodVoid,
  ...ce(e)
});
class st extends pe {
  _parse(t) {
    const { ctx: n, status: a } = this._processInputParams(t), r = this._def;
    if (n.parsedType !== Z.array)
      return H(n, {
        code: O.invalid_type,
        expected: Z.array,
        received: n.parsedType
      }), ie;
    if (r.exactLength !== null) {
      const i = n.data.length > r.exactLength.value, s = n.data.length < r.exactLength.value;
      (i || s) && (H(n, {
        code: i ? O.too_big : O.too_small,
        minimum: s ? r.exactLength.value : void 0,
        maximum: i ? r.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: r.exactLength.message
      }), a.dirty());
    }
    if (r.minLength !== null && n.data.length < r.minLength.value && (H(n, {
      code: O.too_small,
      minimum: r.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.minLength.message
    }), a.dirty()), r.maxLength !== null && n.data.length > r.maxLength.value && (H(n, {
      code: O.too_big,
      maximum: r.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: r.maxLength.message
    }), a.dirty()), n.common.async)
      return Promise.all([...n.data].map((i, s) => r.type._parseAsync(new Ct(n, i, n.path, s)))).then((i) => Ie.mergeArray(a, i));
    const o = [...n.data].map((i, s) => r.type._parseSync(new Ct(n, i, n.path, s)));
    return Ie.mergeArray(a, o);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new st({
      ...this._def,
      minLength: { value: t, message: J.toString(n) }
    });
  }
  max(t, n) {
    return new st({
      ...this._def,
      maxLength: { value: t, message: J.toString(n) }
    });
  }
  length(t, n) {
    return new st({
      ...this._def,
      exactLength: { value: t, message: J.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
st.create = (e, t) => new st({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: re.ZodArray,
  ...ce(t)
});
function Dn(e) {
  if (e instanceof Ce) {
    const t = {};
    for (const n in e.shape) {
      const a = e.shape[n];
      t[n] = xt.create(Dn(a));
    }
    return new Ce({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof st ? new st({
    ...e._def,
    type: Dn(e.element)
  }) : e instanceof xt ? xt.create(Dn(e.unwrap())) : e instanceof tn ? tn.create(Dn(e.unwrap())) : e instanceof St ? St.create(e.items.map((t) => Dn(t))) : e;
}
class Ce extends pe {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = he.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== Z.object) {
      const u = this._getOrReturnCtx(t);
      return H(u, {
        code: O.invalid_type,
        expected: Z.object,
        received: u.parsedType
      }), ie;
    }
    const { status: a, ctx: r } = this._processInputParams(t), { shape: o, keys: i } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Lt && this._def.unknownKeys === "strip"))
      for (const u in r.data)
        i.includes(u) || s.push(u);
    const c = [];
    for (const u of i) {
      const p = o[u], m = r.data[u];
      c.push({
        key: { status: "valid", value: u },
        value: p._parse(new Ct(r, m, r.path, u)),
        alwaysSet: u in r.data
      });
    }
    if (this._def.catchall instanceof Lt) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const p of s)
          c.push({
            key: { status: "valid", value: p },
            value: { status: "valid", value: r.data[p] }
          });
      else if (u === "strict")
        s.length > 0 && (H(r, {
          code: O.unrecognized_keys,
          keys: s
        }), a.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const p of s) {
        const m = r.data[p];
        c.push({
          key: { status: "valid", value: p },
          value: u._parse(
            new Ct(r, m, r.path, p)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: p in r.data
        });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const p of c) {
        const m = await p.key, f = await p.value;
        u.push({
          key: m,
          value: f,
          alwaysSet: p.alwaysSet
        });
      }
      return u;
    }).then((u) => Ie.mergeObjectSync(a, u)) : Ie.mergeObjectSync(a, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return J.errToObj, new Ce({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, a) => {
          var r, o, i, s;
          const c = (i = (o = (r = this._def).errorMap) === null || o === void 0 ? void 0 : o.call(r, n, a).message) !== null && i !== void 0 ? i : a.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (s = J.errToObj(t).message) !== null && s !== void 0 ? s : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new Ce({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Ce({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Ce({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Ce({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: re.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Ce({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return he.objectKeys(t).forEach((a) => {
      t[a] && this.shape[a] && (n[a] = this.shape[a]);
    }), new Ce({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return he.objectKeys(this.shape).forEach((a) => {
      t[a] || (n[a] = this.shape[a]);
    }), new Ce({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return Dn(this);
  }
  partial(t) {
    const n = {};
    return he.objectKeys(this.shape).forEach((a) => {
      const r = this.shape[a];
      t && !t[a] ? n[a] = r : n[a] = r.optional();
    }), new Ce({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return he.objectKeys(this.shape).forEach((a) => {
      if (t && !t[a])
        n[a] = this.shape[a];
      else {
        let o = this.shape[a];
        for (; o instanceof xt; )
          o = o._def.innerType;
        n[a] = o;
      }
    }), new Ce({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return Pf(he.objectKeys(this.shape));
  }
}
Ce.create = (e, t) => new Ce({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Lt.create(),
  typeName: re.ZodObject,
  ...ce(t)
});
Ce.strictCreate = (e, t) => new Ce({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Lt.create(),
  typeName: re.ZodObject,
  ...ce(t)
});
Ce.lazycreate = (e, t) => new Ce({
  shape: e,
  unknownKeys: "strip",
  catchall: Lt.create(),
  typeName: re.ZodObject,
  ...ce(t)
});
class Ia extends pe {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), a = this._def.options;
    function r(o) {
      for (const s of o)
        if (s.result.status === "valid")
          return s.result;
      for (const s of o)
        if (s.result.status === "dirty")
          return n.common.issues.push(...s.ctx.common.issues), s.result;
      const i = o.map((s) => new qe(s.ctx.common.issues));
      return H(n, {
        code: O.invalid_union,
        unionErrors: i
      }), ie;
    }
    if (n.common.async)
      return Promise.all(a.map(async (o) => {
        const i = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await o._parseAsync({
            data: n.data,
            path: n.path,
            parent: i
          }),
          ctx: i
        };
      })).then(r);
    {
      let o;
      const i = [];
      for (const c of a) {
        const u = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, p = c._parseSync({
          data: n.data,
          path: n.path,
          parent: u
        });
        if (p.status === "valid")
          return p;
        p.status === "dirty" && !o && (o = { result: p, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (o)
        return n.common.issues.push(...o.ctx.common.issues), o.result;
      const s = i.map((c) => new qe(c));
      return H(n, {
        code: O.invalid_union,
        unionErrors: s
      }), ie;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ia.create = (e, t) => new Ia({
  options: e,
  typeName: re.ZodUnion,
  ...ce(t)
});
const _t = (e) => e instanceof Fa ? _t(e.schema) : e instanceof pt ? _t(e.innerType()) : e instanceof Ba ? [e.value] : e instanceof en ? e.options : e instanceof Ua ? he.objectValues(e.enum) : e instanceof Ga ? _t(e._def.innerType) : e instanceof ja ? [void 0] : e instanceof Ma ? [null] : e instanceof xt ? [void 0, ..._t(e.unwrap())] : e instanceof tn ? [null, ..._t(e.unwrap())] : e instanceof el || e instanceof Wa ? _t(e.unwrap()) : e instanceof Ha ? _t(e._def.innerType) : [];
class Mo extends pe {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Z.object)
      return H(n, {
        code: O.invalid_type,
        expected: Z.object,
        received: n.parsedType
      }), ie;
    const a = this.discriminator, r = n.data[a], o = this.optionsMap.get(r);
    return o ? n.common.async ? o._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : o._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (H(n, {
      code: O.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [a]
    }), ie);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, a) {
    const r = /* @__PURE__ */ new Map();
    for (const o of n) {
      const i = _t(o.shape[t]);
      if (!i.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const s of i) {
        if (r.has(s))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(s)}`);
        r.set(s, o);
      }
    }
    return new Mo({
      typeName: re.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: r,
      ...ce(a)
    });
  }
}
function Di(e, t) {
  const n = kt(e), a = kt(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === Z.object && a === Z.object) {
    const r = he.objectKeys(t), o = he.objectKeys(e).filter((s) => r.indexOf(s) !== -1), i = { ...e, ...t };
    for (const s of o) {
      const c = Di(e[s], t[s]);
      if (!c.valid)
        return { valid: !1 };
      i[s] = c.data;
    }
    return { valid: !0, data: i };
  } else if (n === Z.array && a === Z.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const r = [];
    for (let o = 0; o < e.length; o++) {
      const i = e[o], s = t[o], c = Di(i, s);
      if (!c.valid)
        return { valid: !1 };
      r.push(c.data);
    }
    return { valid: !0, data: r };
  } else return n === Z.date && a === Z.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Da extends pe {
  _parse(t) {
    const { status: n, ctx: a } = this._processInputParams(t), r = (o, i) => {
      if (Mi(o) || Mi(i))
        return ie;
      const s = Di(o.value, i.value);
      return s.valid ? ((Ii(o) || Ii(i)) && n.dirty(), { status: n.value, value: s.data }) : (H(a, {
        code: O.invalid_intersection_types
      }), ie);
    };
    return a.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      }),
      this._def.right._parseAsync({
        data: a.data,
        path: a.path,
        parent: a
      })
    ]).then(([o, i]) => r(o, i)) : r(this._def.left._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }), this._def.right._parseSync({
      data: a.data,
      path: a.path,
      parent: a
    }));
  }
}
Da.create = (e, t, n) => new Da({
  left: e,
  right: t,
  typeName: re.ZodIntersection,
  ...ce(n)
});
class St extends pe {
  _parse(t) {
    const { status: n, ctx: a } = this._processInputParams(t);
    if (a.parsedType !== Z.array)
      return H(a, {
        code: O.invalid_type,
        expected: Z.array,
        received: a.parsedType
      }), ie;
    if (a.data.length < this._def.items.length)
      return H(a, {
        code: O.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), ie;
    !this._def.rest && a.data.length > this._def.items.length && (H(a, {
      code: O.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const o = [...a.data].map((i, s) => {
      const c = this._def.items[s] || this._def.rest;
      return c ? c._parse(new Ct(a, i, a.path, s)) : null;
    }).filter((i) => !!i);
    return a.common.async ? Promise.all(o).then((i) => Ie.mergeArray(n, i)) : Ie.mergeArray(n, o);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new St({
      ...this._def,
      rest: t
    });
  }
}
St.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new St({
    items: e,
    typeName: re.ZodTuple,
    rest: null,
    ...ce(t)
  });
};
class La extends pe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: a } = this._processInputParams(t);
    if (a.parsedType !== Z.object)
      return H(a, {
        code: O.invalid_type,
        expected: Z.object,
        received: a.parsedType
      }), ie;
    const r = [], o = this._def.keyType, i = this._def.valueType;
    for (const s in a.data)
      r.push({
        key: o._parse(new Ct(a, s, a.path, s)),
        value: i._parse(new Ct(a, a.data[s], a.path, s)),
        alwaysSet: s in a.data
      });
    return a.common.async ? Ie.mergeObjectAsync(n, r) : Ie.mergeObjectSync(n, r);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, a) {
    return n instanceof pe ? new La({
      keyType: t,
      valueType: n,
      typeName: re.ZodRecord,
      ...ce(a)
    }) : new La({
      keyType: it.create(),
      valueType: t,
      typeName: re.ZodRecord,
      ...ce(n)
    });
  }
}
class Kr extends pe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: a } = this._processInputParams(t);
    if (a.parsedType !== Z.map)
      return H(a, {
        code: O.invalid_type,
        expected: Z.map,
        received: a.parsedType
      }), ie;
    const r = this._def.keyType, o = this._def.valueType, i = [...a.data.entries()].map(([s, c], u) => ({
      key: r._parse(new Ct(a, s, a.path, [u, "key"])),
      value: o._parse(new Ct(a, c, a.path, [u, "value"]))
    }));
    if (a.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of i) {
          const u = await c.key, p = await c.value;
          if (u.status === "aborted" || p.status === "aborted")
            return ie;
          (u.status === "dirty" || p.status === "dirty") && n.dirty(), s.set(u.value, p.value);
        }
        return { status: n.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const c of i) {
        const u = c.key, p = c.value;
        if (u.status === "aborted" || p.status === "aborted")
          return ie;
        (u.status === "dirty" || p.status === "dirty") && n.dirty(), s.set(u.value, p.value);
      }
      return { status: n.value, value: s };
    }
  }
}
Kr.create = (e, t, n) => new Kr({
  valueType: t,
  keyType: e,
  typeName: re.ZodMap,
  ...ce(n)
});
class En extends pe {
  _parse(t) {
    const { status: n, ctx: a } = this._processInputParams(t);
    if (a.parsedType !== Z.set)
      return H(a, {
        code: O.invalid_type,
        expected: Z.set,
        received: a.parsedType
      }), ie;
    const r = this._def;
    r.minSize !== null && a.data.size < r.minSize.value && (H(a, {
      code: O.too_small,
      minimum: r.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.minSize.message
    }), n.dirty()), r.maxSize !== null && a.data.size > r.maxSize.value && (H(a, {
      code: O.too_big,
      maximum: r.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: r.maxSize.message
    }), n.dirty());
    const o = this._def.valueType;
    function i(c) {
      const u = /* @__PURE__ */ new Set();
      for (const p of c) {
        if (p.status === "aborted")
          return ie;
        p.status === "dirty" && n.dirty(), u.add(p.value);
      }
      return { status: n.value, value: u };
    }
    const s = [...a.data.values()].map((c, u) => o._parse(new Ct(a, c, a.path, u)));
    return a.common.async ? Promise.all(s).then((c) => i(c)) : i(s);
  }
  min(t, n) {
    return new En({
      ...this._def,
      minSize: { value: t, message: J.toString(n) }
    });
  }
  max(t, n) {
    return new En({
      ...this._def,
      maxSize: { value: t, message: J.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
En.create = (e, t) => new En({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: re.ZodSet,
  ...ce(t)
});
class Wn extends pe {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Z.function)
      return H(n, {
        code: O.invalid_type,
        expected: Z.function,
        received: n.parsedType
      }), ie;
    function a(s, c) {
      return Hr({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Gr(),
          Qn
        ].filter((u) => !!u),
        issueData: {
          code: O.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function r(s, c) {
      return Hr({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Gr(),
          Qn
        ].filter((u) => !!u),
        issueData: {
          code: O.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const o = { errorMap: n.common.contextualErrorMap }, i = n.data;
    if (this._def.returns instanceof ta) {
      const s = this;
      return Be(async function(...c) {
        const u = new qe([]), p = await s._def.args.parseAsync(c, o).catch((h) => {
          throw u.addIssue(a(c, h)), u;
        }), m = await Reflect.apply(i, this, p);
        return await s._def.returns._def.type.parseAsync(m, o).catch((h) => {
          throw u.addIssue(r(m, h)), u;
        });
      });
    } else {
      const s = this;
      return Be(function(...c) {
        const u = s._def.args.safeParse(c, o);
        if (!u.success)
          throw new qe([a(c, u.error)]);
        const p = Reflect.apply(i, this, u.data), m = s._def.returns.safeParse(p, o);
        if (!m.success)
          throw new qe([r(p, m.error)]);
        return m.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Wn({
      ...this._def,
      args: St.create(t).rest(gn.create())
    });
  }
  returns(t) {
    return new Wn({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, a) {
    return new Wn({
      args: t || St.create([]).rest(gn.create()),
      returns: n || gn.create(),
      typeName: re.ZodFunction,
      ...ce(a)
    });
  }
}
class Fa extends pe {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Fa.create = (e, t) => new Fa({
  getter: e,
  typeName: re.ZodLazy,
  ...ce(t)
});
class Ba extends pe {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return H(n, {
        received: n.data,
        code: O.invalid_literal,
        expected: this._def.value
      }), ie;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Ba.create = (e, t) => new Ba({
  value: e,
  typeName: re.ZodLiteral,
  ...ce(t)
});
function Pf(e, t) {
  return new en({
    values: e,
    typeName: re.ZodEnum,
    ...ce(t)
  });
}
class en extends pe {
  constructor() {
    super(...arguments), wa.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), a = this._def.values;
      return H(n, {
        expected: he.joinValues(a),
        received: n.parsedType,
        code: O.invalid_type
      }), ie;
    }
    if (Wr(this, wa) || Ef(this, wa, new Set(this._def.values)), !Wr(this, wa).has(t.data)) {
      const n = this._getOrReturnCtx(t), a = this._def.values;
      return H(n, {
        received: n.data,
        code: O.invalid_enum_value,
        options: a
      }), ie;
    }
    return Be(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return en.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return en.create(this.options.filter((a) => !t.includes(a)), {
      ...this._def,
      ...n
    });
  }
}
wa = /* @__PURE__ */ new WeakMap();
en.create = Pf;
class Ua extends pe {
  constructor() {
    super(...arguments), Ca.set(this, void 0);
  }
  _parse(t) {
    const n = he.getValidEnumValues(this._def.values), a = this._getOrReturnCtx(t);
    if (a.parsedType !== Z.string && a.parsedType !== Z.number) {
      const r = he.objectValues(n);
      return H(a, {
        expected: he.joinValues(r),
        received: a.parsedType,
        code: O.invalid_type
      }), ie;
    }
    if (Wr(this, Ca) || Ef(this, Ca, new Set(he.getValidEnumValues(this._def.values))), !Wr(this, Ca).has(t.data)) {
      const r = he.objectValues(n);
      return H(a, {
        received: a.data,
        code: O.invalid_enum_value,
        options: r
      }), ie;
    }
    return Be(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ca = /* @__PURE__ */ new WeakMap();
Ua.create = (e, t) => new Ua({
  values: e,
  typeName: re.ZodNativeEnum,
  ...ce(t)
});
class ta extends pe {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Z.promise && n.common.async === !1)
      return H(n, {
        code: O.invalid_type,
        expected: Z.promise,
        received: n.parsedType
      }), ie;
    const a = n.parsedType === Z.promise ? n.data : Promise.resolve(n.data);
    return Be(a.then((r) => this._def.type.parseAsync(r, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
ta.create = (e, t) => new ta({
  type: e,
  typeName: re.ZodPromise,
  ...ce(t)
});
class pt extends pe {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === re.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: a } = this._processInputParams(t), r = this._def.effect || null, o = {
      addIssue: (i) => {
        H(a, i), i.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return a.path;
      }
    };
    if (o.addIssue = o.addIssue.bind(o), r.type === "preprocess") {
      const i = r.transform(a.data, o);
      if (a.common.async)
        return Promise.resolve(i).then(async (s) => {
          if (n.value === "aborted")
            return ie;
          const c = await this._def.schema._parseAsync({
            data: s,
            path: a.path,
            parent: a
          });
          return c.status === "aborted" ? ie : c.status === "dirty" || n.value === "dirty" ? Fn(c.value) : c;
        });
      {
        if (n.value === "aborted")
          return ie;
        const s = this._def.schema._parseSync({
          data: i,
          path: a.path,
          parent: a
        });
        return s.status === "aborted" ? ie : s.status === "dirty" || n.value === "dirty" ? Fn(s.value) : s;
      }
    }
    if (r.type === "refinement") {
      const i = (s) => {
        const c = r.refinement(s, o);
        if (a.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (a.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return s.status === "aborted" ? ie : (s.status === "dirty" && n.dirty(), i(s.value), { status: n.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((s) => s.status === "aborted" ? ie : (s.status === "dirty" && n.dirty(), i(s.value).then(() => ({ status: n.value, value: s.value }))));
    }
    if (r.type === "transform")
      if (a.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: a.data,
          path: a.path,
          parent: a
        });
        if (!Cn(i))
          return i;
        const s = r.transform(i.value, o);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: a.data, path: a.path, parent: a }).then((i) => Cn(i) ? Promise.resolve(r.transform(i.value, o)).then((s) => ({ status: n.value, value: s })) : i);
    he.assertNever(r);
  }
}
pt.create = (e, t, n) => new pt({
  schema: e,
  typeName: re.ZodEffects,
  effect: t,
  ...ce(n)
});
pt.createWithPreprocess = (e, t, n) => new pt({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: re.ZodEffects,
  ...ce(n)
});
class xt extends pe {
  _parse(t) {
    return this._getType(t) === Z.undefined ? Be(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
xt.create = (e, t) => new xt({
  innerType: e,
  typeName: re.ZodOptional,
  ...ce(t)
});
class tn extends pe {
  _parse(t) {
    return this._getType(t) === Z.null ? Be(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
tn.create = (e, t) => new tn({
  innerType: e,
  typeName: re.ZodNullable,
  ...ce(t)
});
class Ga extends pe {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let a = n.data;
    return n.parsedType === Z.undefined && (a = this._def.defaultValue()), this._def.innerType._parse({
      data: a,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ga.create = (e, t) => new Ga({
  innerType: e,
  typeName: re.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...ce(t)
});
class Ha extends pe {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), a = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, r = this._def.innerType._parse({
      data: a.data,
      path: a.path,
      parent: {
        ...a
      }
    });
    return ka(r) ? r.then((o) => ({
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new qe(a.common.issues);
        },
        input: a.data
      })
    })) : {
      status: "valid",
      value: r.status === "valid" ? r.value : this._def.catchValue({
        get error() {
          return new qe(a.common.issues);
        },
        input: a.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ha.create = (e, t) => new Ha({
  innerType: e,
  typeName: re.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...ce(t)
});
class Zr extends pe {
  _parse(t) {
    if (this._getType(t) !== Z.nan) {
      const a = this._getOrReturnCtx(t);
      return H(a, {
        code: O.invalid_type,
        expected: Z.nan,
        received: a.parsedType
      }), ie;
    }
    return { status: "valid", value: t.data };
  }
}
Zr.create = (e) => new Zr({
  typeName: re.ZodNaN,
  ...ce(e)
});
const Yx = Symbol("zod_brand");
class el extends pe {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), a = n.data;
    return this._def.type._parse({
      data: a,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class cr extends pe {
  _parse(t) {
    const { status: n, ctx: a } = this._processInputParams(t);
    if (a.common.async)
      return (async () => {
        const o = await this._def.in._parseAsync({
          data: a.data,
          path: a.path,
          parent: a
        });
        return o.status === "aborted" ? ie : o.status === "dirty" ? (n.dirty(), Fn(o.value)) : this._def.out._parseAsync({
          data: o.value,
          path: a.path,
          parent: a
        });
      })();
    {
      const r = this._def.in._parseSync({
        data: a.data,
        path: a.path,
        parent: a
      });
      return r.status === "aborted" ? ie : r.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: r.value
      }) : this._def.out._parseSync({
        data: r.value,
        path: a.path,
        parent: a
      });
    }
  }
  static create(t, n) {
    return new cr({
      in: t,
      out: n,
      typeName: re.ZodPipeline
    });
  }
}
class Wa extends pe {
  _parse(t) {
    const n = this._def.innerType._parse(t), a = (r) => (Cn(r) && (r.value = Object.freeze(r.value)), r);
    return ka(n) ? n.then((r) => a(r)) : a(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Wa.create = (e, t) => new Wa({
  innerType: e,
  typeName: re.ZodReadonly,
  ...ce(t)
});
function _f(e, t = {}, n) {
  return e ? ea.create().superRefine((a, r) => {
    var o, i;
    if (!e(a)) {
      const s = typeof t == "function" ? t(a) : typeof t == "string" ? { message: t } : t, c = (i = (o = s.fatal) !== null && o !== void 0 ? o : n) !== null && i !== void 0 ? i : !0, u = typeof s == "string" ? { message: s } : s;
      r.addIssue({ code: "custom", ...u, fatal: c });
    }
  }) : ea.create();
}
const Xx = {
  object: Ce.lazycreate
};
var re;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(re || (re = {}));
const qx = (e, t = {
  message: `Input not instance of ${e.name}`
}) => _f((n) => n instanceof e, t), Tf = it.create, kf = Jt.create, Jx = Zr.create, Qx = Qt.create, Of = Oa.create, ew = Sn.create, tw = Vr.create, nw = ja.create, aw = Ma.create, rw = ea.create, ow = gn.create, iw = Lt.create, sw = zr.create, lw = st.create, cw = Ce.create, dw = Ce.strictCreate, uw = Ia.create, pw = Mo.create, mw = Da.create, fw = St.create, hw = La.create, gw = Kr.create, bw = En.create, vw = Wn.create, yw = Fa.create, $w = Ba.create, xw = en.create, ww = Ua.create, Cw = ta.create, uc = pt.create, Sw = xt.create, Ew = tn.create, Rw = pt.createWithPreprocess, Nw = cr.create, Aw = () => Tf().optional(), Pw = () => kf().optional(), _w = () => Of().optional(), Tw = {
  string: (e) => it.create({ ...e, coerce: !0 }),
  number: (e) => Jt.create({ ...e, coerce: !0 }),
  boolean: (e) => Oa.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Qt.create({ ...e, coerce: !0 }),
  date: (e) => Sn.create({ ...e, coerce: !0 })
}, kw = ie;
var Ow = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Qn,
  setErrorMap: Rx,
  getErrorMap: Gr,
  makeIssue: Hr,
  EMPTY_PATH: Nx,
  addIssueToContext: H,
  ParseStatus: Ie,
  INVALID: ie,
  DIRTY: Fn,
  OK: Be,
  isAborted: Mi,
  isDirty: Ii,
  isValid: Cn,
  isAsync: ka,
  get util() {
    return he;
  },
  get objectUtil() {
    return ji;
  },
  ZodParsedType: Z,
  getParsedType: kt,
  ZodType: pe,
  datetimeRegex: Af,
  ZodString: it,
  ZodNumber: Jt,
  ZodBigInt: Qt,
  ZodBoolean: Oa,
  ZodDate: Sn,
  ZodSymbol: Vr,
  ZodUndefined: ja,
  ZodNull: Ma,
  ZodAny: ea,
  ZodUnknown: gn,
  ZodNever: Lt,
  ZodVoid: zr,
  ZodArray: st,
  ZodObject: Ce,
  ZodUnion: Ia,
  ZodDiscriminatedUnion: Mo,
  ZodIntersection: Da,
  ZodTuple: St,
  ZodRecord: La,
  ZodMap: Kr,
  ZodSet: En,
  ZodFunction: Wn,
  ZodLazy: Fa,
  ZodLiteral: Ba,
  ZodEnum: en,
  ZodNativeEnum: Ua,
  ZodPromise: ta,
  ZodEffects: pt,
  ZodTransformer: pt,
  ZodOptional: xt,
  ZodNullable: tn,
  ZodDefault: Ga,
  ZodCatch: Ha,
  ZodNaN: Zr,
  BRAND: Yx,
  ZodBranded: el,
  ZodPipeline: cr,
  ZodReadonly: Wa,
  custom: _f,
  Schema: pe,
  ZodSchema: pe,
  late: Xx,
  get ZodFirstPartyTypeKind() {
    return re;
  },
  coerce: Tw,
  any: rw,
  array: lw,
  bigint: Qx,
  boolean: Of,
  date: ew,
  discriminatedUnion: pw,
  effect: uc,
  enum: xw,
  function: vw,
  instanceof: qx,
  intersection: mw,
  lazy: yw,
  literal: $w,
  map: gw,
  nan: Jx,
  nativeEnum: ww,
  never: iw,
  null: aw,
  nullable: Ew,
  number: kf,
  object: cw,
  oboolean: _w,
  onumber: Pw,
  optional: Sw,
  ostring: Aw,
  pipeline: Nw,
  preprocess: Rw,
  promise: Cw,
  record: hw,
  set: bw,
  strictObject: dw,
  string: Tf,
  symbol: tw,
  transformer: uc,
  tuple: fw,
  undefined: nw,
  union: uw,
  unknown: ow,
  void: sw,
  NEVER: kw,
  ZodIssueCode: O,
  quotelessJson: Ex,
  ZodError: qe
});
const qC = Ow.string().refine((e) => {
  try {
    return Sx(e);
  } catch {
    return !1;
  }
}, "Invalid phone number"), jw = Je(
  ({
    className: e,
    onCountryChange: t,
    onChange: n,
    value: a,
    placeholder: r,
    defaultCountry: o,
    inline: i = !1,
    ...s
  }, c) => {
    const [, u] = He(), [p, m] = He(""), [f, h] = He(!1);
    Yr(() => {
      var y;
      if (o) {
        const b = Fr.lookup.countries({
          alpha2: o.toLowerCase()
        })[0];
        if (u(b), m(o.toLowerCase()), !f && ((y = b == null ? void 0 : b.countryCallingCodes) != null && y[0]) && !a) {
          const $ = {
            target: {
              value: b.countryCallingCodes[0]
            }
          };
          n == null || n($), t == null || t(b), h(!0);
        }
      }
    }, [o, n, a, f, t]);
    const v = (y) => {
      let b = y.target.value;
      try {
        const $ = Cx(b);
        if ($ && $.country) {
          const x = $.country;
          m(""), setTimeout(() => {
            m(x.toLowerCase());
          }, 0);
          const w = Fr.lookup.countries({ alpha2: x })[0];
          u(w), t == null || t(w);
        }
        n == null || n(y);
      } catch ($) {
        console.error("Error parsing phone number:", $), n == null || n(y), m(""), u(void 0), t == null || t(void 0);
      }
    }, g = R(
      "flex items-center gap-2 relative bg-transparent transition-colors text-base rounded-md border border-input pl-3 h-9 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed md:text-sm has-[input:focus]:outline-none has-[input:focus]:ring-1 has-[input:focus]:ring-ring [interpolate-size:allow-keywords]",
      i && "rounded-l-none w-full",
      e
    );
    return /* @__PURE__ */ l.jsxs("div", { className: g, children: [
      !i && /* @__PURE__ */ l.jsx("div", { className: "w-4 h-4 rounded-full shrink-0", children: p ? /* @__PURE__ */ l.jsx(Ni, { countryCode: p, height: 16 }) : /* @__PURE__ */ l.jsx(vc, { size: 16 }) }),
      /* @__PURE__ */ l.jsx(
        "input",
        {
          ref: c,
          value: a,
          onChange: v,
          placeholder: r || "Enter number",
          type: "tel",
          autoComplete: "tel",
          name: "phone",
          className: R(
            "flex !w-full border-none bg-transparent text-base transition-colors placeholder:text-muted-foreground outline-none h-9 py-1 p-0 leading-none md:text-sm [interpolate-size:allow-keywords]",
            e
          ),
          ...s
        }
      )
    ] });
  }
);
jw.displayName = "PhoneInput";
function Mw(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const jf = D.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), ca = () => {
  const e = D.useContext(jf);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
Mw(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Iw() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function Dw() {
  return tl(/^Mac/);
}
function Lw() {
  return tl(/^iPhone/);
}
function pc() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function Fw() {
  return tl(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Dw() && navigator.maxTouchPoints > 1;
}
function Mf() {
  return Lw() || Fw();
}
function tl(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const Bw = 24, Uw = typeof window < "u" ? gc : Yr;
function mc(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const ni = typeof document < "u" && window.visualViewport;
function fc(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function If(e) {
  for (fc(e) && (e = e.parentElement); e && !fc(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const Gw = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let yr = 0, ai;
function Hw(e = {}) {
  let { isDisabled: t } = e;
  Uw(() => {
    if (!t)
      return yr++, yr === 1 && Mf() && (ai = Ww()), () => {
        yr--, yr === 0 && (ai == null || ai());
      };
  }, [
    t
  ]);
}
function Ww() {
  let e, t = 0, n = (m) => {
    e = If(m.target), !(e === document.documentElement && e === document.body) && (t = m.changedTouches[0].pageY);
  }, a = (m) => {
    if (!e || e === document.documentElement || e === document.body) {
      m.preventDefault();
      return;
    }
    let f = m.changedTouches[0].pageY, h = e.scrollTop, v = e.scrollHeight - e.clientHeight;
    v !== 0 && ((h <= 0 && f > t || h >= v && f < t) && m.preventDefault(), t = f);
  }, r = (m) => {
    let f = m.target;
    Li(f) && f !== document.activeElement && (m.preventDefault(), f.style.transform = "translateY(-2000px)", f.focus(), requestAnimationFrame(() => {
      f.style.transform = "";
    }));
  }, o = (m) => {
    let f = m.target;
    Li(f) && (f.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      f.style.transform = "", ni && (ni.height < window.innerHeight ? requestAnimationFrame(() => {
        hc(f);
      }) : ni.addEventListener("resize", () => hc(f), {
        once: !0
      }));
    }));
  }, i = () => {
    window.scrollTo(0, 0);
  }, s = window.pageXOffset, c = window.pageYOffset, u = mc(Vw(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let p = mc(ba(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), ba(document, "touchmove", a, {
    passive: !1,
    capture: !0
  }), ba(document, "touchend", r, {
    passive: !1,
    capture: !0
  }), ba(document, "focus", o, !0), ba(window, "scroll", i));
  return () => {
    u(), p(), window.scrollTo(s, c);
  };
}
function Vw(e, t, n) {
  let a = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = a;
  };
}
function ba(e, t, n, a) {
  return e.addEventListener(t, n, a), () => {
    e.removeEventListener(t, n, a);
  };
}
function hc(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = If(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let a = n.getBoundingClientRect().top, r = e.getBoundingClientRect().top, o = e.getBoundingClientRect().bottom;
      const i = n.getBoundingClientRect().bottom + Bw;
      o > i && (n.scrollTop += r - a);
    }
    e = n.parentElement;
  }
}
function Li(e) {
  return e instanceof HTMLInputElement && !Gw.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function zw(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Kw(...e) {
  return (t) => e.forEach((n) => zw(n, t));
}
function Df(...e) {
  return d.useCallback(Kw(...e), e);
}
const Lf = /* @__PURE__ */ new WeakMap();
function Te(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let a = {};
  Object.entries(t).forEach(([r, o]) => {
    if (r.startsWith("--")) {
      e.style.setProperty(r, o);
      return;
    }
    a[r] = e.style[r], e.style[r] = o;
  }), !n && Lf.set(e, a);
}
function Zw(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = Lf.get(e);
  n && (e.style[t] = n[t]);
}
const Pe = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function $r(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), a = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let r = a.match(/^matrix3d\((.+)\)$/);
  return r ? parseFloat(r[1].split(", ")[Pe(t) ? 13 : 12]) : (r = a.match(/^matrix\((.+)\)$/), r ? parseFloat(r[1].split(", ")[Pe(t) ? 5 : 4]) : null);
}
function Yw(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function ri(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function Xw(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const we = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, Ff = 0.4, qw = 0.25, Jw = 100, Bf = 8, fn = 16, Fi = 26, oi = "vaul-dragging";
function Uf(e) {
  const t = D.useRef(e);
  return D.useEffect(() => {
    t.current = e;
  }), D.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function Qw({ defaultProp: e, onChange: t }) {
  const n = D.useState(e), [a] = n, r = D.useRef(a), o = Uf(t);
  return D.useEffect(() => {
    r.current !== a && (o(a), r.current = a);
  }, [
    a,
    r,
    o
  ]), n;
}
function Gf({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [a, r] = Qw({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, i = o ? e : a, s = Uf(n), c = D.useCallback((u) => {
    if (o) {
      const m = typeof u == "function" ? u(e) : u;
      m !== e && s(m);
    } else
      r(u);
  }, [
    o,
    e,
    r,
    s
  ]);
  return [
    i,
    c
  ];
}
function eC({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: a, overlayRef: r, fadeFromIndex: o, onSnapPointChange: i, direction: s = "bottom", container: c, snapToSequentialPoint: u }) {
  const [p, m] = Gf({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [f, h] = D.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  D.useEffect(() => {
    function C() {
      h({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", C), () => window.removeEventListener("resize", C);
  }, []);
  const v = D.useMemo(() => p === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    p
  ]), g = D.useMemo(() => {
    var C;
    return (C = n == null ? void 0 : n.findIndex((T) => T === p)) != null ? C : null;
  }, [
    n,
    p
  ]), y = n && n.length > 0 && (o || o === 0) && !Number.isNaN(o) && n[o] === p || !n, b = D.useMemo(() => {
    const C = c ? {
      width: c.getBoundingClientRect().width,
      height: c.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var T;
    return (T = n == null ? void 0 : n.map((A) => {
      const L = typeof A == "string";
      let V = 0;
      if (L && (V = parseInt(A, 10)), Pe(s)) {
        const _ = L ? V : f ? A * C.height : 0;
        return f ? s === "bottom" ? C.height - _ : -C.height + _ : _;
      }
      const M = L ? V : f ? A * C.width : 0;
      return f ? s === "right" ? C.width - M : -C.width + M : M;
    })) != null ? T : [];
  }, [
    n,
    f,
    c
  ]), $ = D.useMemo(() => g !== null ? b == null ? void 0 : b[g] : null, [
    b,
    g
  ]), x = D.useCallback((C) => {
    var T;
    const A = (T = b == null ? void 0 : b.findIndex((L) => L === C)) != null ? T : null;
    i(A), Te(a.current, {
      transition: `transform ${we.DURATION}s cubic-bezier(${we.EASE.join(",")})`,
      transform: Pe(s) ? `translate3d(0, ${C}px, 0)` : `translate3d(${C}px, 0, 0)`
    }), b && A !== b.length - 1 && o !== void 0 && A !== o && A < o ? Te(r.current, {
      transition: `opacity ${we.DURATION}s cubic-bezier(${we.EASE.join(",")})`,
      opacity: "0"
    }) : Te(r.current, {
      transition: `opacity ${we.DURATION}s cubic-bezier(${we.EASE.join(",")})`,
      opacity: "1"
    }), m(n == null ? void 0 : n[Math.max(A, 0)]);
  }, [
    a.current,
    n,
    b,
    o,
    r,
    m
  ]);
  D.useEffect(() => {
    if (p || e) {
      var C;
      const T = (C = n == null ? void 0 : n.findIndex((A) => A === e || A === p)) != null ? C : -1;
      b && T !== -1 && typeof b[T] == "number" && x(b[T]);
    }
  }, [
    p,
    e,
    n,
    b,
    x
  ]);
  function w({ draggedDistance: C, closeDrawer: T, velocity: A, dismissible: L }) {
    if (o === void 0) return;
    const V = s === "bottom" || s === "right" ? ($ ?? 0) - C : ($ ?? 0) + C, M = g === o - 1, _ = g === 0, K = C > 0;
    if (M && Te(r.current, {
      transition: `opacity ${we.DURATION}s cubic-bezier(${we.EASE.join(",")})`
    }), !u && A > 2 && !K) {
      L ? T() : x(b[0]);
      return;
    }
    if (!u && A > 2 && K && b && n) {
      x(b[n.length - 1]);
      return;
    }
    const Q = b == null ? void 0 : b.reduce((q, z) => typeof q != "number" || typeof z != "number" ? q : Math.abs(z - V) < Math.abs(q - V) ? z : q), W = Pe(s) ? window.innerHeight : window.innerWidth;
    if (A > Ff && Math.abs(C) < W * 0.4) {
      const q = K ? 1 : -1;
      if (q > 0 && v && n) {
        x(b[n.length - 1]);
        return;
      }
      if (_ && q < 0 && L && T(), g === null) return;
      x(b[g + q]);
      return;
    }
    x(Q);
  }
  function S({ draggedDistance: C }) {
    if ($ === null) return;
    const T = s === "bottom" || s === "right" ? $ - C : $ + C;
    (s === "bottom" || s === "right") && T < b[b.length - 1] || (s === "top" || s === "left") && T > b[b.length - 1] || Te(a.current, {
      transform: Pe(s) ? `translate3d(0, ${T}px, 0)` : `translate3d(${T}px, 0, 0)`
    });
  }
  function P(C, T) {
    if (!n || typeof g != "number" || !b || o === void 0) return null;
    const A = g === o - 1;
    if (g >= o && T)
      return 0;
    if (A && !T) return 1;
    if (!y && !A) return null;
    const V = A ? g + 1 : g - 1, M = A ? b[V] - b[V - 1] : b[V + 1] - b[V], _ = C / Math.abs(M);
    return A ? 1 - _ : _;
  }
  return {
    isLastSnapPoint: v,
    activeSnapPoint: p,
    shouldFade: y,
    getPercentageDragged: P,
    setActiveSnapPoint: m,
    activeSnapPointIndex: g,
    onRelease: w,
    onDrag: S,
    snapPointsOffset: b
  };
}
const tC = () => () => {
};
function nC() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: a, noBodyStyles: r } = ca(), o = D.useRef(null), i = Bi(() => document.body.style.backgroundColor, []);
  function s() {
    return (window.innerWidth - Fi) / window.innerWidth;
  }
  D.useEffect(() => {
    if (t && n) {
      o.current && clearTimeout(o.current);
      const c = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!c) return;
      Xw(a && !r ? ri(document.body, {
        background: "black"
      }) : tC, ri(c, {
        transformOrigin: Pe(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${we.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${we.EASE.join(",")})`
      }));
      const u = ri(c, {
        borderRadius: `${Bf}px`,
        overflow: "hidden",
        ...Pe(e) ? {
          transform: `scale(${s()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${s()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        u(), o.current = window.setTimeout(() => {
          i ? document.body.style.background = i : document.body.style.removeProperty("background");
        }, we.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    i
  ]);
}
let va = null;
function aC({ isOpen: e, modal: t, nested: n, hasBeenOpened: a, preventScrollRestoration: r, noBodyStyles: o }) {
  const [i, s] = D.useState(() => typeof window < "u" ? window.location.href : ""), c = D.useRef(0), u = D.useCallback(() => {
    if (pc() && va === null && e && !o) {
      va = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: m, innerHeight: f } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-c.current}px`,
        left: `${-m}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const h = f - window.innerHeight;
        h && c.current >= f && (document.body.style.top = `${-(c.current + h)}px`);
      }), 300);
    }
  }, [
    e
  ]), p = D.useCallback(() => {
    if (pc() && va !== null && !o) {
      const m = -parseInt(document.body.style.top, 10), f = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, va), window.requestAnimationFrame(() => {
        if (r && i !== window.location.href) {
          s(window.location.href);
          return;
        }
        window.scrollTo(f, m);
      }), va = null;
    }
  }, [
    i
  ]);
  return D.useEffect(() => {
    function m() {
      c.current = window.scrollY;
    }
    return m(), window.addEventListener("scroll", m), () => {
      window.removeEventListener("scroll", m);
    };
  }, []), D.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || p();
      };
  }, [
    t,
    p
  ]), D.useEffect(() => {
    n || !a || (e ? (!window.matchMedia("(display-mode: standalone)").matches && u(), t || window.setTimeout(() => {
      p();
    }, 500)) : p());
  }, [
    e,
    a,
    i,
    t,
    n,
    u,
    p
  ]), {
    restorePositionSetting: p
  };
}
function Hf({ open: e, onOpenChange: t, children: n, onDrag: a, onRelease: r, snapPoints: o, shouldScaleBackground: i = !1, setBackgroundColorOnScale: s = !0, closeThreshold: c = qw, scrollLockTimeout: u = Jw, dismissible: p = !0, handleOnly: m = !1, fadeFromIndex: f = o && o.length - 1, activeSnapPoint: h, setActiveSnapPoint: v, fixed: g, modal: y = !0, onClose: b, nested: $, noBodyStyles: x = !1, direction: w = "bottom", defaultOpen: S = !1, disablePreventScroll: P = !0, snapToSequentialPoint: C = !1, preventScrollRestoration: T = !1, repositionInputs: A = !0, onAnimationEnd: L, container: V, autoFocus: M = !1 }) {
  var _, K;
  const [Q = !1, W] = Gf({
    defaultProp: S,
    prop: e,
    onChange: (se) => {
      t == null || t(se), !se && !$ && At(), setTimeout(() => {
        L == null || L(se);
      }, we.DURATION * 1e3), se && !y && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), se || (document.body.style.pointerEvents = "auto");
    }
  }), [q, z] = D.useState(!1), [j, N] = D.useState(!1), [F, E] = D.useState(!1), B = D.useRef(null), X = D.useRef(null), U = D.useRef(null), ne = D.useRef(null), I = D.useRef(null), Y = D.useRef(!1), te = D.useRef(null), le = D.useRef(0), me = D.useRef(!1), fe = D.useRef(!S), Oe = D.useRef(0), k = D.useRef(null), oe = D.useRef(((_ = k.current) == null ? void 0 : _.getBoundingClientRect().height) || 0), xe = D.useRef(((K = k.current) == null ? void 0 : K.getBoundingClientRect().width) || 0), Se = D.useRef(0), je = D.useCallback((se) => {
    o && se === Ze.length - 1 && (X.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: be, activeSnapPointIndex: Ae, setActiveSnapPoint: dn, onRelease: Ke, snapPointsOffset: Ze, onDrag: nt, shouldFade: at, getPercentageDragged: ht } = eC({
    snapPoints: o,
    activeSnapPointProp: h,
    setActiveSnapPointProp: v,
    drawerRef: k,
    fadeFromIndex: f,
    overlayRef: B,
    onSnapPointChange: je,
    direction: w,
    container: V,
    snapToSequentialPoint: C
  });
  Hw({
    isDisabled: !Q || j || !y || F || !q || !A || !P
  });
  const { restorePositionSetting: At } = aC({
    isOpen: Q,
    modal: y,
    nested: $ ?? !1,
    hasBeenOpened: q,
    preventScrollRestoration: T,
    noBodyStyles: x
  });
  function un() {
    return (window.innerWidth - Fi) / window.innerWidth;
  }
  function dr(se) {
    var ve, ye;
    !p && !o || k.current && !k.current.contains(se.target) || (oe.current = ((ve = k.current) == null ? void 0 : ve.getBoundingClientRect().height) || 0, xe.current = ((ye = k.current) == null ? void 0 : ye.getBoundingClientRect().width) || 0, N(!0), U.current = /* @__PURE__ */ new Date(), Mf() && window.addEventListener("touchend", () => Y.current = !1, {
      once: !0
    }), se.target.setPointerCapture(se.pointerId), le.current = Pe(w) ? se.pageY : se.pageX);
  }
  function ur(se, ve) {
    var ye;
    let ge = se;
    const Ee = (ye = window.getSelection()) == null ? void 0 : ye.toString(), Ge = k.current ? $r(k.current, w) : null, Fe = /* @__PURE__ */ new Date();
    if (ge.tagName === "SELECT" || ge.hasAttribute("data-vaul-no-drag") || ge.closest("[data-vaul-no-drag]"))
      return !1;
    if (w === "right" || w === "left")
      return !0;
    if (X.current && Fe.getTime() - X.current.getTime() < 500)
      return !1;
    if (Ge !== null && (w === "bottom" ? Ge > 0 : Ge < 0))
      return !0;
    if (Ee && Ee.length > 0)
      return !1;
    if (I.current && Fe.getTime() - I.current.getTime() < u && Ge === 0 || ve)
      return I.current = Fe, !1;
    for (; ge; ) {
      if (ge.scrollHeight > ge.clientHeight) {
        if (ge.scrollTop !== 0)
          return I.current = /* @__PURE__ */ new Date(), !1;
        if (ge.getAttribute("role") === "dialog")
          return !0;
      }
      ge = ge.parentNode;
    }
    return !0;
  }
  function Io(se) {
    if (k.current && j) {
      const ve = w === "bottom" || w === "right" ? 1 : -1, ye = (le.current - (Pe(w) ? se.pageY : se.pageX)) * ve, ge = ye > 0, Ee = o && !p && !ge;
      if (Ee && Ae === 0) return;
      const Ge = Math.abs(ye), Fe = document.querySelector("[data-vaul-drawer-wrapper]"), Bt = w === "bottom" || w === "top" ? oe.current : xe.current;
      let rt = Ge / Bt;
      const mn = ht(Ge, ge);
      if (mn !== null && (rt = mn), Ee && rt >= 1 || !Y.current && !ur(se.target, ge)) return;
      if (k.current.classList.add(oi), Y.current = !0, Te(k.current, {
        transition: "none"
      }), Te(B.current, {
        transition: "none"
      }), o && nt({
        draggedDistance: ye
      }), ge && !o) {
        const bt = Yw(ye), pr = Math.min(bt * -1, 0) * ve;
        Te(k.current, {
          transform: Pe(w) ? `translate3d(0, ${pr}px, 0)` : `translate3d(${pr}px, 0, 0)`
        });
        return;
      }
      const Ut = 1 - rt;
      if ((at || f && Ae === f - 1) && (a == null || a(se, rt), Te(B.current, {
        opacity: `${Ut}`,
        transition: "none"
      }, !0)), Fe && B.current && i) {
        const bt = Math.min(un() + rt * (1 - un()), 1), pr = 8 - rt * 8, nl = Math.max(0, 14 - rt * 14);
        Te(Fe, {
          borderRadius: `${pr}px`,
          transform: Pe(w) ? `scale(${bt}) translate3d(0, ${nl}px, 0)` : `scale(${bt}) translate3d(${nl}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!o) {
        const bt = Ge * ve;
        Te(k.current, {
          transform: Pe(w) ? `translate3d(0, ${bt}px, 0)` : `translate3d(${bt}px, 0, 0)`
        });
      }
    }
  }
  D.useEffect(() => {
    window.requestAnimationFrame(() => {
      fe.current = !0;
    });
  }, []), D.useEffect(() => {
    var se;
    function ve() {
      if (!k.current || !A) return;
      const ye = document.activeElement;
      if (Li(ye) || me.current) {
        var ge;
        const Ee = ((ge = window.visualViewport) == null ? void 0 : ge.height) || 0, Ge = window.innerHeight;
        let Fe = Ge - Ee;
        const Bt = k.current.getBoundingClientRect().height || 0, rt = Bt > Ge * 0.8;
        Se.current || (Se.current = Bt);
        const mn = k.current.getBoundingClientRect().top;
        if (Math.abs(Oe.current - Fe) > 60 && (me.current = !me.current), o && o.length > 0 && Ze && Ae) {
          const Ut = Ze[Ae] || 0;
          Fe += Ut;
        }
        if (Oe.current = Fe, Bt > Ee || me.current) {
          const Ut = k.current.getBoundingClientRect().height;
          let bt = Ut;
          Ut > Ee && (bt = Ee - (rt ? mn : Fi)), g ? k.current.style.height = `${Ut - Math.max(Fe, 0)}px` : k.current.style.height = `${Math.max(bt, Ee - mn)}px`;
        } else Iw() || (k.current.style.height = `${Se.current}px`);
        o && o.length > 0 && !me.current ? k.current.style.bottom = "0px" : k.current.style.bottom = `${Math.max(Fe, 0)}px`;
      }
    }
    return (se = window.visualViewport) == null || se.addEventListener("resize", ve), () => {
      var ye;
      return (ye = window.visualViewport) == null ? void 0 : ye.removeEventListener("resize", ve);
    };
  }, [
    Ae,
    o,
    Ze
  ]);
  function pn(se) {
    da(), b == null || b(), se || W(!1), setTimeout(() => {
      o && dn(o[0]);
    }, we.DURATION * 1e3);
  }
  function gt() {
    if (!k.current) return;
    const se = document.querySelector("[data-vaul-drawer-wrapper]"), ve = $r(k.current, w);
    Te(k.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${we.DURATION}s cubic-bezier(${we.EASE.join(",")})`
    }), Te(B.current, {
      transition: `opacity ${we.DURATION}s cubic-bezier(${we.EASE.join(",")})`,
      opacity: "1"
    }), i && ve && ve > 0 && Q && Te(se, {
      borderRadius: `${Bf}px`,
      overflow: "hidden",
      ...Pe(w) ? {
        transform: `scale(${un()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${un()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${we.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${we.EASE.join(",")})`
    }, !0);
  }
  function da() {
    !j || !k.current || (k.current.classList.remove(oi), Y.current = !1, N(!1), ne.current = /* @__PURE__ */ new Date());
  }
  function Do(se) {
    if (!j || !k.current) return;
    k.current.classList.remove(oi), Y.current = !1, N(!1), ne.current = /* @__PURE__ */ new Date();
    const ve = $r(k.current, w);
    if (!se || !ur(se.target, !1) || !ve || Number.isNaN(ve) || U.current === null) return;
    const ye = ne.current.getTime() - U.current.getTime(), ge = le.current - (Pe(w) ? se.pageY : se.pageX), Ee = Math.abs(ge) / ye;
    if (Ee > 0.05 && (E(!0), setTimeout(() => {
      E(!1);
    }, 200)), o) {
      Ke({
        draggedDistance: ge * (w === "bottom" || w === "right" ? 1 : -1),
        closeDrawer: pn,
        velocity: Ee,
        dismissible: p
      }), r == null || r(se, !0);
      return;
    }
    if (w === "bottom" || w === "right" ? ge > 0 : ge < 0) {
      gt(), r == null || r(se, !0);
      return;
    }
    if (Ee > Ff) {
      pn(), r == null || r(se, !1);
      return;
    }
    var Ge;
    const Fe = Math.min((Ge = k.current.getBoundingClientRect().height) != null ? Ge : 0, window.innerHeight);
    var Bt;
    const rt = Math.min((Bt = k.current.getBoundingClientRect().width) != null ? Bt : 0, window.innerWidth), mn = w === "left" || w === "right";
    if (Math.abs(ve) >= (mn ? rt : Fe) * c) {
      pn(), r == null || r(se, !1);
      return;
    }
    r == null || r(se, !0), gt();
  }
  D.useEffect(() => (Q && (Te(document.documentElement, {
    scrollBehavior: "auto"
  }), X.current = /* @__PURE__ */ new Date()), () => {
    Zw(document.documentElement, "scrollBehavior");
  }), [
    Q
  ]);
  function Zf(se) {
    const ve = se ? (window.innerWidth - fn) / window.innerWidth : 1, ye = se ? -fn : 0;
    te.current && window.clearTimeout(te.current), Te(k.current, {
      transition: `transform ${we.DURATION}s cubic-bezier(${we.EASE.join(",")})`,
      transform: Pe(w) ? `scale(${ve}) translate3d(0, ${ye}px, 0)` : `scale(${ve}) translate3d(${ye}px, 0, 0)`
    }), !se && k.current && (te.current = setTimeout(() => {
      const ge = $r(k.current, w);
      Te(k.current, {
        transition: "none",
        transform: Pe(w) ? `translate3d(0, ${ge}px, 0)` : `translate3d(${ge}px, 0, 0)`
      });
    }, 500));
  }
  function Yf(se, ve) {
    if (ve < 0) return;
    const ye = (window.innerWidth - fn) / window.innerWidth, ge = ye + ve * (1 - ye), Ee = -fn + ve * fn;
    Te(k.current, {
      transform: Pe(w) ? `scale(${ge}) translate3d(0, ${Ee}px, 0)` : `scale(${ge}) translate3d(${Ee}px, 0, 0)`,
      transition: "none"
    });
  }
  function Xf(se, ve) {
    const ye = Pe(w) ? window.innerHeight : window.innerWidth, ge = ve ? (ye - fn) / ye : 1, Ee = ve ? -fn : 0;
    ve && Te(k.current, {
      transition: `transform ${we.DURATION}s cubic-bezier(${we.EASE.join(",")})`,
      transform: Pe(w) ? `scale(${ge}) translate3d(0, ${Ee}px, 0)` : `scale(${ge}) translate3d(${Ee}px, 0, 0)`
    });
  }
  return D.useEffect(() => {
    y || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    y
  ]), /* @__PURE__ */ D.createElement(xo, {
    defaultOpen: S,
    onOpenChange: (se) => {
      !p && !se || (se ? z(!0) : pn(!0), W(se));
    },
    open: Q
  }, /* @__PURE__ */ D.createElement(jf.Provider, {
    value: {
      activeSnapPoint: be,
      snapPoints: o,
      setActiveSnapPoint: dn,
      drawerRef: k,
      overlayRef: B,
      onOpenChange: t,
      onPress: dr,
      onRelease: Do,
      onDrag: Io,
      dismissible: p,
      shouldAnimate: fe,
      handleOnly: m,
      isOpen: Q,
      isDragging: j,
      shouldFade: at,
      closeDrawer: pn,
      onNestedDrag: Yf,
      onNestedOpenChange: Zf,
      onNestedRelease: Xf,
      keyboardIsOpen: me,
      modal: y,
      snapPointsOffset: Ze,
      activeSnapPointIndex: Ae,
      direction: w,
      shouldScaleBackground: i,
      setBackgroundColorOnScale: s,
      noBodyStyles: x,
      container: V,
      autoFocus: M
    }
  }, n));
}
const Wf = /* @__PURE__ */ D.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: a, onRelease: r, shouldFade: o, isOpen: i, modal: s, shouldAnimate: c } = ca(), u = Df(t, n), p = a && a.length > 0;
  if (!s)
    return null;
  const m = D.useCallback((f) => r(f), [
    r
  ]);
  return /* @__PURE__ */ D.createElement(ia, {
    onMouseUp: m,
    ref: u,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": i && p ? "true" : "false",
    "data-vaul-snap-points-overlay": i && o ? "true" : "false",
    "data-vaul-animate": c != null && c.current ? "true" : "false",
    ...e
  });
});
Wf.displayName = "Drawer.Overlay";
const Vf = /* @__PURE__ */ D.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...a }, r) {
  const { drawerRef: o, onPress: i, onRelease: s, onDrag: c, keyboardIsOpen: u, snapPointsOffset: p, activeSnapPointIndex: m, modal: f, isOpen: h, direction: v, snapPoints: g, container: y, handleOnly: b, shouldAnimate: $, autoFocus: x } = ca(), [w, S] = D.useState(!1), P = Df(r, o), C = D.useRef(null), T = D.useRef(null), A = D.useRef(!1), L = g && g.length > 0;
  nC();
  const V = (_, K, Q = 0) => {
    if (A.current) return !0;
    const W = Math.abs(_.y), q = Math.abs(_.x), z = q > W, j = [
      "bottom",
      "right"
    ].includes(K) ? 1 : -1;
    if (K === "left" || K === "right") {
      if (!(_.x * j < 0) && q >= 0 && q <= Q)
        return z;
    } else if (!(_.y * j < 0) && W >= 0 && W <= Q)
      return !z;
    return A.current = !0, !0;
  };
  D.useEffect(() => {
    L && window.requestAnimationFrame(() => {
      S(!0);
    });
  }, []);
  function M(_) {
    C.current = null, A.current = !1, s(_);
  }
  return /* @__PURE__ */ D.createElement(sa, {
    "data-vaul-drawer-direction": v,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": w ? "true" : "false",
    "data-vaul-snap-points": h && L ? "true" : "false",
    "data-vaul-custom-container": y ? "true" : "false",
    "data-vaul-animate": $ != null && $.current ? "true" : "false",
    ...a,
    ref: P,
    style: p && p.length > 0 ? {
      "--snap-point-height": `${p[m ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (_) => {
      b || (a.onPointerDown == null || a.onPointerDown.call(a, _), C.current = {
        x: _.pageX,
        y: _.pageY
      }, i(_));
    },
    onOpenAutoFocus: (_) => {
      n == null || n(_), x || _.preventDefault();
    },
    onPointerDownOutside: (_) => {
      if (e == null || e(_), !f || _.defaultPrevented) {
        _.preventDefault();
        return;
      }
      u.current && (u.current = !1);
    },
    onFocusOutside: (_) => {
      if (!f) {
        _.preventDefault();
        return;
      }
    },
    onPointerMove: (_) => {
      if (T.current = _, b || (a.onPointerMove == null || a.onPointerMove.call(a, _), !C.current)) return;
      const K = _.pageY - C.current.y, Q = _.pageX - C.current.x, W = _.pointerType === "touch" ? 10 : 2;
      V({
        x: Q,
        y: K
      }, v, W) ? c(_) : (Math.abs(Q) > W || Math.abs(K) > W) && (C.current = null);
    },
    onPointerUp: (_) => {
      a.onPointerUp == null || a.onPointerUp.call(a, _), C.current = null, A.current = !1, s(_);
    },
    onPointerOut: (_) => {
      a.onPointerOut == null || a.onPointerOut.call(a, _), M(T.current);
    },
    onContextMenu: (_) => {
      a.onContextMenu == null || a.onContextMenu.call(a, _), T.current && M(T.current);
    }
  });
});
Vf.displayName = "Drawer.Content";
const rC = 250, oC = 120, zf = /* @__PURE__ */ D.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, a) {
  const { closeDrawer: r, isDragging: o, snapPoints: i, activeSnapPoint: s, setActiveSnapPoint: c, dismissible: u, handleOnly: p, isOpen: m, onPress: f, onDrag: h } = ca(), v = D.useRef(null), g = D.useRef(!1);
  function y() {
    if (g.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      b();
    }, oC);
  }
  function b() {
    if (o || e || g.current) {
      x();
      return;
    }
    if (x(), !i || i.length === 0) {
      u || r();
      return;
    }
    if (s === i[i.length - 1] && u) {
      r();
      return;
    }
    const S = i.findIndex((C) => C === s);
    if (S === -1) return;
    const P = i[S + 1];
    c(P);
  }
  function $() {
    v.current = window.setTimeout(() => {
      g.current = !0;
    }, rC);
  }
  function x() {
    v.current && window.clearTimeout(v.current), g.current = !1;
  }
  return /* @__PURE__ */ D.createElement("div", {
    onClick: y,
    onPointerCancel: x,
    onPointerDown: (w) => {
      p && f(w), $();
    },
    onPointerMove: (w) => {
      p && h(w);
    },
    // onPointerUp is already handled by the content component
    ref: a,
    "data-vaul-drawer-visible": m ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ D.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
zf.displayName = "Drawer.Handle";
function iC({ onDrag: e, onOpenChange: t, open: n, ...a }) {
  const { onNestedDrag: r, onNestedOpenChange: o, onNestedRelease: i } = ca();
  if (!r)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ D.createElement(Hf, {
    nested: !0,
    open: n,
    onClose: () => {
      o(!1);
    },
    onDrag: (s, c) => {
      r(s, c), e == null || e(s, c);
    },
    onOpenChange: (s) => {
      s && o(s), t == null || t(s);
    },
    onRelease: i,
    ...a
  });
}
function sC(e) {
  const t = ca(), { container: n = t.container, ...a } = e;
  return /* @__PURE__ */ D.createElement(wo, {
    container: n,
    ...a
  });
}
const ft = {
  Root: Hf,
  NestedRoot: iC,
  Content: Vf,
  Overlay: Wf,
  Trigger: Ns,
  Portal: sC,
  Handle: zf,
  Close: Co,
  Title: ar,
  Description: rr
}, lC = ({
  shouldScaleBackground: e = !0,
  ...t
}) => /* @__PURE__ */ l.jsx(
  ft.Root,
  {
    shouldScaleBackground: e,
    ...t
  }
);
lC.displayName = "Drawer";
const JC = ft.Trigger, cC = ft.Portal, QC = ft.Close, Kf = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ft.Overlay,
  {
    ref: n,
    className: R("fixed inset-0 z-50 bg-black/80", e),
    ...t
  }
));
Kf.displayName = ft.Overlay.displayName;
const dC = d.forwardRef(({ className: e, children: t, ...n }, a) => /* @__PURE__ */ l.jsxs(cC, { children: [
  /* @__PURE__ */ l.jsx(Kf, {}),
  /* @__PURE__ */ l.jsxs(
    ft.Content,
    {
      ref: a,
      className: R(
        "fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[10px] border bg-background",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ l.jsx("div", { className: "mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" }),
        t
      ]
    }
  )
] }));
dC.displayName = "DrawerContent";
const uC = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R("grid gap-1.5 p-4 text-center sm:text-left", e),
    ...t
  }
);
uC.displayName = "DrawerHeader";
const pC = ({
  className: e,
  ...t
}) => /* @__PURE__ */ l.jsx(
  "div",
  {
    className: R("mt-auto flex flex-col gap-2 p-4", e),
    ...t
  }
);
pC.displayName = "DrawerFooter";
const mC = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ft.Title,
  {
    ref: n,
    className: R(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
mC.displayName = ft.Title.displayName;
const fC = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ l.jsx(
  ft.Description,
  {
    ref: n,
    className: R("text-sm text-muted-foreground", e),
    ...t
  }
));
fC.displayName = ft.Description.displayName;
Promise.resolve({          });
export {
  kr as AdminFeeOption,
  VC as Badge,
  Ne as Button,
  l$ as Card,
  p$ as CardContent,
  u$ as CardDescription,
  m$ as CardFooter,
  c$ as CardHeader,
  d$ as CardTitle,
  Rn as Checkbox,
  SC as CheckboxDropdown,
  Ls as ContactPreference,
  Va as CounterInput,
  XC as CountryDropdown,
  LC as CurrencyInput,
  FC as CurrencySelector,
  Yu as Dialog,
  jC as DialogClose,
  Ps as DialogContent,
  _3 as DialogDescription,
  A3 as DialogFooter,
  N3 as DialogHeader,
  As as DialogOverlay,
  R3 as DialogPortal,
  P3 as DialogTitle,
  OC as DialogTrigger,
  IC as DonationAmountOptions,
  ws as DonationFormHeader,
  DC as DonationFrequencyOptions,
  MC as DonationModal,
  Fs as DonationSection,
  Sp as DonationSummary,
  Pn as DonationSummaryCard,
  lC as Drawer,
  QC as DrawerClose,
  dC as DrawerContent,
  fC as DrawerDescription,
  pC as DrawerFooter,
  uC as DrawerHeader,
  Kf as DrawerOverlay,
  cC as DrawerPortal,
  mC as DrawerTitle,
  JC as DrawerTrigger,
  fs as DropdownMenu,
  vo as DropdownMenuContent,
  xC as DropdownMenuGroup,
  yo as DropdownMenuItem,
  Ab as DropdownMenuLabel,
  wC as DropdownMenuPortal,
  Pb as DropdownMenuSeparator,
  CC as DropdownMenuSub,
  Eb as DropdownMenuSubContent,
  Sb as DropdownMenuSubTrigger,
  hs as DropdownMenuTrigger,
  RC as EntityCard,
  NC as EntityContainer,
  on as EntityHeader,
  PC as EntityList,
  _C as EntityOverlay,
  tr as EntityPanel,
  Qu as FormContainer,
  Xn as GiftAid,
  nr as InfoDisplayCard,
  bs as Input,
  r$ as InputOTP,
  o$ as InputOTPGroup,
  s$ as InputOTPSeparator,
  i$ as InputOTPSlot,
  $o as Label,
  Ru as NavigationButtons,
  xs as NavigationItem,
  ir as OrganizationDonationOption,
  um as PaymentOption,
  jw as PhoneInput,
  P$ as ScrollArea,
  Tm as ScrollBar,
  Cy as Select,
  lm as SelectContent,
  cm as SelectItem,
  om as SelectTrigger,
  Sy as SelectValue,
  GC as Sheet,
  WC as SheetClose,
  By as SheetContent,
  Wy as SheetDescription,
  Gy as SheetFooter,
  Uy as SheetHeader,
  Hy as SheetTitle,
  HC as SheetTrigger,
  zC as Skeleton,
  ku as Switch,
  h$ as Textarea,
  cd as Tooltip,
  as as TooltipContent,
  ld as TooltipProvider,
  dd as TooltipTrigger,
  c3 as Typography,
  xn as UpsellDonationList,
  EC as ValidationError,
  Lb as Warning,
  R as cn,
  qC as phoneSchema,
  _s as useCurrencySelectorContext,
  dm as useOrganizationDonationOption
};
